import { OperationVariables } from '@apollo/client'
// Apollo Client v4 compatibility: BaseMutationOptions and MutationFunction were removed; alias them so the codegen output type-checks.
declare module '@apollo/client/react' {
  export type MutationFunction<TData, TVariables extends OperationVariables> = (
    options?: import('@apollo/client/react').MutationFunctionOptions<TData, TVariables>
  ) => Promise<import('@apollo/client/react').MutationResult<TData>>
  export type BaseMutationOptions<
    TData,
    TVariables extends OperationVariables
  > = import('@apollo/client/react').MutationHookOptions<TData, TVariables>
}
import { gql } from '@apollo/client'
import * as ApolloReactCommon from '@apollo/client/react'
import * as ApolloReactHooks from '@apollo/client/react'
export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  bigint: { input: string; output: string }
  bpchar: { input: string; output: string }
  date: { input: string; output: string }
  jsonb: { input: unknown; output: unknown }
  timestamp: { input: string; output: string }
  timestamptz: { input: string; output: string }
}

export type AuthUserInput = {
  password: Scalars['String']['input']
  username: Scalars['String']['input']
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq: InputMaybe<Scalars['Boolean']['input']>
  _gt: InputMaybe<Scalars['Boolean']['input']>
  _gte: InputMaybe<Scalars['Boolean']['input']>
  _in: InputMaybe<Array<Scalars['Boolean']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['Boolean']['input']>
  _lte: InputMaybe<Scalars['Boolean']['input']>
  _neq: InputMaybe<Scalars['Boolean']['input']>
  _nin: InputMaybe<Array<Scalars['Boolean']['input']>>
}

export type CrisisNotificationOutput = {
  __typename?: 'CrisisNotificationOutput'
  campaignId: Maybe<Scalars['String']['output']>
  message: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type CurrentUserOutput = {
  __typename?: 'CurrentUserOutput'
  user: Maybe<Users>
  userId: Scalars['Int']['output']
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq: InputMaybe<Scalars['Int']['input']>
  _gt: InputMaybe<Scalars['Int']['input']>
  _gte: InputMaybe<Scalars['Int']['input']>
  _in: InputMaybe<Array<Scalars['Int']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['Int']['input']>
  _lte: InputMaybe<Scalars['Int']['input']>
  _neq: InputMaybe<Scalars['Int']['input']>
  _nin: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NominationEmailInput = {
  category: Scalars['String']['input']
  html: Scalars['String']['input']
  mgr_to: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  to: Scalars['String']['input']
  to_name: Scalars['String']['input']
}

export type NominationEmailOutput = {
  __typename?: 'NominationEmailOutput'
  id: Maybe<Scalars['String']['output']>
  success: Maybe<Scalars['Boolean']['output']>
}

export type PresignedUpload = {
  __typename?: 'PresignedUpload'
  fields: Maybe<Scalars['jsonb']['output']>
  presignedGetUrl: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export type PresignedUploadInput = {
  fileName: Scalars['String']['input']
  isPublic: Scalars['Boolean']['input']
  type: Scalars['String']['input']
}

export type RedemptionCodeOutput = {
  __typename?: 'RedemptionCodeOutput'
  code: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ResourceEmailInput = {
  resourceId: Scalars['Int']['input']
  to: Scalars['String']['input']
}

export type ResourceEmailOutput = {
  __typename?: 'ResourceEmailOutput'
  id: Maybe<Scalars['String']['output']>
  success: Maybe<Scalars['Boolean']['output']>
}

export type Session = {
  __typename?: 'Session'
  accessToken: Maybe<Scalars['String']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in: InputMaybe<Array<Scalars['String']['input']>>
  /** does the array contain the given value */
  _contains: InputMaybe<Array<Scalars['String']['input']>>
  _eq: InputMaybe<Array<Scalars['String']['input']>>
  _gt: InputMaybe<Array<Scalars['String']['input']>>
  _gte: InputMaybe<Array<Scalars['String']['input']>>
  _in: InputMaybe<Array<Array<Scalars['String']['input']>>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Array<Scalars['String']['input']>>
  _lte: InputMaybe<Array<Scalars['String']['input']>>
  _neq: InputMaybe<Array<Scalars['String']['input']>>
  _nin: InputMaybe<Array<Array<Scalars['String']['input']>>>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq: InputMaybe<Scalars['String']['input']>
  _gt: InputMaybe<Scalars['String']['input']>
  _gte: InputMaybe<Scalars['String']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike: InputMaybe<Scalars['String']['input']>
  _in: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex: InputMaybe<Scalars['String']['input']>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like: InputMaybe<Scalars['String']['input']>
  _lt: InputMaybe<Scalars['String']['input']>
  _lte: InputMaybe<Scalars['String']['input']>
  _neq: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike: InputMaybe<Scalars['String']['input']>
  _nin: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given pattern */
  _nlike: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar: InputMaybe<Scalars['String']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex: InputMaybe<Scalars['String']['input']>
  /** does the column match the given SQL regular expression */
  _similar: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "v2.adp" */
export type Adp = {
  __typename?: 'adp'
  created_at: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['String']['output']
  ptoBalances: Maybe<Scalars['jsonb']['output']>
  ptoRequests: Maybe<Scalars['jsonb']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  user: Maybe<Users>
  worker: Scalars['jsonb']['output']
}

/** columns and relationships of "v2.adp" */
export type AdpPtoBalancesArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "v2.adp" */
export type AdpPtoRequestsArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "v2.adp" */
export type AdpWorkerArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "v2.adp" */
export type Adp_Aggregate = {
  __typename?: 'adp_aggregate'
  aggregate: Maybe<Adp_Aggregate_Fields>
  nodes: Array<Adp>
}

/** aggregate fields of "v2.adp" */
export type Adp_Aggregate_Fields = {
  __typename?: 'adp_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<Adp_Max_Fields>
  min: Maybe<Adp_Min_Fields>
}

/** aggregate fields of "v2.adp" */
export type Adp_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Adp_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Adp_Append_Input = {
  ptoBalances: InputMaybe<Scalars['jsonb']['input']>
  ptoRequests: InputMaybe<Scalars['jsonb']['input']>
  worker: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp". All fields are combined with a logical 'AND'. */
export type Adp_Bool_Exp = {
  _and: InputMaybe<Array<Adp_Bool_Exp>>
  _not: InputMaybe<Adp_Bool_Exp>
  _or: InputMaybe<Array<Adp_Bool_Exp>>
  created_at: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<String_Comparison_Exp>
  ptoBalances: InputMaybe<Jsonb_Comparison_Exp>
  ptoRequests: InputMaybe<Jsonb_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
  user: InputMaybe<Users_Bool_Exp>
  worker: InputMaybe<Jsonb_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp" */
export enum Adp_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdpPkey = 'adp_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Adp_Delete_At_Path_Input = {
  ptoBalances: InputMaybe<Array<Scalars['String']['input']>>
  ptoRequests: InputMaybe<Array<Scalars['String']['input']>>
  worker: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Adp_Delete_Elem_Input = {
  ptoBalances: InputMaybe<Scalars['Int']['input']>
  ptoRequests: InputMaybe<Scalars['Int']['input']>
  worker: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Adp_Delete_Key_Input = {
  ptoBalances: InputMaybe<Scalars['String']['input']>
  ptoRequests: InputMaybe<Scalars['String']['input']>
  worker: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "v2.adp" */
export type Adp_Insert_Input = {
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['String']['input']>
  ptoBalances: InputMaybe<Scalars['jsonb']['input']>
  ptoRequests: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  user: InputMaybe<Users_Obj_Rel_Insert_Input>
  worker: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate max on columns */
export type Adp_Max_Fields = {
  __typename?: 'adp_max_fields'
  created_at: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Adp_Min_Fields = {
  __typename?: 'adp_min_fields'
  created_at: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp" */
export type Adp_Mutation_Response = {
  __typename?: 'adp_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Adp>
}

/** input type for inserting object relation for remote table "v2.adp" */
export type Adp_Obj_Rel_Insert_Input = {
  data: Adp_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Adp_On_Conflict>
}

/** on_conflict condition type for table "v2.adp" */
export type Adp_On_Conflict = {
  constraint: Adp_Constraint
  update_columns: Array<Adp_Update_Column>
  where: InputMaybe<Adp_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp". */
export type Adp_Order_By = {
  created_at: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  ptoBalances: InputMaybe<Order_By>
  ptoRequests: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
  user: InputMaybe<Users_Order_By>
  worker: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp */
export type Adp_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Adp_Prepend_Input = {
  ptoBalances: InputMaybe<Scalars['jsonb']['input']>
  ptoRequests: InputMaybe<Scalars['jsonb']['input']>
  worker: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.adp" */
export enum Adp_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PtoBalances = 'ptoBalances',
  /** column name */
  PtoRequests = 'ptoRequests',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Worker = 'worker'
}

/** input type for updating data in table "v2.adp" */
export type Adp_Set_Input = {
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['String']['input']>
  ptoBalances: InputMaybe<Scalars['jsonb']['input']>
  ptoRequests: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  worker: InputMaybe<Scalars['jsonb']['input']>
}

/** Streaming cursor of the table "adp" */
export type Adp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Adp_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Adp_Stream_Cursor_Value_Input = {
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['String']['input']>
  ptoBalances: InputMaybe<Scalars['jsonb']['input']>
  ptoRequests: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  worker: InputMaybe<Scalars['jsonb']['input']>
}

/** update columns of table "v2.adp" */
export enum Adp_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PtoBalances = 'ptoBalances',
  /** column name */
  PtoRequests = 'ptoRequests',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Worker = 'worker'
}

export type Adp_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Adp_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Adp_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Adp_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Adp_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Adp_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Adp_Set_Input>
  /** filter the rows which have to be updated */
  where: Adp_Bool_Exp
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq: InputMaybe<Scalars['bigint']['input']>
  _gt: InputMaybe<Scalars['bigint']['input']>
  _gte: InputMaybe<Scalars['bigint']['input']>
  _in: InputMaybe<Array<Scalars['bigint']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['bigint']['input']>
  _lte: InputMaybe<Scalars['bigint']['input']>
  _neq: InputMaybe<Scalars['bigint']['input']>
  _nin: InputMaybe<Array<Scalars['bigint']['input']>>
}

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq: InputMaybe<Scalars['bpchar']['input']>
  _gt: InputMaybe<Scalars['bpchar']['input']>
  _gte: InputMaybe<Scalars['bpchar']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike: InputMaybe<Scalars['bpchar']['input']>
  _in: InputMaybe<Array<Scalars['bpchar']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex: InputMaybe<Scalars['bpchar']['input']>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like: InputMaybe<Scalars['bpchar']['input']>
  _lt: InputMaybe<Scalars['bpchar']['input']>
  _lte: InputMaybe<Scalars['bpchar']['input']>
  _neq: InputMaybe<Scalars['bpchar']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike: InputMaybe<Scalars['bpchar']['input']>
  _nin: InputMaybe<Array<Scalars['bpchar']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex: InputMaybe<Scalars['bpchar']['input']>
  /** does the column NOT match the given pattern */
  _nlike: InputMaybe<Scalars['bpchar']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex: InputMaybe<Scalars['bpchar']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar: InputMaybe<Scalars['bpchar']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex: InputMaybe<Scalars['bpchar']['input']>
  /** does the column match the given SQL regular expression */
  _similar: InputMaybe<Scalars['bpchar']['input']>
}

/** columns and relationships of "v2.bulletin_department" */
export type BulletinDepartments = {
  __typename?: 'bulletinDepartments'
  /** An object relationship */
  bulletin: Maybe<Bulletins>
  bulletinId: Scalars['Int']['output']
  departmentId: Scalars['Int']['output']
}

/** aggregated selection of "v2.bulletin_department" */
export type BulletinDepartments_Aggregate = {
  __typename?: 'bulletinDepartments_aggregate'
  aggregate: Maybe<BulletinDepartments_Aggregate_Fields>
  nodes: Array<BulletinDepartments>
}

export type BulletinDepartments_Aggregate_Bool_Exp = {
  count: InputMaybe<BulletinDepartments_Aggregate_Bool_Exp_Count>
}

export type BulletinDepartments_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<BulletinDepartments_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<BulletinDepartments_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.bulletin_department" */
export type BulletinDepartments_Aggregate_Fields = {
  __typename?: 'bulletinDepartments_aggregate_fields'
  avg: Maybe<BulletinDepartments_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<BulletinDepartments_Max_Fields>
  min: Maybe<BulletinDepartments_Min_Fields>
  stddev: Maybe<BulletinDepartments_Stddev_Fields>
  stddev_pop: Maybe<BulletinDepartments_Stddev_Pop_Fields>
  stddev_samp: Maybe<BulletinDepartments_Stddev_Samp_Fields>
  sum: Maybe<BulletinDepartments_Sum_Fields>
  var_pop: Maybe<BulletinDepartments_Var_Pop_Fields>
  var_samp: Maybe<BulletinDepartments_Var_Samp_Fields>
  variance: Maybe<BulletinDepartments_Variance_Fields>
}

/** aggregate fields of "v2.bulletin_department" */
export type BulletinDepartments_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<BulletinDepartments_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.bulletin_department" */
export type BulletinDepartments_Aggregate_Order_By = {
  avg: InputMaybe<BulletinDepartments_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<BulletinDepartments_Max_Order_By>
  min: InputMaybe<BulletinDepartments_Min_Order_By>
  stddev: InputMaybe<BulletinDepartments_Stddev_Order_By>
  stddev_pop: InputMaybe<BulletinDepartments_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<BulletinDepartments_Stddev_Samp_Order_By>
  sum: InputMaybe<BulletinDepartments_Sum_Order_By>
  var_pop: InputMaybe<BulletinDepartments_Var_Pop_Order_By>
  var_samp: InputMaybe<BulletinDepartments_Var_Samp_Order_By>
  variance: InputMaybe<BulletinDepartments_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.bulletin_department" */
export type BulletinDepartments_Arr_Rel_Insert_Input = {
  data: Array<BulletinDepartments_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<BulletinDepartments_On_Conflict>
}

/** aggregate avg on columns */
export type BulletinDepartments_Avg_Fields = {
  __typename?: 'bulletinDepartments_avg_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Avg_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.bulletin_department". All fields are combined with a logical 'AND'. */
export type BulletinDepartments_Bool_Exp = {
  _and: InputMaybe<Array<BulletinDepartments_Bool_Exp>>
  _not: InputMaybe<BulletinDepartments_Bool_Exp>
  _or: InputMaybe<Array<BulletinDepartments_Bool_Exp>>
  bulletin: InputMaybe<Bulletins_Bool_Exp>
  bulletinId: InputMaybe<Int_Comparison_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.bulletin_department" */
export enum BulletinDepartments_Constraint {
  /** unique or primary key constraint on columns "department_id", "bulletin_id" */
  BulletinDepartmentPkey = 'bulletin_department_pkey'
}

/** input type for incrementing numeric columns in table "v2.bulletin_department" */
export type BulletinDepartments_Inc_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.bulletin_department" */
export type BulletinDepartments_Insert_Input = {
  bulletin: InputMaybe<Bulletins_Obj_Rel_Insert_Input>
  bulletinId: InputMaybe<Scalars['Int']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type BulletinDepartments_Max_Fields = {
  __typename?: 'bulletinDepartments_max_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Max_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type BulletinDepartments_Min_Fields = {
  __typename?: 'bulletinDepartments_min_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Min_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.bulletin_department" */
export type BulletinDepartments_Mutation_Response = {
  __typename?: 'bulletinDepartments_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<BulletinDepartments>
}

/** on_conflict condition type for table "v2.bulletin_department" */
export type BulletinDepartments_On_Conflict = {
  constraint: BulletinDepartments_Constraint
  update_columns: Array<BulletinDepartments_Update_Column>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

/** Ordering options when selecting data from "v2.bulletin_department". */
export type BulletinDepartments_Order_By = {
  bulletin: InputMaybe<Bulletins_Order_By>
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.bulletin_department */
export type BulletinDepartments_Pk_Columns_Input = {
  bulletinId: Scalars['Int']['input']
  departmentId: Scalars['Int']['input']
}

/** select columns of table "v2.bulletin_department" */
export enum BulletinDepartments_Select_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  DepartmentId = 'departmentId'
}

/** input type for updating data in table "v2.bulletin_department" */
export type BulletinDepartments_Set_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type BulletinDepartments_Stddev_Fields = {
  __typename?: 'bulletinDepartments_stddev_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Stddev_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type BulletinDepartments_Stddev_Pop_Fields = {
  __typename?: 'bulletinDepartments_stddev_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Stddev_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type BulletinDepartments_Stddev_Samp_Fields = {
  __typename?: 'bulletinDepartments_stddev_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Stddev_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "bulletinDepartments" */
export type BulletinDepartments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BulletinDepartments_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type BulletinDepartments_Stream_Cursor_Value_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type BulletinDepartments_Sum_Fields = {
  __typename?: 'bulletinDepartments_sum_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Sum_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** update columns of table "v2.bulletin_department" */
export enum BulletinDepartments_Update_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  DepartmentId = 'departmentId'
}

export type BulletinDepartments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<BulletinDepartments_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<BulletinDepartments_Set_Input>
  /** filter the rows which have to be updated */
  where: BulletinDepartments_Bool_Exp
}

/** aggregate var_pop on columns */
export type BulletinDepartments_Var_Pop_Fields = {
  __typename?: 'bulletinDepartments_var_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Var_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type BulletinDepartments_Var_Samp_Fields = {
  __typename?: 'bulletinDepartments_var_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Var_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type BulletinDepartments_Variance_Fields = {
  __typename?: 'bulletinDepartments_variance_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.bulletin_department" */
export type BulletinDepartments_Variance_Order_By = {
  bulletinId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.bulletins" */
export type Bulletins = {
  __typename?: 'bulletins'
  /** An object relationship */
  author: Maybe<Users>
  authorId: Scalars['Int']['output']
  /** An array relationship */
  bulletinDepartments: Array<BulletinDepartments>
  /** An aggregate relationship */
  bulletinDepartments_aggregate: BulletinDepartments_Aggregate
  /** An array relationship */
  bulletinResources: Array<BulletinsResources>
  /** An aggregate relationship */
  bulletinResources_aggregate: BulletinsResources_Aggregate
  /** An array relationship */
  comments: Array<Comments>
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate
  createdAt: Scalars['timestamptz']['output']
  global: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  /** A computed field, executes function "v2.bulletins_lead_email_thumb_url" */
  leadEmailThumbUrl: Maybe<Scalars['String']['output']>
  leadImageUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.bulletins_lead_thumb_url" */
  leadThumbUrl: Maybe<Scalars['String']['output']>
  /** A computed field, executes function "v2.bulletins_lead_web_url" */
  leadWebUrl: Maybe<Scalars['String']['output']>
  modelType: Scalars['bpchar']['output']
  post: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsBulletinDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsBulletinDepartments_AggregateArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsBulletinResourcesArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsBulletinResources_AggregateArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsCommentsArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** columns and relationships of "v2.bulletins" */
export type BulletinsComments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** columns and relationships of "v2.bulletins_resources" */
export type BulletinsResources = {
  __typename?: 'bulletinsResources'
  bulletinId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  /** An object relationship */
  resource: Maybe<Resources>
  resourceId: Scalars['Int']['output']
}

/** aggregated selection of "v2.bulletins_resources" */
export type BulletinsResources_Aggregate = {
  __typename?: 'bulletinsResources_aggregate'
  aggregate: Maybe<BulletinsResources_Aggregate_Fields>
  nodes: Array<BulletinsResources>
}

export type BulletinsResources_Aggregate_Bool_Exp = {
  count: InputMaybe<BulletinsResources_Aggregate_Bool_Exp_Count>
}

export type BulletinsResources_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<BulletinsResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<BulletinsResources_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.bulletins_resources" */
export type BulletinsResources_Aggregate_Fields = {
  __typename?: 'bulletinsResources_aggregate_fields'
  avg: Maybe<BulletinsResources_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<BulletinsResources_Max_Fields>
  min: Maybe<BulletinsResources_Min_Fields>
  stddev: Maybe<BulletinsResources_Stddev_Fields>
  stddev_pop: Maybe<BulletinsResources_Stddev_Pop_Fields>
  stddev_samp: Maybe<BulletinsResources_Stddev_Samp_Fields>
  sum: Maybe<BulletinsResources_Sum_Fields>
  var_pop: Maybe<BulletinsResources_Var_Pop_Fields>
  var_samp: Maybe<BulletinsResources_Var_Samp_Fields>
  variance: Maybe<BulletinsResources_Variance_Fields>
}

/** aggregate fields of "v2.bulletins_resources" */
export type BulletinsResources_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<BulletinsResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.bulletins_resources" */
export type BulletinsResources_Aggregate_Order_By = {
  avg: InputMaybe<BulletinsResources_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<BulletinsResources_Max_Order_By>
  min: InputMaybe<BulletinsResources_Min_Order_By>
  stddev: InputMaybe<BulletinsResources_Stddev_Order_By>
  stddev_pop: InputMaybe<BulletinsResources_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<BulletinsResources_Stddev_Samp_Order_By>
  sum: InputMaybe<BulletinsResources_Sum_Order_By>
  var_pop: InputMaybe<BulletinsResources_Var_Pop_Order_By>
  var_samp: InputMaybe<BulletinsResources_Var_Samp_Order_By>
  variance: InputMaybe<BulletinsResources_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.bulletins_resources" */
export type BulletinsResources_Arr_Rel_Insert_Input = {
  data: Array<BulletinsResources_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<BulletinsResources_On_Conflict>
}

/** aggregate avg on columns */
export type BulletinsResources_Avg_Fields = {
  __typename?: 'bulletinsResources_avg_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Avg_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.bulletins_resources". All fields are combined with a logical 'AND'. */
export type BulletinsResources_Bool_Exp = {
  _and: InputMaybe<Array<BulletinsResources_Bool_Exp>>
  _not: InputMaybe<BulletinsResources_Bool_Exp>
  _or: InputMaybe<Array<BulletinsResources_Bool_Exp>>
  bulletinId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  resource: InputMaybe<Resources_Bool_Exp>
  resourceId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.bulletins_resources" */
export enum BulletinsResources_Constraint {
  /** unique or primary key constraint on columns "id" */
  BulletinsResourcesPkey = 'bulletins_resources_pkey'
}

/** input type for incrementing numeric columns in table "v2.bulletins_resources" */
export type BulletinsResources_Inc_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.bulletins_resources" */
export type BulletinsResources_Insert_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resource: InputMaybe<Resources_Obj_Rel_Insert_Input>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type BulletinsResources_Max_Fields = {
  __typename?: 'bulletinsResources_max_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Max_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type BulletinsResources_Min_Fields = {
  __typename?: 'bulletinsResources_min_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Min_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.bulletins_resources" */
export type BulletinsResources_Mutation_Response = {
  __typename?: 'bulletinsResources_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<BulletinsResources>
}

/** on_conflict condition type for table "v2.bulletins_resources" */
export type BulletinsResources_On_Conflict = {
  constraint: BulletinsResources_Constraint
  update_columns: Array<BulletinsResources_Update_Column>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

/** Ordering options when selecting data from "v2.bulletins_resources". */
export type BulletinsResources_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resource: InputMaybe<Resources_Order_By>
  resourceId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.bulletins_resources */
export type BulletinsResources_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.bulletins_resources" */
export enum BulletinsResources_Select_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId'
}

/** input type for updating data in table "v2.bulletins_resources" */
export type BulletinsResources_Set_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type BulletinsResources_Stddev_Fields = {
  __typename?: 'bulletinsResources_stddev_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Stddev_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type BulletinsResources_Stddev_Pop_Fields = {
  __typename?: 'bulletinsResources_stddev_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Stddev_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type BulletinsResources_Stddev_Samp_Fields = {
  __typename?: 'bulletinsResources_stddev_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Stddev_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "bulletinsResources" */
export type BulletinsResources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BulletinsResources_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type BulletinsResources_Stream_Cursor_Value_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type BulletinsResources_Sum_Fields = {
  __typename?: 'bulletinsResources_sum_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Sum_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** update columns of table "v2.bulletins_resources" */
export enum BulletinsResources_Update_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId'
}

export type BulletinsResources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<BulletinsResources_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<BulletinsResources_Set_Input>
  /** filter the rows which have to be updated */
  where: BulletinsResources_Bool_Exp
}

/** aggregate var_pop on columns */
export type BulletinsResources_Var_Pop_Fields = {
  __typename?: 'bulletinsResources_var_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Var_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type BulletinsResources_Var_Samp_Fields = {
  __typename?: 'bulletinsResources_var_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Var_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type BulletinsResources_Variance_Fields = {
  __typename?: 'bulletinsResources_variance_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.bulletins_resources" */
export type BulletinsResources_Variance_Order_By = {
  bulletinId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregated selection of "v2.bulletins" */
export type Bulletins_Aggregate = {
  __typename?: 'bulletins_aggregate'
  aggregate: Maybe<Bulletins_Aggregate_Fields>
  nodes: Array<Bulletins>
}

/** aggregate fields of "v2.bulletins" */
export type Bulletins_Aggregate_Fields = {
  __typename?: 'bulletins_aggregate_fields'
  avg: Maybe<Bulletins_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Bulletins_Max_Fields>
  min: Maybe<Bulletins_Min_Fields>
  stddev: Maybe<Bulletins_Stddev_Fields>
  stddev_pop: Maybe<Bulletins_Stddev_Pop_Fields>
  stddev_samp: Maybe<Bulletins_Stddev_Samp_Fields>
  sum: Maybe<Bulletins_Sum_Fields>
  var_pop: Maybe<Bulletins_Var_Pop_Fields>
  var_samp: Maybe<Bulletins_Var_Samp_Fields>
  variance: Maybe<Bulletins_Variance_Fields>
}

/** aggregate fields of "v2.bulletins" */
export type Bulletins_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Bulletins_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Bulletins_Avg_Fields = {
  __typename?: 'bulletins_avg_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.bulletins". All fields are combined with a logical 'AND'. */
export type Bulletins_Bool_Exp = {
  _and: InputMaybe<Array<Bulletins_Bool_Exp>>
  _not: InputMaybe<Bulletins_Bool_Exp>
  _or: InputMaybe<Array<Bulletins_Bool_Exp>>
  author: InputMaybe<Users_Bool_Exp>
  authorId: InputMaybe<Int_Comparison_Exp>
  bulletinDepartments: InputMaybe<BulletinDepartments_Bool_Exp>
  bulletinDepartments_aggregate: InputMaybe<BulletinDepartments_Aggregate_Bool_Exp>
  bulletinResources: InputMaybe<BulletinsResources_Bool_Exp>
  bulletinResources_aggregate: InputMaybe<BulletinsResources_Aggregate_Bool_Exp>
  comments: InputMaybe<Comments_Bool_Exp>
  comments_aggregate: InputMaybe<Comments_Aggregate_Bool_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  global: InputMaybe<Boolean_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  leadEmailThumbUrl: InputMaybe<String_Comparison_Exp>
  leadImageUploadId: InputMaybe<Int_Comparison_Exp>
  leadThumbUrl: InputMaybe<String_Comparison_Exp>
  leadWebUrl: InputMaybe<String_Comparison_Exp>
  modelType: InputMaybe<Bpchar_Comparison_Exp>
  post: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.bulletins" */
export enum Bulletins_Constraint {
  /** unique or primary key constraint on columns "id" */
  BulletinsPkey = 'bulletins_pkey'
}

/** input type for incrementing numeric columns in table "v2.bulletins" */
export type Bulletins_Inc_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  leadImageUploadId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.bulletins" */
export type Bulletins_Insert_Input = {
  author: InputMaybe<Users_Obj_Rel_Insert_Input>
  authorId: InputMaybe<Scalars['Int']['input']>
  bulletinDepartments: InputMaybe<BulletinDepartments_Arr_Rel_Insert_Input>
  bulletinResources: InputMaybe<BulletinsResources_Arr_Rel_Insert_Input>
  comments: InputMaybe<Comments_Arr_Rel_Insert_Input>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  leadImageUploadId: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Bulletins_Max_Fields = {
  __typename?: 'bulletins_max_fields'
  authorId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.bulletins_lead_email_thumb_url" */
  leadEmailThumbUrl: Maybe<Scalars['String']['output']>
  leadImageUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.bulletins_lead_thumb_url" */
  leadThumbUrl: Maybe<Scalars['String']['output']>
  /** A computed field, executes function "v2.bulletins_lead_web_url" */
  leadWebUrl: Maybe<Scalars['String']['output']>
  modelType: Maybe<Scalars['bpchar']['output']>
  post: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Bulletins_Min_Fields = {
  __typename?: 'bulletins_min_fields'
  authorId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.bulletins_lead_email_thumb_url" */
  leadEmailThumbUrl: Maybe<Scalars['String']['output']>
  leadImageUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.bulletins_lead_thumb_url" */
  leadThumbUrl: Maybe<Scalars['String']['output']>
  /** A computed field, executes function "v2.bulletins_lead_web_url" */
  leadWebUrl: Maybe<Scalars['String']['output']>
  modelType: Maybe<Scalars['bpchar']['output']>
  post: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.bulletins" */
export type Bulletins_Mutation_Response = {
  __typename?: 'bulletins_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Bulletins>
}

/** input type for inserting object relation for remote table "v2.bulletins" */
export type Bulletins_Obj_Rel_Insert_Input = {
  data: Bulletins_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Bulletins_On_Conflict>
}

/** on_conflict condition type for table "v2.bulletins" */
export type Bulletins_On_Conflict = {
  constraint: Bulletins_Constraint
  update_columns: Array<Bulletins_Update_Column>
  where: InputMaybe<Bulletins_Bool_Exp>
}

/** Ordering options when selecting data from "v2.bulletins". */
export type Bulletins_Order_By = {
  author: InputMaybe<Users_Order_By>
  authorId: InputMaybe<Order_By>
  bulletinDepartments_aggregate: InputMaybe<BulletinDepartments_Aggregate_Order_By>
  bulletinResources_aggregate: InputMaybe<BulletinsResources_Aggregate_Order_By>
  comments_aggregate: InputMaybe<Comments_Aggregate_Order_By>
  createdAt: InputMaybe<Order_By>
  global: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  leadEmailThumbUrl: InputMaybe<Order_By>
  leadImageUploadId: InputMaybe<Order_By>
  leadThumbUrl: InputMaybe<Order_By>
  leadWebUrl: InputMaybe<Order_By>
  modelType: InputMaybe<Order_By>
  post: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.bulletins */
export type Bulletins_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.bulletins" */
export enum Bulletins_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Global = 'global',
  /** column name */
  Id = 'id',
  /** column name */
  LeadImageUploadId = 'leadImageUploadId',
  /** column name */
  ModelType = 'modelType',
  /** column name */
  Post = 'post',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.bulletins" */
export type Bulletins_Set_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  leadImageUploadId: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Bulletins_Stddev_Fields = {
  __typename?: 'bulletins_stddev_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Bulletins_Stddev_Pop_Fields = {
  __typename?: 'bulletins_stddev_pop_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Bulletins_Stddev_Samp_Fields = {
  __typename?: 'bulletins_stddev_samp_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "bulletins" */
export type Bulletins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bulletins_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Bulletins_Stream_Cursor_Value_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  leadImageUploadId: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Bulletins_Sum_Fields = {
  __typename?: 'bulletins_sum_fields'
  authorId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  leadImageUploadId: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.bulletins" */
export enum Bulletins_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Global = 'global',
  /** column name */
  Id = 'id',
  /** column name */
  LeadImageUploadId = 'leadImageUploadId',
  /** column name */
  ModelType = 'modelType',
  /** column name */
  Post = 'post',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Bulletins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Bulletins_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Bulletins_Set_Input>
  /** filter the rows which have to be updated */
  where: Bulletins_Bool_Exp
}

/** aggregate var_pop on columns */
export type Bulletins_Var_Pop_Fields = {
  __typename?: 'bulletins_var_pop_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Bulletins_Var_Samp_Fields = {
  __typename?: 'bulletins_var_samp_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Bulletins_Variance_Fields = {
  __typename?: 'bulletins_variance_fields'
  authorId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  leadImageUploadId: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.camera_embeds" */
export type CameraEmbeds = {
  __typename?: 'cameraEmbeds'
  active: Scalars['Boolean']['output']
  createdAt: Scalars['timestamptz']['output']
  id: Scalars['Int']['output']
  /** An object relationship */
  jobsite: Maybe<Jobsites>
  jobsiteId: Maybe<Scalars['Int']['output']>
  source: Scalars['String']['output']
  stillUrl: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** aggregated selection of "v2.camera_embeds" */
export type CameraEmbeds_Aggregate = {
  __typename?: 'cameraEmbeds_aggregate'
  aggregate: Maybe<CameraEmbeds_Aggregate_Fields>
  nodes: Array<CameraEmbeds>
}

/** aggregate fields of "v2.camera_embeds" */
export type CameraEmbeds_Aggregate_Fields = {
  __typename?: 'cameraEmbeds_aggregate_fields'
  avg: Maybe<CameraEmbeds_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<CameraEmbeds_Max_Fields>
  min: Maybe<CameraEmbeds_Min_Fields>
  stddev: Maybe<CameraEmbeds_Stddev_Fields>
  stddev_pop: Maybe<CameraEmbeds_Stddev_Pop_Fields>
  stddev_samp: Maybe<CameraEmbeds_Stddev_Samp_Fields>
  sum: Maybe<CameraEmbeds_Sum_Fields>
  var_pop: Maybe<CameraEmbeds_Var_Pop_Fields>
  var_samp: Maybe<CameraEmbeds_Var_Samp_Fields>
  variance: Maybe<CameraEmbeds_Variance_Fields>
}

/** aggregate fields of "v2.camera_embeds" */
export type CameraEmbeds_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<CameraEmbeds_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type CameraEmbeds_Avg_Fields = {
  __typename?: 'cameraEmbeds_avg_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.camera_embeds". All fields are combined with a logical 'AND'. */
export type CameraEmbeds_Bool_Exp = {
  _and: InputMaybe<Array<CameraEmbeds_Bool_Exp>>
  _not: InputMaybe<CameraEmbeds_Bool_Exp>
  _or: InputMaybe<Array<CameraEmbeds_Bool_Exp>>
  active: InputMaybe<Boolean_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  jobsite: InputMaybe<Jobsites_Bool_Exp>
  jobsiteId: InputMaybe<Int_Comparison_Exp>
  source: InputMaybe<String_Comparison_Exp>
  stillUrl: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.camera_embeds" */
export enum CameraEmbeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  CameraEmbedsPkey = 'camera_embeds_pkey'
}

/** input type for incrementing numeric columns in table "v2.camera_embeds" */
export type CameraEmbeds_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.camera_embeds" */
export type CameraEmbeds_Insert_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  jobsite: InputMaybe<Jobsites_Obj_Rel_Insert_Input>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  source: InputMaybe<Scalars['String']['input']>
  stillUrl: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type CameraEmbeds_Max_Fields = {
  __typename?: 'cameraEmbeds_max_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
  source: Maybe<Scalars['String']['output']>
  stillUrl: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type CameraEmbeds_Min_Fields = {
  __typename?: 'cameraEmbeds_min_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
  source: Maybe<Scalars['String']['output']>
  stillUrl: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.camera_embeds" */
export type CameraEmbeds_Mutation_Response = {
  __typename?: 'cameraEmbeds_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<CameraEmbeds>
}

/** on_conflict condition type for table "v2.camera_embeds" */
export type CameraEmbeds_On_Conflict = {
  constraint: CameraEmbeds_Constraint
  update_columns: Array<CameraEmbeds_Update_Column>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

/** Ordering options when selecting data from "v2.camera_embeds". */
export type CameraEmbeds_Order_By = {
  active: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsite: InputMaybe<Jobsites_Order_By>
  jobsiteId: InputMaybe<Order_By>
  source: InputMaybe<Order_By>
  stillUrl: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.camera_embeds */
export type CameraEmbeds_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.camera_embeds" */
export enum CameraEmbeds_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobsiteId = 'jobsiteId',
  /** column name */
  Source = 'source',
  /** column name */
  StillUrl = 'stillUrl',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.camera_embeds" */
export type CameraEmbeds_Set_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  source: InputMaybe<Scalars['String']['input']>
  stillUrl: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type CameraEmbeds_Stddev_Fields = {
  __typename?: 'cameraEmbeds_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type CameraEmbeds_Stddev_Pop_Fields = {
  __typename?: 'cameraEmbeds_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type CameraEmbeds_Stddev_Samp_Fields = {
  __typename?: 'cameraEmbeds_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "cameraEmbeds" */
export type CameraEmbeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CameraEmbeds_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type CameraEmbeds_Stream_Cursor_Value_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  source: InputMaybe<Scalars['String']['input']>
  stillUrl: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type CameraEmbeds_Sum_Fields = {
  __typename?: 'cameraEmbeds_sum_fields'
  id: Maybe<Scalars['Int']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.camera_embeds" */
export enum CameraEmbeds_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobsiteId = 'jobsiteId',
  /** column name */
  Source = 'source',
  /** column name */
  StillUrl = 'stillUrl',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CameraEmbeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<CameraEmbeds_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<CameraEmbeds_Set_Input>
  /** filter the rows which have to be updated */
  where: CameraEmbeds_Bool_Exp
}

/** aggregate var_pop on columns */
export type CameraEmbeds_Var_Pop_Fields = {
  __typename?: 'cameraEmbeds_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type CameraEmbeds_Var_Samp_Fields = {
  __typename?: 'cameraEmbeds_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type CameraEmbeds_Variance_Fields = {
  __typename?: 'cameraEmbeds_variance_fields'
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.comments" */
export type Comments = {
  __typename?: 'comments'
  /** An object relationship */
  bulletin: Maybe<Bulletins>
  bulletinId: Maybe<Scalars['Int']['output']>
  comment: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  /** An object relationship */
  discussion: Maybe<Discussions>
  discussionId: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  nominationId: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Maybe<Users>
  userId: Scalars['Int']['output']
}

/** aggregated selection of "v2.comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate'
  aggregate: Maybe<Comments_Aggregate_Fields>
  nodes: Array<Comments>
}

export type Comments_Aggregate_Bool_Exp = {
  count: InputMaybe<Comments_Aggregate_Bool_Exp_Count>
}

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Comments_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Comments_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields'
  avg: Maybe<Comments_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Comments_Max_Fields>
  min: Maybe<Comments_Min_Fields>
  stddev: Maybe<Comments_Stddev_Fields>
  stddev_pop: Maybe<Comments_Stddev_Pop_Fields>
  stddev_samp: Maybe<Comments_Stddev_Samp_Fields>
  sum: Maybe<Comments_Sum_Fields>
  var_pop: Maybe<Comments_Var_Pop_Fields>
  var_samp: Maybe<Comments_Var_Samp_Fields>
  variance: Maybe<Comments_Variance_Fields>
}

/** aggregate fields of "v2.comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Comments_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.comments" */
export type Comments_Aggregate_Order_By = {
  avg: InputMaybe<Comments_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<Comments_Max_Order_By>
  min: InputMaybe<Comments_Min_Order_By>
  stddev: InputMaybe<Comments_Stddev_Order_By>
  stddev_pop: InputMaybe<Comments_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<Comments_Stddev_Samp_Order_By>
  sum: InputMaybe<Comments_Sum_Order_By>
  var_pop: InputMaybe<Comments_Var_Pop_Order_By>
  var_samp: InputMaybe<Comments_Var_Samp_Order_By>
  variance: InputMaybe<Comments_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<Comments_On_Conflict>
}

/** aggregate avg on columns */
export type Comments_Avg_Fields = {
  __typename?: 'comments_avg_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.comments" */
export type Comments_Avg_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and: InputMaybe<Array<Comments_Bool_Exp>>
  _not: InputMaybe<Comments_Bool_Exp>
  _or: InputMaybe<Array<Comments_Bool_Exp>>
  bulletin: InputMaybe<Bulletins_Bool_Exp>
  bulletinId: InputMaybe<Int_Comparison_Exp>
  comment: InputMaybe<String_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  discussion: InputMaybe<Discussions_Bool_Exp>
  discussionId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  nominationId: InputMaybe<Int_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
  user: InputMaybe<Users_Bool_Exp>
  userId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey'
}

/** input type for incrementing numeric columns in table "v2.comments" */
export type Comments_Inc_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  nominationId: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.comments" */
export type Comments_Insert_Input = {
  bulletin: InputMaybe<Bulletins_Obj_Rel_Insert_Input>
  bulletinId: InputMaybe<Scalars['Int']['input']>
  comment: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  discussion: InputMaybe<Discussions_Obj_Rel_Insert_Input>
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  nominationId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  user: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  comment: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  nominationId: Maybe<Scalars['Int']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.comments" */
export type Comments_Max_Order_By = {
  bulletinId: InputMaybe<Order_By>
  comment: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  comment: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  nominationId: Maybe<Scalars['Int']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.comments" */
export type Comments_Min_Order_By = {
  bulletinId: InputMaybe<Order_By>
  comment: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Comments>
}

/** on_conflict condition type for table "v2.comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint
  update_columns: Array<Comments_Update_Column>
  where: InputMaybe<Comments_Bool_Exp>
}

/** Ordering options when selecting data from "v2.comments". */
export type Comments_Order_By = {
  bulletin: InputMaybe<Bulletins_Order_By>
  bulletinId: InputMaybe<Order_By>
  comment: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  discussion: InputMaybe<Discussions_Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  user: InputMaybe<Users_Order_By>
  userId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.comments" */
export enum Comments_Select_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscussionId = 'discussionId',
  /** column name */
  Id = 'id',
  /** column name */
  NominationId = 'nominationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "v2.comments" */
export type Comments_Set_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  comment: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  nominationId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type Comments_Stddev_Fields = {
  __typename?: 'comments_stddev_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.comments" */
export type Comments_Stddev_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Comments_Stddev_Pop_Fields = {
  __typename?: 'comments_stddev_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.comments" */
export type Comments_Stddev_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Comments_Stddev_Samp_Fields = {
  __typename?: 'comments_stddev_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.comments" */
export type Comments_Stddev_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  bulletinId: InputMaybe<Scalars['Int']['input']>
  comment: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  nominationId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type Comments_Sum_Fields = {
  __typename?: 'comments_sum_fields'
  bulletinId: Maybe<Scalars['Int']['output']>
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  nominationId: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.comments" */
export type Comments_Sum_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** update columns of table "v2.comments" */
export enum Comments_Update_Column {
  /** column name */
  BulletinId = 'bulletinId',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DiscussionId = 'discussionId',
  /** column name */
  Id = 'id',
  /** column name */
  NominationId = 'nominationId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Comments_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Comments_Set_Input>
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp
}

/** aggregate var_pop on columns */
export type Comments_Var_Pop_Fields = {
  __typename?: 'comments_var_pop_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.comments" */
export type Comments_Var_Pop_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Comments_Var_Samp_Fields = {
  __typename?: 'comments_var_samp_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.comments" */
export type Comments_Var_Samp_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Comments_Variance_Fields = {
  __typename?: 'comments_variance_fields'
  bulletinId: Maybe<Scalars['Float']['output']>
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  nominationId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.comments" */
export type Comments_Variance_Order_By = {
  bulletinId: InputMaybe<Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  nominationId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.config" */
export type Config = {
  __typename?: 'config'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

/** aggregated selection of "v2.config" */
export type Config_Aggregate = {
  __typename?: 'config_aggregate'
  aggregate: Maybe<Config_Aggregate_Fields>
  nodes: Array<Config>
}

/** aggregate fields of "v2.config" */
export type Config_Aggregate_Fields = {
  __typename?: 'config_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<Config_Max_Fields>
  min: Maybe<Config_Min_Fields>
}

/** aggregate fields of "v2.config" */
export type Config_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Config_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.config". All fields are combined with a logical 'AND'. */
export type Config_Bool_Exp = {
  _and: InputMaybe<Array<Config_Bool_Exp>>
  _not: InputMaybe<Config_Bool_Exp>
  _or: InputMaybe<Array<Config_Bool_Exp>>
  key: InputMaybe<String_Comparison_Exp>
  value: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.config" */
export enum Config_Constraint {
  /** unique or primary key constraint on columns "key" */
  ConfigPkey = 'config_pkey'
}

/** input type for inserting data into table "v2.config" */
export type Config_Insert_Input = {
  key: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Config_Max_Fields = {
  __typename?: 'config_max_fields'
  key: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Config_Min_Fields = {
  __typename?: 'config_min_fields'
  key: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.config" */
export type Config_Mutation_Response = {
  __typename?: 'config_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Config>
}

/** on_conflict condition type for table "v2.config" */
export type Config_On_Conflict = {
  constraint: Config_Constraint
  update_columns: Array<Config_Update_Column>
  where: InputMaybe<Config_Bool_Exp>
}

/** Ordering options when selecting data from "v2.config". */
export type Config_Order_By = {
  key: InputMaybe<Order_By>
  value: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.config */
export type Config_Pk_Columns_Input = {
  key: Scalars['String']['input']
}

/** select columns of table "v2.config" */
export enum Config_Select_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "v2.config" */
export type Config_Set_Input = {
  key: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "config" */
export type Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Config_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Config_Stream_Cursor_Value_Input = {
  key: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "v2.config" */
export enum Config_Update_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Config_Set_Input>
  /** filter the rows which have to be updated */
  where: Config_Bool_Exp
}

/** columns and relationships of "v2.department_contents" */
export type Contents = {
  __typename?: 'contents'
  active: Scalars['Boolean']['output']
  body: Maybe<Scalars['String']['output']>
  /** An array relationship */
  contentResources: Array<ContentsResources>
  /** An aggregate relationship */
  contentResources_aggregate: ContentsResources_Aggregate
  /** An array relationship */
  contents: Array<Contents>
  /** An aggregate relationship */
  contents_aggregate: Contents_Aggregate
  createdAt: Scalars['timestamptz']['output']
  departmentId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  parentId: Maybe<Scalars['Int']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.department_contents" */
export type ContentsContentResourcesArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

/** columns and relationships of "v2.department_contents" */
export type ContentsContentResources_AggregateArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

/** columns and relationships of "v2.department_contents" */
export type ContentsContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

/** columns and relationships of "v2.department_contents" */
export type ContentsContents_AggregateArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

/** columns and relationships of "v2.department_contents_resources" */
export type ContentsResources = {
  __typename?: 'contentsResources'
  /** An object relationship */
  departmentContent: Maybe<Contents>
  departmentContentId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  /** An object relationship */
  resource: Maybe<Resources>
  resourceId: Scalars['Int']['output']
}

/** aggregated selection of "v2.department_contents_resources" */
export type ContentsResources_Aggregate = {
  __typename?: 'contentsResources_aggregate'
  aggregate: Maybe<ContentsResources_Aggregate_Fields>
  nodes: Array<ContentsResources>
}

export type ContentsResources_Aggregate_Bool_Exp = {
  count: InputMaybe<ContentsResources_Aggregate_Bool_Exp_Count>
}

export type ContentsResources_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<ContentsResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<ContentsResources_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.department_contents_resources" */
export type ContentsResources_Aggregate_Fields = {
  __typename?: 'contentsResources_aggregate_fields'
  avg: Maybe<ContentsResources_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<ContentsResources_Max_Fields>
  min: Maybe<ContentsResources_Min_Fields>
  stddev: Maybe<ContentsResources_Stddev_Fields>
  stddev_pop: Maybe<ContentsResources_Stddev_Pop_Fields>
  stddev_samp: Maybe<ContentsResources_Stddev_Samp_Fields>
  sum: Maybe<ContentsResources_Sum_Fields>
  var_pop: Maybe<ContentsResources_Var_Pop_Fields>
  var_samp: Maybe<ContentsResources_Var_Samp_Fields>
  variance: Maybe<ContentsResources_Variance_Fields>
}

/** aggregate fields of "v2.department_contents_resources" */
export type ContentsResources_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<ContentsResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.department_contents_resources" */
export type ContentsResources_Aggregate_Order_By = {
  avg: InputMaybe<ContentsResources_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<ContentsResources_Max_Order_By>
  min: InputMaybe<ContentsResources_Min_Order_By>
  stddev: InputMaybe<ContentsResources_Stddev_Order_By>
  stddev_pop: InputMaybe<ContentsResources_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<ContentsResources_Stddev_Samp_Order_By>
  sum: InputMaybe<ContentsResources_Sum_Order_By>
  var_pop: InputMaybe<ContentsResources_Var_Pop_Order_By>
  var_samp: InputMaybe<ContentsResources_Var_Samp_Order_By>
  variance: InputMaybe<ContentsResources_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.department_contents_resources" */
export type ContentsResources_Arr_Rel_Insert_Input = {
  data: Array<ContentsResources_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<ContentsResources_On_Conflict>
}

/** aggregate avg on columns */
export type ContentsResources_Avg_Fields = {
  __typename?: 'contentsResources_avg_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Avg_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.department_contents_resources". All fields are combined with a logical 'AND'. */
export type ContentsResources_Bool_Exp = {
  _and: InputMaybe<Array<ContentsResources_Bool_Exp>>
  _not: InputMaybe<ContentsResources_Bool_Exp>
  _or: InputMaybe<Array<ContentsResources_Bool_Exp>>
  departmentContent: InputMaybe<Contents_Bool_Exp>
  departmentContentId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  resource: InputMaybe<Resources_Bool_Exp>
  resourceId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.department_contents_resources" */
export enum ContentsResources_Constraint {
  /** unique or primary key constraint on columns "resource_id", "department_content_id" */
  DepartmentContentsResourcesDepartmentContentIdResourcKey = 'department_contents_resources_department_content_id_resourc_key',
  /** unique or primary key constraint on columns "id" */
  DepartmentContentsResourcesPkey = 'department_contents_resources_pkey'
}

/** input type for incrementing numeric columns in table "v2.department_contents_resources" */
export type ContentsResources_Inc_Input = {
  departmentContentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.department_contents_resources" */
export type ContentsResources_Insert_Input = {
  departmentContent: InputMaybe<Contents_Obj_Rel_Insert_Input>
  departmentContentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resource: InputMaybe<Resources_Obj_Rel_Insert_Input>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type ContentsResources_Max_Fields = {
  __typename?: 'contentsResources_max_fields'
  departmentContentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Max_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type ContentsResources_Min_Fields = {
  __typename?: 'contentsResources_min_fields'
  departmentContentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Min_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.department_contents_resources" */
export type ContentsResources_Mutation_Response = {
  __typename?: 'contentsResources_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<ContentsResources>
}

/** input type for inserting object relation for remote table "v2.department_contents_resources" */
export type ContentsResources_Obj_Rel_Insert_Input = {
  data: ContentsResources_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<ContentsResources_On_Conflict>
}

/** on_conflict condition type for table "v2.department_contents_resources" */
export type ContentsResources_On_Conflict = {
  constraint: ContentsResources_Constraint
  update_columns: Array<ContentsResources_Update_Column>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

/** Ordering options when selecting data from "v2.department_contents_resources". */
export type ContentsResources_Order_By = {
  departmentContent: InputMaybe<Contents_Order_By>
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resource: InputMaybe<Resources_Order_By>
  resourceId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.department_contents_resources */
export type ContentsResources_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.department_contents_resources" */
export enum ContentsResources_Select_Column {
  /** column name */
  DepartmentContentId = 'departmentContentId',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId'
}

/** input type for updating data in table "v2.department_contents_resources" */
export type ContentsResources_Set_Input = {
  departmentContentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type ContentsResources_Stddev_Fields = {
  __typename?: 'contentsResources_stddev_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Stddev_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type ContentsResources_Stddev_Pop_Fields = {
  __typename?: 'contentsResources_stddev_pop_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Stddev_Pop_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type ContentsResources_Stddev_Samp_Fields = {
  __typename?: 'contentsResources_stddev_samp_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Stddev_Samp_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "contentsResources" */
export type ContentsResources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ContentsResources_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type ContentsResources_Stream_Cursor_Value_Input = {
  departmentContentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type ContentsResources_Sum_Fields = {
  __typename?: 'contentsResources_sum_fields'
  departmentContentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Sum_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** update columns of table "v2.department_contents_resources" */
export enum ContentsResources_Update_Column {
  /** column name */
  DepartmentContentId = 'departmentContentId',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId'
}

export type ContentsResources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<ContentsResources_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<ContentsResources_Set_Input>
  /** filter the rows which have to be updated */
  where: ContentsResources_Bool_Exp
}

/** aggregate var_pop on columns */
export type ContentsResources_Var_Pop_Fields = {
  __typename?: 'contentsResources_var_pop_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Var_Pop_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type ContentsResources_Var_Samp_Fields = {
  __typename?: 'contentsResources_var_samp_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Var_Samp_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type ContentsResources_Variance_Fields = {
  __typename?: 'contentsResources_variance_fields'
  departmentContentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.department_contents_resources" */
export type ContentsResources_Variance_Order_By = {
  departmentContentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
}

/** aggregated selection of "v2.department_contents" */
export type Contents_Aggregate = {
  __typename?: 'contents_aggregate'
  aggregate: Maybe<Contents_Aggregate_Fields>
  nodes: Array<Contents>
}

export type Contents_Aggregate_Bool_Exp = {
  bool_and: InputMaybe<Contents_Aggregate_Bool_Exp_Bool_And>
  bool_or: InputMaybe<Contents_Aggregate_Bool_Exp_Bool_Or>
  count: InputMaybe<Contents_Aggregate_Bool_Exp_Count>
}

export type Contents_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Contents_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Contents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Contents_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Contents_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Contents_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Contents_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.department_contents" */
export type Contents_Aggregate_Fields = {
  __typename?: 'contents_aggregate_fields'
  avg: Maybe<Contents_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Contents_Max_Fields>
  min: Maybe<Contents_Min_Fields>
  stddev: Maybe<Contents_Stddev_Fields>
  stddev_pop: Maybe<Contents_Stddev_Pop_Fields>
  stddev_samp: Maybe<Contents_Stddev_Samp_Fields>
  sum: Maybe<Contents_Sum_Fields>
  var_pop: Maybe<Contents_Var_Pop_Fields>
  var_samp: Maybe<Contents_Var_Samp_Fields>
  variance: Maybe<Contents_Variance_Fields>
}

/** aggregate fields of "v2.department_contents" */
export type Contents_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Contents_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.department_contents" */
export type Contents_Aggregate_Order_By = {
  avg: InputMaybe<Contents_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<Contents_Max_Order_By>
  min: InputMaybe<Contents_Min_Order_By>
  stddev: InputMaybe<Contents_Stddev_Order_By>
  stddev_pop: InputMaybe<Contents_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<Contents_Stddev_Samp_Order_By>
  sum: InputMaybe<Contents_Sum_Order_By>
  var_pop: InputMaybe<Contents_Var_Pop_Order_By>
  var_samp: InputMaybe<Contents_Var_Samp_Order_By>
  variance: InputMaybe<Contents_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.department_contents" */
export type Contents_Arr_Rel_Insert_Input = {
  data: Array<Contents_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<Contents_On_Conflict>
}

/** aggregate avg on columns */
export type Contents_Avg_Fields = {
  __typename?: 'contents_avg_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.department_contents" */
export type Contents_Avg_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.department_contents". All fields are combined with a logical 'AND'. */
export type Contents_Bool_Exp = {
  _and: InputMaybe<Array<Contents_Bool_Exp>>
  _not: InputMaybe<Contents_Bool_Exp>
  _or: InputMaybe<Array<Contents_Bool_Exp>>
  active: InputMaybe<Boolean_Comparison_Exp>
  body: InputMaybe<String_Comparison_Exp>
  contentResources: InputMaybe<ContentsResources_Bool_Exp>
  contentResources_aggregate: InputMaybe<ContentsResources_Aggregate_Bool_Exp>
  contents: InputMaybe<Contents_Bool_Exp>
  contents_aggregate: InputMaybe<Contents_Aggregate_Bool_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  parentId: InputMaybe<Int_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.department_contents" */
export enum Contents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentContentsPkey = 'department_contents_pkey'
}

/** input type for incrementing numeric columns in table "v2.department_contents" */
export type Contents_Inc_Input = {
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.department_contents" */
export type Contents_Insert_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  body: InputMaybe<Scalars['String']['input']>
  contentResources: InputMaybe<ContentsResources_Arr_Rel_Insert_Input>
  contents: InputMaybe<Contents_Arr_Rel_Insert_Input>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Contents_Max_Fields = {
  __typename?: 'contents_max_fields'
  body: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  parentId: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "v2.department_contents" */
export type Contents_Max_Order_By = {
  body: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Contents_Min_Fields = {
  __typename?: 'contents_min_fields'
  body: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  parentId: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "v2.department_contents" */
export type Contents_Min_Order_By = {
  body: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.department_contents" */
export type Contents_Mutation_Response = {
  __typename?: 'contents_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Contents>
}

/** input type for inserting object relation for remote table "v2.department_contents" */
export type Contents_Obj_Rel_Insert_Input = {
  data: Contents_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Contents_On_Conflict>
}

/** on_conflict condition type for table "v2.department_contents" */
export type Contents_On_Conflict = {
  constraint: Contents_Constraint
  update_columns: Array<Contents_Update_Column>
  where: InputMaybe<Contents_Bool_Exp>
}

/** Ordering options when selecting data from "v2.department_contents". */
export type Contents_Order_By = {
  active: InputMaybe<Order_By>
  body: InputMaybe<Order_By>
  contentResources_aggregate: InputMaybe<ContentsResources_Aggregate_Order_By>
  contents_aggregate: InputMaybe<Contents_Aggregate_Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.department_contents */
export type Contents_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.department_contents" */
export enum Contents_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "contents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "v2.department_contents" */
export enum Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "contents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "v2.department_contents" */
export enum Contents_Select_Column_Contents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "v2.department_contents" */
export type Contents_Set_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  body: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Contents_Stddev_Fields = {
  __typename?: 'contents_stddev_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.department_contents" */
export type Contents_Stddev_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Contents_Stddev_Pop_Fields = {
  __typename?: 'contents_stddev_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.department_contents" */
export type Contents_Stddev_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Contents_Stddev_Samp_Fields = {
  __typename?: 'contents_stddev_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.department_contents" */
export type Contents_Stddev_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "contents" */
export type Contents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contents_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Contents_Stream_Cursor_Value_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  body: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Contents_Sum_Fields = {
  __typename?: 'contents_sum_fields'
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  parentId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.department_contents" */
export type Contents_Sum_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** update columns of table "v2.department_contents" */
export enum Contents_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Contents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Contents_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Contents_Set_Input>
  /** filter the rows which have to be updated */
  where: Contents_Bool_Exp
}

/** aggregate var_pop on columns */
export type Contents_Var_Pop_Fields = {
  __typename?: 'contents_var_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.department_contents" */
export type Contents_Var_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Contents_Var_Samp_Fields = {
  __typename?: 'contents_var_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.department_contents" */
export type Contents_Var_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Contents_Variance_Fields = {
  __typename?: 'contents_variance_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  parentId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.department_contents" */
export type Contents_Variance_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  parentId: InputMaybe<Order_By>
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq: InputMaybe<Scalars['date']['input']>
  _gt: InputMaybe<Scalars['date']['input']>
  _gte: InputMaybe<Scalars['date']['input']>
  _in: InputMaybe<Array<Scalars['date']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['date']['input']>
  _lte: InputMaybe<Scalars['date']['input']>
  _neq: InputMaybe<Scalars['date']['input']>
  _nin: InputMaybe<Array<Scalars['date']['input']>>
}

/** columns and relationships of "v2.department_faqs" */
export type DepartmentFaqs = {
  __typename?: 'departmentFaqs'
  answer: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  departmentId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  question: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** aggregated selection of "v2.department_faqs" */
export type DepartmentFaqs_Aggregate = {
  __typename?: 'departmentFaqs_aggregate'
  aggregate: Maybe<DepartmentFaqs_Aggregate_Fields>
  nodes: Array<DepartmentFaqs>
}

export type DepartmentFaqs_Aggregate_Bool_Exp = {
  count: InputMaybe<DepartmentFaqs_Aggregate_Bool_Exp_Count>
}

export type DepartmentFaqs_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<DepartmentFaqs_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.department_faqs" */
export type DepartmentFaqs_Aggregate_Fields = {
  __typename?: 'departmentFaqs_aggregate_fields'
  avg: Maybe<DepartmentFaqs_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<DepartmentFaqs_Max_Fields>
  min: Maybe<DepartmentFaqs_Min_Fields>
  stddev: Maybe<DepartmentFaqs_Stddev_Fields>
  stddev_pop: Maybe<DepartmentFaqs_Stddev_Pop_Fields>
  stddev_samp: Maybe<DepartmentFaqs_Stddev_Samp_Fields>
  sum: Maybe<DepartmentFaqs_Sum_Fields>
  var_pop: Maybe<DepartmentFaqs_Var_Pop_Fields>
  var_samp: Maybe<DepartmentFaqs_Var_Samp_Fields>
  variance: Maybe<DepartmentFaqs_Variance_Fields>
}

/** aggregate fields of "v2.department_faqs" */
export type DepartmentFaqs_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.department_faqs" */
export type DepartmentFaqs_Aggregate_Order_By = {
  avg: InputMaybe<DepartmentFaqs_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<DepartmentFaqs_Max_Order_By>
  min: InputMaybe<DepartmentFaqs_Min_Order_By>
  stddev: InputMaybe<DepartmentFaqs_Stddev_Order_By>
  stddev_pop: InputMaybe<DepartmentFaqs_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<DepartmentFaqs_Stddev_Samp_Order_By>
  sum: InputMaybe<DepartmentFaqs_Sum_Order_By>
  var_pop: InputMaybe<DepartmentFaqs_Var_Pop_Order_By>
  var_samp: InputMaybe<DepartmentFaqs_Var_Samp_Order_By>
  variance: InputMaybe<DepartmentFaqs_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.department_faqs" */
export type DepartmentFaqs_Arr_Rel_Insert_Input = {
  data: Array<DepartmentFaqs_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<DepartmentFaqs_On_Conflict>
}

/** aggregate avg on columns */
export type DepartmentFaqs_Avg_Fields = {
  __typename?: 'departmentFaqs_avg_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Avg_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.department_faqs". All fields are combined with a logical 'AND'. */
export type DepartmentFaqs_Bool_Exp = {
  _and: InputMaybe<Array<DepartmentFaqs_Bool_Exp>>
  _not: InputMaybe<DepartmentFaqs_Bool_Exp>
  _or: InputMaybe<Array<DepartmentFaqs_Bool_Exp>>
  answer: InputMaybe<String_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  question: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.department_faqs" */
export enum DepartmentFaqs_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentFaqsPkey = 'department_faqs_pkey'
}

/** input type for incrementing numeric columns in table "v2.department_faqs" */
export type DepartmentFaqs_Inc_Input = {
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.department_faqs" */
export type DepartmentFaqs_Insert_Input = {
  answer: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  question: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type DepartmentFaqs_Max_Fields = {
  __typename?: 'departmentFaqs_max_fields'
  answer: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  question: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Max_Order_By = {
  answer: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  question: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type DepartmentFaqs_Min_Fields = {
  __typename?: 'departmentFaqs_min_fields'
  answer: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  question: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Min_Order_By = {
  answer: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  question: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.department_faqs" */
export type DepartmentFaqs_Mutation_Response = {
  __typename?: 'departmentFaqs_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<DepartmentFaqs>
}

/** on_conflict condition type for table "v2.department_faqs" */
export type DepartmentFaqs_On_Conflict = {
  constraint: DepartmentFaqs_Constraint
  update_columns: Array<DepartmentFaqs_Update_Column>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

/** Ordering options when selecting data from "v2.department_faqs". */
export type DepartmentFaqs_Order_By = {
  answer: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  question: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.department_faqs */
export type DepartmentFaqs_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.department_faqs" */
export enum DepartmentFaqs_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.department_faqs" */
export type DepartmentFaqs_Set_Input = {
  answer: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  question: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type DepartmentFaqs_Stddev_Fields = {
  __typename?: 'departmentFaqs_stddev_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Stddev_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type DepartmentFaqs_Stddev_Pop_Fields = {
  __typename?: 'departmentFaqs_stddev_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Stddev_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type DepartmentFaqs_Stddev_Samp_Fields = {
  __typename?: 'departmentFaqs_stddev_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Stddev_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Streaming cursor of the table "departmentFaqs" */
export type DepartmentFaqs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DepartmentFaqs_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type DepartmentFaqs_Stream_Cursor_Value_Input = {
  answer: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  question: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type DepartmentFaqs_Sum_Fields = {
  __typename?: 'departmentFaqs_sum_fields'
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Sum_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** update columns of table "v2.department_faqs" */
export enum DepartmentFaqs_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DepartmentFaqs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<DepartmentFaqs_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<DepartmentFaqs_Set_Input>
  /** filter the rows which have to be updated */
  where: DepartmentFaqs_Bool_Exp
}

/** aggregate var_pop on columns */
export type DepartmentFaqs_Var_Pop_Fields = {
  __typename?: 'departmentFaqs_var_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Var_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type DepartmentFaqs_Var_Samp_Fields = {
  __typename?: 'departmentFaqs_var_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Var_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type DepartmentFaqs_Variance_Fields = {
  __typename?: 'departmentFaqs_variance_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.department_faqs" */
export type DepartmentFaqs_Variance_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** columns and relationships of "v2.department_quicklinks" */
export type DepartmentQuicklinks = {
  __typename?: 'departmentQuicklinks'
  createdAt: Scalars['timestamptz']['output']
  departmentId: Scalars['Int']['output']
  description: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
  url: Scalars['String']['output']
}

/** aggregated selection of "v2.department_quicklinks" */
export type DepartmentQuicklinks_Aggregate = {
  __typename?: 'departmentQuicklinks_aggregate'
  aggregate: Maybe<DepartmentQuicklinks_Aggregate_Fields>
  nodes: Array<DepartmentQuicklinks>
}

export type DepartmentQuicklinks_Aggregate_Bool_Exp = {
  count: InputMaybe<DepartmentQuicklinks_Aggregate_Bool_Exp_Count>
}

export type DepartmentQuicklinks_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<DepartmentQuicklinks_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.department_quicklinks" */
export type DepartmentQuicklinks_Aggregate_Fields = {
  __typename?: 'departmentQuicklinks_aggregate_fields'
  avg: Maybe<DepartmentQuicklinks_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<DepartmentQuicklinks_Max_Fields>
  min: Maybe<DepartmentQuicklinks_Min_Fields>
  stddev: Maybe<DepartmentQuicklinks_Stddev_Fields>
  stddev_pop: Maybe<DepartmentQuicklinks_Stddev_Pop_Fields>
  stddev_samp: Maybe<DepartmentQuicklinks_Stddev_Samp_Fields>
  sum: Maybe<DepartmentQuicklinks_Sum_Fields>
  var_pop: Maybe<DepartmentQuicklinks_Var_Pop_Fields>
  var_samp: Maybe<DepartmentQuicklinks_Var_Samp_Fields>
  variance: Maybe<DepartmentQuicklinks_Variance_Fields>
}

/** aggregate fields of "v2.department_quicklinks" */
export type DepartmentQuicklinks_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Aggregate_Order_By = {
  avg: InputMaybe<DepartmentQuicklinks_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<DepartmentQuicklinks_Max_Order_By>
  min: InputMaybe<DepartmentQuicklinks_Min_Order_By>
  stddev: InputMaybe<DepartmentQuicklinks_Stddev_Order_By>
  stddev_pop: InputMaybe<DepartmentQuicklinks_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<DepartmentQuicklinks_Stddev_Samp_Order_By>
  sum: InputMaybe<DepartmentQuicklinks_Sum_Order_By>
  var_pop: InputMaybe<DepartmentQuicklinks_Var_Pop_Order_By>
  var_samp: InputMaybe<DepartmentQuicklinks_Var_Samp_Order_By>
  variance: InputMaybe<DepartmentQuicklinks_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Arr_Rel_Insert_Input = {
  data: Array<DepartmentQuicklinks_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<DepartmentQuicklinks_On_Conflict>
}

/** aggregate avg on columns */
export type DepartmentQuicklinks_Avg_Fields = {
  __typename?: 'departmentQuicklinks_avg_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Avg_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.department_quicklinks". All fields are combined with a logical 'AND'. */
export type DepartmentQuicklinks_Bool_Exp = {
  _and: InputMaybe<Array<DepartmentQuicklinks_Bool_Exp>>
  _not: InputMaybe<DepartmentQuicklinks_Bool_Exp>
  _or: InputMaybe<Array<DepartmentQuicklinks_Bool_Exp>>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
  url: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.department_quicklinks" */
export enum DepartmentQuicklinks_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentQuicklinksPkey = 'department_quicklinks_pkey'
}

/** input type for incrementing numeric columns in table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Inc_Input = {
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Insert_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  description: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type DepartmentQuicklinks_Max_Fields = {
  __typename?: 'departmentQuicklinks_max_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  description: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  url: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Max_Order_By = {
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  url: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type DepartmentQuicklinks_Min_Fields = {
  __typename?: 'departmentQuicklinks_min_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  description: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  url: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Min_Order_By = {
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  url: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Mutation_Response = {
  __typename?: 'departmentQuicklinks_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<DepartmentQuicklinks>
}

/** on_conflict condition type for table "v2.department_quicklinks" */
export type DepartmentQuicklinks_On_Conflict = {
  constraint: DepartmentQuicklinks_Constraint
  update_columns: Array<DepartmentQuicklinks_Update_Column>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

/** Ordering options when selecting data from "v2.department_quicklinks". */
export type DepartmentQuicklinks_Order_By = {
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  url: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.department_quicklinks */
export type DepartmentQuicklinks_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.department_quicklinks" */
export enum DepartmentQuicklinks_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Set_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  description: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type DepartmentQuicklinks_Stddev_Fields = {
  __typename?: 'departmentQuicklinks_stddev_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Stddev_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type DepartmentQuicklinks_Stddev_Pop_Fields = {
  __typename?: 'departmentQuicklinks_stddev_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Stddev_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type DepartmentQuicklinks_Stddev_Samp_Fields = {
  __typename?: 'departmentQuicklinks_stddev_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Stddev_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Streaming cursor of the table "departmentQuicklinks" */
export type DepartmentQuicklinks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DepartmentQuicklinks_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type DepartmentQuicklinks_Stream_Cursor_Value_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  description: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type DepartmentQuicklinks_Sum_Fields = {
  __typename?: 'departmentQuicklinks_sum_fields'
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Sum_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** update columns of table "v2.department_quicklinks" */
export enum DepartmentQuicklinks_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url'
}

export type DepartmentQuicklinks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<DepartmentQuicklinks_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<DepartmentQuicklinks_Set_Input>
  /** filter the rows which have to be updated */
  where: DepartmentQuicklinks_Bool_Exp
}

/** aggregate var_pop on columns */
export type DepartmentQuicklinks_Var_Pop_Fields = {
  __typename?: 'departmentQuicklinks_var_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Var_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type DepartmentQuicklinks_Var_Samp_Fields = {
  __typename?: 'departmentQuicklinks_var_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Var_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type DepartmentQuicklinks_Variance_Fields = {
  __typename?: 'departmentQuicklinks_variance_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.department_quicklinks" */
export type DepartmentQuicklinks_Variance_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** columns and relationships of "v2.departments" */
export type Departments = {
  __typename?: 'departments'
  /** An array relationship */
  bulletins: Array<BulletinDepartments>
  /** An aggregate relationship */
  bulletins_aggregate: BulletinDepartments_Aggregate
  /** An array relationship */
  contents: Array<Contents>
  /** An aggregate relationship */
  contents_aggregate: Contents_Aggregate
  createdAt: Scalars['timestamptz']['output']
  /** An array relationship */
  discussions: Array<Discussions>
  /** An aggregate relationship */
  discussions_aggregate: Discussions_Aggregate
  /** An array relationship */
  employees: Array<Users>
  /** An aggregate relationship */
  employees_aggregate: Users_Aggregate
  /** An array relationship */
  faqs: Array<DepartmentFaqs>
  /** An aggregate relationship */
  faqs_aggregate: DepartmentFaqs_Aggregate
  id: Scalars['Int']['output']
  /** An object relationship */
  logo: Maybe<Uploads>
  logoUploadId: Maybe<Scalars['Int']['output']>
  /** An object relationship */
  masthead: Maybe<Uploads>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  missionStatement: Scalars['String']['output']
  ownerId: Scalars['Int']['output']
  /** An array relationship */
  quicklinks: Array<DepartmentQuicklinks>
  /** An aggregate relationship */
  quicklinks_aggregate: DepartmentQuicklinks_Aggregate
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.departments" */
export type DepartmentsBulletinsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsBulletins_AggregateArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsContents_AggregateArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsDiscussionsArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsDiscussions_AggregateArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsEmployeesArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsEmployees_AggregateArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsFaqsArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsFaqs_AggregateArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsQuicklinksArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

/** columns and relationships of "v2.departments" */
export type DepartmentsQuicklinks_AggregateArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

/** aggregated selection of "v2.departments" */
export type Departments_Aggregate = {
  __typename?: 'departments_aggregate'
  aggregate: Maybe<Departments_Aggregate_Fields>
  nodes: Array<Departments>
}

/** aggregate fields of "v2.departments" */
export type Departments_Aggregate_Fields = {
  __typename?: 'departments_aggregate_fields'
  avg: Maybe<Departments_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Departments_Max_Fields>
  min: Maybe<Departments_Min_Fields>
  stddev: Maybe<Departments_Stddev_Fields>
  stddev_pop: Maybe<Departments_Stddev_Pop_Fields>
  stddev_samp: Maybe<Departments_Stddev_Samp_Fields>
  sum: Maybe<Departments_Sum_Fields>
  var_pop: Maybe<Departments_Var_Pop_Fields>
  var_samp: Maybe<Departments_Var_Samp_Fields>
  variance: Maybe<Departments_Variance_Fields>
}

/** aggregate fields of "v2.departments" */
export type Departments_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Departments_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Departments_Avg_Fields = {
  __typename?: 'departments_avg_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.departments". All fields are combined with a logical 'AND'. */
export type Departments_Bool_Exp = {
  _and: InputMaybe<Array<Departments_Bool_Exp>>
  _not: InputMaybe<Departments_Bool_Exp>
  _or: InputMaybe<Array<Departments_Bool_Exp>>
  bulletins: InputMaybe<BulletinDepartments_Bool_Exp>
  bulletins_aggregate: InputMaybe<BulletinDepartments_Aggregate_Bool_Exp>
  contents: InputMaybe<Contents_Bool_Exp>
  contents_aggregate: InputMaybe<Contents_Aggregate_Bool_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  discussions: InputMaybe<Discussions_Bool_Exp>
  discussions_aggregate: InputMaybe<Discussions_Aggregate_Bool_Exp>
  employees: InputMaybe<Users_Bool_Exp>
  employees_aggregate: InputMaybe<Users_Aggregate_Bool_Exp>
  faqs: InputMaybe<DepartmentFaqs_Bool_Exp>
  faqs_aggregate: InputMaybe<DepartmentFaqs_Aggregate_Bool_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  logo: InputMaybe<Uploads_Bool_Exp>
  logoUploadId: InputMaybe<Int_Comparison_Exp>
  masthead: InputMaybe<Uploads_Bool_Exp>
  mastheadUploadId: InputMaybe<Int_Comparison_Exp>
  missionStatement: InputMaybe<String_Comparison_Exp>
  ownerId: InputMaybe<Int_Comparison_Exp>
  quicklinks: InputMaybe<DepartmentQuicklinks_Bool_Exp>
  quicklinks_aggregate: InputMaybe<DepartmentQuicklinks_Aggregate_Bool_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.departments" */
export enum Departments_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentsPkey = 'departments_pkey'
}

/** input type for incrementing numeric columns in table "v2.departments" */
export type Departments_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  logoUploadId: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  ownerId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.departments" */
export type Departments_Insert_Input = {
  bulletins: InputMaybe<BulletinDepartments_Arr_Rel_Insert_Input>
  contents: InputMaybe<Contents_Arr_Rel_Insert_Input>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  discussions: InputMaybe<Discussions_Arr_Rel_Insert_Input>
  employees: InputMaybe<Users_Arr_Rel_Insert_Input>
  faqs: InputMaybe<DepartmentFaqs_Arr_Rel_Insert_Input>
  id: InputMaybe<Scalars['Int']['input']>
  logo: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  logoUploadId: InputMaybe<Scalars['Int']['input']>
  masthead: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  missionStatement: InputMaybe<Scalars['String']['input']>
  ownerId: InputMaybe<Scalars['Int']['input']>
  quicklinks: InputMaybe<DepartmentQuicklinks_Arr_Rel_Insert_Input>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Departments_Max_Fields = {
  __typename?: 'departments_max_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  logoUploadId: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  missionStatement: Maybe<Scalars['String']['output']>
  ownerId: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Departments_Min_Fields = {
  __typename?: 'departments_min_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  logoUploadId: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  missionStatement: Maybe<Scalars['String']['output']>
  ownerId: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.departments" */
export type Departments_Mutation_Response = {
  __typename?: 'departments_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Departments>
}

/** input type for inserting object relation for remote table "v2.departments" */
export type Departments_Obj_Rel_Insert_Input = {
  data: Departments_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Departments_On_Conflict>
}

/** on_conflict condition type for table "v2.departments" */
export type Departments_On_Conflict = {
  constraint: Departments_Constraint
  update_columns: Array<Departments_Update_Column>
  where: InputMaybe<Departments_Bool_Exp>
}

/** Ordering options when selecting data from "v2.departments". */
export type Departments_Order_By = {
  bulletins_aggregate: InputMaybe<BulletinDepartments_Aggregate_Order_By>
  contents_aggregate: InputMaybe<Contents_Aggregate_Order_By>
  createdAt: InputMaybe<Order_By>
  discussions_aggregate: InputMaybe<Discussions_Aggregate_Order_By>
  employees_aggregate: InputMaybe<Users_Aggregate_Order_By>
  faqs_aggregate: InputMaybe<DepartmentFaqs_Aggregate_Order_By>
  id: InputMaybe<Order_By>
  logo: InputMaybe<Uploads_Order_By>
  logoUploadId: InputMaybe<Order_By>
  masthead: InputMaybe<Uploads_Order_By>
  mastheadUploadId: InputMaybe<Order_By>
  missionStatement: InputMaybe<Order_By>
  ownerId: InputMaybe<Order_By>
  quicklinks_aggregate: InputMaybe<DepartmentQuicklinks_Aggregate_Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.departments */
export type Departments_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.departments" */
export enum Departments_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUploadId = 'logoUploadId',
  /** column name */
  MastheadUploadId = 'mastheadUploadId',
  /** column name */
  MissionStatement = 'missionStatement',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.departments" */
export type Departments_Set_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  logoUploadId: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  missionStatement: InputMaybe<Scalars['String']['input']>
  ownerId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Departments_Stddev_Fields = {
  __typename?: 'departments_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Departments_Stddev_Pop_Fields = {
  __typename?: 'departments_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Departments_Stddev_Samp_Fields = {
  __typename?: 'departments_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "departments" */
export type Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Departments_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Departments_Stream_Cursor_Value_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  logoUploadId: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  missionStatement: InputMaybe<Scalars['String']['input']>
  ownerId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Departments_Sum_Fields = {
  __typename?: 'departments_sum_fields'
  id: Maybe<Scalars['Int']['output']>
  logoUploadId: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  ownerId: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.departments" */
export enum Departments_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LogoUploadId = 'logoUploadId',
  /** column name */
  MastheadUploadId = 'mastheadUploadId',
  /** column name */
  MissionStatement = 'missionStatement',
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Departments_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Departments_Set_Input>
  /** filter the rows which have to be updated */
  where: Departments_Bool_Exp
}

/** aggregate var_pop on columns */
export type Departments_Var_Pop_Fields = {
  __typename?: 'departments_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Departments_Var_Samp_Fields = {
  __typename?: 'departments_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Departments_Variance_Fields = {
  __typename?: 'departments_variance_fields'
  id: Maybe<Scalars['Float']['output']>
  logoUploadId: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
  ownerId: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.discussions" */
export type Discussions = {
  __typename?: 'discussions'
  /** An object relationship */
  author: Maybe<Users>
  authorId: Scalars['Int']['output']
  /** An array relationship */
  comments: Array<Comments>
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate
  createdAt: Scalars['timestamptz']['output']
  departmentId: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  post: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.discussions" */
export type DiscussionsCommentsArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** columns and relationships of "v2.discussions" */
export type DiscussionsComments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** aggregated selection of "v2.discussions" */
export type Discussions_Aggregate = {
  __typename?: 'discussions_aggregate'
  aggregate: Maybe<Discussions_Aggregate_Fields>
  nodes: Array<Discussions>
}

export type Discussions_Aggregate_Bool_Exp = {
  count: InputMaybe<Discussions_Aggregate_Bool_Exp_Count>
}

export type Discussions_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Discussions_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Discussions_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.discussions" */
export type Discussions_Aggregate_Fields = {
  __typename?: 'discussions_aggregate_fields'
  avg: Maybe<Discussions_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Discussions_Max_Fields>
  min: Maybe<Discussions_Min_Fields>
  stddev: Maybe<Discussions_Stddev_Fields>
  stddev_pop: Maybe<Discussions_Stddev_Pop_Fields>
  stddev_samp: Maybe<Discussions_Stddev_Samp_Fields>
  sum: Maybe<Discussions_Sum_Fields>
  var_pop: Maybe<Discussions_Var_Pop_Fields>
  var_samp: Maybe<Discussions_Var_Samp_Fields>
  variance: Maybe<Discussions_Variance_Fields>
}

/** aggregate fields of "v2.discussions" */
export type Discussions_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Discussions_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.discussions" */
export type Discussions_Aggregate_Order_By = {
  avg: InputMaybe<Discussions_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<Discussions_Max_Order_By>
  min: InputMaybe<Discussions_Min_Order_By>
  stddev: InputMaybe<Discussions_Stddev_Order_By>
  stddev_pop: InputMaybe<Discussions_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<Discussions_Stddev_Samp_Order_By>
  sum: InputMaybe<Discussions_Sum_Order_By>
  var_pop: InputMaybe<Discussions_Var_Pop_Order_By>
  var_samp: InputMaybe<Discussions_Var_Samp_Order_By>
  variance: InputMaybe<Discussions_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.discussions" */
export type Discussions_Arr_Rel_Insert_Input = {
  data: Array<Discussions_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<Discussions_On_Conflict>
}

/** aggregate avg on columns */
export type Discussions_Avg_Fields = {
  __typename?: 'discussions_avg_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.discussions" */
export type Discussions_Avg_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.discussions". All fields are combined with a logical 'AND'. */
export type Discussions_Bool_Exp = {
  _and: InputMaybe<Array<Discussions_Bool_Exp>>
  _not: InputMaybe<Discussions_Bool_Exp>
  _or: InputMaybe<Array<Discussions_Bool_Exp>>
  author: InputMaybe<Users_Bool_Exp>
  authorId: InputMaybe<Int_Comparison_Exp>
  comments: InputMaybe<Comments_Bool_Exp>
  comments_aggregate: InputMaybe<Comments_Aggregate_Bool_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  post: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.discussions" */
export enum Discussions_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiscussionsPkey = 'discussions_pkey'
}

/** input type for incrementing numeric columns in table "v2.discussions" */
export type Discussions_Inc_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.discussions" */
export type Discussions_Insert_Input = {
  author: InputMaybe<Users_Obj_Rel_Insert_Input>
  authorId: InputMaybe<Scalars['Int']['input']>
  comments: InputMaybe<Comments_Arr_Rel_Insert_Input>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Discussions_Max_Fields = {
  __typename?: 'discussions_max_fields'
  authorId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  post: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "v2.discussions" */
export type Discussions_Max_Order_By = {
  authorId: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  post: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Discussions_Min_Fields = {
  __typename?: 'discussions_min_fields'
  authorId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  post: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "v2.discussions" */
export type Discussions_Min_Order_By = {
  authorId: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  post: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.discussions" */
export type Discussions_Mutation_Response = {
  __typename?: 'discussions_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Discussions>
}

/** input type for inserting object relation for remote table "v2.discussions" */
export type Discussions_Obj_Rel_Insert_Input = {
  data: Discussions_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Discussions_On_Conflict>
}

/** on_conflict condition type for table "v2.discussions" */
export type Discussions_On_Conflict = {
  constraint: Discussions_Constraint
  update_columns: Array<Discussions_Update_Column>
  where: InputMaybe<Discussions_Bool_Exp>
}

/** Ordering options when selecting data from "v2.discussions". */
export type Discussions_Order_By = {
  author: InputMaybe<Users_Order_By>
  authorId: InputMaybe<Order_By>
  comments_aggregate: InputMaybe<Comments_Aggregate_Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  post: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.discussions */
export type Discussions_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.discussions" */
export enum Discussions_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Post = 'post',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.discussions" */
export type Discussions_Set_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Discussions_Stddev_Fields = {
  __typename?: 'discussions_stddev_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.discussions" */
export type Discussions_Stddev_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Discussions_Stddev_Pop_Fields = {
  __typename?: 'discussions_stddev_pop_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.discussions" */
export type Discussions_Stddev_Pop_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Discussions_Stddev_Samp_Fields = {
  __typename?: 'discussions_stddev_samp_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.discussions" */
export type Discussions_Stddev_Samp_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** Streaming cursor of the table "discussions" */
export type Discussions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discussions_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Discussions_Stream_Cursor_Value_Input = {
  authorId: InputMaybe<Scalars['Int']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  post: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Discussions_Sum_Fields = {
  __typename?: 'discussions_sum_fields'
  authorId: Maybe<Scalars['Int']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.discussions" */
export type Discussions_Sum_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** update columns of table "v2.discussions" */
export enum Discussions_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Post = 'post',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Discussions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Discussions_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Discussions_Set_Input>
  /** filter the rows which have to be updated */
  where: Discussions_Bool_Exp
}

/** aggregate var_pop on columns */
export type Discussions_Var_Pop_Fields = {
  __typename?: 'discussions_var_pop_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.discussions" */
export type Discussions_Var_Pop_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Discussions_Var_Samp_Fields = {
  __typename?: 'discussions_var_samp_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.discussions" */
export type Discussions_Var_Samp_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Discussions_Variance_Fields = {
  __typename?: 'discussions_variance_fields'
  authorId: Maybe<Scalars['Float']['output']>
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.discussions" */
export type Discussions_Variance_Order_By = {
  authorId: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
}

/** columns and relationships of "v2.event_types" */
export type EventTypes = {
  __typename?: 'eventTypes'
  comment: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

/** aggregated selection of "v2.event_types" */
export type EventTypes_Aggregate = {
  __typename?: 'eventTypes_aggregate'
  aggregate: Maybe<EventTypes_Aggregate_Fields>
  nodes: Array<EventTypes>
}

/** aggregate fields of "v2.event_types" */
export type EventTypes_Aggregate_Fields = {
  __typename?: 'eventTypes_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<EventTypes_Max_Fields>
  min: Maybe<EventTypes_Min_Fields>
}

/** aggregate fields of "v2.event_types" */
export type EventTypes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<EventTypes_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.event_types". All fields are combined with a logical 'AND'. */
export type EventTypes_Bool_Exp = {
  _and: InputMaybe<Array<EventTypes_Bool_Exp>>
  _not: InputMaybe<EventTypes_Bool_Exp>
  _or: InputMaybe<Array<EventTypes_Bool_Exp>>
  comment: InputMaybe<String_Comparison_Exp>
  value: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.event_types" */
export enum EventTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  EventTypesPkey = 'event_types_pkey'
}

export enum EventTypes_Enum {
  Birthday = 'BIRTHDAY',
  Holiday = 'HOLIDAY',
  IndustryEvent = 'INDUSTRY_EVENT',
  NibbiEvent = 'NIBBI_EVENT',
  OaklandOffice = 'OAKLAND_OFFICE',
  Pto = 'PTO',
  Training = 'TRAINING'
}

/** Boolean expression to compare columns of type "eventTypes_enum". All fields are combined with logical 'AND'. */
export type EventTypes_Enum_Comparison_Exp = {
  _eq: InputMaybe<EventTypes_Enum>
  _in: InputMaybe<Array<EventTypes_Enum>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _neq: InputMaybe<EventTypes_Enum>
  _nin: InputMaybe<Array<EventTypes_Enum>>
}

/** input type for inserting data into table "v2.event_types" */
export type EventTypes_Insert_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type EventTypes_Max_Fields = {
  __typename?: 'eventTypes_max_fields'
  comment: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type EventTypes_Min_Fields = {
  __typename?: 'eventTypes_min_fields'
  comment: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.event_types" */
export type EventTypes_Mutation_Response = {
  __typename?: 'eventTypes_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<EventTypes>
}

/** on_conflict condition type for table "v2.event_types" */
export type EventTypes_On_Conflict = {
  constraint: EventTypes_Constraint
  update_columns: Array<EventTypes_Update_Column>
  where: InputMaybe<EventTypes_Bool_Exp>
}

/** Ordering options when selecting data from "v2.event_types". */
export type EventTypes_Order_By = {
  comment: InputMaybe<Order_By>
  value: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.event_types */
export type EventTypes_Pk_Columns_Input = {
  value: Scalars['String']['input']
}

/** select columns of table "v2.event_types" */
export enum EventTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "v2.event_types" */
export type EventTypes_Set_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "eventTypes" */
export type EventTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventTypes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type EventTypes_Stream_Cursor_Value_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "v2.event_types" */
export enum EventTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type EventTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<EventTypes_Set_Input>
  /** filter the rows which have to be updated */
  where: EventTypes_Bool_Exp
}

/** columns and relationships of "v2.events" */
export type Events = {
  __typename?: 'events'
  adp_request_id: Maybe<Scalars['String']['output']>
  allDay: Scalars['Boolean']['output']
  description: Maybe<Scalars['String']['output']>
  endsAt: Scalars['timestamptz']['output']
  id: Scalars['Int']['output']
  startsAt: Scalars['timestamptz']['output']
  title: Scalars['String']['output']
  type: EventTypes_Enum
}

/** aggregated selection of "v2.events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate'
  aggregate: Maybe<Events_Aggregate_Fields>
  nodes: Array<Events>
}

/** aggregate fields of "v2.events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields'
  avg: Maybe<Events_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Events_Max_Fields>
  min: Maybe<Events_Min_Fields>
  stddev: Maybe<Events_Stddev_Fields>
  stddev_pop: Maybe<Events_Stddev_Pop_Fields>
  stddev_samp: Maybe<Events_Stddev_Samp_Fields>
  sum: Maybe<Events_Sum_Fields>
  var_pop: Maybe<Events_Var_Pop_Fields>
  var_samp: Maybe<Events_Var_Samp_Fields>
  variance: Maybe<Events_Variance_Fields>
}

/** aggregate fields of "v2.events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Events_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and: InputMaybe<Array<Events_Bool_Exp>>
  _not: InputMaybe<Events_Bool_Exp>
  _or: InputMaybe<Array<Events_Bool_Exp>>
  adp_request_id: InputMaybe<String_Comparison_Exp>
  allDay: InputMaybe<Boolean_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  endsAt: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  startsAt: InputMaybe<Timestamptz_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  type: InputMaybe<EventTypes_Enum_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey'
}

/** input type for incrementing numeric columns in table "v2.events" */
export type Events_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.events" */
export type Events_Insert_Input = {
  adp_request_id: InputMaybe<Scalars['String']['input']>
  allDay: InputMaybe<Scalars['Boolean']['input']>
  description: InputMaybe<Scalars['String']['input']>
  endsAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  startsAt: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  type: InputMaybe<EventTypes_Enum>
}

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields'
  adp_request_id: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  endsAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  startsAt: Maybe<Scalars['timestamptz']['output']>
  title: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields'
  adp_request_id: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  endsAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  startsAt: Maybe<Scalars['timestamptz']['output']>
  title: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Events>
}

/** columns and relationships of "events" */
export type Events_Old = {
  __typename?: 'events_old'
  all_day: Maybe<Scalars['Boolean']['output']>
  calendar_type: Maybe<Scalars['bigint']['output']>
  created_at: Scalars['timestamptz']['output']
  description: Maybe<Scalars['String']['output']>
  ends_at: Maybe<Scalars['timestamptz']['output']>
  eventable_id: Maybe<Scalars['bigint']['output']>
  eventable_type: Maybe<Scalars['String']['output']>
  id: Scalars['bigint']['output']
  starts_at: Maybe<Scalars['timestamptz']['output']>
  title: Maybe<Scalars['String']['output']>
  updated_at: Scalars['timestamptz']['output']
}

/** aggregated selection of "events" */
export type Events_Old_Aggregate = {
  __typename?: 'events_old_aggregate'
  aggregate: Maybe<Events_Old_Aggregate_Fields>
  nodes: Array<Events_Old>
}

/** aggregate fields of "events" */
export type Events_Old_Aggregate_Fields = {
  __typename?: 'events_old_aggregate_fields'
  avg: Maybe<Events_Old_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Events_Old_Max_Fields>
  min: Maybe<Events_Old_Min_Fields>
  stddev: Maybe<Events_Old_Stddev_Fields>
  stddev_pop: Maybe<Events_Old_Stddev_Pop_Fields>
  stddev_samp: Maybe<Events_Old_Stddev_Samp_Fields>
  sum: Maybe<Events_Old_Sum_Fields>
  var_pop: Maybe<Events_Old_Var_Pop_Fields>
  var_samp: Maybe<Events_Old_Var_Samp_Fields>
  variance: Maybe<Events_Old_Variance_Fields>
}

/** aggregate fields of "events" */
export type Events_Old_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Events_Old_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Events_Old_Avg_Fields = {
  __typename?: 'events_old_avg_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Old_Bool_Exp = {
  _and: InputMaybe<Array<Events_Old_Bool_Exp>>
  _not: InputMaybe<Events_Old_Bool_Exp>
  _or: InputMaybe<Array<Events_Old_Bool_Exp>>
  all_day: InputMaybe<Boolean_Comparison_Exp>
  calendar_type: InputMaybe<Bigint_Comparison_Exp>
  created_at: InputMaybe<Timestamptz_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  ends_at: InputMaybe<Timestamptz_Comparison_Exp>
  eventable_id: InputMaybe<Bigint_Comparison_Exp>
  eventable_type: InputMaybe<String_Comparison_Exp>
  id: InputMaybe<Bigint_Comparison_Exp>
  starts_at: InputMaybe<Timestamptz_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "events" */
export enum Events_Old_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_110095Primary = 'idx_110095_primary'
}

/** input type for incrementing numeric columns in table "events" */
export type Events_Old_Inc_Input = {
  calendar_type: InputMaybe<Scalars['bigint']['input']>
  eventable_id: InputMaybe<Scalars['bigint']['input']>
  id: InputMaybe<Scalars['bigint']['input']>
}

/** input type for inserting data into table "events" */
export type Events_Old_Insert_Input = {
  all_day: InputMaybe<Scalars['Boolean']['input']>
  calendar_type: InputMaybe<Scalars['bigint']['input']>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  ends_at: InputMaybe<Scalars['timestamptz']['input']>
  eventable_id: InputMaybe<Scalars['bigint']['input']>
  eventable_type: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['bigint']['input']>
  starts_at: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Events_Old_Max_Fields = {
  __typename?: 'events_old_max_fields'
  calendar_type: Maybe<Scalars['bigint']['output']>
  created_at: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  ends_at: Maybe<Scalars['timestamptz']['output']>
  eventable_id: Maybe<Scalars['bigint']['output']>
  eventable_type: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['bigint']['output']>
  starts_at: Maybe<Scalars['timestamptz']['output']>
  title: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Events_Old_Min_Fields = {
  __typename?: 'events_old_min_fields'
  calendar_type: Maybe<Scalars['bigint']['output']>
  created_at: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  ends_at: Maybe<Scalars['timestamptz']['output']>
  eventable_id: Maybe<Scalars['bigint']['output']>
  eventable_type: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['bigint']['output']>
  starts_at: Maybe<Scalars['timestamptz']['output']>
  title: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "events" */
export type Events_Old_Mutation_Response = {
  __typename?: 'events_old_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Events_Old>
}

/** on_conflict condition type for table "events" */
export type Events_Old_On_Conflict = {
  constraint: Events_Old_Constraint
  update_columns: Array<Events_Old_Update_Column>
  where: InputMaybe<Events_Old_Bool_Exp>
}

/** Ordering options when selecting data from "events". */
export type Events_Old_Order_By = {
  all_day: InputMaybe<Order_By>
  calendar_type: InputMaybe<Order_By>
  created_at: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  ends_at: InputMaybe<Order_By>
  eventable_id: InputMaybe<Order_By>
  eventable_type: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  starts_at: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: events */
export type Events_Old_Pk_Columns_Input = {
  id: Scalars['bigint']['input']
}

/** select columns of table "events" */
export enum Events_Old_Select_Column {
  /** column name */
  AllDay = 'all_day',
  /** column name */
  CalendarType = 'calendar_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  EventableId = 'eventable_id',
  /** column name */
  EventableType = 'eventable_type',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "events" */
export type Events_Old_Set_Input = {
  all_day: InputMaybe<Scalars['Boolean']['input']>
  calendar_type: InputMaybe<Scalars['bigint']['input']>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  ends_at: InputMaybe<Scalars['timestamptz']['input']>
  eventable_id: InputMaybe<Scalars['bigint']['input']>
  eventable_type: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['bigint']['input']>
  starts_at: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Events_Old_Stddev_Fields = {
  __typename?: 'events_old_stddev_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Events_Old_Stddev_Pop_Fields = {
  __typename?: 'events_old_stddev_pop_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Events_Old_Stddev_Samp_Fields = {
  __typename?: 'events_old_stddev_samp_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "events_old" */
export type Events_Old_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Old_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Events_Old_Stream_Cursor_Value_Input = {
  all_day: InputMaybe<Scalars['Boolean']['input']>
  calendar_type: InputMaybe<Scalars['bigint']['input']>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  ends_at: InputMaybe<Scalars['timestamptz']['input']>
  eventable_id: InputMaybe<Scalars['bigint']['input']>
  eventable_type: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['bigint']['input']>
  starts_at: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Events_Old_Sum_Fields = {
  __typename?: 'events_old_sum_fields'
  calendar_type: Maybe<Scalars['bigint']['output']>
  eventable_id: Maybe<Scalars['bigint']['output']>
  id: Maybe<Scalars['bigint']['output']>
}

/** update columns of table "events" */
export enum Events_Old_Update_Column {
  /** column name */
  AllDay = 'all_day',
  /** column name */
  CalendarType = 'calendar_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  EventableId = 'eventable_id',
  /** column name */
  EventableType = 'eventable_type',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Events_Old_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Events_Old_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Events_Old_Set_Input>
  /** filter the rows which have to be updated */
  where: Events_Old_Bool_Exp
}

/** aggregate var_pop on columns */
export type Events_Old_Var_Pop_Fields = {
  __typename?: 'events_old_var_pop_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Events_Old_Var_Samp_Fields = {
  __typename?: 'events_old_var_samp_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Events_Old_Variance_Fields = {
  __typename?: 'events_old_variance_fields'
  calendar_type: Maybe<Scalars['Float']['output']>
  eventable_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** on_conflict condition type for table "v2.events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint
  update_columns: Array<Events_Update_Column>
  where: InputMaybe<Events_Bool_Exp>
}

/** Ordering options when selecting data from "v2.events". */
export type Events_Order_By = {
  adp_request_id: InputMaybe<Order_By>
  allDay: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  endsAt: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  startsAt: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  type: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.events */
export type Events_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.events" */
export enum Events_Select_Column {
  /** column name */
  AdpRequestId = 'adp_request_id',
  /** column name */
  AllDay = 'allDay',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "v2.events" */
export type Events_Set_Input = {
  adp_request_id: InputMaybe<Scalars['String']['input']>
  allDay: InputMaybe<Scalars['Boolean']['input']>
  description: InputMaybe<Scalars['String']['input']>
  endsAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  startsAt: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  type: InputMaybe<EventTypes_Enum>
}

/** aggregate stddev on columns */
export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  adp_request_id: InputMaybe<Scalars['String']['input']>
  allDay: InputMaybe<Scalars['Boolean']['input']>
  description: InputMaybe<Scalars['String']['input']>
  endsAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  startsAt: InputMaybe<Scalars['timestamptz']['input']>
  title: InputMaybe<Scalars['String']['input']>
  type: InputMaybe<EventTypes_Enum>
}

/** aggregate sum on columns */
export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields'
  id: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.events" */
export enum Events_Update_Column {
  /** column name */
  AdpRequestId = 'adp_request_id',
  /** column name */
  AllDay = 'allDay',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  Id = 'id',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type'
}

export type Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Events_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Events_Set_Input>
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp
}

/** aggregate var_pop on columns */
export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.favorite_discussions" */
export type FavoriteDiscussions = {
  __typename?: 'favoriteDiscussions'
  /** An object relationship */
  discussion: Maybe<Discussions>
  discussionId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  userId: Scalars['Int']['output']
}

/** aggregated selection of "v2.favorite_discussions" */
export type FavoriteDiscussions_Aggregate = {
  __typename?: 'favoriteDiscussions_aggregate'
  aggregate: Maybe<FavoriteDiscussions_Aggregate_Fields>
  nodes: Array<FavoriteDiscussions>
}

export type FavoriteDiscussions_Aggregate_Bool_Exp = {
  count: InputMaybe<FavoriteDiscussions_Aggregate_Bool_Exp_Count>
}

export type FavoriteDiscussions_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<FavoriteDiscussions_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.favorite_discussions" */
export type FavoriteDiscussions_Aggregate_Fields = {
  __typename?: 'favoriteDiscussions_aggregate_fields'
  avg: Maybe<FavoriteDiscussions_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<FavoriteDiscussions_Max_Fields>
  min: Maybe<FavoriteDiscussions_Min_Fields>
  stddev: Maybe<FavoriteDiscussions_Stddev_Fields>
  stddev_pop: Maybe<FavoriteDiscussions_Stddev_Pop_Fields>
  stddev_samp: Maybe<FavoriteDiscussions_Stddev_Samp_Fields>
  sum: Maybe<FavoriteDiscussions_Sum_Fields>
  var_pop: Maybe<FavoriteDiscussions_Var_Pop_Fields>
  var_samp: Maybe<FavoriteDiscussions_Var_Samp_Fields>
  variance: Maybe<FavoriteDiscussions_Variance_Fields>
}

/** aggregate fields of "v2.favorite_discussions" */
export type FavoriteDiscussions_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Aggregate_Order_By = {
  avg: InputMaybe<FavoriteDiscussions_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<FavoriteDiscussions_Max_Order_By>
  min: InputMaybe<FavoriteDiscussions_Min_Order_By>
  stddev: InputMaybe<FavoriteDiscussions_Stddev_Order_By>
  stddev_pop: InputMaybe<FavoriteDiscussions_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<FavoriteDiscussions_Stddev_Samp_Order_By>
  sum: InputMaybe<FavoriteDiscussions_Sum_Order_By>
  var_pop: InputMaybe<FavoriteDiscussions_Var_Pop_Order_By>
  var_samp: InputMaybe<FavoriteDiscussions_Var_Samp_Order_By>
  variance: InputMaybe<FavoriteDiscussions_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.favorite_discussions" */
export type FavoriteDiscussions_Arr_Rel_Insert_Input = {
  data: Array<FavoriteDiscussions_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<FavoriteDiscussions_On_Conflict>
}

/** aggregate avg on columns */
export type FavoriteDiscussions_Avg_Fields = {
  __typename?: 'favoriteDiscussions_avg_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Avg_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.favorite_discussions". All fields are combined with a logical 'AND'. */
export type FavoriteDiscussions_Bool_Exp = {
  _and: InputMaybe<Array<FavoriteDiscussions_Bool_Exp>>
  _not: InputMaybe<FavoriteDiscussions_Bool_Exp>
  _or: InputMaybe<Array<FavoriteDiscussions_Bool_Exp>>
  discussion: InputMaybe<Discussions_Bool_Exp>
  discussionId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  userId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.favorite_discussions" */
export enum FavoriteDiscussions_Constraint {
  /** unique or primary key constraint on columns "id" */
  FavoriteDiscussionsPkey = 'favorite_discussions_pkey'
}

/** input type for incrementing numeric columns in table "v2.favorite_discussions" */
export type FavoriteDiscussions_Inc_Input = {
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.favorite_discussions" */
export type FavoriteDiscussions_Insert_Input = {
  discussion: InputMaybe<Discussions_Obj_Rel_Insert_Input>
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type FavoriteDiscussions_Max_Fields = {
  __typename?: 'favoriteDiscussions_max_fields'
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Max_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type FavoriteDiscussions_Min_Fields = {
  __typename?: 'favoriteDiscussions_min_fields'
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Min_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.favorite_discussions" */
export type FavoriteDiscussions_Mutation_Response = {
  __typename?: 'favoriteDiscussions_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<FavoriteDiscussions>
}

/** on_conflict condition type for table "v2.favorite_discussions" */
export type FavoriteDiscussions_On_Conflict = {
  constraint: FavoriteDiscussions_Constraint
  update_columns: Array<FavoriteDiscussions_Update_Column>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

/** Ordering options when selecting data from "v2.favorite_discussions". */
export type FavoriteDiscussions_Order_By = {
  discussion: InputMaybe<Discussions_Order_By>
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.favorite_discussions */
export type FavoriteDiscussions_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.favorite_discussions" */
export enum FavoriteDiscussions_Select_Column {
  /** column name */
  DiscussionId = 'discussionId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "v2.favorite_discussions" */
export type FavoriteDiscussions_Set_Input = {
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type FavoriteDiscussions_Stddev_Fields = {
  __typename?: 'favoriteDiscussions_stddev_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Stddev_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type FavoriteDiscussions_Stddev_Pop_Fields = {
  __typename?: 'favoriteDiscussions_stddev_pop_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Stddev_Pop_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type FavoriteDiscussions_Stddev_Samp_Fields = {
  __typename?: 'favoriteDiscussions_stddev_samp_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Stddev_Samp_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "favoriteDiscussions" */
export type FavoriteDiscussions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FavoriteDiscussions_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type FavoriteDiscussions_Stream_Cursor_Value_Input = {
  discussionId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type FavoriteDiscussions_Sum_Fields = {
  __typename?: 'favoriteDiscussions_sum_fields'
  discussionId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Sum_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** update columns of table "v2.favorite_discussions" */
export enum FavoriteDiscussions_Update_Column {
  /** column name */
  DiscussionId = 'discussionId',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

export type FavoriteDiscussions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<FavoriteDiscussions_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<FavoriteDiscussions_Set_Input>
  /** filter the rows which have to be updated */
  where: FavoriteDiscussions_Bool_Exp
}

/** aggregate var_pop on columns */
export type FavoriteDiscussions_Var_Pop_Fields = {
  __typename?: 'favoriteDiscussions_var_pop_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Var_Pop_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type FavoriteDiscussions_Var_Samp_Fields = {
  __typename?: 'favoriteDiscussions_var_samp_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Var_Samp_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type FavoriteDiscussions_Variance_Fields = {
  __typename?: 'favoriteDiscussions_variance_fields'
  discussionId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.favorite_discussions" */
export type FavoriteDiscussions_Variance_Order_By = {
  discussionId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.favorite_resources" */
export type FavoriteResources = {
  __typename?: 'favoriteResources'
  id: Scalars['Int']['output']
  /** An object relationship */
  resource: Maybe<Resources>
  resourceId: Scalars['Int']['output']
  userId: Scalars['Int']['output']
}

/** aggregated selection of "v2.favorite_resources" */
export type FavoriteResources_Aggregate = {
  __typename?: 'favoriteResources_aggregate'
  aggregate: Maybe<FavoriteResources_Aggregate_Fields>
  nodes: Array<FavoriteResources>
}

export type FavoriteResources_Aggregate_Bool_Exp = {
  count: InputMaybe<FavoriteResources_Aggregate_Bool_Exp_Count>
}

export type FavoriteResources_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<FavoriteResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<FavoriteResources_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.favorite_resources" */
export type FavoriteResources_Aggregate_Fields = {
  __typename?: 'favoriteResources_aggregate_fields'
  avg: Maybe<FavoriteResources_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<FavoriteResources_Max_Fields>
  min: Maybe<FavoriteResources_Min_Fields>
  stddev: Maybe<FavoriteResources_Stddev_Fields>
  stddev_pop: Maybe<FavoriteResources_Stddev_Pop_Fields>
  stddev_samp: Maybe<FavoriteResources_Stddev_Samp_Fields>
  sum: Maybe<FavoriteResources_Sum_Fields>
  var_pop: Maybe<FavoriteResources_Var_Pop_Fields>
  var_samp: Maybe<FavoriteResources_Var_Samp_Fields>
  variance: Maybe<FavoriteResources_Variance_Fields>
}

/** aggregate fields of "v2.favorite_resources" */
export type FavoriteResources_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<FavoriteResources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.favorite_resources" */
export type FavoriteResources_Aggregate_Order_By = {
  avg: InputMaybe<FavoriteResources_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<FavoriteResources_Max_Order_By>
  min: InputMaybe<FavoriteResources_Min_Order_By>
  stddev: InputMaybe<FavoriteResources_Stddev_Order_By>
  stddev_pop: InputMaybe<FavoriteResources_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<FavoriteResources_Stddev_Samp_Order_By>
  sum: InputMaybe<FavoriteResources_Sum_Order_By>
  var_pop: InputMaybe<FavoriteResources_Var_Pop_Order_By>
  var_samp: InputMaybe<FavoriteResources_Var_Samp_Order_By>
  variance: InputMaybe<FavoriteResources_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.favorite_resources" */
export type FavoriteResources_Arr_Rel_Insert_Input = {
  data: Array<FavoriteResources_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<FavoriteResources_On_Conflict>
}

/** aggregate avg on columns */
export type FavoriteResources_Avg_Fields = {
  __typename?: 'favoriteResources_avg_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Avg_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.favorite_resources". All fields are combined with a logical 'AND'. */
export type FavoriteResources_Bool_Exp = {
  _and: InputMaybe<Array<FavoriteResources_Bool_Exp>>
  _not: InputMaybe<FavoriteResources_Bool_Exp>
  _or: InputMaybe<Array<FavoriteResources_Bool_Exp>>
  id: InputMaybe<Int_Comparison_Exp>
  resource: InputMaybe<Resources_Bool_Exp>
  resourceId: InputMaybe<Int_Comparison_Exp>
  userId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.favorite_resources" */
export enum FavoriteResources_Constraint {
  /** unique or primary key constraint on columns "id" */
  FavoriteResourcesPkey = 'favorite_resources_pkey'
}

/** input type for incrementing numeric columns in table "v2.favorite_resources" */
export type FavoriteResources_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.favorite_resources" */
export type FavoriteResources_Insert_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  resource: InputMaybe<Resources_Obj_Rel_Insert_Input>
  resourceId: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type FavoriteResources_Max_Fields = {
  __typename?: 'favoriteResources_max_fields'
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Max_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type FavoriteResources_Min_Fields = {
  __typename?: 'favoriteResources_min_fields'
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Min_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.favorite_resources" */
export type FavoriteResources_Mutation_Response = {
  __typename?: 'favoriteResources_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<FavoriteResources>
}

/** on_conflict condition type for table "v2.favorite_resources" */
export type FavoriteResources_On_Conflict = {
  constraint: FavoriteResources_Constraint
  update_columns: Array<FavoriteResources_Update_Column>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

/** Ordering options when selecting data from "v2.favorite_resources". */
export type FavoriteResources_Order_By = {
  id: InputMaybe<Order_By>
  resource: InputMaybe<Resources_Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.favorite_resources */
export type FavoriteResources_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.favorite_resources" */
export enum FavoriteResources_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "v2.favorite_resources" */
export type FavoriteResources_Set_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type FavoriteResources_Stddev_Fields = {
  __typename?: 'favoriteResources_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Stddev_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type FavoriteResources_Stddev_Pop_Fields = {
  __typename?: 'favoriteResources_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Stddev_Pop_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type FavoriteResources_Stddev_Samp_Fields = {
  __typename?: 'favoriteResources_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Stddev_Samp_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "favoriteResources" */
export type FavoriteResources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FavoriteResources_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type FavoriteResources_Stream_Cursor_Value_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  resourceId: InputMaybe<Scalars['Int']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type FavoriteResources_Sum_Fields = {
  __typename?: 'favoriteResources_sum_fields'
  id: Maybe<Scalars['Int']['output']>
  resourceId: Maybe<Scalars['Int']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Sum_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** update columns of table "v2.favorite_resources" */
export enum FavoriteResources_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ResourceId = 'resourceId',
  /** column name */
  UserId = 'userId'
}

export type FavoriteResources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<FavoriteResources_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<FavoriteResources_Set_Input>
  /** filter the rows which have to be updated */
  where: FavoriteResources_Bool_Exp
}

/** aggregate var_pop on columns */
export type FavoriteResources_Var_Pop_Fields = {
  __typename?: 'favoriteResources_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Var_Pop_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type FavoriteResources_Var_Samp_Fields = {
  __typename?: 'favoriteResources_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Var_Samp_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type FavoriteResources_Variance_Fields = {
  __typename?: 'favoriteResources_variance_fields'
  id: Maybe<Scalars['Float']['output']>
  resourceId: Maybe<Scalars['Float']['output']>
  userId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.favorite_resources" */
export type FavoriteResources_Variance_Order_By = {
  id: InputMaybe<Order_By>
  resourceId: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.galleries" */
export type Galleries = {
  __typename?: 'galleries'
  active: Scalars['Boolean']['output']
  children: Scalars['jsonb']['output']
  /** An object relationship */
  coverPhoto: Maybe<GalleryPhotos>
  coverPhotoId: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['timestamptz']['output']
  date: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['Int']['output']
  /** An array relationship */
  photos: Array<GalleryPhotos>
  /** An aggregate relationship */
  photos_aggregate: GalleryPhotos_Aggregate
  /** A computed field, executes function "v2.galleries_thumb_url" */
  thumbUrl: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
  /** An object relationship */
  videoThumbnail: Maybe<Uploads>
  videoThumbnailUploadId: Maybe<Scalars['Int']['output']>
  /** An object relationship */
  videoUpload: Maybe<Uploads>
  videoUploadId: Maybe<Scalars['Int']['output']>
}

/** columns and relationships of "v2.galleries" */
export type GalleriesChildrenArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "v2.galleries" */
export type GalleriesPhotosArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

/** columns and relationships of "v2.galleries" */
export type GalleriesPhotos_AggregateArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

/** aggregated selection of "v2.galleries" */
export type Galleries_Aggregate = {
  __typename?: 'galleries_aggregate'
  aggregate: Maybe<Galleries_Aggregate_Fields>
  nodes: Array<Galleries>
}

/** aggregate fields of "v2.galleries" */
export type Galleries_Aggregate_Fields = {
  __typename?: 'galleries_aggregate_fields'
  avg: Maybe<Galleries_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Galleries_Max_Fields>
  min: Maybe<Galleries_Min_Fields>
  stddev: Maybe<Galleries_Stddev_Fields>
  stddev_pop: Maybe<Galleries_Stddev_Pop_Fields>
  stddev_samp: Maybe<Galleries_Stddev_Samp_Fields>
  sum: Maybe<Galleries_Sum_Fields>
  var_pop: Maybe<Galleries_Var_Pop_Fields>
  var_samp: Maybe<Galleries_Var_Samp_Fields>
  variance: Maybe<Galleries_Variance_Fields>
}

/** aggregate fields of "v2.galleries" */
export type Galleries_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Galleries_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Galleries_Append_Input = {
  children: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type Galleries_Avg_Fields = {
  __typename?: 'galleries_avg_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.galleries". All fields are combined with a logical 'AND'. */
export type Galleries_Bool_Exp = {
  _and: InputMaybe<Array<Galleries_Bool_Exp>>
  _not: InputMaybe<Galleries_Bool_Exp>
  _or: InputMaybe<Array<Galleries_Bool_Exp>>
  active: InputMaybe<Boolean_Comparison_Exp>
  children: InputMaybe<Jsonb_Comparison_Exp>
  coverPhoto: InputMaybe<GalleryPhotos_Bool_Exp>
  coverPhotoId: InputMaybe<Int_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  date: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  photos: InputMaybe<GalleryPhotos_Bool_Exp>
  photos_aggregate: InputMaybe<GalleryPhotos_Aggregate_Bool_Exp>
  thumbUrl: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
  videoThumbnail: InputMaybe<Uploads_Bool_Exp>
  videoThumbnailUploadId: InputMaybe<Int_Comparison_Exp>
  videoUpload: InputMaybe<Uploads_Bool_Exp>
  videoUploadId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.galleries" */
export enum Galleries_Constraint {
  /** unique or primary key constraint on columns "id" */
  GalleriesPkey = 'galleries_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Galleries_Delete_At_Path_Input = {
  children: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Galleries_Delete_Elem_Input = {
  children: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Galleries_Delete_Key_Input = {
  children: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "v2.galleries" */
export type Galleries_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
  videoUploadId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.galleries" */
export type Galleries_Insert_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  coverPhoto: InputMaybe<GalleryPhotos_Obj_Rel_Insert_Input>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  date: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  photos: InputMaybe<GalleryPhotos_Arr_Rel_Insert_Input>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  videoThumbnail: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
  videoUpload: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  videoUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type Galleries_Max_Fields = {
  __typename?: 'galleries_max_fields'
  coverPhotoId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  date: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.galleries_thumb_url" */
  thumbUrl: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Int']['output']>
  videoUploadId: Maybe<Scalars['Int']['output']>
}

/** aggregate min on columns */
export type Galleries_Min_Fields = {
  __typename?: 'galleries_min_fields'
  coverPhotoId: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  date: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.galleries_thumb_url" */
  thumbUrl: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Int']['output']>
  videoUploadId: Maybe<Scalars['Int']['output']>
}

/** response of any mutation on the table "v2.galleries" */
export type Galleries_Mutation_Response = {
  __typename?: 'galleries_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Galleries>
}

/** on_conflict condition type for table "v2.galleries" */
export type Galleries_On_Conflict = {
  constraint: Galleries_Constraint
  update_columns: Array<Galleries_Update_Column>
  where: InputMaybe<Galleries_Bool_Exp>
}

/** Ordering options when selecting data from "v2.galleries". */
export type Galleries_Order_By = {
  active: InputMaybe<Order_By>
  children: InputMaybe<Order_By>
  coverPhoto: InputMaybe<GalleryPhotos_Order_By>
  coverPhotoId: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  date: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  photos_aggregate: InputMaybe<GalleryPhotos_Aggregate_Order_By>
  thumbUrl: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  videoThumbnail: InputMaybe<Uploads_Order_By>
  videoThumbnailUploadId: InputMaybe<Order_By>
  videoUpload: InputMaybe<Uploads_Order_By>
  videoUploadId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.galleries */
export type Galleries_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Galleries_Prepend_Input = {
  children: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.galleries" */
export enum Galleries_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Children = 'children',
  /** column name */
  CoverPhotoId = 'coverPhotoId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoThumbnailUploadId = 'videoThumbnailUploadId',
  /** column name */
  VideoUploadId = 'videoUploadId'
}

/** input type for updating data in table "v2.galleries" */
export type Galleries_Set_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  date: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
  videoUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type Galleries_Stddev_Fields = {
  __typename?: 'galleries_stddev_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Galleries_Stddev_Pop_Fields = {
  __typename?: 'galleries_stddev_pop_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Galleries_Stddev_Samp_Fields = {
  __typename?: 'galleries_stddev_samp_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "galleries" */
export type Galleries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Galleries_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Galleries_Stream_Cursor_Value_Input = {
  active: InputMaybe<Scalars['Boolean']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  coverPhotoId: InputMaybe<Scalars['Int']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  date: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
  videoUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type Galleries_Sum_Fields = {
  __typename?: 'galleries_sum_fields'
  coverPhotoId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Int']['output']>
  videoUploadId: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.galleries" */
export enum Galleries_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Children = 'children',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VideoThumbnailUploadId = 'videoThumbnailUploadId',
  /** column name */
  VideoUploadId = 'videoUploadId'
}

export type Galleries_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Galleries_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Galleries_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Galleries_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Galleries_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Galleries_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Galleries_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Galleries_Set_Input>
  /** filter the rows which have to be updated */
  where: Galleries_Bool_Exp
}

/** aggregate var_pop on columns */
export type Galleries_Var_Pop_Fields = {
  __typename?: 'galleries_var_pop_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Galleries_Var_Samp_Fields = {
  __typename?: 'galleries_var_samp_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Galleries_Variance_Fields = {
  __typename?: 'galleries_variance_fields'
  coverPhotoId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  videoThumbnailUploadId: Maybe<Scalars['Float']['output']>
  videoUploadId: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.gallery_photos" */
export type GalleryPhotos = {
  __typename?: 'galleryPhotos'
  caption: Maybe<Scalars['String']['output']>
  createdAt: Scalars['timestamptz']['output']
  galleryId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  /** An object relationship */
  image: Maybe<Uploads>
  imageUploadId: Maybe<Scalars['Int']['output']>
}

/** aggregated selection of "v2.gallery_photos" */
export type GalleryPhotos_Aggregate = {
  __typename?: 'galleryPhotos_aggregate'
  aggregate: Maybe<GalleryPhotos_Aggregate_Fields>
  nodes: Array<GalleryPhotos>
}

export type GalleryPhotos_Aggregate_Bool_Exp = {
  count: InputMaybe<GalleryPhotos_Aggregate_Bool_Exp_Count>
}

export type GalleryPhotos_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<GalleryPhotos_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<GalleryPhotos_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.gallery_photos" */
export type GalleryPhotos_Aggregate_Fields = {
  __typename?: 'galleryPhotos_aggregate_fields'
  avg: Maybe<GalleryPhotos_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<GalleryPhotos_Max_Fields>
  min: Maybe<GalleryPhotos_Min_Fields>
  stddev: Maybe<GalleryPhotos_Stddev_Fields>
  stddev_pop: Maybe<GalleryPhotos_Stddev_Pop_Fields>
  stddev_samp: Maybe<GalleryPhotos_Stddev_Samp_Fields>
  sum: Maybe<GalleryPhotos_Sum_Fields>
  var_pop: Maybe<GalleryPhotos_Var_Pop_Fields>
  var_samp: Maybe<GalleryPhotos_Var_Samp_Fields>
  variance: Maybe<GalleryPhotos_Variance_Fields>
}

/** aggregate fields of "v2.gallery_photos" */
export type GalleryPhotos_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<GalleryPhotos_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.gallery_photos" */
export type GalleryPhotos_Aggregate_Order_By = {
  avg: InputMaybe<GalleryPhotos_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<GalleryPhotos_Max_Order_By>
  min: InputMaybe<GalleryPhotos_Min_Order_By>
  stddev: InputMaybe<GalleryPhotos_Stddev_Order_By>
  stddev_pop: InputMaybe<GalleryPhotos_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<GalleryPhotos_Stddev_Samp_Order_By>
  sum: InputMaybe<GalleryPhotos_Sum_Order_By>
  var_pop: InputMaybe<GalleryPhotos_Var_Pop_Order_By>
  var_samp: InputMaybe<GalleryPhotos_Var_Samp_Order_By>
  variance: InputMaybe<GalleryPhotos_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.gallery_photos" */
export type GalleryPhotos_Arr_Rel_Insert_Input = {
  data: Array<GalleryPhotos_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<GalleryPhotos_On_Conflict>
}

/** aggregate avg on columns */
export type GalleryPhotos_Avg_Fields = {
  __typename?: 'galleryPhotos_avg_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Avg_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.gallery_photos". All fields are combined with a logical 'AND'. */
export type GalleryPhotos_Bool_Exp = {
  _and: InputMaybe<Array<GalleryPhotos_Bool_Exp>>
  _not: InputMaybe<GalleryPhotos_Bool_Exp>
  _or: InputMaybe<Array<GalleryPhotos_Bool_Exp>>
  caption: InputMaybe<String_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  galleryId: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  image: InputMaybe<Uploads_Bool_Exp>
  imageUploadId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.gallery_photos" */
export enum GalleryPhotos_Constraint {
  /** unique or primary key constraint on columns "id" */
  GalleryPhotosPkey = 'gallery_photos_pkey'
}

/** input type for incrementing numeric columns in table "v2.gallery_photos" */
export type GalleryPhotos_Inc_Input = {
  galleryId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  imageUploadId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.gallery_photos" */
export type GalleryPhotos_Insert_Input = {
  caption: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  galleryId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  image: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  imageUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type GalleryPhotos_Max_Fields = {
  __typename?: 'galleryPhotos_max_fields'
  caption: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  galleryId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  imageUploadId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Max_Order_By = {
  caption: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type GalleryPhotos_Min_Fields = {
  __typename?: 'galleryPhotos_min_fields'
  caption: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  galleryId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  imageUploadId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Min_Order_By = {
  caption: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.gallery_photos" */
export type GalleryPhotos_Mutation_Response = {
  __typename?: 'galleryPhotos_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<GalleryPhotos>
}

/** input type for inserting object relation for remote table "v2.gallery_photos" */
export type GalleryPhotos_Obj_Rel_Insert_Input = {
  data: GalleryPhotos_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<GalleryPhotos_On_Conflict>
}

/** on_conflict condition type for table "v2.gallery_photos" */
export type GalleryPhotos_On_Conflict = {
  constraint: GalleryPhotos_Constraint
  update_columns: Array<GalleryPhotos_Update_Column>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

/** Ordering options when selecting data from "v2.gallery_photos". */
export type GalleryPhotos_Order_By = {
  caption: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  image: InputMaybe<Uploads_Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.gallery_photos */
export type GalleryPhotos_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.gallery_photos" */
export enum GalleryPhotos_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GalleryId = 'galleryId',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUploadId = 'imageUploadId'
}

/** input type for updating data in table "v2.gallery_photos" */
export type GalleryPhotos_Set_Input = {
  caption: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  galleryId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  imageUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type GalleryPhotos_Stddev_Fields = {
  __typename?: 'galleryPhotos_stddev_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Stddev_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type GalleryPhotos_Stddev_Pop_Fields = {
  __typename?: 'galleryPhotos_stddev_pop_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Stddev_Pop_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type GalleryPhotos_Stddev_Samp_Fields = {
  __typename?: 'galleryPhotos_stddev_samp_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Stddev_Samp_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "galleryPhotos" */
export type GalleryPhotos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GalleryPhotos_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type GalleryPhotos_Stream_Cursor_Value_Input = {
  caption: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  galleryId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  imageUploadId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type GalleryPhotos_Sum_Fields = {
  __typename?: 'galleryPhotos_sum_fields'
  galleryId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  imageUploadId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Sum_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** update columns of table "v2.gallery_photos" */
export enum GalleryPhotos_Update_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GalleryId = 'galleryId',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUploadId = 'imageUploadId'
}

export type GalleryPhotos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<GalleryPhotos_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<GalleryPhotos_Set_Input>
  /** filter the rows which have to be updated */
  where: GalleryPhotos_Bool_Exp
}

/** aggregate var_pop on columns */
export type GalleryPhotos_Var_Pop_Fields = {
  __typename?: 'galleryPhotos_var_pop_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Var_Pop_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type GalleryPhotos_Var_Samp_Fields = {
  __typename?: 'galleryPhotos_var_samp_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Var_Samp_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type GalleryPhotos_Variance_Fields = {
  __typename?: 'galleryPhotos_variance_fields'
  galleryId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  imageUploadId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.gallery_photos" */
export type GalleryPhotos_Variance_Order_By = {
  galleryId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  imageUploadId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.jobsites" */
export type Jobsites = {
  __typename?: 'jobsites'
  alt_names: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  id: Scalars['Int']['output']
  isHidden: Scalars['Boolean']['output']
  mainAddress: Maybe<Scalars['String']['output']>
  mainAddress2: Maybe<Scalars['String']['output']>
  mainAddressCity: Maybe<Scalars['String']['output']>
  mainAddressState: Maybe<Scalars['String']['output']>
  mainAddressZip: Maybe<Scalars['String']['output']>
  officeAddress: Maybe<Scalars['String']['output']>
  officeAddress2: Maybe<Scalars['String']['output']>
  officeAddressCity: Maybe<Scalars['String']['output']>
  officeAddressState: Maybe<Scalars['String']['output']>
  officeAddressZip: Maybe<Scalars['String']['output']>
  phone: Scalars['String']['output']
  siteNumber: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** aggregated selection of "v2.jobsites" */
export type Jobsites_Aggregate = {
  __typename?: 'jobsites_aggregate'
  aggregate: Maybe<Jobsites_Aggregate_Fields>
  nodes: Array<Jobsites>
}

/** aggregate fields of "v2.jobsites" */
export type Jobsites_Aggregate_Fields = {
  __typename?: 'jobsites_aggregate_fields'
  avg: Maybe<Jobsites_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Jobsites_Max_Fields>
  min: Maybe<Jobsites_Min_Fields>
  stddev: Maybe<Jobsites_Stddev_Fields>
  stddev_pop: Maybe<Jobsites_Stddev_Pop_Fields>
  stddev_samp: Maybe<Jobsites_Stddev_Samp_Fields>
  sum: Maybe<Jobsites_Sum_Fields>
  var_pop: Maybe<Jobsites_Var_Pop_Fields>
  var_samp: Maybe<Jobsites_Var_Samp_Fields>
  variance: Maybe<Jobsites_Variance_Fields>
}

/** aggregate fields of "v2.jobsites" */
export type Jobsites_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Jobsites_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Jobsites_Avg_Fields = {
  __typename?: 'jobsites_avg_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.jobsites". All fields are combined with a logical 'AND'. */
export type Jobsites_Bool_Exp = {
  _and: InputMaybe<Array<Jobsites_Bool_Exp>>
  _not: InputMaybe<Jobsites_Bool_Exp>
  _or: InputMaybe<Array<Jobsites_Bool_Exp>>
  alt_names: InputMaybe<String_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  isHidden: InputMaybe<Boolean_Comparison_Exp>
  mainAddress: InputMaybe<String_Comparison_Exp>
  mainAddress2: InputMaybe<String_Comparison_Exp>
  mainAddressCity: InputMaybe<String_Comparison_Exp>
  mainAddressState: InputMaybe<String_Comparison_Exp>
  mainAddressZip: InputMaybe<String_Comparison_Exp>
  officeAddress: InputMaybe<String_Comparison_Exp>
  officeAddress2: InputMaybe<String_Comparison_Exp>
  officeAddressCity: InputMaybe<String_Comparison_Exp>
  officeAddressState: InputMaybe<String_Comparison_Exp>
  officeAddressZip: InputMaybe<String_Comparison_Exp>
  phone: InputMaybe<String_Comparison_Exp>
  siteNumber: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.jobsites" */
export enum Jobsites_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobsitesPkey = 'jobsites_pkey',
  /** unique or primary key constraint on columns "title" */
  JobsitesTitleKey = 'jobsites_title_key'
}

/** input type for incrementing numeric columns in table "v2.jobsites" */
export type Jobsites_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.jobsites" */
export type Jobsites_Insert_Input = {
  alt_names: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isHidden: InputMaybe<Scalars['Boolean']['input']>
  mainAddress: InputMaybe<Scalars['String']['input']>
  mainAddress2: InputMaybe<Scalars['String']['input']>
  mainAddressCity: InputMaybe<Scalars['String']['input']>
  mainAddressState: InputMaybe<Scalars['String']['input']>
  mainAddressZip: InputMaybe<Scalars['String']['input']>
  officeAddress: InputMaybe<Scalars['String']['input']>
  officeAddress2: InputMaybe<Scalars['String']['input']>
  officeAddressCity: InputMaybe<Scalars['String']['input']>
  officeAddressState: InputMaybe<Scalars['String']['input']>
  officeAddressZip: InputMaybe<Scalars['String']['input']>
  phone: InputMaybe<Scalars['String']['input']>
  siteNumber: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Jobsites_Max_Fields = {
  __typename?: 'jobsites_max_fields'
  alt_names: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  mainAddress: Maybe<Scalars['String']['output']>
  mainAddress2: Maybe<Scalars['String']['output']>
  mainAddressCity: Maybe<Scalars['String']['output']>
  mainAddressState: Maybe<Scalars['String']['output']>
  mainAddressZip: Maybe<Scalars['String']['output']>
  officeAddress: Maybe<Scalars['String']['output']>
  officeAddress2: Maybe<Scalars['String']['output']>
  officeAddressCity: Maybe<Scalars['String']['output']>
  officeAddressState: Maybe<Scalars['String']['output']>
  officeAddressZip: Maybe<Scalars['String']['output']>
  phone: Maybe<Scalars['String']['output']>
  siteNumber: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Jobsites_Min_Fields = {
  __typename?: 'jobsites_min_fields'
  alt_names: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  mainAddress: Maybe<Scalars['String']['output']>
  mainAddress2: Maybe<Scalars['String']['output']>
  mainAddressCity: Maybe<Scalars['String']['output']>
  mainAddressState: Maybe<Scalars['String']['output']>
  mainAddressZip: Maybe<Scalars['String']['output']>
  officeAddress: Maybe<Scalars['String']['output']>
  officeAddress2: Maybe<Scalars['String']['output']>
  officeAddressCity: Maybe<Scalars['String']['output']>
  officeAddressState: Maybe<Scalars['String']['output']>
  officeAddressZip: Maybe<Scalars['String']['output']>
  phone: Maybe<Scalars['String']['output']>
  siteNumber: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.jobsites" */
export type Jobsites_Mutation_Response = {
  __typename?: 'jobsites_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Jobsites>
}

/** input type for inserting object relation for remote table "v2.jobsites" */
export type Jobsites_Obj_Rel_Insert_Input = {
  data: Jobsites_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Jobsites_On_Conflict>
}

/** on_conflict condition type for table "v2.jobsites" */
export type Jobsites_On_Conflict = {
  constraint: Jobsites_Constraint
  update_columns: Array<Jobsites_Update_Column>
  where: InputMaybe<Jobsites_Bool_Exp>
}

/** Ordering options when selecting data from "v2.jobsites". */
export type Jobsites_Order_By = {
  alt_names: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  isHidden: InputMaybe<Order_By>
  mainAddress: InputMaybe<Order_By>
  mainAddress2: InputMaybe<Order_By>
  mainAddressCity: InputMaybe<Order_By>
  mainAddressState: InputMaybe<Order_By>
  mainAddressZip: InputMaybe<Order_By>
  officeAddress: InputMaybe<Order_By>
  officeAddress2: InputMaybe<Order_By>
  officeAddressCity: InputMaybe<Order_By>
  officeAddressState: InputMaybe<Order_By>
  officeAddressZip: InputMaybe<Order_By>
  phone: InputMaybe<Order_By>
  siteNumber: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.jobsites */
export type Jobsites_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.jobsites" */
export enum Jobsites_Select_Column {
  /** column name */
  AltNames = 'alt_names',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  MainAddress = 'mainAddress',
  /** column name */
  MainAddress2 = 'mainAddress2',
  /** column name */
  MainAddressCity = 'mainAddressCity',
  /** column name */
  MainAddressState = 'mainAddressState',
  /** column name */
  MainAddressZip = 'mainAddressZip',
  /** column name */
  OfficeAddress = 'officeAddress',
  /** column name */
  OfficeAddress2 = 'officeAddress2',
  /** column name */
  OfficeAddressCity = 'officeAddressCity',
  /** column name */
  OfficeAddressState = 'officeAddressState',
  /** column name */
  OfficeAddressZip = 'officeAddressZip',
  /** column name */
  Phone = 'phone',
  /** column name */
  SiteNumber = 'siteNumber',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.jobsites" */
export type Jobsites_Set_Input = {
  alt_names: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isHidden: InputMaybe<Scalars['Boolean']['input']>
  mainAddress: InputMaybe<Scalars['String']['input']>
  mainAddress2: InputMaybe<Scalars['String']['input']>
  mainAddressCity: InputMaybe<Scalars['String']['input']>
  mainAddressState: InputMaybe<Scalars['String']['input']>
  mainAddressZip: InputMaybe<Scalars['String']['input']>
  officeAddress: InputMaybe<Scalars['String']['input']>
  officeAddress2: InputMaybe<Scalars['String']['input']>
  officeAddressCity: InputMaybe<Scalars['String']['input']>
  officeAddressState: InputMaybe<Scalars['String']['input']>
  officeAddressZip: InputMaybe<Scalars['String']['input']>
  phone: InputMaybe<Scalars['String']['input']>
  siteNumber: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Jobsites_Stddev_Fields = {
  __typename?: 'jobsites_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Jobsites_Stddev_Pop_Fields = {
  __typename?: 'jobsites_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Jobsites_Stddev_Samp_Fields = {
  __typename?: 'jobsites_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "jobsites" */
export type Jobsites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jobsites_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Jobsites_Stream_Cursor_Value_Input = {
  alt_names: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isHidden: InputMaybe<Scalars['Boolean']['input']>
  mainAddress: InputMaybe<Scalars['String']['input']>
  mainAddress2: InputMaybe<Scalars['String']['input']>
  mainAddressCity: InputMaybe<Scalars['String']['input']>
  mainAddressState: InputMaybe<Scalars['String']['input']>
  mainAddressZip: InputMaybe<Scalars['String']['input']>
  officeAddress: InputMaybe<Scalars['String']['input']>
  officeAddress2: InputMaybe<Scalars['String']['input']>
  officeAddressCity: InputMaybe<Scalars['String']['input']>
  officeAddressState: InputMaybe<Scalars['String']['input']>
  officeAddressZip: InputMaybe<Scalars['String']['input']>
  phone: InputMaybe<Scalars['String']['input']>
  siteNumber: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Jobsites_Sum_Fields = {
  __typename?: 'jobsites_sum_fields'
  id: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.jobsites" */
export enum Jobsites_Update_Column {
  /** column name */
  AltNames = 'alt_names',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  MainAddress = 'mainAddress',
  /** column name */
  MainAddress2 = 'mainAddress2',
  /** column name */
  MainAddressCity = 'mainAddressCity',
  /** column name */
  MainAddressState = 'mainAddressState',
  /** column name */
  MainAddressZip = 'mainAddressZip',
  /** column name */
  OfficeAddress = 'officeAddress',
  /** column name */
  OfficeAddress2 = 'officeAddress2',
  /** column name */
  OfficeAddressCity = 'officeAddressCity',
  /** column name */
  OfficeAddressState = 'officeAddressState',
  /** column name */
  OfficeAddressZip = 'officeAddressZip',
  /** column name */
  Phone = 'phone',
  /** column name */
  SiteNumber = 'siteNumber',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Jobsites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Jobsites_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Jobsites_Set_Input>
  /** filter the rows which have to be updated */
  where: Jobsites_Bool_Exp
}

/** aggregate var_pop on columns */
export type Jobsites_Var_Pop_Fields = {
  __typename?: 'jobsites_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Jobsites_Var_Samp_Fields = {
  __typename?: 'jobsites_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Jobsites_Variance_Fields = {
  __typename?: 'jobsites_variance_fields'
  id: Maybe<Scalars['Float']['output']>
}

export type Jsonb_Cast_Exp = {
  String: InputMaybe<String_Comparison_Exp>
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast: InputMaybe<Jsonb_Cast_Exp>
  /** is the column contained in the given json value */
  _contained_in: InputMaybe<Scalars['jsonb']['input']>
  /** does the column contain the given json value at the top level */
  _contains: InputMaybe<Scalars['jsonb']['input']>
  _eq: InputMaybe<Scalars['jsonb']['input']>
  _gt: InputMaybe<Scalars['jsonb']['input']>
  _gte: InputMaybe<Scalars['jsonb']['input']>
  /** does the string exist as a top-level key in the column */
  _has_key: InputMaybe<Scalars['String']['input']>
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all: InputMaybe<Array<Scalars['String']['input']>>
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any: InputMaybe<Array<Scalars['String']['input']>>
  _in: InputMaybe<Array<Scalars['jsonb']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists: InputMaybe<Scalars['String']['input']>
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match: InputMaybe<Scalars['String']['input']>
  _lt: InputMaybe<Scalars['jsonb']['input']>
  _lte: InputMaybe<Scalars['jsonb']['input']>
  _neq: InputMaybe<Scalars['jsonb']['input']>
  _nin: InputMaybe<Array<Scalars['jsonb']['input']>>
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root'
  authenticateUser: Maybe<Session>
  /** delete data from the table: "v2.adp" */
  deleteAdp: Maybe<Adp_Mutation_Response>
  /** delete single row from the table: "v2.adp" */
  deleteAdpById: Maybe<Adp>
  /** delete single row from the table: "v2.bulletins" */
  deleteBulletinById: Maybe<Bulletins>
  /** delete single row from the table: "v2.bulletin_department" */
  deleteBulletinDepartmentById: Maybe<BulletinDepartments>
  /** delete data from the table: "v2.bulletin_department" */
  deleteBulletinDepartments: Maybe<BulletinDepartments_Mutation_Response>
  /** delete data from the table: "v2.bulletins" */
  deleteBulletins: Maybe<Bulletins_Mutation_Response>
  /** delete single row from the table: "v2.bulletins_resources" */
  deleteBulletinsResourceById: Maybe<BulletinsResources>
  /** delete data from the table: "v2.bulletins_resources" */
  deleteBulletinsResources: Maybe<BulletinsResources_Mutation_Response>
  /** delete single row from the table: "v2.camera_embeds" */
  deleteCameraEmbedById: Maybe<CameraEmbeds>
  /** delete data from the table: "v2.camera_embeds" */
  deleteCameraEmbeds: Maybe<CameraEmbeds_Mutation_Response>
  /** delete single row from the table: "v2.comments" */
  deleteCommentById: Maybe<Comments>
  /** delete data from the table: "v2.comments" */
  deleteComments: Maybe<Comments_Mutation_Response>
  /** delete single row from the table: "v2.config" */
  deleteConfigById: Maybe<Config>
  /** delete data from the table: "v2.config" */
  deleteConfigs: Maybe<Config_Mutation_Response>
  /** delete single row from the table: "v2.department_contents" */
  deleteContentById: Maybe<Contents>
  /** delete data from the table: "v2.department_contents" */
  deleteContents: Maybe<Contents_Mutation_Response>
  /** delete single row from the table: "v2.department_contents_resources" */
  deleteContentsResourceById: Maybe<ContentsResources>
  /** delete data from the table: "v2.department_contents_resources" */
  deleteContentsResources: Maybe<ContentsResources_Mutation_Response>
  /** delete single row from the table: "v2.departments" */
  deleteDepartmentById: Maybe<Departments>
  /** delete single row from the table: "v2.department_faqs" */
  deleteDepartmentFaqById: Maybe<DepartmentFaqs>
  /** delete data from the table: "v2.department_faqs" */
  deleteDepartmentFaqs: Maybe<DepartmentFaqs_Mutation_Response>
  /** delete single row from the table: "v2.department_quicklinks" */
  deleteDepartmentQuicklinkById: Maybe<DepartmentQuicklinks>
  /** delete data from the table: "v2.department_quicklinks" */
  deleteDepartmentQuicklinks: Maybe<DepartmentQuicklinks_Mutation_Response>
  /** delete data from the table: "v2.departments" */
  deleteDepartments: Maybe<Departments_Mutation_Response>
  /** delete single row from the table: "v2.discussions" */
  deleteDiscussionById: Maybe<Discussions>
  /** delete data from the table: "v2.discussions" */
  deleteDiscussions: Maybe<Discussions_Mutation_Response>
  /** delete single row from the table: "v2.events" */
  deleteEventById: Maybe<Events>
  /** delete single row from the table: "v2.event_types" */
  deleteEventTypeById: Maybe<EventTypes>
  /** delete data from the table: "v2.event_types" */
  deleteEventTypes: Maybe<EventTypes_Mutation_Response>
  /** delete data from the table: "v2.events" */
  deleteEvents: Maybe<Events_Mutation_Response>
  /** delete single row from the table: "v2.favorite_discussions" */
  deleteFavoriteDiscussionById: Maybe<FavoriteDiscussions>
  /** delete data from the table: "v2.favorite_discussions" */
  deleteFavoriteDiscussions: Maybe<FavoriteDiscussions_Mutation_Response>
  /** delete single row from the table: "v2.favorite_resources" */
  deleteFavoriteResourceById: Maybe<FavoriteResources>
  /** delete data from the table: "v2.favorite_resources" */
  deleteFavoriteResources: Maybe<FavoriteResources_Mutation_Response>
  /** delete data from the table: "v2.galleries" */
  deleteGalleries: Maybe<Galleries_Mutation_Response>
  /** delete single row from the table: "v2.galleries" */
  deleteGalleryById: Maybe<Galleries>
  /** delete single row from the table: "v2.gallery_photos" */
  deleteGalleryPhotoById: Maybe<GalleryPhotos>
  /** delete data from the table: "v2.gallery_photos" */
  deleteGalleryPhotos: Maybe<GalleryPhotos_Mutation_Response>
  /** delete single row from the table: "v2.jobsites" */
  deleteJobsiteById: Maybe<Jobsites>
  /** delete data from the table: "v2.jobsites" */
  deleteJobsites: Maybe<Jobsites_Mutation_Response>
  /** delete single row from the table: "v2.pages" */
  deletePageBySlug: Maybe<Pages>
  /** delete data from the table: "v2.pages" */
  deletePages: Maybe<Pages_Mutation_Response>
  /** delete single row from the table: "v2.resources" */
  deleteResourceById: Maybe<Resources>
  /** delete data from the table: "v2.resources" */
  deleteResources: Maybe<Resources_Mutation_Response>
  /** delete single row from the table: "v2.roles" */
  deleteRoleByValue: Maybe<Roles>
  /** delete data from the table: "v2.roles" */
  deleteRoles: Maybe<Roles_Mutation_Response>
  /** delete single row from the table: "v2.uploads" */
  deleteUploadById: Maybe<Uploads>
  /** delete data from the table: "v2.uploads" */
  deleteUploads: Maybe<Uploads_Mutation_Response>
  /** delete single row from the table: "v2.users" */
  deleteUserById: Maybe<Users>
  /** delete single row from the table: "v2.user_roles" */
  deleteUserRoleById: Maybe<UserRoles>
  /** delete data from the table: "v2.user_roles" */
  deleteUserRoles: Maybe<UserRoles_Mutation_Response>
  /** delete data from the table: "v2.users" */
  deleteUsers: Maybe<Users_Mutation_Response>
  /** delete data from the table: "events" */
  delete_events_old: Maybe<Events_Old_Mutation_Response>
  /** delete single row from the table: "events" */
  delete_events_old_by_pk: Maybe<Events_Old>
  /** delete data from the table: "v2.adp_associate_certification" */
  delete_v2_adp_associate_certification: Maybe<V2_Adp_Associate_Certification_Mutation_Response>
  /** delete single row from the table: "v2.adp_associate_certification" */
  delete_v2_adp_associate_certification_by_pk: Maybe<V2_Adp_Associate_Certification>
  /** delete data from the table: "v2.adp_associates" */
  delete_v2_adp_associates: Maybe<V2_Adp_Associates_Mutation_Response>
  /** delete single row from the table: "v2.adp_associates" */
  delete_v2_adp_associates_by_pk: Maybe<V2_Adp_Associates>
  /** delete data from the table: "v2.adp_certification_categories" */
  delete_v2_adp_certification_categories: Maybe<V2_Adp_Certification_Categories_Mutation_Response>
  /** delete single row from the table: "v2.adp_certification_categories" */
  delete_v2_adp_certification_categories_by_pk: Maybe<V2_Adp_Certification_Categories>
  /** delete data from the table: "v2.adp_certifications" */
  delete_v2_adp_certifications: Maybe<V2_Adp_Certifications_Mutation_Response>
  /** delete single row from the table: "v2.adp_certifications" */
  delete_v2_adp_certifications_by_pk: Maybe<V2_Adp_Certifications>
  /** delete data from the table: "v2.adp_license_categories" */
  delete_v2_adp_license_categories: Maybe<V2_Adp_License_Categories_Mutation_Response>
  /** delete single row from the table: "v2.adp_license_categories" */
  delete_v2_adp_license_categories_by_pk: Maybe<V2_Adp_License_Categories>
  /** delete data from the table: "v2.adp_licenses" */
  delete_v2_adp_licenses: Maybe<V2_Adp_Licenses_Mutation_Response>
  /** delete single row from the table: "v2.adp_licenses" */
  delete_v2_adp_licenses_by_pk: Maybe<V2_Adp_Licenses>
  /** delete data from the table: "v2.docebo_courses" */
  delete_v2_docebo_courses: Maybe<V2_Docebo_Courses_Mutation_Response>
  /** delete single row from the table: "v2.docebo_courses" */
  delete_v2_docebo_courses_by_pk: Maybe<V2_Docebo_Courses>
  /** delete data from the table: "v2.nomination_thumbsup" */
  delete_v2_nomination_thumbsup: Maybe<V2_Nomination_Thumbsup_Mutation_Response>
  /** delete single row from the table: "v2.nomination_thumbsup" */
  delete_v2_nomination_thumbsup_by_pk: Maybe<V2_Nomination_Thumbsup>
  /** delete data from the table: "v2.nominations" */
  delete_v2_nominations: Maybe<V2_Nominations_Mutation_Response>
  /** delete single row from the table: "v2.nominations" */
  delete_v2_nominations_by_pk: Maybe<V2_Nominations>
  /** delete data from the table: "v2.redemption_codes" */
  delete_v2_redemption_codes: Maybe<V2_Redemption_Codes_Mutation_Response>
  /** delete single row from the table: "v2.redemption_codes" */
  delete_v2_redemption_codes_by_pk: Maybe<V2_Redemption_Codes>
  getPresignedUpload: Maybe<PresignedUpload>
  /** insert a single row into the table: "v2.adp" */
  insertAdp: Maybe<Adp>
  /** insert data into the table: "v2.adp" */
  insertAdps: Maybe<Adp_Mutation_Response>
  /** insert a single row into the table: "v2.bulletins" */
  insertBulletin: Maybe<Bulletins>
  /** insert a single row into the table: "v2.bulletin_department" */
  insertBulletinDepartment: Maybe<BulletinDepartments>
  /** insert data into the table: "v2.bulletin_department" */
  insertBulletinDepartments: Maybe<BulletinDepartments_Mutation_Response>
  /** insert data into the table: "v2.bulletins" */
  insertBulletins: Maybe<Bulletins_Mutation_Response>
  /** insert a single row into the table: "v2.bulletins_resources" */
  insertBulletinsResource: Maybe<BulletinsResources>
  /** insert data into the table: "v2.bulletins_resources" */
  insertBulletinsResources: Maybe<BulletinsResources_Mutation_Response>
  /** insert a single row into the table: "v2.camera_embeds" */
  insertCameraEmbed: Maybe<CameraEmbeds>
  /** insert data into the table: "v2.camera_embeds" */
  insertCameraEmbeds: Maybe<CameraEmbeds_Mutation_Response>
  /** insert a single row into the table: "v2.comments" */
  insertComment: Maybe<Comments>
  /** insert data into the table: "v2.comments" */
  insertComments: Maybe<Comments_Mutation_Response>
  /** insert a single row into the table: "v2.config" */
  insertConfig: Maybe<Config>
  /** insert data into the table: "v2.config" */
  insertConfigs: Maybe<Config_Mutation_Response>
  /** insert a single row into the table: "v2.department_contents" */
  insertContent: Maybe<Contents>
  /** insert data into the table: "v2.department_contents" */
  insertContents: Maybe<Contents_Mutation_Response>
  /** insert a single row into the table: "v2.department_contents_resources" */
  insertContentsResource: Maybe<ContentsResources>
  /** insert data into the table: "v2.department_contents_resources" */
  insertContentsResources: Maybe<ContentsResources_Mutation_Response>
  /** insert a single row into the table: "v2.departments" */
  insertDepartment: Maybe<Departments>
  /** insert a single row into the table: "v2.department_faqs" */
  insertDepartmentFaq: Maybe<DepartmentFaqs>
  /** insert data into the table: "v2.department_faqs" */
  insertDepartmentFaqs: Maybe<DepartmentFaqs_Mutation_Response>
  /** insert a single row into the table: "v2.department_quicklinks" */
  insertDepartmentQuicklink: Maybe<DepartmentQuicklinks>
  /** insert data into the table: "v2.department_quicklinks" */
  insertDepartmentQuicklinks: Maybe<DepartmentQuicklinks_Mutation_Response>
  /** insert data into the table: "v2.departments" */
  insertDepartments: Maybe<Departments_Mutation_Response>
  /** insert a single row into the table: "v2.discussions" */
  insertDiscussion: Maybe<Discussions>
  /** insert data into the table: "v2.discussions" */
  insertDiscussions: Maybe<Discussions_Mutation_Response>
  /** insert a single row into the table: "v2.events" */
  insertEvent: Maybe<Events>
  /** insert a single row into the table: "v2.event_types" */
  insertEventType: Maybe<EventTypes>
  /** insert data into the table: "v2.event_types" */
  insertEventTypes: Maybe<EventTypes_Mutation_Response>
  /** insert data into the table: "v2.events" */
  insertEvents: Maybe<Events_Mutation_Response>
  /** insert a single row into the table: "v2.favorite_discussions" */
  insertFavoriteDiscussion: Maybe<FavoriteDiscussions>
  /** insert data into the table: "v2.favorite_discussions" */
  insertFavoriteDiscussions: Maybe<FavoriteDiscussions_Mutation_Response>
  /** insert a single row into the table: "v2.favorite_resources" */
  insertFavoriteResource: Maybe<FavoriteResources>
  /** insert data into the table: "v2.favorite_resources" */
  insertFavoriteResources: Maybe<FavoriteResources_Mutation_Response>
  /** insert data into the table: "v2.galleries" */
  insertGalleries: Maybe<Galleries_Mutation_Response>
  /** insert a single row into the table: "v2.galleries" */
  insertGallery: Maybe<Galleries>
  /** insert a single row into the table: "v2.gallery_photos" */
  insertGalleryPhoto: Maybe<GalleryPhotos>
  /** insert data into the table: "v2.gallery_photos" */
  insertGalleryPhotos: Maybe<GalleryPhotos_Mutation_Response>
  /** insert a single row into the table: "v2.jobsites" */
  insertJobsite: Maybe<Jobsites>
  /** insert data into the table: "v2.jobsites" */
  insertJobsites: Maybe<Jobsites_Mutation_Response>
  /** insert a single row into the table: "v2.pages" */
  insertPage: Maybe<Pages>
  /** insert data into the table: "v2.pages" */
  insertPages: Maybe<Pages_Mutation_Response>
  /** insert a single row into the table: "v2.resources" */
  insertResource: Maybe<Resources>
  /** insert data into the table: "v2.resources" */
  insertResources: Maybe<Resources_Mutation_Response>
  /** insert data into the table: "v2.roles" */
  insertRoles: Maybe<Roles_Mutation_Response>
  /** insert a single row into the table: "v2.roles" */
  insertTole: Maybe<Roles>
  /** insert a single row into the table: "v2.uploads" */
  insertUpload: Maybe<Uploads>
  /** insert data into the table: "v2.uploads" */
  insertUploads: Maybe<Uploads_Mutation_Response>
  /** insert a single row into the table: "v2.users" */
  insertUser: Maybe<Users>
  /** insert a single row into the table: "v2.user_roles" */
  insertUserRole: Maybe<UserRoles>
  /** insert data into the table: "v2.user_roles" */
  insertUserRoles: Maybe<UserRoles_Mutation_Response>
  /** insert data into the table: "v2.users" */
  insertUsers: Maybe<Users_Mutation_Response>
  /** insert data into the table: "events" */
  insert_events_old: Maybe<Events_Old_Mutation_Response>
  /** insert a single row into the table: "events" */
  insert_events_old_one: Maybe<Events_Old>
  /** insert data into the table: "v2.adp_associate_certification" */
  insert_v2_adp_associate_certification: Maybe<V2_Adp_Associate_Certification_Mutation_Response>
  /** insert a single row into the table: "v2.adp_associate_certification" */
  insert_v2_adp_associate_certification_one: Maybe<V2_Adp_Associate_Certification>
  /** insert data into the table: "v2.adp_associates" */
  insert_v2_adp_associates: Maybe<V2_Adp_Associates_Mutation_Response>
  /** insert a single row into the table: "v2.adp_associates" */
  insert_v2_adp_associates_one: Maybe<V2_Adp_Associates>
  /** insert data into the table: "v2.adp_certification_categories" */
  insert_v2_adp_certification_categories: Maybe<V2_Adp_Certification_Categories_Mutation_Response>
  /** insert a single row into the table: "v2.adp_certification_categories" */
  insert_v2_adp_certification_categories_one: Maybe<V2_Adp_Certification_Categories>
  /** insert data into the table: "v2.adp_certifications" */
  insert_v2_adp_certifications: Maybe<V2_Adp_Certifications_Mutation_Response>
  /** insert a single row into the table: "v2.adp_certifications" */
  insert_v2_adp_certifications_one: Maybe<V2_Adp_Certifications>
  /** insert data into the table: "v2.adp_license_categories" */
  insert_v2_adp_license_categories: Maybe<V2_Adp_License_Categories_Mutation_Response>
  /** insert a single row into the table: "v2.adp_license_categories" */
  insert_v2_adp_license_categories_one: Maybe<V2_Adp_License_Categories>
  /** insert data into the table: "v2.adp_licenses" */
  insert_v2_adp_licenses: Maybe<V2_Adp_Licenses_Mutation_Response>
  /** insert a single row into the table: "v2.adp_licenses" */
  insert_v2_adp_licenses_one: Maybe<V2_Adp_Licenses>
  /** insert data into the table: "v2.docebo_courses" */
  insert_v2_docebo_courses: Maybe<V2_Docebo_Courses_Mutation_Response>
  /** insert a single row into the table: "v2.docebo_courses" */
  insert_v2_docebo_courses_one: Maybe<V2_Docebo_Courses>
  /** insert data into the table: "v2.nomination_thumbsup" */
  insert_v2_nomination_thumbsup: Maybe<V2_Nomination_Thumbsup_Mutation_Response>
  /** insert a single row into the table: "v2.nomination_thumbsup" */
  insert_v2_nomination_thumbsup_one: Maybe<V2_Nomination_Thumbsup>
  /** insert data into the table: "v2.nominations" */
  insert_v2_nominations: Maybe<V2_Nominations_Mutation_Response>
  /** insert a single row into the table: "v2.nominations" */
  insert_v2_nominations_one: Maybe<V2_Nominations>
  /** insert data into the table: "v2.redemption_codes" */
  insert_v2_redemption_codes: Maybe<V2_Redemption_Codes_Mutation_Response>
  /** insert a single row into the table: "v2.redemption_codes" */
  insert_v2_redemption_codes_one: Maybe<V2_Redemption_Codes>
  sendCrisisNotification: Maybe<CrisisNotificationOutput>
  sendNominationEmail: Maybe<NominationEmailOutput>
  sendResourceEmail: Maybe<ResourceEmailOutput>
  /** update data of the table: "v2.adp" */
  updateAdp: Maybe<Adp_Mutation_Response>
  /** update single row of the table: "v2.adp" */
  updateAdpById: Maybe<Adp>
  /** update single row of the table: "v2.bulletins" */
  updateBulletinById: Maybe<Bulletins>
  /** update single row of the table: "v2.bulletin_department" */
  updateBulletinDepartmentById: Maybe<BulletinDepartments>
  /** update data of the table: "v2.bulletin_department" */
  updateBulletinDepartments: Maybe<BulletinDepartments_Mutation_Response>
  /** update data of the table: "v2.bulletins" */
  updateBulletins: Maybe<Bulletins_Mutation_Response>
  /** update single row of the table: "v2.bulletins_resources" */
  updateBulletinsResourceById: Maybe<BulletinsResources>
  /** update data of the table: "v2.bulletins_resources" */
  updateBulletinsResources: Maybe<BulletinsResources_Mutation_Response>
  /** update single row of the table: "v2.camera_embeds" */
  updateCameraEmbedById: Maybe<CameraEmbeds>
  /** update data of the table: "v2.camera_embeds" */
  updateCameraEmbeds: Maybe<CameraEmbeds_Mutation_Response>
  /** update single row of the table: "v2.comments" */
  updateCommentById: Maybe<Comments>
  /** update data of the table: "v2.comments" */
  updateComments: Maybe<Comments_Mutation_Response>
  /** update data of the table: "v2.config" */
  updateConfig: Maybe<Config_Mutation_Response>
  /** update single row of the table: "v2.config" */
  updateConfigByKey: Maybe<Config>
  /** update single row of the table: "v2.department_contents" */
  updateContentById: Maybe<Contents>
  /** update data of the table: "v2.department_contents" */
  updateContents: Maybe<Contents_Mutation_Response>
  /** update single row of the table: "v2.department_contents_resources" */
  updateContentsResourceById: Maybe<ContentsResources>
  /** update data of the table: "v2.department_contents_resources" */
  updateContentsResources: Maybe<ContentsResources_Mutation_Response>
  /** update single row of the table: "v2.departments" */
  updateDepartmentById: Maybe<Departments>
  /** update single row of the table: "v2.department_faqs" */
  updateDepartmentFaqById: Maybe<DepartmentFaqs>
  /** update data of the table: "v2.department_faqs" */
  updateDepartmentFaqs: Maybe<DepartmentFaqs_Mutation_Response>
  /** update single row of the table: "v2.department_quicklinks" */
  updateDepartmentQuicklinkById: Maybe<DepartmentQuicklinks>
  /** update data of the table: "v2.department_quicklinks" */
  updateDepartmentQuicklinks: Maybe<DepartmentQuicklinks_Mutation_Response>
  /** update data of the table: "v2.departments" */
  updateDepartments: Maybe<Departments_Mutation_Response>
  /** update single row of the table: "v2.discussions" */
  updateDiscussionById: Maybe<Discussions>
  /** update data of the table: "v2.discussions" */
  updateDiscussions: Maybe<Discussions_Mutation_Response>
  /** update single row of the table: "v2.events" */
  updateEventById: Maybe<Events>
  /** update single row of the table: "v2.event_types" */
  updateEventTypeById: Maybe<EventTypes>
  /** update data of the table: "v2.event_types" */
  updateEventTypes: Maybe<EventTypes_Mutation_Response>
  /** update data of the table: "v2.events" */
  updateEvents: Maybe<Events_Mutation_Response>
  /** update single row of the table: "v2.favorite_discussions" */
  updateFavoriteDiscussionById: Maybe<FavoriteDiscussions>
  /** update data of the table: "v2.favorite_discussions" */
  updateFavoriteDiscussions: Maybe<FavoriteDiscussions_Mutation_Response>
  /** update single row of the table: "v2.favorite_resources" */
  updateFavoriteResourceById: Maybe<FavoriteResources>
  /** update data of the table: "v2.favorite_resources" */
  updateFavoriteResources: Maybe<FavoriteResources_Mutation_Response>
  /** update data of the table: "v2.galleries" */
  updateGalleries: Maybe<Galleries_Mutation_Response>
  /** update single row of the table: "v2.galleries" */
  updateGalleryById: Maybe<Galleries>
  /** update single row of the table: "v2.gallery_photos" */
  updateGalleryPhotoById: Maybe<GalleryPhotos>
  /** update data of the table: "v2.gallery_photos" */
  updateGalleryPhotos: Maybe<GalleryPhotos_Mutation_Response>
  /** update single row of the table: "v2.jobsites" */
  updateJobsiteById: Maybe<Jobsites>
  /** update data of the table: "v2.jobsites" */
  updateJobsites: Maybe<Jobsites_Mutation_Response>
  /** update single row of the table: "v2.pages" */
  updatePageBySlug: Maybe<Pages>
  /** update data of the table: "v2.pages" */
  updatePages: Maybe<Pages_Mutation_Response>
  /** update single row of the table: "v2.resources" */
  updateResourceById: Maybe<Resources>
  /** update data of the table: "v2.resources" */
  updateResources: Maybe<Resources_Mutation_Response>
  /** update single row of the table: "v2.roles" */
  updateRoleByValue: Maybe<Roles>
  /** update data of the table: "v2.roles" */
  updateRoles: Maybe<Roles_Mutation_Response>
  /** update single row of the table: "v2.uploads" */
  updateUploadById: Maybe<Uploads>
  /** update data of the table: "v2.uploads" */
  updateUploads: Maybe<Uploads_Mutation_Response>
  /** update single row of the table: "v2.users" */
  updateUserById: Maybe<Users>
  /** update single row of the table: "v2.user_roles" */
  updateUserRoleById: Maybe<UserRoles>
  /** update data of the table: "v2.user_roles" */
  updateUserRoles: Maybe<UserRoles_Mutation_Response>
  /** update data of the table: "v2.users" */
  updateUsers: Maybe<Users_Mutation_Response>
  /** update multiples rows of table: "v2.adp" */
  update_adp_many: Maybe<Array<Maybe<Adp_Mutation_Response>>>
  /** update multiples rows of table: "v2.bulletin_department" */
  update_bulletinDepartments_many: Maybe<Array<Maybe<BulletinDepartments_Mutation_Response>>>
  /** update multiples rows of table: "v2.bulletins_resources" */
  update_bulletinsResources_many: Maybe<Array<Maybe<BulletinsResources_Mutation_Response>>>
  /** update multiples rows of table: "v2.bulletins" */
  update_bulletins_many: Maybe<Array<Maybe<Bulletins_Mutation_Response>>>
  /** update multiples rows of table: "v2.camera_embeds" */
  update_cameraEmbeds_many: Maybe<Array<Maybe<CameraEmbeds_Mutation_Response>>>
  /** update multiples rows of table: "v2.comments" */
  update_comments_many: Maybe<Array<Maybe<Comments_Mutation_Response>>>
  /** update multiples rows of table: "v2.config" */
  update_config_many: Maybe<Array<Maybe<Config_Mutation_Response>>>
  /** update multiples rows of table: "v2.department_contents_resources" */
  update_contentsResources_many: Maybe<Array<Maybe<ContentsResources_Mutation_Response>>>
  /** update multiples rows of table: "v2.department_contents" */
  update_contents_many: Maybe<Array<Maybe<Contents_Mutation_Response>>>
  /** update multiples rows of table: "v2.department_faqs" */
  update_departmentFaqs_many: Maybe<Array<Maybe<DepartmentFaqs_Mutation_Response>>>
  /** update multiples rows of table: "v2.department_quicklinks" */
  update_departmentQuicklinks_many: Maybe<Array<Maybe<DepartmentQuicklinks_Mutation_Response>>>
  /** update multiples rows of table: "v2.departments" */
  update_departments_many: Maybe<Array<Maybe<Departments_Mutation_Response>>>
  /** update multiples rows of table: "v2.discussions" */
  update_discussions_many: Maybe<Array<Maybe<Discussions_Mutation_Response>>>
  /** update multiples rows of table: "v2.event_types" */
  update_eventTypes_many: Maybe<Array<Maybe<EventTypes_Mutation_Response>>>
  /** update multiples rows of table: "v2.events" */
  update_events_many: Maybe<Array<Maybe<Events_Mutation_Response>>>
  /** update data of the table: "events" */
  update_events_old: Maybe<Events_Old_Mutation_Response>
  /** update single row of the table: "events" */
  update_events_old_by_pk: Maybe<Events_Old>
  /** update multiples rows of table: "events" */
  update_events_old_many: Maybe<Array<Maybe<Events_Old_Mutation_Response>>>
  /** update multiples rows of table: "v2.favorite_discussions" */
  update_favoriteDiscussions_many: Maybe<Array<Maybe<FavoriteDiscussions_Mutation_Response>>>
  /** update multiples rows of table: "v2.favorite_resources" */
  update_favoriteResources_many: Maybe<Array<Maybe<FavoriteResources_Mutation_Response>>>
  /** update multiples rows of table: "v2.galleries" */
  update_galleries_many: Maybe<Array<Maybe<Galleries_Mutation_Response>>>
  /** update multiples rows of table: "v2.gallery_photos" */
  update_galleryPhotos_many: Maybe<Array<Maybe<GalleryPhotos_Mutation_Response>>>
  /** update multiples rows of table: "v2.jobsites" */
  update_jobsites_many: Maybe<Array<Maybe<Jobsites_Mutation_Response>>>
  /** update multiples rows of table: "v2.pages" */
  update_pages_many: Maybe<Array<Maybe<Pages_Mutation_Response>>>
  /** update multiples rows of table: "v2.resources" */
  update_resources_many: Maybe<Array<Maybe<Resources_Mutation_Response>>>
  /** update multiples rows of table: "v2.roles" */
  update_roles_many: Maybe<Array<Maybe<Roles_Mutation_Response>>>
  /** update multiples rows of table: "v2.uploads" */
  update_uploads_many: Maybe<Array<Maybe<Uploads_Mutation_Response>>>
  /** update multiples rows of table: "v2.user_roles" */
  update_userRoles_many: Maybe<Array<Maybe<UserRoles_Mutation_Response>>>
  /** update multiples rows of table: "v2.users" */
  update_users_many: Maybe<Array<Maybe<Users_Mutation_Response>>>
  /** update data of the table: "v2.adp_associate_certification" */
  update_v2_adp_associate_certification: Maybe<V2_Adp_Associate_Certification_Mutation_Response>
  /** update single row of the table: "v2.adp_associate_certification" */
  update_v2_adp_associate_certification_by_pk: Maybe<V2_Adp_Associate_Certification>
  /** update multiples rows of table: "v2.adp_associate_certification" */
  update_v2_adp_associate_certification_many: Maybe<Array<Maybe<V2_Adp_Associate_Certification_Mutation_Response>>>
  /** update data of the table: "v2.adp_associates" */
  update_v2_adp_associates: Maybe<V2_Adp_Associates_Mutation_Response>
  /** update single row of the table: "v2.adp_associates" */
  update_v2_adp_associates_by_pk: Maybe<V2_Adp_Associates>
  /** update multiples rows of table: "v2.adp_associates" */
  update_v2_adp_associates_many: Maybe<Array<Maybe<V2_Adp_Associates_Mutation_Response>>>
  /** update data of the table: "v2.adp_certification_categories" */
  update_v2_adp_certification_categories: Maybe<V2_Adp_Certification_Categories_Mutation_Response>
  /** update single row of the table: "v2.adp_certification_categories" */
  update_v2_adp_certification_categories_by_pk: Maybe<V2_Adp_Certification_Categories>
  /** update multiples rows of table: "v2.adp_certification_categories" */
  update_v2_adp_certification_categories_many: Maybe<Array<Maybe<V2_Adp_Certification_Categories_Mutation_Response>>>
  /** update data of the table: "v2.adp_certifications" */
  update_v2_adp_certifications: Maybe<V2_Adp_Certifications_Mutation_Response>
  /** update single row of the table: "v2.adp_certifications" */
  update_v2_adp_certifications_by_pk: Maybe<V2_Adp_Certifications>
  /** update multiples rows of table: "v2.adp_certifications" */
  update_v2_adp_certifications_many: Maybe<Array<Maybe<V2_Adp_Certifications_Mutation_Response>>>
  /** update data of the table: "v2.adp_license_categories" */
  update_v2_adp_license_categories: Maybe<V2_Adp_License_Categories_Mutation_Response>
  /** update single row of the table: "v2.adp_license_categories" */
  update_v2_adp_license_categories_by_pk: Maybe<V2_Adp_License_Categories>
  /** update multiples rows of table: "v2.adp_license_categories" */
  update_v2_adp_license_categories_many: Maybe<Array<Maybe<V2_Adp_License_Categories_Mutation_Response>>>
  /** update data of the table: "v2.adp_licenses" */
  update_v2_adp_licenses: Maybe<V2_Adp_Licenses_Mutation_Response>
  /** update single row of the table: "v2.adp_licenses" */
  update_v2_adp_licenses_by_pk: Maybe<V2_Adp_Licenses>
  /** update multiples rows of table: "v2.adp_licenses" */
  update_v2_adp_licenses_many: Maybe<Array<Maybe<V2_Adp_Licenses_Mutation_Response>>>
  /** update data of the table: "v2.docebo_courses" */
  update_v2_docebo_courses: Maybe<V2_Docebo_Courses_Mutation_Response>
  /** update single row of the table: "v2.docebo_courses" */
  update_v2_docebo_courses_by_pk: Maybe<V2_Docebo_Courses>
  /** update multiples rows of table: "v2.docebo_courses" */
  update_v2_docebo_courses_many: Maybe<Array<Maybe<V2_Docebo_Courses_Mutation_Response>>>
  /** update data of the table: "v2.nomination_thumbsup" */
  update_v2_nomination_thumbsup: Maybe<V2_Nomination_Thumbsup_Mutation_Response>
  /** update single row of the table: "v2.nomination_thumbsup" */
  update_v2_nomination_thumbsup_by_pk: Maybe<V2_Nomination_Thumbsup>
  /** update multiples rows of table: "v2.nomination_thumbsup" */
  update_v2_nomination_thumbsup_many: Maybe<Array<Maybe<V2_Nomination_Thumbsup_Mutation_Response>>>
  /** update data of the table: "v2.nominations" */
  update_v2_nominations: Maybe<V2_Nominations_Mutation_Response>
  /** update single row of the table: "v2.nominations" */
  update_v2_nominations_by_pk: Maybe<V2_Nominations>
  /** update multiples rows of table: "v2.nominations" */
  update_v2_nominations_many: Maybe<Array<Maybe<V2_Nominations_Mutation_Response>>>
  /** update data of the table: "v2.redemption_codes" */
  update_v2_redemption_codes: Maybe<V2_Redemption_Codes_Mutation_Response>
  /** update single row of the table: "v2.redemption_codes" */
  update_v2_redemption_codes_by_pk: Maybe<V2_Redemption_Codes>
  /** update multiples rows of table: "v2.redemption_codes" */
  update_v2_redemption_codes_many: Maybe<Array<Maybe<V2_Redemption_Codes_Mutation_Response>>>
}

/** mutation root */
export type Mutation_RootAuthenticateUserArgs = {
  credentials: AuthUserInput
}

/** mutation root */
export type Mutation_RootDeleteAdpArgs = {
  where: Adp_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAdpByIdArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteBulletinByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteBulletinDepartmentByIdArgs = {
  bulletinId: Scalars['Int']['input']
  departmentId: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteBulletinDepartmentsArgs = {
  where: BulletinDepartments_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteBulletinsArgs = {
  where: Bulletins_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteBulletinsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteBulletinsResourcesArgs = {
  where: BulletinsResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteCameraEmbedByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteCameraEmbedsArgs = {
  where: CameraEmbeds_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteCommentByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteCommentsArgs = {
  where: Comments_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteConfigByIdArgs = {
  key: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteConfigsArgs = {
  where: Config_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteContentByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteContentsArgs = {
  where: Contents_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteContentsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteContentsResourcesArgs = {
  where: ContentsResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteDepartmentByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteDepartmentFaqByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteDepartmentFaqsArgs = {
  where: DepartmentFaqs_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteDepartmentQuicklinkByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteDepartmentQuicklinksArgs = {
  where: DepartmentQuicklinks_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteDepartmentsArgs = {
  where: Departments_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteDiscussionByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteDiscussionsArgs = {
  where: Discussions_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteEventByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteEventTypeByIdArgs = {
  value: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteEventTypesArgs = {
  where: EventTypes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteEventsArgs = {
  where: Events_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteFavoriteDiscussionByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteFavoriteDiscussionsArgs = {
  where: FavoriteDiscussions_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteFavoriteResourceByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteFavoriteResourcesArgs = {
  where: FavoriteResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteGalleriesArgs = {
  where: Galleries_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteGalleryByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteGalleryPhotoByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteGalleryPhotosArgs = {
  where: GalleryPhotos_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteJobsiteByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteJobsitesArgs = {
  where: Jobsites_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeletePageBySlugArgs = {
  slug: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeletePagesArgs = {
  where: Pages_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteResourceByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteResourcesArgs = {
  where: Resources_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteRoleByValueArgs = {
  value: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteRolesArgs = {
  where: Roles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteUploadByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteUploadsArgs = {
  where: Uploads_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteUserByIdArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteUserRoleByIdArgs = {
  role: Roles_Enum
  userId: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDeleteUserRolesArgs = {
  where: UserRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Events_OldArgs = {
  where: Events_Old_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Events_Old_By_PkArgs = {
  id: Scalars['bigint']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Associate_CertificationArgs = {
  where: V2_Adp_Associate_Certification_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Associate_Certification_By_PkArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_AssociatesArgs = {
  where: V2_Adp_Associates_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Associates_By_PkArgs = {
  associate_oid: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Certification_CategoriesArgs = {
  where: V2_Adp_Certification_Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Certification_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_CertificationsArgs = {
  where: V2_Adp_Certifications_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Certifications_By_PkArgs = {
  code: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_License_CategoriesArgs = {
  where: V2_Adp_License_Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_License_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_LicensesArgs = {
  where: V2_Adp_Licenses_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Adp_Licenses_By_PkArgs = {
  code: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Docebo_CoursesArgs = {
  where: V2_Docebo_Courses_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Docebo_Courses_By_PkArgs = {
  uid: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Nomination_ThumbsupArgs = {
  where: V2_Nomination_Thumbsup_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Nomination_Thumbsup_By_PkArgs = {
  nomination_id: Scalars['Int']['input']
  user_id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_NominationsArgs = {
  where: V2_Nominations_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Nominations_By_PkArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootDelete_V2_Redemption_CodesArgs = {
  where: V2_Redemption_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_V2_Redemption_Codes_By_PkArgs = {
  id: Scalars['Int']['input']
}

/** mutation root */
export type Mutation_RootGetPresignedUploadArgs = {
  config: PresignedUploadInput
}

/** mutation root */
export type Mutation_RootInsertAdpArgs = {
  object: Adp_Insert_Input
  on_conflict: InputMaybe<Adp_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAdpsArgs = {
  objects: Array<Adp_Insert_Input>
  on_conflict: InputMaybe<Adp_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinArgs = {
  object: Bulletins_Insert_Input
  on_conflict: InputMaybe<Bulletins_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinDepartmentArgs = {
  object: BulletinDepartments_Insert_Input
  on_conflict: InputMaybe<BulletinDepartments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinDepartmentsArgs = {
  objects: Array<BulletinDepartments_Insert_Input>
  on_conflict: InputMaybe<BulletinDepartments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinsArgs = {
  objects: Array<Bulletins_Insert_Input>
  on_conflict: InputMaybe<Bulletins_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinsResourceArgs = {
  object: BulletinsResources_Insert_Input
  on_conflict: InputMaybe<BulletinsResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBulletinsResourcesArgs = {
  objects: Array<BulletinsResources_Insert_Input>
  on_conflict: InputMaybe<BulletinsResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertCameraEmbedArgs = {
  object: CameraEmbeds_Insert_Input
  on_conflict: InputMaybe<CameraEmbeds_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertCameraEmbedsArgs = {
  objects: Array<CameraEmbeds_Insert_Input>
  on_conflict: InputMaybe<CameraEmbeds_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertCommentArgs = {
  object: Comments_Insert_Input
  on_conflict: InputMaybe<Comments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertCommentsArgs = {
  objects: Array<Comments_Insert_Input>
  on_conflict: InputMaybe<Comments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertConfigArgs = {
  object: Config_Insert_Input
  on_conflict: InputMaybe<Config_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertConfigsArgs = {
  objects: Array<Config_Insert_Input>
  on_conflict: InputMaybe<Config_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertContentArgs = {
  object: Contents_Insert_Input
  on_conflict: InputMaybe<Contents_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertContentsArgs = {
  objects: Array<Contents_Insert_Input>
  on_conflict: InputMaybe<Contents_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertContentsResourceArgs = {
  object: ContentsResources_Insert_Input
  on_conflict: InputMaybe<ContentsResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertContentsResourcesArgs = {
  objects: Array<ContentsResources_Insert_Input>
  on_conflict: InputMaybe<ContentsResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentArgs = {
  object: Departments_Insert_Input
  on_conflict: InputMaybe<Departments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentFaqArgs = {
  object: DepartmentFaqs_Insert_Input
  on_conflict: InputMaybe<DepartmentFaqs_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentFaqsArgs = {
  objects: Array<DepartmentFaqs_Insert_Input>
  on_conflict: InputMaybe<DepartmentFaqs_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentQuicklinkArgs = {
  object: DepartmentQuicklinks_Insert_Input
  on_conflict: InputMaybe<DepartmentQuicklinks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentQuicklinksArgs = {
  objects: Array<DepartmentQuicklinks_Insert_Input>
  on_conflict: InputMaybe<DepartmentQuicklinks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDepartmentsArgs = {
  objects: Array<Departments_Insert_Input>
  on_conflict: InputMaybe<Departments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDiscussionArgs = {
  object: Discussions_Insert_Input
  on_conflict: InputMaybe<Discussions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertDiscussionsArgs = {
  objects: Array<Discussions_Insert_Input>
  on_conflict: InputMaybe<Discussions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertEventArgs = {
  object: Events_Insert_Input
  on_conflict: InputMaybe<Events_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertEventTypeArgs = {
  object: EventTypes_Insert_Input
  on_conflict: InputMaybe<EventTypes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertEventTypesArgs = {
  objects: Array<EventTypes_Insert_Input>
  on_conflict: InputMaybe<EventTypes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertEventsArgs = {
  objects: Array<Events_Insert_Input>
  on_conflict: InputMaybe<Events_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFavoriteDiscussionArgs = {
  object: FavoriteDiscussions_Insert_Input
  on_conflict: InputMaybe<FavoriteDiscussions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFavoriteDiscussionsArgs = {
  objects: Array<FavoriteDiscussions_Insert_Input>
  on_conflict: InputMaybe<FavoriteDiscussions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFavoriteResourceArgs = {
  object: FavoriteResources_Insert_Input
  on_conflict: InputMaybe<FavoriteResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFavoriteResourcesArgs = {
  objects: Array<FavoriteResources_Insert_Input>
  on_conflict: InputMaybe<FavoriteResources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertGalleriesArgs = {
  objects: Array<Galleries_Insert_Input>
  on_conflict: InputMaybe<Galleries_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertGalleryArgs = {
  object: Galleries_Insert_Input
  on_conflict: InputMaybe<Galleries_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertGalleryPhotoArgs = {
  object: GalleryPhotos_Insert_Input
  on_conflict: InputMaybe<GalleryPhotos_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertGalleryPhotosArgs = {
  objects: Array<GalleryPhotos_Insert_Input>
  on_conflict: InputMaybe<GalleryPhotos_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertJobsiteArgs = {
  object: Jobsites_Insert_Input
  on_conflict: InputMaybe<Jobsites_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertJobsitesArgs = {
  objects: Array<Jobsites_Insert_Input>
  on_conflict: InputMaybe<Jobsites_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertPageArgs = {
  object: Pages_Insert_Input
  on_conflict: InputMaybe<Pages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertPagesArgs = {
  objects: Array<Pages_Insert_Input>
  on_conflict: InputMaybe<Pages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertResourceArgs = {
  object: Resources_Insert_Input
  on_conflict: InputMaybe<Resources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertResourcesArgs = {
  objects: Array<Resources_Insert_Input>
  on_conflict: InputMaybe<Resources_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertRolesArgs = {
  objects: Array<Roles_Insert_Input>
  on_conflict: InputMaybe<Roles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertToleArgs = {
  object: Roles_Insert_Input
  on_conflict: InputMaybe<Roles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUploadArgs = {
  object: Uploads_Insert_Input
  on_conflict: InputMaybe<Uploads_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUploadsArgs = {
  objects: Array<Uploads_Insert_Input>
  on_conflict: InputMaybe<Uploads_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input
  on_conflict: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUserRoleArgs = {
  object: UserRoles_Insert_Input
  on_conflict: InputMaybe<UserRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUserRolesArgs = {
  objects: Array<UserRoles_Insert_Input>
  on_conflict: InputMaybe<UserRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>
  on_conflict: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Events_OldArgs = {
  objects: Array<Events_Old_Insert_Input>
  on_conflict: InputMaybe<Events_Old_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Events_Old_OneArgs = {
  object: Events_Old_Insert_Input
  on_conflict: InputMaybe<Events_Old_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Associate_CertificationArgs = {
  objects: Array<V2_Adp_Associate_Certification_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_Associate_Certification_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Associate_Certification_OneArgs = {
  object: V2_Adp_Associate_Certification_Insert_Input
  on_conflict: InputMaybe<V2_Adp_Associate_Certification_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_AssociatesArgs = {
  objects: Array<V2_Adp_Associates_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_Associates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Associates_OneArgs = {
  object: V2_Adp_Associates_Insert_Input
  on_conflict: InputMaybe<V2_Adp_Associates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Certification_CategoriesArgs = {
  objects: Array<V2_Adp_Certification_Categories_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_Certification_Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Certification_Categories_OneArgs = {
  object: V2_Adp_Certification_Categories_Insert_Input
  on_conflict: InputMaybe<V2_Adp_Certification_Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_CertificationsArgs = {
  objects: Array<V2_Adp_Certifications_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_Certifications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Certifications_OneArgs = {
  object: V2_Adp_Certifications_Insert_Input
  on_conflict: InputMaybe<V2_Adp_Certifications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_License_CategoriesArgs = {
  objects: Array<V2_Adp_License_Categories_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_License_Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_License_Categories_OneArgs = {
  object: V2_Adp_License_Categories_Insert_Input
  on_conflict: InputMaybe<V2_Adp_License_Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_LicensesArgs = {
  objects: Array<V2_Adp_Licenses_Insert_Input>
  on_conflict: InputMaybe<V2_Adp_Licenses_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Adp_Licenses_OneArgs = {
  object: V2_Adp_Licenses_Insert_Input
  on_conflict: InputMaybe<V2_Adp_Licenses_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Docebo_CoursesArgs = {
  objects: Array<V2_Docebo_Courses_Insert_Input>
  on_conflict: InputMaybe<V2_Docebo_Courses_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Docebo_Courses_OneArgs = {
  object: V2_Docebo_Courses_Insert_Input
  on_conflict: InputMaybe<V2_Docebo_Courses_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Nomination_ThumbsupArgs = {
  objects: Array<V2_Nomination_Thumbsup_Insert_Input>
  on_conflict: InputMaybe<V2_Nomination_Thumbsup_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Nomination_Thumbsup_OneArgs = {
  object: V2_Nomination_Thumbsup_Insert_Input
  on_conflict: InputMaybe<V2_Nomination_Thumbsup_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_NominationsArgs = {
  objects: Array<V2_Nominations_Insert_Input>
  on_conflict: InputMaybe<V2_Nominations_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Nominations_OneArgs = {
  object: V2_Nominations_Insert_Input
  on_conflict: InputMaybe<V2_Nominations_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Redemption_CodesArgs = {
  objects: Array<V2_Redemption_Codes_Insert_Input>
  on_conflict: InputMaybe<V2_Redemption_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_V2_Redemption_Codes_OneArgs = {
  object: V2_Redemption_Codes_Insert_Input
  on_conflict: InputMaybe<V2_Redemption_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootSendCrisisNotificationArgs = {
  text: Scalars['String']['input']
  title: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootSendNominationEmailArgs = {
  config: NominationEmailInput
}

/** mutation root */
export type Mutation_RootSendResourceEmailArgs = {
  config: ResourceEmailInput
}

/** mutation root */
export type Mutation_RootUpdateAdpArgs = {
  _append: InputMaybe<Adp_Append_Input>
  _delete_at_path: InputMaybe<Adp_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Adp_Delete_Elem_Input>
  _delete_key: InputMaybe<Adp_Delete_Key_Input>
  _prepend: InputMaybe<Adp_Prepend_Input>
  _set: InputMaybe<Adp_Set_Input>
  where: Adp_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAdpByIdArgs = {
  _append: InputMaybe<Adp_Append_Input>
  _delete_at_path: InputMaybe<Adp_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Adp_Delete_Elem_Input>
  _delete_key: InputMaybe<Adp_Delete_Key_Input>
  _prepend: InputMaybe<Adp_Prepend_Input>
  _set: InputMaybe<Adp_Set_Input>
  pk_columns: Adp_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateBulletinByIdArgs = {
  _inc: InputMaybe<Bulletins_Inc_Input>
  _set: InputMaybe<Bulletins_Set_Input>
  pk_columns: Bulletins_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateBulletinDepartmentByIdArgs = {
  _inc: InputMaybe<BulletinDepartments_Inc_Input>
  _set: InputMaybe<BulletinDepartments_Set_Input>
  pk_columns: BulletinDepartments_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateBulletinDepartmentsArgs = {
  _inc: InputMaybe<BulletinDepartments_Inc_Input>
  _set: InputMaybe<BulletinDepartments_Set_Input>
  where: BulletinDepartments_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateBulletinsArgs = {
  _inc: InputMaybe<Bulletins_Inc_Input>
  _set: InputMaybe<Bulletins_Set_Input>
  where: Bulletins_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateBulletinsResourceByIdArgs = {
  _inc: InputMaybe<BulletinsResources_Inc_Input>
  _set: InputMaybe<BulletinsResources_Set_Input>
  pk_columns: BulletinsResources_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateBulletinsResourcesArgs = {
  _inc: InputMaybe<BulletinsResources_Inc_Input>
  _set: InputMaybe<BulletinsResources_Set_Input>
  where: BulletinsResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateCameraEmbedByIdArgs = {
  _inc: InputMaybe<CameraEmbeds_Inc_Input>
  _set: InputMaybe<CameraEmbeds_Set_Input>
  pk_columns: CameraEmbeds_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateCameraEmbedsArgs = {
  _inc: InputMaybe<CameraEmbeds_Inc_Input>
  _set: InputMaybe<CameraEmbeds_Set_Input>
  where: CameraEmbeds_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateCommentByIdArgs = {
  _inc: InputMaybe<Comments_Inc_Input>
  _set: InputMaybe<Comments_Set_Input>
  pk_columns: Comments_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateCommentsArgs = {
  _inc: InputMaybe<Comments_Inc_Input>
  _set: InputMaybe<Comments_Set_Input>
  where: Comments_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateConfigArgs = {
  _set: InputMaybe<Config_Set_Input>
  where: Config_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateConfigByKeyArgs = {
  _set: InputMaybe<Config_Set_Input>
  pk_columns: Config_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateContentByIdArgs = {
  _inc: InputMaybe<Contents_Inc_Input>
  _set: InputMaybe<Contents_Set_Input>
  pk_columns: Contents_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateContentsArgs = {
  _inc: InputMaybe<Contents_Inc_Input>
  _set: InputMaybe<Contents_Set_Input>
  where: Contents_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateContentsResourceByIdArgs = {
  _inc: InputMaybe<ContentsResources_Inc_Input>
  _set: InputMaybe<ContentsResources_Set_Input>
  pk_columns: ContentsResources_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateContentsResourcesArgs = {
  _inc: InputMaybe<ContentsResources_Inc_Input>
  _set: InputMaybe<ContentsResources_Set_Input>
  where: ContentsResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateDepartmentByIdArgs = {
  _inc: InputMaybe<Departments_Inc_Input>
  _set: InputMaybe<Departments_Set_Input>
  pk_columns: Departments_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateDepartmentFaqByIdArgs = {
  _inc: InputMaybe<DepartmentFaqs_Inc_Input>
  _set: InputMaybe<DepartmentFaqs_Set_Input>
  pk_columns: DepartmentFaqs_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateDepartmentFaqsArgs = {
  _inc: InputMaybe<DepartmentFaqs_Inc_Input>
  _set: InputMaybe<DepartmentFaqs_Set_Input>
  where: DepartmentFaqs_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateDepartmentQuicklinkByIdArgs = {
  _inc: InputMaybe<DepartmentQuicklinks_Inc_Input>
  _set: InputMaybe<DepartmentQuicklinks_Set_Input>
  pk_columns: DepartmentQuicklinks_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateDepartmentQuicklinksArgs = {
  _inc: InputMaybe<DepartmentQuicklinks_Inc_Input>
  _set: InputMaybe<DepartmentQuicklinks_Set_Input>
  where: DepartmentQuicklinks_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateDepartmentsArgs = {
  _inc: InputMaybe<Departments_Inc_Input>
  _set: InputMaybe<Departments_Set_Input>
  where: Departments_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateDiscussionByIdArgs = {
  _inc: InputMaybe<Discussions_Inc_Input>
  _set: InputMaybe<Discussions_Set_Input>
  pk_columns: Discussions_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateDiscussionsArgs = {
  _inc: InputMaybe<Discussions_Inc_Input>
  _set: InputMaybe<Discussions_Set_Input>
  where: Discussions_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateEventByIdArgs = {
  _inc: InputMaybe<Events_Inc_Input>
  _set: InputMaybe<Events_Set_Input>
  pk_columns: Events_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateEventTypeByIdArgs = {
  _set: InputMaybe<EventTypes_Set_Input>
  pk_columns: EventTypes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateEventTypesArgs = {
  _set: InputMaybe<EventTypes_Set_Input>
  where: EventTypes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateEventsArgs = {
  _inc: InputMaybe<Events_Inc_Input>
  _set: InputMaybe<Events_Set_Input>
  where: Events_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateFavoriteDiscussionByIdArgs = {
  _inc: InputMaybe<FavoriteDiscussions_Inc_Input>
  _set: InputMaybe<FavoriteDiscussions_Set_Input>
  pk_columns: FavoriteDiscussions_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateFavoriteDiscussionsArgs = {
  _inc: InputMaybe<FavoriteDiscussions_Inc_Input>
  _set: InputMaybe<FavoriteDiscussions_Set_Input>
  where: FavoriteDiscussions_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateFavoriteResourceByIdArgs = {
  _inc: InputMaybe<FavoriteResources_Inc_Input>
  _set: InputMaybe<FavoriteResources_Set_Input>
  pk_columns: FavoriteResources_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateFavoriteResourcesArgs = {
  _inc: InputMaybe<FavoriteResources_Inc_Input>
  _set: InputMaybe<FavoriteResources_Set_Input>
  where: FavoriteResources_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateGalleriesArgs = {
  _append: InputMaybe<Galleries_Append_Input>
  _delete_at_path: InputMaybe<Galleries_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Galleries_Delete_Elem_Input>
  _delete_key: InputMaybe<Galleries_Delete_Key_Input>
  _inc: InputMaybe<Galleries_Inc_Input>
  _prepend: InputMaybe<Galleries_Prepend_Input>
  _set: InputMaybe<Galleries_Set_Input>
  where: Galleries_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateGalleryByIdArgs = {
  _append: InputMaybe<Galleries_Append_Input>
  _delete_at_path: InputMaybe<Galleries_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Galleries_Delete_Elem_Input>
  _delete_key: InputMaybe<Galleries_Delete_Key_Input>
  _inc: InputMaybe<Galleries_Inc_Input>
  _prepend: InputMaybe<Galleries_Prepend_Input>
  _set: InputMaybe<Galleries_Set_Input>
  pk_columns: Galleries_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateGalleryPhotoByIdArgs = {
  _inc: InputMaybe<GalleryPhotos_Inc_Input>
  _set: InputMaybe<GalleryPhotos_Set_Input>
  pk_columns: GalleryPhotos_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateGalleryPhotosArgs = {
  _inc: InputMaybe<GalleryPhotos_Inc_Input>
  _set: InputMaybe<GalleryPhotos_Set_Input>
  where: GalleryPhotos_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateJobsiteByIdArgs = {
  _inc: InputMaybe<Jobsites_Inc_Input>
  _set: InputMaybe<Jobsites_Set_Input>
  pk_columns: Jobsites_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateJobsitesArgs = {
  _inc: InputMaybe<Jobsites_Inc_Input>
  _set: InputMaybe<Jobsites_Set_Input>
  where: Jobsites_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdatePageBySlugArgs = {
  _append: InputMaybe<Pages_Append_Input>
  _delete_at_path: InputMaybe<Pages_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Pages_Delete_Elem_Input>
  _delete_key: InputMaybe<Pages_Delete_Key_Input>
  _inc: InputMaybe<Pages_Inc_Input>
  _prepend: InputMaybe<Pages_Prepend_Input>
  _set: InputMaybe<Pages_Set_Input>
  pk_columns: Pages_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdatePagesArgs = {
  _append: InputMaybe<Pages_Append_Input>
  _delete_at_path: InputMaybe<Pages_Delete_At_Path_Input>
  _delete_elem: InputMaybe<Pages_Delete_Elem_Input>
  _delete_key: InputMaybe<Pages_Delete_Key_Input>
  _inc: InputMaybe<Pages_Inc_Input>
  _prepend: InputMaybe<Pages_Prepend_Input>
  _set: InputMaybe<Pages_Set_Input>
  where: Pages_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateResourceByIdArgs = {
  _inc: InputMaybe<Resources_Inc_Input>
  _set: InputMaybe<Resources_Set_Input>
  pk_columns: Resources_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateResourcesArgs = {
  _inc: InputMaybe<Resources_Inc_Input>
  _set: InputMaybe<Resources_Set_Input>
  where: Resources_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateRoleByValueArgs = {
  _set: InputMaybe<Roles_Set_Input>
  pk_columns: Roles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateRolesArgs = {
  _set: InputMaybe<Roles_Set_Input>
  where: Roles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateUploadByIdArgs = {
  _inc: InputMaybe<Uploads_Inc_Input>
  _set: InputMaybe<Uploads_Set_Input>
  pk_columns: Uploads_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateUploadsArgs = {
  _inc: InputMaybe<Uploads_Inc_Input>
  _set: InputMaybe<Uploads_Set_Input>
  where: Uploads_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateUserByIdArgs = {
  _inc: InputMaybe<Users_Inc_Input>
  _set: InputMaybe<Users_Set_Input>
  pk_columns: Users_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateUserRoleByIdArgs = {
  _inc: InputMaybe<UserRoles_Inc_Input>
  _set: InputMaybe<UserRoles_Set_Input>
  pk_columns: UserRoles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateUserRolesArgs = {
  _inc: InputMaybe<UserRoles_Inc_Input>
  _set: InputMaybe<UserRoles_Set_Input>
  where: UserRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _inc: InputMaybe<Users_Inc_Input>
  _set: InputMaybe<Users_Set_Input>
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Adp_ManyArgs = {
  updates: Array<Adp_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_BulletinDepartments_ManyArgs = {
  updates: Array<BulletinDepartments_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_BulletinsResources_ManyArgs = {
  updates: Array<BulletinsResources_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Bulletins_ManyArgs = {
  updates: Array<Bulletins_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CameraEmbeds_ManyArgs = {
  updates: Array<CameraEmbeds_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Config_ManyArgs = {
  updates: Array<Config_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ContentsResources_ManyArgs = {
  updates: Array<ContentsResources_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Contents_ManyArgs = {
  updates: Array<Contents_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_DepartmentFaqs_ManyArgs = {
  updates: Array<DepartmentFaqs_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_DepartmentQuicklinks_ManyArgs = {
  updates: Array<DepartmentQuicklinks_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Departments_ManyArgs = {
  updates: Array<Departments_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Discussions_ManyArgs = {
  updates: Array<Discussions_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_EventTypes_ManyArgs = {
  updates: Array<EventTypes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Events_OldArgs = {
  _inc: InputMaybe<Events_Old_Inc_Input>
  _set: InputMaybe<Events_Old_Set_Input>
  where: Events_Old_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Events_Old_By_PkArgs = {
  _inc: InputMaybe<Events_Old_Inc_Input>
  _set: InputMaybe<Events_Old_Set_Input>
  pk_columns: Events_Old_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Events_Old_ManyArgs = {
  updates: Array<Events_Old_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_FavoriteDiscussions_ManyArgs = {
  updates: Array<FavoriteDiscussions_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_FavoriteResources_ManyArgs = {
  updates: Array<FavoriteResources_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Galleries_ManyArgs = {
  updates: Array<Galleries_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_GalleryPhotos_ManyArgs = {
  updates: Array<GalleryPhotos_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Jobsites_ManyArgs = {
  updates: Array<Jobsites_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Pages_ManyArgs = {
  updates: Array<Pages_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Resources_ManyArgs = {
  updates: Array<Resources_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Uploads_ManyArgs = {
  updates: Array<Uploads_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_UserRoles_ManyArgs = {
  updates: Array<UserRoles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Associate_CertificationArgs = {
  _append: InputMaybe<V2_Adp_Associate_Certification_Append_Input>
  _delete_at_path: InputMaybe<V2_Adp_Associate_Certification_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Adp_Associate_Certification_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Adp_Associate_Certification_Delete_Key_Input>
  _prepend: InputMaybe<V2_Adp_Associate_Certification_Prepend_Input>
  _set: InputMaybe<V2_Adp_Associate_Certification_Set_Input>
  where: V2_Adp_Associate_Certification_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Associate_Certification_By_PkArgs = {
  _append: InputMaybe<V2_Adp_Associate_Certification_Append_Input>
  _delete_at_path: InputMaybe<V2_Adp_Associate_Certification_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Adp_Associate_Certification_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Adp_Associate_Certification_Delete_Key_Input>
  _prepend: InputMaybe<V2_Adp_Associate_Certification_Prepend_Input>
  _set: InputMaybe<V2_Adp_Associate_Certification_Set_Input>
  pk_columns: V2_Adp_Associate_Certification_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Associate_Certification_ManyArgs = {
  updates: Array<V2_Adp_Associate_Certification_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_AssociatesArgs = {
  _append: InputMaybe<V2_Adp_Associates_Append_Input>
  _delete_at_path: InputMaybe<V2_Adp_Associates_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Adp_Associates_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Adp_Associates_Delete_Key_Input>
  _prepend: InputMaybe<V2_Adp_Associates_Prepend_Input>
  _set: InputMaybe<V2_Adp_Associates_Set_Input>
  where: V2_Adp_Associates_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Associates_By_PkArgs = {
  _append: InputMaybe<V2_Adp_Associates_Append_Input>
  _delete_at_path: InputMaybe<V2_Adp_Associates_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Adp_Associates_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Adp_Associates_Delete_Key_Input>
  _prepend: InputMaybe<V2_Adp_Associates_Prepend_Input>
  _set: InputMaybe<V2_Adp_Associates_Set_Input>
  pk_columns: V2_Adp_Associates_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Associates_ManyArgs = {
  updates: Array<V2_Adp_Associates_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Certification_CategoriesArgs = {
  _set: InputMaybe<V2_Adp_Certification_Categories_Set_Input>
  where: V2_Adp_Certification_Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Certification_Categories_By_PkArgs = {
  _set: InputMaybe<V2_Adp_Certification_Categories_Set_Input>
  pk_columns: V2_Adp_Certification_Categories_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Certification_Categories_ManyArgs = {
  updates: Array<V2_Adp_Certification_Categories_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_CertificationsArgs = {
  _inc: InputMaybe<V2_Adp_Certifications_Inc_Input>
  _set: InputMaybe<V2_Adp_Certifications_Set_Input>
  where: V2_Adp_Certifications_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Certifications_By_PkArgs = {
  _inc: InputMaybe<V2_Adp_Certifications_Inc_Input>
  _set: InputMaybe<V2_Adp_Certifications_Set_Input>
  pk_columns: V2_Adp_Certifications_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Certifications_ManyArgs = {
  updates: Array<V2_Adp_Certifications_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_License_CategoriesArgs = {
  _set: InputMaybe<V2_Adp_License_Categories_Set_Input>
  where: V2_Adp_License_Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_License_Categories_By_PkArgs = {
  _set: InputMaybe<V2_Adp_License_Categories_Set_Input>
  pk_columns: V2_Adp_License_Categories_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_License_Categories_ManyArgs = {
  updates: Array<V2_Adp_License_Categories_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_LicensesArgs = {
  _set: InputMaybe<V2_Adp_Licenses_Set_Input>
  where: V2_Adp_Licenses_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Licenses_By_PkArgs = {
  _set: InputMaybe<V2_Adp_Licenses_Set_Input>
  pk_columns: V2_Adp_Licenses_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Adp_Licenses_ManyArgs = {
  updates: Array<V2_Adp_Licenses_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Docebo_CoursesArgs = {
  _append: InputMaybe<V2_Docebo_Courses_Append_Input>
  _delete_at_path: InputMaybe<V2_Docebo_Courses_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Docebo_Courses_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Docebo_Courses_Delete_Key_Input>
  _inc: InputMaybe<V2_Docebo_Courses_Inc_Input>
  _prepend: InputMaybe<V2_Docebo_Courses_Prepend_Input>
  _set: InputMaybe<V2_Docebo_Courses_Set_Input>
  where: V2_Docebo_Courses_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Docebo_Courses_By_PkArgs = {
  _append: InputMaybe<V2_Docebo_Courses_Append_Input>
  _delete_at_path: InputMaybe<V2_Docebo_Courses_Delete_At_Path_Input>
  _delete_elem: InputMaybe<V2_Docebo_Courses_Delete_Elem_Input>
  _delete_key: InputMaybe<V2_Docebo_Courses_Delete_Key_Input>
  _inc: InputMaybe<V2_Docebo_Courses_Inc_Input>
  _prepend: InputMaybe<V2_Docebo_Courses_Prepend_Input>
  _set: InputMaybe<V2_Docebo_Courses_Set_Input>
  pk_columns: V2_Docebo_Courses_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Docebo_Courses_ManyArgs = {
  updates: Array<V2_Docebo_Courses_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Nomination_ThumbsupArgs = {
  _inc: InputMaybe<V2_Nomination_Thumbsup_Inc_Input>
  _set: InputMaybe<V2_Nomination_Thumbsup_Set_Input>
  where: V2_Nomination_Thumbsup_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Nomination_Thumbsup_By_PkArgs = {
  _inc: InputMaybe<V2_Nomination_Thumbsup_Inc_Input>
  _set: InputMaybe<V2_Nomination_Thumbsup_Set_Input>
  pk_columns: V2_Nomination_Thumbsup_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Nomination_Thumbsup_ManyArgs = {
  updates: Array<V2_Nomination_Thumbsup_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_NominationsArgs = {
  _inc: InputMaybe<V2_Nominations_Inc_Input>
  _set: InputMaybe<V2_Nominations_Set_Input>
  where: V2_Nominations_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Nominations_By_PkArgs = {
  _inc: InputMaybe<V2_Nominations_Inc_Input>
  _set: InputMaybe<V2_Nominations_Set_Input>
  pk_columns: V2_Nominations_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Nominations_ManyArgs = {
  updates: Array<V2_Nominations_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_V2_Redemption_CodesArgs = {
  _inc: InputMaybe<V2_Redemption_Codes_Inc_Input>
  _set: InputMaybe<V2_Redemption_Codes_Set_Input>
  where: V2_Redemption_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_V2_Redemption_Codes_By_PkArgs = {
  _inc: InputMaybe<V2_Redemption_Codes_Inc_Input>
  _set: InputMaybe<V2_Redemption_Codes_Set_Input>
  pk_columns: V2_Redemption_Codes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_V2_Redemption_Codes_ManyArgs = {
  updates: Array<V2_Redemption_Codes_Updates>
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "v2.pages" */
export type Pages = {
  __typename?: 'pages'
  body: Maybe<Scalars['String']['output']>
  children: Maybe<Scalars['jsonb']['output']>
  createdAt: Scalars['timestamptz']['output']
  id: Scalars['Int']['output']
  /** An object relationship */
  masthead: Maybe<Uploads>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.pages" */
export type PagesChildrenArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "v2.pages" */
export type Pages_Aggregate = {
  __typename?: 'pages_aggregate'
  aggregate: Maybe<Pages_Aggregate_Fields>
  nodes: Array<Pages>
}

/** aggregate fields of "v2.pages" */
export type Pages_Aggregate_Fields = {
  __typename?: 'pages_aggregate_fields'
  avg: Maybe<Pages_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Pages_Max_Fields>
  min: Maybe<Pages_Min_Fields>
  stddev: Maybe<Pages_Stddev_Fields>
  stddev_pop: Maybe<Pages_Stddev_Pop_Fields>
  stddev_samp: Maybe<Pages_Stddev_Samp_Fields>
  sum: Maybe<Pages_Sum_Fields>
  var_pop: Maybe<Pages_Var_Pop_Fields>
  var_samp: Maybe<Pages_Var_Samp_Fields>
  variance: Maybe<Pages_Variance_Fields>
}

/** aggregate fields of "v2.pages" */
export type Pages_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Pages_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pages_Append_Input = {
  children: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type Pages_Avg_Fields = {
  __typename?: 'pages_avg_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.pages". All fields are combined with a logical 'AND'. */
export type Pages_Bool_Exp = {
  _and: InputMaybe<Array<Pages_Bool_Exp>>
  _not: InputMaybe<Pages_Bool_Exp>
  _or: InputMaybe<Array<Pages_Bool_Exp>>
  body: InputMaybe<String_Comparison_Exp>
  children: InputMaybe<Jsonb_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  masthead: InputMaybe<Uploads_Bool_Exp>
  mastheadUploadId: InputMaybe<Int_Comparison_Exp>
  slug: InputMaybe<String_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.pages" */
export enum Pages_Constraint {
  /** unique or primary key constraint on columns "slug" */
  PagesPkey = 'pages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pages_Delete_At_Path_Input = {
  children: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pages_Delete_Elem_Input = {
  children: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pages_Delete_Key_Input = {
  children: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "v2.pages" */
export type Pages_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.pages" */
export type Pages_Insert_Input = {
  body: InputMaybe<Scalars['String']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  masthead: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  slug: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Pages_Max_Fields = {
  __typename?: 'pages_max_fields'
  body: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  slug: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Pages_Min_Fields = {
  __typename?: 'pages_min_fields'
  body: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  id: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
  slug: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.pages" */
export type Pages_Mutation_Response = {
  __typename?: 'pages_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Pages>
}

/** on_conflict condition type for table "v2.pages" */
export type Pages_On_Conflict = {
  constraint: Pages_Constraint
  update_columns: Array<Pages_Update_Column>
  where: InputMaybe<Pages_Bool_Exp>
}

/** Ordering options when selecting data from "v2.pages". */
export type Pages_Order_By = {
  body: InputMaybe<Order_By>
  children: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  masthead: InputMaybe<Uploads_Order_By>
  mastheadUploadId: InputMaybe<Order_By>
  slug: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.pages */
export type Pages_Pk_Columns_Input = {
  slug: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pages_Prepend_Input = {
  children: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.pages" */
export enum Pages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Children = 'children',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MastheadUploadId = 'mastheadUploadId',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "v2.pages" */
export type Pages_Set_Input = {
  body: InputMaybe<Scalars['String']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  slug: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Pages_Stddev_Fields = {
  __typename?: 'pages_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Pages_Stddev_Pop_Fields = {
  __typename?: 'pages_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Pages_Stddev_Samp_Fields = {
  __typename?: 'pages_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "pages" */
export type Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pages_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Pages_Stream_Cursor_Value_Input = {
  body: InputMaybe<Scalars['String']['input']>
  children: InputMaybe<Scalars['jsonb']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  slug: InputMaybe<Scalars['String']['input']>
  title: InputMaybe<Scalars['String']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Pages_Sum_Fields = {
  __typename?: 'pages_sum_fields'
  id: Maybe<Scalars['Int']['output']>
  mastheadUploadId: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.pages" */
export enum Pages_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Children = 'children',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MastheadUploadId = 'mastheadUploadId',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Pages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<Pages_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<Pages_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<Pages_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<Pages_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Pages_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<Pages_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Pages_Set_Input>
  /** filter the rows which have to be updated */
  where: Pages_Bool_Exp
}

/** aggregate var_pop on columns */
export type Pages_Var_Pop_Fields = {
  __typename?: 'pages_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Pages_Var_Samp_Fields = {
  __typename?: 'pages_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Pages_Variance_Fields = {
  __typename?: 'pages_variance_fields'
  id: Maybe<Scalars['Float']['output']>
  mastheadUploadId: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.pto" */
export type Pto = {
  __typename?: 'pto'
  allDay: Maybe<Scalars['Boolean']['output']>
  endsAt: Maybe<Scalars['timestamp']['output']>
  startsAt: Maybe<Scalars['timestamp']['output']>
  /** An object relationship */
  user: Maybe<Users>
  userId: Maybe<Scalars['Int']['output']>
}

/** aggregated selection of "v2.pto" */
export type Pto_Aggregate = {
  __typename?: 'pto_aggregate'
  aggregate: Maybe<Pto_Aggregate_Fields>
  nodes: Array<Pto>
}

/** aggregate fields of "v2.pto" */
export type Pto_Aggregate_Fields = {
  __typename?: 'pto_aggregate_fields'
  avg: Maybe<Pto_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Pto_Max_Fields>
  min: Maybe<Pto_Min_Fields>
  stddev: Maybe<Pto_Stddev_Fields>
  stddev_pop: Maybe<Pto_Stddev_Pop_Fields>
  stddev_samp: Maybe<Pto_Stddev_Samp_Fields>
  sum: Maybe<Pto_Sum_Fields>
  var_pop: Maybe<Pto_Var_Pop_Fields>
  var_samp: Maybe<Pto_Var_Samp_Fields>
  variance: Maybe<Pto_Variance_Fields>
}

/** aggregate fields of "v2.pto" */
export type Pto_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Pto_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Pto_Avg_Fields = {
  __typename?: 'pto_avg_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.pto". All fields are combined with a logical 'AND'. */
export type Pto_Bool_Exp = {
  _and: InputMaybe<Array<Pto_Bool_Exp>>
  _not: InputMaybe<Pto_Bool_Exp>
  _or: InputMaybe<Array<Pto_Bool_Exp>>
  allDay: InputMaybe<Boolean_Comparison_Exp>
  endsAt: InputMaybe<Timestamp_Comparison_Exp>
  startsAt: InputMaybe<Timestamp_Comparison_Exp>
  user: InputMaybe<Users_Bool_Exp>
  userId: InputMaybe<Int_Comparison_Exp>
}

/** aggregate max on columns */
export type Pto_Max_Fields = {
  __typename?: 'pto_max_fields'
  endsAt: Maybe<Scalars['timestamp']['output']>
  startsAt: Maybe<Scalars['timestamp']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** aggregate min on columns */
export type Pto_Min_Fields = {
  __typename?: 'pto_min_fields'
  endsAt: Maybe<Scalars['timestamp']['output']>
  startsAt: Maybe<Scalars['timestamp']['output']>
  userId: Maybe<Scalars['Int']['output']>
}

/** Ordering options when selecting data from "v2.pto". */
export type Pto_Order_By = {
  allDay: InputMaybe<Order_By>
  endsAt: InputMaybe<Order_By>
  startsAt: InputMaybe<Order_By>
  user: InputMaybe<Users_Order_By>
  userId: InputMaybe<Order_By>
}

/** select columns of table "v2.pto" */
export enum Pto_Select_Column {
  /** column name */
  AllDay = 'allDay',
  /** column name */
  EndsAt = 'endsAt',
  /** column name */
  StartsAt = 'startsAt',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type Pto_Stddev_Fields = {
  __typename?: 'pto_stddev_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Pto_Stddev_Pop_Fields = {
  __typename?: 'pto_stddev_pop_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Pto_Stddev_Samp_Fields = {
  __typename?: 'pto_stddev_samp_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "pto" */
export type Pto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pto_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Pto_Stream_Cursor_Value_Input = {
  allDay: InputMaybe<Scalars['Boolean']['input']>
  endsAt: InputMaybe<Scalars['timestamp']['input']>
  startsAt: InputMaybe<Scalars['timestamp']['input']>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type Pto_Sum_Fields = {
  __typename?: 'pto_sum_fields'
  userId: Maybe<Scalars['Int']['output']>
}

/** aggregate var_pop on columns */
export type Pto_Var_Pop_Fields = {
  __typename?: 'pto_var_pop_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Pto_Var_Samp_Fields = {
  __typename?: 'pto_var_samp_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Pto_Variance_Fields = {
  __typename?: 'pto_variance_fields'
  userId: Maybe<Scalars['Float']['output']>
}

export type Query_Root = {
  __typename?: 'query_root'
  /** fetch data from the table: "v2.adp" */
  adp: Array<Adp>
  /** fetch data from the table: "v2.adp" using primary key columns */
  adpById: Maybe<Adp>
  /** fetch aggregated fields from the table: "v2.adp" */
  adp_aggregate: Adp_Aggregate
  /** fetch data from the table: "v2.bulletins" using primary key columns */
  bulletinById: Maybe<Bulletins>
  /** fetch data from the table: "v2.bulletin_department" using primary key columns */
  bulletinDepartmentById: Maybe<BulletinDepartments>
  /** An array relationship */
  bulletinDepartments: Array<BulletinDepartments>
  /** fetch data from the table: "v2.bulletins" */
  bulletins: Array<Bulletins>
  /** fetch data from the table: "v2.bulletins_resources" using primary key columns */
  bulletinsResourceById: Maybe<BulletinsResources>
  /** fetch data from the table: "v2.bulletins_resources" */
  bulletinsResources: Array<BulletinsResources>
  /** fetch data from the table: "v2.camera_embeds" using primary key columns */
  cameraEmbedById: Maybe<CameraEmbeds>
  /** fetch data from the table: "v2.camera_embeds" */
  cameraEmbeds: Array<CameraEmbeds>
  /** fetch data from the table: "v2.comments" using primary key columns */
  commentById: Maybe<Comments>
  /** An array relationship */
  comments: Array<Comments>
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate
  /** fetch data from the table: "v2.config" */
  config: Array<Config>
  /** fetch data from the table: "v2.config" using primary key columns */
  configByKey: Maybe<Config>
  /** fetch aggregated fields from the table: "v2.config" */
  config_aggregate: Config_Aggregate
  /** fetch data from the table: "v2.department_contents" using primary key columns */
  contentById: Maybe<Contents>
  /** An array relationship */
  contents: Array<Contents>
  /** fetch data from the table: "v2.department_contents_resources" using primary key columns */
  contentsResourceById: Maybe<ContentsResources>
  /** fetch data from the table: "v2.department_contents_resources" */
  contentsResources: Array<ContentsResources>
  currentUser: Maybe<CurrentUserOutput>
  /** fetch data from the table: "v2.departments" using primary key columns */
  departmentById: Maybe<Departments>
  /** fetch data from the table: "v2.department_faqs" using primary key columns */
  departmentFaqById: Maybe<DepartmentFaqs>
  /** fetch data from the table: "v2.department_faqs" */
  departmentFaqs: Array<DepartmentFaqs>
  /** fetch data from the table: "v2.department_quicklinks" using primary key columns */
  departmentQuicklinkById: Maybe<DepartmentQuicklinks>
  /** fetch data from the table: "v2.department_quicklinks" */
  departmentQuicklinks: Array<DepartmentQuicklinks>
  /** fetch data from the table: "v2.departments" */
  departments: Array<Departments>
  /** fetch data from the table: "v2.discussions" using primary key columns */
  discussionById: Maybe<Discussions>
  /** An array relationship */
  discussions: Array<Discussions>
  /** fetch data from the table: "v2.events" using primary key columns */
  eventById: Maybe<Events>
  /** fetch data from the table: "v2.event_types" using primary key columns */
  eventTypeById: Maybe<EventTypes>
  /** fetch data from the table: "v2.event_types" */
  eventTypes: Array<EventTypes>
  /** fetch data from the table: "v2.events" */
  events: Array<Events>
  /** fetch data from the table: "events" */
  events_old: Array<Events_Old>
  /** fetch aggregated fields from the table: "events" */
  events_old_aggregate: Events_Old_Aggregate
  /** fetch data from the table: "events" using primary key columns */
  events_old_by_pk: Maybe<Events_Old>
  /** An array relationship */
  favoriteDiscussions: Array<FavoriteDiscussions>
  /** fetch data from the table: "v2.favorite_discussions" using primary key columns */
  favoriteDiscussionsById: Maybe<FavoriteDiscussions>
  /** An aggregate relationship */
  favoriteDiscussions_aggregate: FavoriteDiscussions_Aggregate
  /** An array relationship */
  favoriteResources: Array<FavoriteResources>
  /** fetch data from the table: "v2.favorite_resources" using primary key columns */
  favoriteResourcesById: Maybe<FavoriteResources>
  /** An aggregate relationship */
  favoriteResources_aggregate: FavoriteResources_Aggregate
  /** fetch data from the table: "v2.galleries" */
  galleries: Array<Galleries>
  /** fetch data from the table: "v2.galleries" using primary key columns */
  galleryById: Maybe<Galleries>
  /** fetch data from the table: "v2.gallery_photos" using primary key columns */
  galleryPhotoById: Maybe<GalleryPhotos>
  /** fetch data from the table: "v2.gallery_photos" */
  galleryPhotos: Array<GalleryPhotos>
  iosRedemptionCode: Maybe<RedemptionCodeOutput>
  /** fetch data from the table: "v2.jobsites" */
  jobsites: Array<Jobsites>
  /** fetch data from the table: "v2.jobsites" using primary key columns */
  jobsitesById: Maybe<Jobsites>
  /** fetch data from the table: "v2.pages" */
  pages: Array<Pages>
  /** fetch data from the table: "v2.pages" using primary key columns */
  pagesBySlug: Maybe<Pages>
  /** fetch data from the table: "v2.pto" */
  pto: Array<Pto>
  /** fetch aggregated fields from the table: "v2.pto" */
  pto_aggregate: Pto_Aggregate
  /** fetch data from the table: "v2.resources" using primary key columns */
  resourceById: Maybe<Resources>
  /** fetch data from the table: "v2.resources" */
  resources: Array<Resources>
  /** fetch data from the table: "v2.roles" using primary key columns */
  roleByValue: Maybe<Roles>
  /** fetch data from the table: "v2.roles" */
  roles: Array<Roles>
  /** fetch aggregated fields from the table: "v2.roles" */
  roles_aggregate: Roles_Aggregate
  /** fetch data from the table: "v2.search" */
  search: Array<Search>
  /** fetch data from the table: "v2.uploads" using primary key columns */
  uploadById: Maybe<Uploads>
  /** fetch data from the table: "v2.uploads" */
  uploads: Array<Uploads>
  /** fetch data from the table: "v2.users" using primary key columns */
  userById: Maybe<Users>
  /** fetch data from the table: "v2.user_roles" using primary key columns */
  userRoleById: Maybe<UserRoles>
  /** fetch data from the table: "v2.user_roles" */
  userRoles: Array<UserRoles>
  /** fetch aggregated fields from the table: "v2.user_roles" */
  userRoles_aggregate: UserRoles_Aggregate
  /** fetch data from the table: "v2.users" */
  users: Array<Users>
  /** fetch data from the table: "v2.adp_associate_certification" */
  v2_adp_associate_certification: Array<V2_Adp_Associate_Certification>
  /** fetch aggregated fields from the table: "v2.adp_associate_certification" */
  v2_adp_associate_certification_aggregate: V2_Adp_Associate_Certification_Aggregate
  /** fetch data from the table: "v2.adp_associate_certification" using primary key columns */
  v2_adp_associate_certification_by_pk: Maybe<V2_Adp_Associate_Certification>
  /** fetch data from the table: "v2.adp_associates" */
  v2_adp_associates: Array<V2_Adp_Associates>
  /** fetch aggregated fields from the table: "v2.adp_associates" */
  v2_adp_associates_aggregate: V2_Adp_Associates_Aggregate
  /** fetch data from the table: "v2.adp_associates" using primary key columns */
  v2_adp_associates_by_pk: Maybe<V2_Adp_Associates>
  /** fetch data from the table: "v2.adp_certification_categories" */
  v2_adp_certification_categories: Array<V2_Adp_Certification_Categories>
  /** fetch aggregated fields from the table: "v2.adp_certification_categories" */
  v2_adp_certification_categories_aggregate: V2_Adp_Certification_Categories_Aggregate
  /** fetch data from the table: "v2.adp_certification_categories" using primary key columns */
  v2_adp_certification_categories_by_pk: Maybe<V2_Adp_Certification_Categories>
  /** fetch data from the table: "v2.adp_certifications" */
  v2_adp_certifications: Array<V2_Adp_Certifications>
  /** fetch aggregated fields from the table: "v2.adp_certifications" */
  v2_adp_certifications_aggregate: V2_Adp_Certifications_Aggregate
  /** fetch data from the table: "v2.adp_certifications" using primary key columns */
  v2_adp_certifications_by_pk: Maybe<V2_Adp_Certifications>
  /** fetch data from the table: "v2.adp_license_categories" */
  v2_adp_license_categories: Array<V2_Adp_License_Categories>
  /** fetch aggregated fields from the table: "v2.adp_license_categories" */
  v2_adp_license_categories_aggregate: V2_Adp_License_Categories_Aggregate
  /** fetch data from the table: "v2.adp_license_categories" using primary key columns */
  v2_adp_license_categories_by_pk: Maybe<V2_Adp_License_Categories>
  /** fetch data from the table: "v2.adp_licenses" */
  v2_adp_licenses: Array<V2_Adp_Licenses>
  /** fetch aggregated fields from the table: "v2.adp_licenses" */
  v2_adp_licenses_aggregate: V2_Adp_Licenses_Aggregate
  /** fetch data from the table: "v2.adp_licenses" using primary key columns */
  v2_adp_licenses_by_pk: Maybe<V2_Adp_Licenses>
  /** fetch data from the table: "v2.docebo_courses" */
  v2_docebo_courses: Array<V2_Docebo_Courses>
  /** fetch aggregated fields from the table: "v2.docebo_courses" */
  v2_docebo_courses_aggregate: V2_Docebo_Courses_Aggregate
  /** fetch data from the table: "v2.docebo_courses" using primary key columns */
  v2_docebo_courses_by_pk: Maybe<V2_Docebo_Courses>
  /** fetch data from the table: "v2.months" */
  v2_months: Array<V2_Months>
  /** fetch aggregated fields from the table: "v2.months" */
  v2_months_aggregate: V2_Months_Aggregate
  /** fetch data from the table: "v2.nomination_thumbsup" */
  v2_nomination_thumbsup: Array<V2_Nomination_Thumbsup>
  /** fetch aggregated fields from the table: "v2.nomination_thumbsup" */
  v2_nomination_thumbsup_aggregate: V2_Nomination_Thumbsup_Aggregate
  /** fetch data from the table: "v2.nomination_thumbsup" using primary key columns */
  v2_nomination_thumbsup_by_pk: Maybe<V2_Nomination_Thumbsup>
  /** fetch data from the table: "v2.nominations" */
  v2_nominations: Array<V2_Nominations>
  /** fetch aggregated fields from the table: "v2.nominations" */
  v2_nominations_aggregate: V2_Nominations_Aggregate
  /** fetch data from the table: "v2.nominations" using primary key columns */
  v2_nominations_by_pk: Maybe<V2_Nominations>
  /** fetch data from the table: "v2.redemption_codes" */
  v2_redemption_codes: Array<V2_Redemption_Codes>
  /** fetch aggregated fields from the table: "v2.redemption_codes" */
  v2_redemption_codes_aggregate: V2_Redemption_Codes_Aggregate
  /** fetch data from the table: "v2.redemption_codes" using primary key columns */
  v2_redemption_codes_by_pk: Maybe<V2_Redemption_Codes>
  /** fetch aggregated fields from the table: "v2.bulletin_department" */
  zaggBulletinDepartments: BulletinDepartments_Aggregate
  /** fetch aggregated fields from the table: "v2.bulletins" */
  zaggBulletins: Bulletins_Aggregate
  /** fetch aggregated fields from the table: "v2.bulletins_resources" */
  zaggBulletinsResources: BulletinsResources_Aggregate
  /** fetch aggregated fields from the table: "v2.camera_embeds" */
  zaggCameraEmbeds: CameraEmbeds_Aggregate
  /** fetch aggregated fields from the table: "v2.department_contents" */
  zaggContents: Contents_Aggregate
  /** fetch aggregated fields from the table: "v2.department_contents_resources" */
  zaggContentsResources: ContentsResources_Aggregate
  /** fetch aggregated fields from the table: "v2.department_faqs" */
  zaggDepartmentFaqs: DepartmentFaqs_Aggregate
  /** fetch aggregated fields from the table: "v2.department_quicklinks" */
  zaggDepartmentQuicklinks: DepartmentQuicklinks_Aggregate
  /** fetch aggregated fields from the table: "v2.departments" */
  zaggDepartments: Departments_Aggregate
  /** fetch aggregated fields from the table: "v2.discussions" */
  zaggDiscussions: Discussions_Aggregate
  /** fetch aggregated fields from the table: "v2.event_types" */
  zaggEventTypes: EventTypes_Aggregate
  /** fetch aggregated fields from the table: "v2.events" */
  zaggEvents: Events_Aggregate
  /** fetch aggregated fields from the table: "v2.galleries" */
  zaggGalleries: Galleries_Aggregate
  /** fetch aggregated fields from the table: "v2.gallery_photos" */
  zaggGalleryPhotos: GalleryPhotos_Aggregate
  /** fetch aggregated fields from the table: "v2.jobsites" */
  zaggJobsites: Jobsites_Aggregate
  /** fetch aggregated fields from the table: "v2.pages" */
  zaggPages: Pages_Aggregate
  /** fetch aggregated fields from the table: "v2.resources" */
  zaggResources: Resources_Aggregate
  /** fetch aggregated fields from the table: "v2.search" */
  zaggSearch: Search_Aggregate
  /** fetch aggregated fields from the table: "v2.uploads" */
  zaggUploads: Uploads_Aggregate
  /** fetch aggregated fields from the table: "v2.users" */
  zaggUsers: Users_Aggregate
}

export type Query_RootAdpArgs = {
  distinct_on: InputMaybe<Array<Adp_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Adp_Order_By>>
  where: InputMaybe<Adp_Bool_Exp>
}

export type Query_RootAdpByIdArgs = {
  id: Scalars['String']['input']
}

export type Query_RootAdp_AggregateArgs = {
  distinct_on: InputMaybe<Array<Adp_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Adp_Order_By>>
  where: InputMaybe<Adp_Bool_Exp>
}

export type Query_RootBulletinByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootBulletinDepartmentByIdArgs = {
  bulletinId: Scalars['Int']['input']
  departmentId: Scalars['Int']['input']
}

export type Query_RootBulletinDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

export type Query_RootBulletinsArgs = {
  distinct_on: InputMaybe<Array<Bulletins_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Bulletins_Order_By>>
  where: InputMaybe<Bulletins_Bool_Exp>
}

export type Query_RootBulletinsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootBulletinsResourcesArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

export type Query_RootCameraEmbedByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootCameraEmbedsArgs = {
  distinct_on: InputMaybe<Array<CameraEmbeds_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<CameraEmbeds_Order_By>>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

export type Query_RootCommentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootCommentsArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

export type Query_RootComments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

export type Query_RootConfigArgs = {
  distinct_on: InputMaybe<Array<Config_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Config_Order_By>>
  where: InputMaybe<Config_Bool_Exp>
}

export type Query_RootConfigByKeyArgs = {
  key: Scalars['String']['input']
}

export type Query_RootConfig_AggregateArgs = {
  distinct_on: InputMaybe<Array<Config_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Config_Order_By>>
  where: InputMaybe<Config_Bool_Exp>
}

export type Query_RootContentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

export type Query_RootContentsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootContentsResourcesArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

export type Query_RootDepartmentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootDepartmentFaqByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootDepartmentFaqsArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

export type Query_RootDepartmentQuicklinkByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootDepartmentQuicklinksArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

export type Query_RootDepartmentsArgs = {
  distinct_on: InputMaybe<Array<Departments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Departments_Order_By>>
  where: InputMaybe<Departments_Bool_Exp>
}

export type Query_RootDiscussionByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootDiscussionsArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

export type Query_RootEventByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootEventTypeByIdArgs = {
  value: Scalars['String']['input']
}

export type Query_RootEventTypesArgs = {
  distinct_on: InputMaybe<Array<EventTypes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<EventTypes_Order_By>>
  where: InputMaybe<EventTypes_Bool_Exp>
}

export type Query_RootEventsArgs = {
  distinct_on: InputMaybe<Array<Events_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Order_By>>
  where: InputMaybe<Events_Bool_Exp>
}

export type Query_RootEvents_OldArgs = {
  distinct_on: InputMaybe<Array<Events_Old_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Old_Order_By>>
  where: InputMaybe<Events_Old_Bool_Exp>
}

export type Query_RootEvents_Old_AggregateArgs = {
  distinct_on: InputMaybe<Array<Events_Old_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Old_Order_By>>
  where: InputMaybe<Events_Old_Bool_Exp>
}

export type Query_RootEvents_Old_By_PkArgs = {
  id: Scalars['bigint']['input']
}

export type Query_RootFavoriteDiscussionsArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

export type Query_RootFavoriteDiscussionsByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootFavoriteDiscussions_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

export type Query_RootFavoriteResourcesArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

export type Query_RootFavoriteResourcesByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootFavoriteResources_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

export type Query_RootGalleriesArgs = {
  distinct_on: InputMaybe<Array<Galleries_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Galleries_Order_By>>
  where: InputMaybe<Galleries_Bool_Exp>
}

export type Query_RootGalleryByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootGalleryPhotoByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootGalleryPhotosArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

export type Query_RootJobsitesArgs = {
  distinct_on: InputMaybe<Array<Jobsites_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Jobsites_Order_By>>
  where: InputMaybe<Jobsites_Bool_Exp>
}

export type Query_RootJobsitesByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootPagesArgs = {
  distinct_on: InputMaybe<Array<Pages_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pages_Order_By>>
  where: InputMaybe<Pages_Bool_Exp>
}

export type Query_RootPagesBySlugArgs = {
  slug: Scalars['String']['input']
}

export type Query_RootPtoArgs = {
  distinct_on: InputMaybe<Array<Pto_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pto_Order_By>>
  where: InputMaybe<Pto_Bool_Exp>
}

export type Query_RootPto_AggregateArgs = {
  distinct_on: InputMaybe<Array<Pto_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pto_Order_By>>
  where: InputMaybe<Pto_Bool_Exp>
}

export type Query_RootResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootResourcesArgs = {
  distinct_on: InputMaybe<Array<Resources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Resources_Order_By>>
  where: InputMaybe<Resources_Bool_Exp>
}

export type Query_RootRoleByValueArgs = {
  value: Scalars['String']['input']
}

export type Query_RootRolesArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Roles_Order_By>>
  where: InputMaybe<Roles_Bool_Exp>
}

export type Query_RootRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Roles_Order_By>>
  where: InputMaybe<Roles_Bool_Exp>
}

export type Query_RootSearchArgs = {
  distinct_on: InputMaybe<Array<Search_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Search_Order_By>>
  where: InputMaybe<Search_Bool_Exp>
}

export type Query_RootUploadByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootUploadsArgs = {
  distinct_on: InputMaybe<Array<Uploads_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Uploads_Order_By>>
  where: InputMaybe<Uploads_Bool_Exp>
}

export type Query_RootUserByIdArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootUserRoleByIdArgs = {
  role: Roles_Enum
  userId: Scalars['Int']['input']
}

export type Query_RootUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

export type Query_RootUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

export type Query_RootUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

export type Query_RootV2_Adp_Associate_CertificationArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associate_Certification_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associate_Certification_Order_By>>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

export type Query_RootV2_Adp_Associate_Certification_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associate_Certification_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associate_Certification_Order_By>>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

export type Query_RootV2_Adp_Associate_Certification_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Query_RootV2_Adp_AssociatesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associates_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associates_Order_By>>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

export type Query_RootV2_Adp_Associates_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associates_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associates_Order_By>>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

export type Query_RootV2_Adp_Associates_By_PkArgs = {
  associate_oid: Scalars['String']['input']
}

export type Query_RootV2_Adp_Certification_CategoriesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certification_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certification_Categories_Order_By>>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

export type Query_RootV2_Adp_Certification_Categories_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certification_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certification_Categories_Order_By>>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

export type Query_RootV2_Adp_Certification_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Query_RootV2_Adp_CertificationsArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certifications_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certifications_Order_By>>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

export type Query_RootV2_Adp_Certifications_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certifications_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certifications_Order_By>>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

export type Query_RootV2_Adp_Certifications_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Query_RootV2_Adp_License_CategoriesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_License_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_License_Categories_Order_By>>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

export type Query_RootV2_Adp_License_Categories_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_License_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_License_Categories_Order_By>>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

export type Query_RootV2_Adp_License_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Query_RootV2_Adp_LicensesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Licenses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Licenses_Order_By>>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

export type Query_RootV2_Adp_Licenses_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Licenses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Licenses_Order_By>>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

export type Query_RootV2_Adp_Licenses_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Query_RootV2_Docebo_CoursesArgs = {
  distinct_on: InputMaybe<Array<V2_Docebo_Courses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Docebo_Courses_Order_By>>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

export type Query_RootV2_Docebo_Courses_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Docebo_Courses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Docebo_Courses_Order_By>>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

export type Query_RootV2_Docebo_Courses_By_PkArgs = {
  uid: Scalars['String']['input']
}

export type Query_RootV2_MonthsArgs = {
  distinct_on: InputMaybe<Array<V2_Months_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Months_Order_By>>
  where: InputMaybe<V2_Months_Bool_Exp>
}

export type Query_RootV2_Months_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Months_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Months_Order_By>>
  where: InputMaybe<V2_Months_Bool_Exp>
}

export type Query_RootV2_Nomination_ThumbsupArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

export type Query_RootV2_Nomination_Thumbsup_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

export type Query_RootV2_Nomination_Thumbsup_By_PkArgs = {
  nomination_id: Scalars['Int']['input']
  user_id: Scalars['Int']['input']
}

export type Query_RootV2_NominationsArgs = {
  distinct_on: InputMaybe<Array<V2_Nominations_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nominations_Order_By>>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

export type Query_RootV2_Nominations_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Nominations_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nominations_Order_By>>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

export type Query_RootV2_Nominations_By_PkArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootV2_Redemption_CodesArgs = {
  distinct_on: InputMaybe<Array<V2_Redemption_Codes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Redemption_Codes_Order_By>>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

export type Query_RootV2_Redemption_Codes_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Redemption_Codes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Redemption_Codes_Order_By>>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

export type Query_RootV2_Redemption_Codes_By_PkArgs = {
  id: Scalars['Int']['input']
}

export type Query_RootZaggBulletinDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

export type Query_RootZaggBulletinsArgs = {
  distinct_on: InputMaybe<Array<Bulletins_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Bulletins_Order_By>>
  where: InputMaybe<Bulletins_Bool_Exp>
}

export type Query_RootZaggBulletinsResourcesArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

export type Query_RootZaggCameraEmbedsArgs = {
  distinct_on: InputMaybe<Array<CameraEmbeds_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<CameraEmbeds_Order_By>>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

export type Query_RootZaggContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

export type Query_RootZaggContentsResourcesArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

export type Query_RootZaggDepartmentFaqsArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

export type Query_RootZaggDepartmentQuicklinksArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

export type Query_RootZaggDepartmentsArgs = {
  distinct_on: InputMaybe<Array<Departments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Departments_Order_By>>
  where: InputMaybe<Departments_Bool_Exp>
}

export type Query_RootZaggDiscussionsArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

export type Query_RootZaggEventTypesArgs = {
  distinct_on: InputMaybe<Array<EventTypes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<EventTypes_Order_By>>
  where: InputMaybe<EventTypes_Bool_Exp>
}

export type Query_RootZaggEventsArgs = {
  distinct_on: InputMaybe<Array<Events_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Order_By>>
  where: InputMaybe<Events_Bool_Exp>
}

export type Query_RootZaggGalleriesArgs = {
  distinct_on: InputMaybe<Array<Galleries_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Galleries_Order_By>>
  where: InputMaybe<Galleries_Bool_Exp>
}

export type Query_RootZaggGalleryPhotosArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

export type Query_RootZaggJobsitesArgs = {
  distinct_on: InputMaybe<Array<Jobsites_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Jobsites_Order_By>>
  where: InputMaybe<Jobsites_Bool_Exp>
}

export type Query_RootZaggPagesArgs = {
  distinct_on: InputMaybe<Array<Pages_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pages_Order_By>>
  where: InputMaybe<Pages_Bool_Exp>
}

export type Query_RootZaggResourcesArgs = {
  distinct_on: InputMaybe<Array<Resources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Resources_Order_By>>
  where: InputMaybe<Resources_Bool_Exp>
}

export type Query_RootZaggSearchArgs = {
  distinct_on: InputMaybe<Array<Search_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Search_Order_By>>
  where: InputMaybe<Search_Bool_Exp>
}

export type Query_RootZaggUploadsArgs = {
  distinct_on: InputMaybe<Array<Uploads_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Uploads_Order_By>>
  where: InputMaybe<Uploads_Bool_Exp>
}

export type Query_RootZaggUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** columns and relationships of "v2.resources" */
export type Resources = {
  __typename?: 'resources'
  createdAt: Scalars['timestamptz']['output']
  deleted: Maybe<Scalars['Boolean']['output']>
  /** An object relationship */
  departmentContentsResources: Maybe<ContentsResources>
  description: Maybe<Scalars['String']['output']>
  /** An object relationship */
  file: Maybe<Uploads>
  fileUploadId: Maybe<Scalars['Int']['output']>
  global: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  modelType: Scalars['bpchar']['output']
  title: Scalars['String']['output']
}

/** aggregated selection of "v2.resources" */
export type Resources_Aggregate = {
  __typename?: 'resources_aggregate'
  aggregate: Maybe<Resources_Aggregate_Fields>
  nodes: Array<Resources>
}

/** aggregate fields of "v2.resources" */
export type Resources_Aggregate_Fields = {
  __typename?: 'resources_aggregate_fields'
  avg: Maybe<Resources_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Resources_Max_Fields>
  min: Maybe<Resources_Min_Fields>
  stddev: Maybe<Resources_Stddev_Fields>
  stddev_pop: Maybe<Resources_Stddev_Pop_Fields>
  stddev_samp: Maybe<Resources_Stddev_Samp_Fields>
  sum: Maybe<Resources_Sum_Fields>
  var_pop: Maybe<Resources_Var_Pop_Fields>
  var_samp: Maybe<Resources_Var_Samp_Fields>
  variance: Maybe<Resources_Variance_Fields>
}

/** aggregate fields of "v2.resources" */
export type Resources_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Resources_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Resources_Avg_Fields = {
  __typename?: 'resources_avg_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.resources". All fields are combined with a logical 'AND'. */
export type Resources_Bool_Exp = {
  _and: InputMaybe<Array<Resources_Bool_Exp>>
  _not: InputMaybe<Resources_Bool_Exp>
  _or: InputMaybe<Array<Resources_Bool_Exp>>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  deleted: InputMaybe<Boolean_Comparison_Exp>
  departmentContentsResources: InputMaybe<ContentsResources_Bool_Exp>
  description: InputMaybe<String_Comparison_Exp>
  file: InputMaybe<Uploads_Bool_Exp>
  fileUploadId: InputMaybe<Int_Comparison_Exp>
  global: InputMaybe<Boolean_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  modelType: InputMaybe<Bpchar_Comparison_Exp>
  title: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.resources" */
export enum Resources_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResourcesPkey = 'resources_pkey'
}

/** input type for incrementing numeric columns in table "v2.resources" */
export type Resources_Inc_Input = {
  fileUploadId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.resources" */
export type Resources_Insert_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  deleted: InputMaybe<Scalars['Boolean']['input']>
  departmentContentsResources: InputMaybe<ContentsResources_Obj_Rel_Insert_Input>
  description: InputMaybe<Scalars['String']['input']>
  file: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  fileUploadId: InputMaybe<Scalars['Int']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  title: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Resources_Max_Fields = {
  __typename?: 'resources_max_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  fileUploadId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  modelType: Maybe<Scalars['bpchar']['output']>
  title: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Resources_Min_Fields = {
  __typename?: 'resources_min_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  fileUploadId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  modelType: Maybe<Scalars['bpchar']['output']>
  title: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.resources" */
export type Resources_Mutation_Response = {
  __typename?: 'resources_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Resources>
}

/** input type for inserting object relation for remote table "v2.resources" */
export type Resources_Obj_Rel_Insert_Input = {
  data: Resources_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Resources_On_Conflict>
}

/** on_conflict condition type for table "v2.resources" */
export type Resources_On_Conflict = {
  constraint: Resources_Constraint
  update_columns: Array<Resources_Update_Column>
  where: InputMaybe<Resources_Bool_Exp>
}

/** Ordering options when selecting data from "v2.resources". */
export type Resources_Order_By = {
  createdAt: InputMaybe<Order_By>
  deleted: InputMaybe<Order_By>
  departmentContentsResources: InputMaybe<ContentsResources_Order_By>
  description: InputMaybe<Order_By>
  file: InputMaybe<Uploads_Order_By>
  fileUploadId: InputMaybe<Order_By>
  global: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  modelType: InputMaybe<Order_By>
  title: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.resources */
export type Resources_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.resources" */
export enum Resources_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  FileUploadId = 'fileUploadId',
  /** column name */
  Global = 'global',
  /** column name */
  Id = 'id',
  /** column name */
  ModelType = 'modelType',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "v2.resources" */
export type Resources_Set_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  deleted: InputMaybe<Scalars['Boolean']['input']>
  description: InputMaybe<Scalars['String']['input']>
  fileUploadId: InputMaybe<Scalars['Int']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  title: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Resources_Stddev_Fields = {
  __typename?: 'resources_stddev_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Resources_Stddev_Pop_Fields = {
  __typename?: 'resources_stddev_pop_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Resources_Stddev_Samp_Fields = {
  __typename?: 'resources_stddev_samp_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "resources" */
export type Resources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resources_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Resources_Stream_Cursor_Value_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  deleted: InputMaybe<Scalars['Boolean']['input']>
  description: InputMaybe<Scalars['String']['input']>
  fileUploadId: InputMaybe<Scalars['Int']['input']>
  global: InputMaybe<Scalars['Boolean']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['bpchar']['input']>
  title: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Resources_Sum_Fields = {
  __typename?: 'resources_sum_fields'
  fileUploadId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.resources" */
export enum Resources_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Description = 'description',
  /** column name */
  FileUploadId = 'fileUploadId',
  /** column name */
  Global = 'global',
  /** column name */
  Id = 'id',
  /** column name */
  ModelType = 'modelType',
  /** column name */
  Title = 'title'
}

export type Resources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Resources_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Resources_Set_Input>
  /** filter the rows which have to be updated */
  where: Resources_Bool_Exp
}

/** aggregate var_pop on columns */
export type Resources_Var_Pop_Fields = {
  __typename?: 'resources_var_pop_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Resources_Var_Samp_Fields = {
  __typename?: 'resources_var_samp_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Resources_Variance_Fields = {
  __typename?: 'resources_variance_fields'
  fileUploadId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.roles" */
export type Roles = {
  __typename?: 'roles'
  comment: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

/** aggregated selection of "v2.roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate'
  aggregate: Maybe<Roles_Aggregate_Fields>
  nodes: Array<Roles>
}

/** aggregate fields of "v2.roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<Roles_Max_Fields>
  min: Maybe<Roles_Min_Fields>
}

/** aggregate fields of "v2.roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Roles_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and: InputMaybe<Array<Roles_Bool_Exp>>
  _not: InputMaybe<Roles_Bool_Exp>
  _or: InputMaybe<Array<Roles_Bool_Exp>>
  comment: InputMaybe<String_Comparison_Exp>
  value: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "value" */
  RolesPkey = 'roles_pkey'
}

export enum Roles_Enum {
  Crisis = 'Crisis',
  Editor = 'Editor',
  Gallery = 'Gallery',
  SuperAdmin = 'SuperAdmin'
}

/** Boolean expression to compare columns of type "roles_enum". All fields are combined with logical 'AND'. */
export type Roles_Enum_Comparison_Exp = {
  _eq: InputMaybe<Roles_Enum>
  _in: InputMaybe<Array<Roles_Enum>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _neq: InputMaybe<Roles_Enum>
  _nin: InputMaybe<Array<Roles_Enum>>
}

/** input type for inserting data into table "v2.roles" */
export type Roles_Insert_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields'
  comment: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields'
  comment: Maybe<Scalars['String']['output']>
  value: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Roles>
}

/** on_conflict condition type for table "v2.roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint
  update_columns: Array<Roles_Update_Column>
  where: InputMaybe<Roles_Bool_Exp>
}

/** Ordering options when selecting data from "v2.roles". */
export type Roles_Order_By = {
  comment: InputMaybe<Order_By>
  value: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.roles */
export type Roles_Pk_Columns_Input = {
  value: Scalars['String']['input']
}

/** select columns of table "v2.roles" */
export enum Roles_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "v2.roles" */
export type Roles_Set_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  comment: InputMaybe<Scalars['String']['input']>
  value: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "v2.roles" */
export enum Roles_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Roles_Set_Input>
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp
}

/** columns and relationships of "v2.search" */
export type Search = {
  __typename?: 'search'
  /** An object relationship */
  bulletin: Maybe<Bulletins>
  keywords: Maybe<Scalars['String']['output']>
  modelId: Maybe<Scalars['Int']['output']>
  modelType: Maybe<Scalars['String']['output']>
  /** An object relationship */
  resource: Maybe<Resources>
  /** An object relationship */
  user: Maybe<Users>
}

/** aggregated selection of "v2.search" */
export type Search_Aggregate = {
  __typename?: 'search_aggregate'
  aggregate: Maybe<Search_Aggregate_Fields>
  nodes: Array<Search>
}

/** aggregate fields of "v2.search" */
export type Search_Aggregate_Fields = {
  __typename?: 'search_aggregate_fields'
  avg: Maybe<Search_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Search_Max_Fields>
  min: Maybe<Search_Min_Fields>
  stddev: Maybe<Search_Stddev_Fields>
  stddev_pop: Maybe<Search_Stddev_Pop_Fields>
  stddev_samp: Maybe<Search_Stddev_Samp_Fields>
  sum: Maybe<Search_Sum_Fields>
  var_pop: Maybe<Search_Var_Pop_Fields>
  var_samp: Maybe<Search_Var_Samp_Fields>
  variance: Maybe<Search_Variance_Fields>
}

/** aggregate fields of "v2.search" */
export type Search_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Search_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Search_Avg_Fields = {
  __typename?: 'search_avg_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.search". All fields are combined with a logical 'AND'. */
export type Search_Bool_Exp = {
  _and: InputMaybe<Array<Search_Bool_Exp>>
  _not: InputMaybe<Search_Bool_Exp>
  _or: InputMaybe<Array<Search_Bool_Exp>>
  bulletin: InputMaybe<Bulletins_Bool_Exp>
  keywords: InputMaybe<String_Comparison_Exp>
  modelId: InputMaybe<Int_Comparison_Exp>
  modelType: InputMaybe<String_Comparison_Exp>
  resource: InputMaybe<Resources_Bool_Exp>
  user: InputMaybe<Users_Bool_Exp>
}

/** aggregate max on columns */
export type Search_Max_Fields = {
  __typename?: 'search_max_fields'
  keywords: Maybe<Scalars['String']['output']>
  modelId: Maybe<Scalars['Int']['output']>
  modelType: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Search_Min_Fields = {
  __typename?: 'search_min_fields'
  keywords: Maybe<Scalars['String']['output']>
  modelId: Maybe<Scalars['Int']['output']>
  modelType: Maybe<Scalars['String']['output']>
}

/** Ordering options when selecting data from "v2.search". */
export type Search_Order_By = {
  bulletin: InputMaybe<Bulletins_Order_By>
  keywords: InputMaybe<Order_By>
  modelId: InputMaybe<Order_By>
  modelType: InputMaybe<Order_By>
  resource: InputMaybe<Resources_Order_By>
  user: InputMaybe<Users_Order_By>
}

/** select columns of table "v2.search" */
export enum Search_Select_Column {
  /** column name */
  Keywords = 'keywords',
  /** column name */
  ModelId = 'modelId',
  /** column name */
  ModelType = 'modelType'
}

/** aggregate stddev on columns */
export type Search_Stddev_Fields = {
  __typename?: 'search_stddev_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Search_Stddev_Pop_Fields = {
  __typename?: 'search_stddev_pop_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Search_Stddev_Samp_Fields = {
  __typename?: 'search_stddev_samp_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "search" */
export type Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Search_Stream_Cursor_Value_Input = {
  keywords: InputMaybe<Scalars['String']['input']>
  modelId: InputMaybe<Scalars['Int']['input']>
  modelType: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Search_Sum_Fields = {
  __typename?: 'search_sum_fields'
  modelId: Maybe<Scalars['Int']['output']>
}

/** aggregate var_pop on columns */
export type Search_Var_Pop_Fields = {
  __typename?: 'search_var_pop_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Search_Var_Samp_Fields = {
  __typename?: 'search_var_samp_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Search_Variance_Fields = {
  __typename?: 'search_variance_fields'
  modelId: Maybe<Scalars['Float']['output']>
}

export type Subscription_Root = {
  __typename?: 'subscription_root'
  /** fetch data from the table: "v2.adp" */
  adp: Array<Adp>
  /** fetch data from the table: "v2.adp" using primary key columns */
  adpById: Maybe<Adp>
  /** fetch aggregated fields from the table: "v2.adp" */
  adp_aggregate: Adp_Aggregate
  /** fetch data from the table in a streaming manner: "v2.adp" */
  adp_stream: Array<Adp>
  /** fetch data from the table: "v2.bulletins" using primary key columns */
  bulletinById: Maybe<Bulletins>
  /** fetch data from the table: "v2.bulletin_department" using primary key columns */
  bulletinDepartmentById: Maybe<BulletinDepartments>
  /** An array relationship */
  bulletinDepartments: Array<BulletinDepartments>
  /** fetch data from the table in a streaming manner: "v2.bulletin_department" */
  bulletinDepartments_stream: Array<BulletinDepartments>
  /** fetch data from the table: "v2.bulletins" */
  bulletins: Array<Bulletins>
  /** fetch data from the table: "v2.bulletins_resources" using primary key columns */
  bulletinsResourceById: Maybe<BulletinsResources>
  /** fetch data from the table: "v2.bulletins_resources" */
  bulletinsResources: Array<BulletinsResources>
  /** fetch data from the table in a streaming manner: "v2.bulletins_resources" */
  bulletinsResources_stream: Array<BulletinsResources>
  /** fetch data from the table in a streaming manner: "v2.bulletins" */
  bulletins_stream: Array<Bulletins>
  /** fetch data from the table: "v2.camera_embeds" using primary key columns */
  cameraEmbedById: Maybe<CameraEmbeds>
  /** fetch data from the table: "v2.camera_embeds" */
  cameraEmbeds: Array<CameraEmbeds>
  /** fetch data from the table in a streaming manner: "v2.camera_embeds" */
  cameraEmbeds_stream: Array<CameraEmbeds>
  /** fetch data from the table: "v2.comments" using primary key columns */
  commentById: Maybe<Comments>
  /** An array relationship */
  comments: Array<Comments>
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate
  /** fetch data from the table in a streaming manner: "v2.comments" */
  comments_stream: Array<Comments>
  /** fetch data from the table: "v2.config" */
  config: Array<Config>
  /** fetch data from the table: "v2.config" using primary key columns */
  configByKey: Maybe<Config>
  /** fetch aggregated fields from the table: "v2.config" */
  config_aggregate: Config_Aggregate
  /** fetch data from the table in a streaming manner: "v2.config" */
  config_stream: Array<Config>
  /** fetch data from the table: "v2.department_contents" using primary key columns */
  contentById: Maybe<Contents>
  /** An array relationship */
  contents: Array<Contents>
  /** fetch data from the table: "v2.department_contents_resources" using primary key columns */
  contentsResourceById: Maybe<ContentsResources>
  /** fetch data from the table: "v2.department_contents_resources" */
  contentsResources: Array<ContentsResources>
  /** fetch data from the table in a streaming manner: "v2.department_contents_resources" */
  contentsResources_stream: Array<ContentsResources>
  /** fetch data from the table in a streaming manner: "v2.department_contents" */
  contents_stream: Array<Contents>
  /** fetch data from the table: "v2.departments" using primary key columns */
  departmentById: Maybe<Departments>
  /** fetch data from the table: "v2.department_faqs" using primary key columns */
  departmentFaqById: Maybe<DepartmentFaqs>
  /** fetch data from the table: "v2.department_faqs" */
  departmentFaqs: Array<DepartmentFaqs>
  /** fetch data from the table in a streaming manner: "v2.department_faqs" */
  departmentFaqs_stream: Array<DepartmentFaqs>
  /** fetch data from the table: "v2.department_quicklinks" using primary key columns */
  departmentQuicklinkById: Maybe<DepartmentQuicklinks>
  /** fetch data from the table: "v2.department_quicklinks" */
  departmentQuicklinks: Array<DepartmentQuicklinks>
  /** fetch data from the table in a streaming manner: "v2.department_quicklinks" */
  departmentQuicklinks_stream: Array<DepartmentQuicklinks>
  /** fetch data from the table: "v2.departments" */
  departments: Array<Departments>
  /** fetch data from the table in a streaming manner: "v2.departments" */
  departments_stream: Array<Departments>
  /** fetch data from the table: "v2.discussions" using primary key columns */
  discussionById: Maybe<Discussions>
  /** An array relationship */
  discussions: Array<Discussions>
  /** fetch data from the table in a streaming manner: "v2.discussions" */
  discussions_stream: Array<Discussions>
  /** fetch data from the table: "v2.events" using primary key columns */
  eventById: Maybe<Events>
  /** fetch data from the table: "v2.event_types" using primary key columns */
  eventTypeById: Maybe<EventTypes>
  /** fetch data from the table: "v2.event_types" */
  eventTypes: Array<EventTypes>
  /** fetch data from the table in a streaming manner: "v2.event_types" */
  eventTypes_stream: Array<EventTypes>
  /** fetch data from the table: "v2.events" */
  events: Array<Events>
  /** fetch data from the table: "events" */
  events_old: Array<Events_Old>
  /** fetch aggregated fields from the table: "events" */
  events_old_aggregate: Events_Old_Aggregate
  /** fetch data from the table: "events" using primary key columns */
  events_old_by_pk: Maybe<Events_Old>
  /** fetch data from the table in a streaming manner: "events" */
  events_old_stream: Array<Events_Old>
  /** fetch data from the table in a streaming manner: "v2.events" */
  events_stream: Array<Events>
  /** An array relationship */
  favoriteDiscussions: Array<FavoriteDiscussions>
  /** fetch data from the table: "v2.favorite_discussions" using primary key columns */
  favoriteDiscussionsById: Maybe<FavoriteDiscussions>
  /** An aggregate relationship */
  favoriteDiscussions_aggregate: FavoriteDiscussions_Aggregate
  /** fetch data from the table in a streaming manner: "v2.favorite_discussions" */
  favoriteDiscussions_stream: Array<FavoriteDiscussions>
  /** An array relationship */
  favoriteResources: Array<FavoriteResources>
  /** fetch data from the table: "v2.favorite_resources" using primary key columns */
  favoriteResourcesById: Maybe<FavoriteResources>
  /** An aggregate relationship */
  favoriteResources_aggregate: FavoriteResources_Aggregate
  /** fetch data from the table in a streaming manner: "v2.favorite_resources" */
  favoriteResources_stream: Array<FavoriteResources>
  /** fetch data from the table: "v2.galleries" */
  galleries: Array<Galleries>
  /** fetch data from the table in a streaming manner: "v2.galleries" */
  galleries_stream: Array<Galleries>
  /** fetch data from the table: "v2.galleries" using primary key columns */
  galleryById: Maybe<Galleries>
  /** fetch data from the table: "v2.gallery_photos" using primary key columns */
  galleryPhotoById: Maybe<GalleryPhotos>
  /** fetch data from the table: "v2.gallery_photos" */
  galleryPhotos: Array<GalleryPhotos>
  /** fetch data from the table in a streaming manner: "v2.gallery_photos" */
  galleryPhotos_stream: Array<GalleryPhotos>
  /** fetch data from the table: "v2.jobsites" */
  jobsites: Array<Jobsites>
  /** fetch data from the table: "v2.jobsites" using primary key columns */
  jobsitesById: Maybe<Jobsites>
  /** fetch data from the table in a streaming manner: "v2.jobsites" */
  jobsites_stream: Array<Jobsites>
  /** fetch data from the table: "v2.pages" */
  pages: Array<Pages>
  /** fetch data from the table: "v2.pages" using primary key columns */
  pagesBySlug: Maybe<Pages>
  /** fetch data from the table in a streaming manner: "v2.pages" */
  pages_stream: Array<Pages>
  /** fetch data from the table: "v2.pto" */
  pto: Array<Pto>
  /** fetch aggregated fields from the table: "v2.pto" */
  pto_aggregate: Pto_Aggregate
  /** fetch data from the table in a streaming manner: "v2.pto" */
  pto_stream: Array<Pto>
  /** fetch data from the table: "v2.resources" using primary key columns */
  resourceById: Maybe<Resources>
  /** fetch data from the table: "v2.resources" */
  resources: Array<Resources>
  /** fetch data from the table in a streaming manner: "v2.resources" */
  resources_stream: Array<Resources>
  /** fetch data from the table: "v2.roles" using primary key columns */
  roleByValue: Maybe<Roles>
  /** fetch data from the table: "v2.roles" */
  roles: Array<Roles>
  /** fetch aggregated fields from the table: "v2.roles" */
  roles_aggregate: Roles_Aggregate
  /** fetch data from the table in a streaming manner: "v2.roles" */
  roles_stream: Array<Roles>
  /** fetch data from the table: "v2.search" */
  search: Array<Search>
  /** fetch data from the table in a streaming manner: "v2.search" */
  search_stream: Array<Search>
  /** fetch data from the table: "v2.uploads" using primary key columns */
  uploadById: Maybe<Uploads>
  /** fetch data from the table: "v2.uploads" */
  uploads: Array<Uploads>
  /** fetch data from the table in a streaming manner: "v2.uploads" */
  uploads_stream: Array<Uploads>
  /** fetch data from the table: "v2.users" using primary key columns */
  userById: Maybe<Users>
  /** fetch data from the table: "v2.user_roles" using primary key columns */
  userRoleById: Maybe<UserRoles>
  /** fetch data from the table: "v2.user_roles" */
  userRoles: Array<UserRoles>
  /** fetch aggregated fields from the table: "v2.user_roles" */
  userRoles_aggregate: UserRoles_Aggregate
  /** fetch data from the table in a streaming manner: "v2.user_roles" */
  userRoles_stream: Array<UserRoles>
  /** fetch data from the table: "v2.users" */
  users: Array<Users>
  /** fetch data from the table in a streaming manner: "v2.users" */
  users_stream: Array<Users>
  /** fetch data from the table: "v2.adp_associate_certification" */
  v2_adp_associate_certification: Array<V2_Adp_Associate_Certification>
  /** fetch aggregated fields from the table: "v2.adp_associate_certification" */
  v2_adp_associate_certification_aggregate: V2_Adp_Associate_Certification_Aggregate
  /** fetch data from the table: "v2.adp_associate_certification" using primary key columns */
  v2_adp_associate_certification_by_pk: Maybe<V2_Adp_Associate_Certification>
  /** fetch data from the table in a streaming manner: "v2.adp_associate_certification" */
  v2_adp_associate_certification_stream: Array<V2_Adp_Associate_Certification>
  /** fetch data from the table: "v2.adp_associates" */
  v2_adp_associates: Array<V2_Adp_Associates>
  /** fetch aggregated fields from the table: "v2.adp_associates" */
  v2_adp_associates_aggregate: V2_Adp_Associates_Aggregate
  /** fetch data from the table: "v2.adp_associates" using primary key columns */
  v2_adp_associates_by_pk: Maybe<V2_Adp_Associates>
  /** fetch data from the table in a streaming manner: "v2.adp_associates" */
  v2_adp_associates_stream: Array<V2_Adp_Associates>
  /** fetch data from the table: "v2.adp_certification_categories" */
  v2_adp_certification_categories: Array<V2_Adp_Certification_Categories>
  /** fetch aggregated fields from the table: "v2.adp_certification_categories" */
  v2_adp_certification_categories_aggregate: V2_Adp_Certification_Categories_Aggregate
  /** fetch data from the table: "v2.adp_certification_categories" using primary key columns */
  v2_adp_certification_categories_by_pk: Maybe<V2_Adp_Certification_Categories>
  /** fetch data from the table in a streaming manner: "v2.adp_certification_categories" */
  v2_adp_certification_categories_stream: Array<V2_Adp_Certification_Categories>
  /** fetch data from the table: "v2.adp_certifications" */
  v2_adp_certifications: Array<V2_Adp_Certifications>
  /** fetch aggregated fields from the table: "v2.adp_certifications" */
  v2_adp_certifications_aggregate: V2_Adp_Certifications_Aggregate
  /** fetch data from the table: "v2.adp_certifications" using primary key columns */
  v2_adp_certifications_by_pk: Maybe<V2_Adp_Certifications>
  /** fetch data from the table in a streaming manner: "v2.adp_certifications" */
  v2_adp_certifications_stream: Array<V2_Adp_Certifications>
  /** fetch data from the table: "v2.adp_license_categories" */
  v2_adp_license_categories: Array<V2_Adp_License_Categories>
  /** fetch aggregated fields from the table: "v2.adp_license_categories" */
  v2_adp_license_categories_aggregate: V2_Adp_License_Categories_Aggregate
  /** fetch data from the table: "v2.adp_license_categories" using primary key columns */
  v2_adp_license_categories_by_pk: Maybe<V2_Adp_License_Categories>
  /** fetch data from the table in a streaming manner: "v2.adp_license_categories" */
  v2_adp_license_categories_stream: Array<V2_Adp_License_Categories>
  /** fetch data from the table: "v2.adp_licenses" */
  v2_adp_licenses: Array<V2_Adp_Licenses>
  /** fetch aggregated fields from the table: "v2.adp_licenses" */
  v2_adp_licenses_aggregate: V2_Adp_Licenses_Aggregate
  /** fetch data from the table: "v2.adp_licenses" using primary key columns */
  v2_adp_licenses_by_pk: Maybe<V2_Adp_Licenses>
  /** fetch data from the table in a streaming manner: "v2.adp_licenses" */
  v2_adp_licenses_stream: Array<V2_Adp_Licenses>
  /** fetch data from the table: "v2.docebo_courses" */
  v2_docebo_courses: Array<V2_Docebo_Courses>
  /** fetch aggregated fields from the table: "v2.docebo_courses" */
  v2_docebo_courses_aggregate: V2_Docebo_Courses_Aggregate
  /** fetch data from the table: "v2.docebo_courses" using primary key columns */
  v2_docebo_courses_by_pk: Maybe<V2_Docebo_Courses>
  /** fetch data from the table in a streaming manner: "v2.docebo_courses" */
  v2_docebo_courses_stream: Array<V2_Docebo_Courses>
  /** fetch data from the table: "v2.months" */
  v2_months: Array<V2_Months>
  /** fetch aggregated fields from the table: "v2.months" */
  v2_months_aggregate: V2_Months_Aggregate
  /** fetch data from the table in a streaming manner: "v2.months" */
  v2_months_stream: Array<V2_Months>
  /** fetch data from the table: "v2.nomination_thumbsup" */
  v2_nomination_thumbsup: Array<V2_Nomination_Thumbsup>
  /** fetch aggregated fields from the table: "v2.nomination_thumbsup" */
  v2_nomination_thumbsup_aggregate: V2_Nomination_Thumbsup_Aggregate
  /** fetch data from the table: "v2.nomination_thumbsup" using primary key columns */
  v2_nomination_thumbsup_by_pk: Maybe<V2_Nomination_Thumbsup>
  /** fetch data from the table in a streaming manner: "v2.nomination_thumbsup" */
  v2_nomination_thumbsup_stream: Array<V2_Nomination_Thumbsup>
  /** fetch data from the table: "v2.nominations" */
  v2_nominations: Array<V2_Nominations>
  /** fetch aggregated fields from the table: "v2.nominations" */
  v2_nominations_aggregate: V2_Nominations_Aggregate
  /** fetch data from the table: "v2.nominations" using primary key columns */
  v2_nominations_by_pk: Maybe<V2_Nominations>
  /** fetch data from the table in a streaming manner: "v2.nominations" */
  v2_nominations_stream: Array<V2_Nominations>
  /** fetch data from the table: "v2.redemption_codes" */
  v2_redemption_codes: Array<V2_Redemption_Codes>
  /** fetch aggregated fields from the table: "v2.redemption_codes" */
  v2_redemption_codes_aggregate: V2_Redemption_Codes_Aggregate
  /** fetch data from the table: "v2.redemption_codes" using primary key columns */
  v2_redemption_codes_by_pk: Maybe<V2_Redemption_Codes>
  /** fetch data from the table in a streaming manner: "v2.redemption_codes" */
  v2_redemption_codes_stream: Array<V2_Redemption_Codes>
  /** fetch aggregated fields from the table: "v2.bulletin_department" */
  zaggBulletinDepartments: BulletinDepartments_Aggregate
  /** fetch aggregated fields from the table: "v2.bulletins" */
  zaggBulletins: Bulletins_Aggregate
  /** fetch aggregated fields from the table: "v2.bulletins_resources" */
  zaggBulletinsResources: BulletinsResources_Aggregate
  /** fetch aggregated fields from the table: "v2.camera_embeds" */
  zaggCameraEmbeds: CameraEmbeds_Aggregate
  /** fetch aggregated fields from the table: "v2.department_contents" */
  zaggContents: Contents_Aggregate
  /** fetch aggregated fields from the table: "v2.department_contents_resources" */
  zaggContentsResources: ContentsResources_Aggregate
  /** fetch aggregated fields from the table: "v2.department_faqs" */
  zaggDepartmentFaqs: DepartmentFaqs_Aggregate
  /** fetch aggregated fields from the table: "v2.department_quicklinks" */
  zaggDepartmentQuicklinks: DepartmentQuicklinks_Aggregate
  /** fetch aggregated fields from the table: "v2.departments" */
  zaggDepartments: Departments_Aggregate
  /** fetch aggregated fields from the table: "v2.discussions" */
  zaggDiscussions: Discussions_Aggregate
  /** fetch aggregated fields from the table: "v2.event_types" */
  zaggEventTypes: EventTypes_Aggregate
  /** fetch aggregated fields from the table: "v2.events" */
  zaggEvents: Events_Aggregate
  /** fetch aggregated fields from the table: "v2.galleries" */
  zaggGalleries: Galleries_Aggregate
  /** fetch aggregated fields from the table: "v2.gallery_photos" */
  zaggGalleryPhotos: GalleryPhotos_Aggregate
  /** fetch aggregated fields from the table: "v2.jobsites" */
  zaggJobsites: Jobsites_Aggregate
  /** fetch aggregated fields from the table: "v2.pages" */
  zaggPages: Pages_Aggregate
  /** fetch aggregated fields from the table: "v2.resources" */
  zaggResources: Resources_Aggregate
  /** fetch aggregated fields from the table: "v2.search" */
  zaggSearch: Search_Aggregate
  /** fetch aggregated fields from the table: "v2.uploads" */
  zaggUploads: Uploads_Aggregate
  /** fetch aggregated fields from the table: "v2.users" */
  zaggUsers: Users_Aggregate
}

export type Subscription_RootAdpArgs = {
  distinct_on: InputMaybe<Array<Adp_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Adp_Order_By>>
  where: InputMaybe<Adp_Bool_Exp>
}

export type Subscription_RootAdpByIdArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootAdp_AggregateArgs = {
  distinct_on: InputMaybe<Array<Adp_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Adp_Order_By>>
  where: InputMaybe<Adp_Bool_Exp>
}

export type Subscription_RootAdp_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Adp_Stream_Cursor_Input>>
  where: InputMaybe<Adp_Bool_Exp>
}

export type Subscription_RootBulletinByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootBulletinDepartmentByIdArgs = {
  bulletinId: Scalars['Int']['input']
  departmentId: Scalars['Int']['input']
}

export type Subscription_RootBulletinDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

export type Subscription_RootBulletinDepartments_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<BulletinDepartments_Stream_Cursor_Input>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

export type Subscription_RootBulletinsArgs = {
  distinct_on: InputMaybe<Array<Bulletins_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Bulletins_Order_By>>
  where: InputMaybe<Bulletins_Bool_Exp>
}

export type Subscription_RootBulletinsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootBulletinsResourcesArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

export type Subscription_RootBulletinsResources_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<BulletinsResources_Stream_Cursor_Input>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

export type Subscription_RootBulletins_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Bulletins_Stream_Cursor_Input>>
  where: InputMaybe<Bulletins_Bool_Exp>
}

export type Subscription_RootCameraEmbedByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootCameraEmbedsArgs = {
  distinct_on: InputMaybe<Array<CameraEmbeds_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<CameraEmbeds_Order_By>>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

export type Subscription_RootCameraEmbeds_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<CameraEmbeds_Stream_Cursor_Input>>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

export type Subscription_RootCommentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootCommentsArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

export type Subscription_RootComments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

export type Subscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>
  where: InputMaybe<Comments_Bool_Exp>
}

export type Subscription_RootConfigArgs = {
  distinct_on: InputMaybe<Array<Config_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Config_Order_By>>
  where: InputMaybe<Config_Bool_Exp>
}

export type Subscription_RootConfigByKeyArgs = {
  key: Scalars['String']['input']
}

export type Subscription_RootConfig_AggregateArgs = {
  distinct_on: InputMaybe<Array<Config_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Config_Order_By>>
  where: InputMaybe<Config_Bool_Exp>
}

export type Subscription_RootConfig_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Config_Stream_Cursor_Input>>
  where: InputMaybe<Config_Bool_Exp>
}

export type Subscription_RootContentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

export type Subscription_RootContentsResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootContentsResourcesArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

export type Subscription_RootContentsResources_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<ContentsResources_Stream_Cursor_Input>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

export type Subscription_RootContents_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Contents_Stream_Cursor_Input>>
  where: InputMaybe<Contents_Bool_Exp>
}

export type Subscription_RootDepartmentByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootDepartmentFaqByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootDepartmentFaqsArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

export type Subscription_RootDepartmentFaqs_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<DepartmentFaqs_Stream_Cursor_Input>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

export type Subscription_RootDepartmentQuicklinkByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootDepartmentQuicklinksArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

export type Subscription_RootDepartmentQuicklinks_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<DepartmentQuicklinks_Stream_Cursor_Input>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

export type Subscription_RootDepartmentsArgs = {
  distinct_on: InputMaybe<Array<Departments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Departments_Order_By>>
  where: InputMaybe<Departments_Bool_Exp>
}

export type Subscription_RootDepartments_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Departments_Stream_Cursor_Input>>
  where: InputMaybe<Departments_Bool_Exp>
}

export type Subscription_RootDiscussionByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootDiscussionsArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

export type Subscription_RootDiscussions_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Discussions_Stream_Cursor_Input>>
  where: InputMaybe<Discussions_Bool_Exp>
}

export type Subscription_RootEventByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootEventTypeByIdArgs = {
  value: Scalars['String']['input']
}

export type Subscription_RootEventTypesArgs = {
  distinct_on: InputMaybe<Array<EventTypes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<EventTypes_Order_By>>
  where: InputMaybe<EventTypes_Bool_Exp>
}

export type Subscription_RootEventTypes_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<EventTypes_Stream_Cursor_Input>>
  where: InputMaybe<EventTypes_Bool_Exp>
}

export type Subscription_RootEventsArgs = {
  distinct_on: InputMaybe<Array<Events_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Order_By>>
  where: InputMaybe<Events_Bool_Exp>
}

export type Subscription_RootEvents_OldArgs = {
  distinct_on: InputMaybe<Array<Events_Old_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Old_Order_By>>
  where: InputMaybe<Events_Old_Bool_Exp>
}

export type Subscription_RootEvents_Old_AggregateArgs = {
  distinct_on: InputMaybe<Array<Events_Old_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Old_Order_By>>
  where: InputMaybe<Events_Old_Bool_Exp>
}

export type Subscription_RootEvents_Old_By_PkArgs = {
  id: Scalars['bigint']['input']
}

export type Subscription_RootEvents_Old_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Events_Old_Stream_Cursor_Input>>
  where: InputMaybe<Events_Old_Bool_Exp>
}

export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>
  where: InputMaybe<Events_Bool_Exp>
}

export type Subscription_RootFavoriteDiscussionsArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

export type Subscription_RootFavoriteDiscussionsByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootFavoriteDiscussions_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

export type Subscription_RootFavoriteDiscussions_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<FavoriteDiscussions_Stream_Cursor_Input>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

export type Subscription_RootFavoriteResourcesArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

export type Subscription_RootFavoriteResourcesByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootFavoriteResources_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

export type Subscription_RootFavoriteResources_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<FavoriteResources_Stream_Cursor_Input>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

export type Subscription_RootGalleriesArgs = {
  distinct_on: InputMaybe<Array<Galleries_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Galleries_Order_By>>
  where: InputMaybe<Galleries_Bool_Exp>
}

export type Subscription_RootGalleries_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Galleries_Stream_Cursor_Input>>
  where: InputMaybe<Galleries_Bool_Exp>
}

export type Subscription_RootGalleryByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootGalleryPhotoByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootGalleryPhotosArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

export type Subscription_RootGalleryPhotos_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<GalleryPhotos_Stream_Cursor_Input>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

export type Subscription_RootJobsitesArgs = {
  distinct_on: InputMaybe<Array<Jobsites_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Jobsites_Order_By>>
  where: InputMaybe<Jobsites_Bool_Exp>
}

export type Subscription_RootJobsitesByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootJobsites_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Jobsites_Stream_Cursor_Input>>
  where: InputMaybe<Jobsites_Bool_Exp>
}

export type Subscription_RootPagesArgs = {
  distinct_on: InputMaybe<Array<Pages_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pages_Order_By>>
  where: InputMaybe<Pages_Bool_Exp>
}

export type Subscription_RootPagesBySlugArgs = {
  slug: Scalars['String']['input']
}

export type Subscription_RootPages_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Pages_Stream_Cursor_Input>>
  where: InputMaybe<Pages_Bool_Exp>
}

export type Subscription_RootPtoArgs = {
  distinct_on: InputMaybe<Array<Pto_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pto_Order_By>>
  where: InputMaybe<Pto_Bool_Exp>
}

export type Subscription_RootPto_AggregateArgs = {
  distinct_on: InputMaybe<Array<Pto_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pto_Order_By>>
  where: InputMaybe<Pto_Bool_Exp>
}

export type Subscription_RootPto_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Pto_Stream_Cursor_Input>>
  where: InputMaybe<Pto_Bool_Exp>
}

export type Subscription_RootResourceByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootResourcesArgs = {
  distinct_on: InputMaybe<Array<Resources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Resources_Order_By>>
  where: InputMaybe<Resources_Bool_Exp>
}

export type Subscription_RootResources_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Resources_Stream_Cursor_Input>>
  where: InputMaybe<Resources_Bool_Exp>
}

export type Subscription_RootRoleByValueArgs = {
  value: Scalars['String']['input']
}

export type Subscription_RootRolesArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Roles_Order_By>>
  where: InputMaybe<Roles_Bool_Exp>
}

export type Subscription_RootRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Roles_Order_By>>
  where: InputMaybe<Roles_Bool_Exp>
}

export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>
  where: InputMaybe<Roles_Bool_Exp>
}

export type Subscription_RootSearchArgs = {
  distinct_on: InputMaybe<Array<Search_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Search_Order_By>>
  where: InputMaybe<Search_Bool_Exp>
}

export type Subscription_RootSearch_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Search_Stream_Cursor_Input>>
  where: InputMaybe<Search_Bool_Exp>
}

export type Subscription_RootUploadByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootUploadsArgs = {
  distinct_on: InputMaybe<Array<Uploads_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Uploads_Order_By>>
  where: InputMaybe<Uploads_Bool_Exp>
}

export type Subscription_RootUploads_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Uploads_Stream_Cursor_Input>>
  where: InputMaybe<Uploads_Bool_Exp>
}

export type Subscription_RootUserByIdArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootUserRoleByIdArgs = {
  role: Roles_Enum
  userId: Scalars['Int']['input']
}

export type Subscription_RootUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

export type Subscription_RootUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

export type Subscription_RootUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<UserRoles_Stream_Cursor_Input>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

export type Subscription_RootUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>
  where: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootV2_Adp_Associate_CertificationArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associate_Certification_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associate_Certification_Order_By>>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

export type Subscription_RootV2_Adp_Associate_Certification_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associate_Certification_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associate_Certification_Order_By>>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

export type Subscription_RootV2_Adp_Associate_Certification_By_PkArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_Associate_Certification_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_Associate_Certification_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

export type Subscription_RootV2_Adp_AssociatesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associates_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associates_Order_By>>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

export type Subscription_RootV2_Adp_Associates_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Associates_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Associates_Order_By>>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

export type Subscription_RootV2_Adp_Associates_By_PkArgs = {
  associate_oid: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_Associates_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_Associates_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

export type Subscription_RootV2_Adp_Certification_CategoriesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certification_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certification_Categories_Order_By>>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_Certification_Categories_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certification_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certification_Categories_Order_By>>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_Certification_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_Certification_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_Certification_Categories_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_CertificationsArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certifications_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certifications_Order_By>>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

export type Subscription_RootV2_Adp_Certifications_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Certifications_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Certifications_Order_By>>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

export type Subscription_RootV2_Adp_Certifications_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_Certifications_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_Certifications_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

export type Subscription_RootV2_Adp_License_CategoriesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_License_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_License_Categories_Order_By>>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_License_Categories_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_License_Categories_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_License_Categories_Order_By>>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_License_Categories_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_License_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_License_Categories_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

export type Subscription_RootV2_Adp_LicensesArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Licenses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Licenses_Order_By>>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

export type Subscription_RootV2_Adp_Licenses_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Adp_Licenses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Adp_Licenses_Order_By>>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

export type Subscription_RootV2_Adp_Licenses_By_PkArgs = {
  code: Scalars['String']['input']
}

export type Subscription_RootV2_Adp_Licenses_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Adp_Licenses_Stream_Cursor_Input>>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

export type Subscription_RootV2_Docebo_CoursesArgs = {
  distinct_on: InputMaybe<Array<V2_Docebo_Courses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Docebo_Courses_Order_By>>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

export type Subscription_RootV2_Docebo_Courses_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Docebo_Courses_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Docebo_Courses_Order_By>>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

export type Subscription_RootV2_Docebo_Courses_By_PkArgs = {
  uid: Scalars['String']['input']
}

export type Subscription_RootV2_Docebo_Courses_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Docebo_Courses_Stream_Cursor_Input>>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

export type Subscription_RootV2_MonthsArgs = {
  distinct_on: InputMaybe<Array<V2_Months_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Months_Order_By>>
  where: InputMaybe<V2_Months_Bool_Exp>
}

export type Subscription_RootV2_Months_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Months_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Months_Order_By>>
  where: InputMaybe<V2_Months_Bool_Exp>
}

export type Subscription_RootV2_Months_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Months_Stream_Cursor_Input>>
  where: InputMaybe<V2_Months_Bool_Exp>
}

export type Subscription_RootV2_Nomination_ThumbsupArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

export type Subscription_RootV2_Nomination_Thumbsup_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

export type Subscription_RootV2_Nomination_Thumbsup_By_PkArgs = {
  nomination_id: Scalars['Int']['input']
  user_id: Scalars['Int']['input']
}

export type Subscription_RootV2_Nomination_Thumbsup_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Nomination_Thumbsup_Stream_Cursor_Input>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

export type Subscription_RootV2_NominationsArgs = {
  distinct_on: InputMaybe<Array<V2_Nominations_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nominations_Order_By>>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

export type Subscription_RootV2_Nominations_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Nominations_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nominations_Order_By>>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

export type Subscription_RootV2_Nominations_By_PkArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootV2_Nominations_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Nominations_Stream_Cursor_Input>>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

export type Subscription_RootV2_Redemption_CodesArgs = {
  distinct_on: InputMaybe<Array<V2_Redemption_Codes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Redemption_Codes_Order_By>>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

export type Subscription_RootV2_Redemption_Codes_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Redemption_Codes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Redemption_Codes_Order_By>>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

export type Subscription_RootV2_Redemption_Codes_By_PkArgs = {
  id: Scalars['Int']['input']
}

export type Subscription_RootV2_Redemption_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<V2_Redemption_Codes_Stream_Cursor_Input>>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

export type Subscription_RootZaggBulletinDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BulletinDepartments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinDepartments_Order_By>>
  where: InputMaybe<BulletinDepartments_Bool_Exp>
}

export type Subscription_RootZaggBulletinsArgs = {
  distinct_on: InputMaybe<Array<Bulletins_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Bulletins_Order_By>>
  where: InputMaybe<Bulletins_Bool_Exp>
}

export type Subscription_RootZaggBulletinsResourcesArgs = {
  distinct_on: InputMaybe<Array<BulletinsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<BulletinsResources_Order_By>>
  where: InputMaybe<BulletinsResources_Bool_Exp>
}

export type Subscription_RootZaggCameraEmbedsArgs = {
  distinct_on: InputMaybe<Array<CameraEmbeds_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<CameraEmbeds_Order_By>>
  where: InputMaybe<CameraEmbeds_Bool_Exp>
}

export type Subscription_RootZaggContentsArgs = {
  distinct_on: InputMaybe<Array<Contents_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Contents_Order_By>>
  where: InputMaybe<Contents_Bool_Exp>
}

export type Subscription_RootZaggContentsResourcesArgs = {
  distinct_on: InputMaybe<Array<ContentsResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<ContentsResources_Order_By>>
  where: InputMaybe<ContentsResources_Bool_Exp>
}

export type Subscription_RootZaggDepartmentFaqsArgs = {
  distinct_on: InputMaybe<Array<DepartmentFaqs_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentFaqs_Order_By>>
  where: InputMaybe<DepartmentFaqs_Bool_Exp>
}

export type Subscription_RootZaggDepartmentQuicklinksArgs = {
  distinct_on: InputMaybe<Array<DepartmentQuicklinks_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<DepartmentQuicklinks_Order_By>>
  where: InputMaybe<DepartmentQuicklinks_Bool_Exp>
}

export type Subscription_RootZaggDepartmentsArgs = {
  distinct_on: InputMaybe<Array<Departments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Departments_Order_By>>
  where: InputMaybe<Departments_Bool_Exp>
}

export type Subscription_RootZaggDiscussionsArgs = {
  distinct_on: InputMaybe<Array<Discussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Discussions_Order_By>>
  where: InputMaybe<Discussions_Bool_Exp>
}

export type Subscription_RootZaggEventTypesArgs = {
  distinct_on: InputMaybe<Array<EventTypes_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<EventTypes_Order_By>>
  where: InputMaybe<EventTypes_Bool_Exp>
}

export type Subscription_RootZaggEventsArgs = {
  distinct_on: InputMaybe<Array<Events_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Events_Order_By>>
  where: InputMaybe<Events_Bool_Exp>
}

export type Subscription_RootZaggGalleriesArgs = {
  distinct_on: InputMaybe<Array<Galleries_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Galleries_Order_By>>
  where: InputMaybe<Galleries_Bool_Exp>
}

export type Subscription_RootZaggGalleryPhotosArgs = {
  distinct_on: InputMaybe<Array<GalleryPhotos_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<GalleryPhotos_Order_By>>
  where: InputMaybe<GalleryPhotos_Bool_Exp>
}

export type Subscription_RootZaggJobsitesArgs = {
  distinct_on: InputMaybe<Array<Jobsites_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Jobsites_Order_By>>
  where: InputMaybe<Jobsites_Bool_Exp>
}

export type Subscription_RootZaggPagesArgs = {
  distinct_on: InputMaybe<Array<Pages_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Pages_Order_By>>
  where: InputMaybe<Pages_Bool_Exp>
}

export type Subscription_RootZaggResourcesArgs = {
  distinct_on: InputMaybe<Array<Resources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Resources_Order_By>>
  where: InputMaybe<Resources_Bool_Exp>
}

export type Subscription_RootZaggSearchArgs = {
  distinct_on: InputMaybe<Array<Search_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Search_Order_By>>
  where: InputMaybe<Search_Bool_Exp>
}

export type Subscription_RootZaggUploadsArgs = {
  distinct_on: InputMaybe<Array<Uploads_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Uploads_Order_By>>
  where: InputMaybe<Uploads_Bool_Exp>
}

export type Subscription_RootZaggUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq: InputMaybe<Scalars['timestamp']['input']>
  _gt: InputMaybe<Scalars['timestamp']['input']>
  _gte: InputMaybe<Scalars['timestamp']['input']>
  _in: InputMaybe<Array<Scalars['timestamp']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['timestamp']['input']>
  _lte: InputMaybe<Scalars['timestamp']['input']>
  _neq: InputMaybe<Scalars['timestamp']['input']>
  _nin: InputMaybe<Array<Scalars['timestamp']['input']>>
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq: InputMaybe<Scalars['timestamptz']['input']>
  _gt: InputMaybe<Scalars['timestamptz']['input']>
  _gte: InputMaybe<Scalars['timestamptz']['input']>
  _in: InputMaybe<Array<Scalars['timestamptz']['input']>>
  _is_null: InputMaybe<Scalars['Boolean']['input']>
  _lt: InputMaybe<Scalars['timestamptz']['input']>
  _lte: InputMaybe<Scalars['timestamptz']['input']>
  _neq: InputMaybe<Scalars['timestamptz']['input']>
  _nin: InputMaybe<Array<Scalars['timestamptz']['input']>>
}

/** columns and relationships of "v2.uploads" */
export type Uploads = {
  __typename?: 'uploads'
  createdAt: Scalars['timestamptz']['output']
  createdBy: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  key: Scalars['String']['output']
  /** A computed field, executes function "v2.uploads_public_url" */
  publicUrl: Maybe<Scalars['String']['output']>
  size: Scalars['Int']['output']
  type: Scalars['String']['output']
  url: Maybe<Scalars['String']['output']>
}

/** aggregated selection of "v2.uploads" */
export type Uploads_Aggregate = {
  __typename?: 'uploads_aggregate'
  aggregate: Maybe<Uploads_Aggregate_Fields>
  nodes: Array<Uploads>
}

/** aggregate fields of "v2.uploads" */
export type Uploads_Aggregate_Fields = {
  __typename?: 'uploads_aggregate_fields'
  avg: Maybe<Uploads_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Uploads_Max_Fields>
  min: Maybe<Uploads_Min_Fields>
  stddev: Maybe<Uploads_Stddev_Fields>
  stddev_pop: Maybe<Uploads_Stddev_Pop_Fields>
  stddev_samp: Maybe<Uploads_Stddev_Samp_Fields>
  sum: Maybe<Uploads_Sum_Fields>
  var_pop: Maybe<Uploads_Var_Pop_Fields>
  var_samp: Maybe<Uploads_Var_Samp_Fields>
  variance: Maybe<Uploads_Variance_Fields>
}

/** aggregate fields of "v2.uploads" */
export type Uploads_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Uploads_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Uploads_Avg_Fields = {
  __typename?: 'uploads_avg_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.uploads". All fields are combined with a logical 'AND'. */
export type Uploads_Bool_Exp = {
  _and: InputMaybe<Array<Uploads_Bool_Exp>>
  _not: InputMaybe<Uploads_Bool_Exp>
  _or: InputMaybe<Array<Uploads_Bool_Exp>>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  createdBy: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  key: InputMaybe<String_Comparison_Exp>
  publicUrl: InputMaybe<String_Comparison_Exp>
  size: InputMaybe<Int_Comparison_Exp>
  type: InputMaybe<String_Comparison_Exp>
  url: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.uploads" */
export enum Uploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadsPkey = 'uploads_pkey'
}

/** input type for incrementing numeric columns in table "v2.uploads" */
export type Uploads_Inc_Input = {
  createdBy: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  size: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.uploads" */
export type Uploads_Insert_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  createdBy: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  key: InputMaybe<Scalars['String']['input']>
  size: InputMaybe<Scalars['Int']['input']>
  type: InputMaybe<Scalars['String']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Uploads_Max_Fields = {
  __typename?: 'uploads_max_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  createdBy: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  key: Maybe<Scalars['String']['output']>
  /** A computed field, executes function "v2.uploads_public_url" */
  publicUrl: Maybe<Scalars['String']['output']>
  size: Maybe<Scalars['Int']['output']>
  type: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Uploads_Min_Fields = {
  __typename?: 'uploads_min_fields'
  createdAt: Maybe<Scalars['timestamptz']['output']>
  createdBy: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  key: Maybe<Scalars['String']['output']>
  /** A computed field, executes function "v2.uploads_public_url" */
  publicUrl: Maybe<Scalars['String']['output']>
  size: Maybe<Scalars['Int']['output']>
  type: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.uploads" */
export type Uploads_Mutation_Response = {
  __typename?: 'uploads_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Uploads>
}

/** input type for inserting object relation for remote table "v2.uploads" */
export type Uploads_Obj_Rel_Insert_Input = {
  data: Uploads_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Uploads_On_Conflict>
}

/** on_conflict condition type for table "v2.uploads" */
export type Uploads_On_Conflict = {
  constraint: Uploads_Constraint
  update_columns: Array<Uploads_Update_Column>
  where: InputMaybe<Uploads_Bool_Exp>
}

/** Ordering options when selecting data from "v2.uploads". */
export type Uploads_Order_By = {
  createdAt: InputMaybe<Order_By>
  createdBy: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  key: InputMaybe<Order_By>
  publicUrl: InputMaybe<Order_By>
  size: InputMaybe<Order_By>
  type: InputMaybe<Order_By>
  url: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.uploads */
export type Uploads_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.uploads" */
export enum Uploads_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "v2.uploads" */
export type Uploads_Set_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  createdBy: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  key: InputMaybe<Scalars['String']['input']>
  size: InputMaybe<Scalars['Int']['input']>
  type: InputMaybe<Scalars['String']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Uploads_Stddev_Fields = {
  __typename?: 'uploads_stddev_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Uploads_Stddev_Pop_Fields = {
  __typename?: 'uploads_stddev_pop_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Uploads_Stddev_Samp_Fields = {
  __typename?: 'uploads_stddev_samp_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "uploads" */
export type Uploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uploads_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Uploads_Stream_Cursor_Value_Input = {
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  createdBy: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  key: InputMaybe<Scalars['String']['input']>
  size: InputMaybe<Scalars['Int']['input']>
  type: InputMaybe<Scalars['String']['input']>
  url: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Uploads_Sum_Fields = {
  __typename?: 'uploads_sum_fields'
  createdBy: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  size: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.uploads" */
export enum Uploads_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

export type Uploads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Uploads_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Uploads_Set_Input>
  /** filter the rows which have to be updated */
  where: Uploads_Bool_Exp
}

/** aggregate var_pop on columns */
export type Uploads_Var_Pop_Fields = {
  __typename?: 'uploads_var_pop_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Uploads_Var_Samp_Fields = {
  __typename?: 'uploads_var_samp_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Uploads_Variance_Fields = {
  __typename?: 'uploads_variance_fields'
  createdBy: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  size: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.user_roles" */
export type UserRoles = {
  __typename?: 'userRoles'
  role: Roles_Enum
  userId: Scalars['Int']['output']
}

/** aggregated selection of "v2.user_roles" */
export type UserRoles_Aggregate = {
  __typename?: 'userRoles_aggregate'
  aggregate: Maybe<UserRoles_Aggregate_Fields>
  nodes: Array<UserRoles>
}

export type UserRoles_Aggregate_Bool_Exp = {
  count: InputMaybe<UserRoles_Aggregate_Bool_Exp_Count>
}

export type UserRoles_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<UserRoles_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<UserRoles_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.user_roles" */
export type UserRoles_Aggregate_Fields = {
  __typename?: 'userRoles_aggregate_fields'
  avg: Maybe<UserRoles_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<UserRoles_Max_Fields>
  min: Maybe<UserRoles_Min_Fields>
  stddev: Maybe<UserRoles_Stddev_Fields>
  stddev_pop: Maybe<UserRoles_Stddev_Pop_Fields>
  stddev_samp: Maybe<UserRoles_Stddev_Samp_Fields>
  sum: Maybe<UserRoles_Sum_Fields>
  var_pop: Maybe<UserRoles_Var_Pop_Fields>
  var_samp: Maybe<UserRoles_Var_Samp_Fields>
  variance: Maybe<UserRoles_Variance_Fields>
}

/** aggregate fields of "v2.user_roles" */
export type UserRoles_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRoles_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.user_roles" */
export type UserRoles_Aggregate_Order_By = {
  avg: InputMaybe<UserRoles_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<UserRoles_Max_Order_By>
  min: InputMaybe<UserRoles_Min_Order_By>
  stddev: InputMaybe<UserRoles_Stddev_Order_By>
  stddev_pop: InputMaybe<UserRoles_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<UserRoles_Stddev_Samp_Order_By>
  sum: InputMaybe<UserRoles_Sum_Order_By>
  var_pop: InputMaybe<UserRoles_Var_Pop_Order_By>
  var_samp: InputMaybe<UserRoles_Var_Samp_Order_By>
  variance: InputMaybe<UserRoles_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.user_roles" */
export type UserRoles_Arr_Rel_Insert_Input = {
  data: Array<UserRoles_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<UserRoles_On_Conflict>
}

/** aggregate avg on columns */
export type UserRoles_Avg_Fields = {
  __typename?: 'userRoles_avg_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.user_roles" */
export type UserRoles_Avg_Order_By = {
  userId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.user_roles". All fields are combined with a logical 'AND'. */
export type UserRoles_Bool_Exp = {
  _and: InputMaybe<Array<UserRoles_Bool_Exp>>
  _not: InputMaybe<UserRoles_Bool_Exp>
  _or: InputMaybe<Array<UserRoles_Bool_Exp>>
  role: InputMaybe<Roles_Enum_Comparison_Exp>
  userId: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.user_roles" */
export enum UserRoles_Constraint {
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesPkey = 'user_roles_pkey'
}

/** input type for incrementing numeric columns in table "v2.user_roles" */
export type UserRoles_Inc_Input = {
  userId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.user_roles" */
export type UserRoles_Insert_Input = {
  role: InputMaybe<Roles_Enum>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type UserRoles_Max_Fields = {
  __typename?: 'userRoles_max_fields'
  userId: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.user_roles" */
export type UserRoles_Max_Order_By = {
  userId: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type UserRoles_Min_Fields = {
  __typename?: 'userRoles_min_fields'
  userId: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.user_roles" */
export type UserRoles_Min_Order_By = {
  userId: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.user_roles" */
export type UserRoles_Mutation_Response = {
  __typename?: 'userRoles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<UserRoles>
}

/** on_conflict condition type for table "v2.user_roles" */
export type UserRoles_On_Conflict = {
  constraint: UserRoles_Constraint
  update_columns: Array<UserRoles_Update_Column>
  where: InputMaybe<UserRoles_Bool_Exp>
}

/** Ordering options when selecting data from "v2.user_roles". */
export type UserRoles_Order_By = {
  role: InputMaybe<Order_By>
  userId: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.user_roles */
export type UserRoles_Pk_Columns_Input = {
  role: Roles_Enum
  userId: Scalars['Int']['input']
}

/** select columns of table "v2.user_roles" */
export enum UserRoles_Select_Column {
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "v2.user_roles" */
export type UserRoles_Set_Input = {
  role: InputMaybe<Roles_Enum>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type UserRoles_Stddev_Fields = {
  __typename?: 'userRoles_stddev_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.user_roles" */
export type UserRoles_Stddev_Order_By = {
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type UserRoles_Stddev_Pop_Fields = {
  __typename?: 'userRoles_stddev_pop_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.user_roles" */
export type UserRoles_Stddev_Pop_Order_By = {
  userId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type UserRoles_Stddev_Samp_Fields = {
  __typename?: 'userRoles_stddev_samp_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.user_roles" */
export type UserRoles_Stddev_Samp_Order_By = {
  userId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "userRoles" */
export type UserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserRoles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type UserRoles_Stream_Cursor_Value_Input = {
  role: InputMaybe<Roles_Enum>
  userId: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type UserRoles_Sum_Fields = {
  __typename?: 'userRoles_sum_fields'
  userId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.user_roles" */
export type UserRoles_Sum_Order_By = {
  userId: InputMaybe<Order_By>
}

/** update columns of table "v2.user_roles" */
export enum UserRoles_Update_Column {
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type UserRoles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<UserRoles_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<UserRoles_Set_Input>
  /** filter the rows which have to be updated */
  where: UserRoles_Bool_Exp
}

/** aggregate var_pop on columns */
export type UserRoles_Var_Pop_Fields = {
  __typename?: 'userRoles_var_pop_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.user_roles" */
export type UserRoles_Var_Pop_Order_By = {
  userId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type UserRoles_Var_Samp_Fields = {
  __typename?: 'userRoles_var_samp_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.user_roles" */
export type UserRoles_Var_Samp_Order_By = {
  userId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type UserRoles_Variance_Fields = {
  __typename?: 'userRoles_variance_fields'
  userId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.user_roles" */
export type UserRoles_Variance_Order_By = {
  userId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.users" */
export type Users = {
  __typename?: 'users'
  /** An object relationship */
  adp: Maybe<Adp>
  adpId: Maybe<Scalars['String']['output']>
  birthday: Maybe<Scalars['String']['output']>
  createdAt: Scalars['timestamptz']['output']
  /** An object relationship */
  department: Maybe<Departments>
  departmentId: Maybe<Scalars['Int']['output']>
  /** An array relationship */
  directReports: Array<Users>
  /** An aggregate relationship */
  directReports_aggregate: Users_Aggregate
  dn: Scalars['String']['output']
  email: Scalars['String']['output']
  entra_id: Maybe<Scalars['String']['output']>
  /** An array relationship */
  favoriteDiscussions: Array<FavoriteDiscussions>
  /** An aggregate relationship */
  favoriteDiscussions_aggregate: FavoriteDiscussions_Aggregate
  /** An array relationship */
  favoriteResources: Array<FavoriteResources>
  /** An aggregate relationship */
  favoriteResources_aggregate: FavoriteResources_Aggregate
  firstName: Scalars['String']['output']
  id: Scalars['Int']['output']
  isActive: Scalars['Boolean']['output']
  jobTitle: Maybe<Scalars['String']['output']>
  /** An object relationship */
  jobsite: Maybe<Jobsites>
  jobsiteId: Maybe<Scalars['Int']['output']>
  lastName: Scalars['String']['output']
  model_type: Scalars['bpchar']['output']
  /** A computed field, executes function "v2.users_original_photo_url" */
  originalPhotoUrl: Maybe<Scalars['String']['output']>
  phoneCell: Maybe<Scalars['String']['output']>
  phoneDirect: Maybe<Scalars['String']['output']>
  phoneExt: Maybe<Scalars['String']['output']>
  /** An object relationship */
  photo: Maybe<Uploads>
  photoUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.users_profile_photo_url" */
  profilePhotoUrl: Maybe<Scalars['String']['output']>
  /** An array relationship */
  roles: Array<UserRoles>
  /** An aggregate relationship */
  roles_aggregate: UserRoles_Aggregate
  /** An object relationship */
  supervisor: Maybe<Users>
  supervisorId: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['timestamptz']['output']
  username: Scalars['String']['output']
  workerType: Maybe<Scalars['String']['output']>
}

/** columns and relationships of "v2.users" */
export type UsersDirectReportsArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersDirectReports_AggregateArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Users_Order_By>>
  where: InputMaybe<Users_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersFavoriteDiscussionsArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersFavoriteDiscussions_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteDiscussions_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteDiscussions_Order_By>>
  where: InputMaybe<FavoriteDiscussions_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersFavoriteResourcesArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersFavoriteResources_AggregateArgs = {
  distinct_on: InputMaybe<Array<FavoriteResources_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<FavoriteResources_Order_By>>
  where: InputMaybe<FavoriteResources_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

/** columns and relationships of "v2.users" */
export type UsersRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<UserRoles_Order_By>>
  where: InputMaybe<UserRoles_Bool_Exp>
}

/** aggregated selection of "v2.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate'
  aggregate: Maybe<Users_Aggregate_Fields>
  nodes: Array<Users>
}

export type Users_Aggregate_Bool_Exp = {
  bool_and: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>
  bool_or: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>
  count: InputMaybe<Users_Aggregate_Bool_Exp_Count>
}

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Users_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Users_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Users_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<Users_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<Users_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields'
  avg: Maybe<Users_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<Users_Max_Fields>
  min: Maybe<Users_Min_Fields>
  stddev: Maybe<Users_Stddev_Fields>
  stddev_pop: Maybe<Users_Stddev_Pop_Fields>
  stddev_samp: Maybe<Users_Stddev_Samp_Fields>
  sum: Maybe<Users_Sum_Fields>
  var_pop: Maybe<Users_Var_Pop_Fields>
  var_samp: Maybe<Users_Var_Samp_Fields>
  variance: Maybe<Users_Variance_Fields>
}

/** aggregate fields of "v2.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Users_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.users" */
export type Users_Aggregate_Order_By = {
  avg: InputMaybe<Users_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<Users_Max_Order_By>
  min: InputMaybe<Users_Min_Order_By>
  stddev: InputMaybe<Users_Stddev_Order_By>
  stddev_pop: InputMaybe<Users_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<Users_Stddev_Samp_Order_By>
  sum: InputMaybe<Users_Sum_Order_By>
  var_pop: InputMaybe<Users_Var_Pop_Order_By>
  var_samp: InputMaybe<Users_Var_Samp_Order_By>
  variance: InputMaybe<Users_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<Users_On_Conflict>
}

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.users" */
export type Users_Avg_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and: InputMaybe<Array<Users_Bool_Exp>>
  _not: InputMaybe<Users_Bool_Exp>
  _or: InputMaybe<Array<Users_Bool_Exp>>
  adp: InputMaybe<Adp_Bool_Exp>
  adpId: InputMaybe<String_Comparison_Exp>
  birthday: InputMaybe<String_Comparison_Exp>
  createdAt: InputMaybe<Timestamptz_Comparison_Exp>
  department: InputMaybe<Departments_Bool_Exp>
  departmentId: InputMaybe<Int_Comparison_Exp>
  directReports: InputMaybe<Users_Bool_Exp>
  directReports_aggregate: InputMaybe<Users_Aggregate_Bool_Exp>
  dn: InputMaybe<String_Comparison_Exp>
  email: InputMaybe<String_Comparison_Exp>
  entra_id: InputMaybe<String_Comparison_Exp>
  favoriteDiscussions: InputMaybe<FavoriteDiscussions_Bool_Exp>
  favoriteDiscussions_aggregate: InputMaybe<FavoriteDiscussions_Aggregate_Bool_Exp>
  favoriteResources: InputMaybe<FavoriteResources_Bool_Exp>
  favoriteResources_aggregate: InputMaybe<FavoriteResources_Aggregate_Bool_Exp>
  firstName: InputMaybe<String_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  isActive: InputMaybe<Boolean_Comparison_Exp>
  jobTitle: InputMaybe<String_Comparison_Exp>
  jobsite: InputMaybe<Jobsites_Bool_Exp>
  jobsiteId: InputMaybe<Int_Comparison_Exp>
  lastName: InputMaybe<String_Comparison_Exp>
  model_type: InputMaybe<Bpchar_Comparison_Exp>
  originalPhotoUrl: InputMaybe<String_Comparison_Exp>
  phoneCell: InputMaybe<String_Comparison_Exp>
  phoneDirect: InputMaybe<String_Comparison_Exp>
  phoneExt: InputMaybe<String_Comparison_Exp>
  photo: InputMaybe<Uploads_Bool_Exp>
  photoUploadId: InputMaybe<Int_Comparison_Exp>
  profilePhotoUrl: InputMaybe<String_Comparison_Exp>
  roles: InputMaybe<UserRoles_Bool_Exp>
  roles_aggregate: InputMaybe<UserRoles_Aggregate_Bool_Exp>
  supervisor: InputMaybe<Users_Bool_Exp>
  supervisorId: InputMaybe<Int_Comparison_Exp>
  updatedAt: InputMaybe<Timestamptz_Comparison_Exp>
  username: InputMaybe<String_Comparison_Exp>
  workerType: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "adp_id" */
  UsersAdpIdKey = 'users_adp_id_key',
  /** unique or primary key constraint on columns "dn" */
  UsersDnKey = 'users_dn_key',
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "username" */
  UsersUsernameKey = 'users_username_key'
}

/** input type for incrementing numeric columns in table "v2.users" */
export type Users_Inc_Input = {
  departmentId: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  photoUploadId: InputMaybe<Scalars['Int']['input']>
  supervisorId: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.users" */
export type Users_Insert_Input = {
  adp: InputMaybe<Adp_Obj_Rel_Insert_Input>
  adpId: InputMaybe<Scalars['String']['input']>
  birthday: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  department: InputMaybe<Departments_Obj_Rel_Insert_Input>
  departmentId: InputMaybe<Scalars['Int']['input']>
  directReports: InputMaybe<Users_Arr_Rel_Insert_Input>
  dn: InputMaybe<Scalars['String']['input']>
  email: InputMaybe<Scalars['String']['input']>
  entra_id: InputMaybe<Scalars['String']['input']>
  favoriteDiscussions: InputMaybe<FavoriteDiscussions_Arr_Rel_Insert_Input>
  favoriteResources: InputMaybe<FavoriteResources_Arr_Rel_Insert_Input>
  firstName: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isActive: InputMaybe<Scalars['Boolean']['input']>
  jobTitle: InputMaybe<Scalars['String']['input']>
  jobsite: InputMaybe<Jobsites_Obj_Rel_Insert_Input>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  lastName: InputMaybe<Scalars['String']['input']>
  model_type: InputMaybe<Scalars['bpchar']['input']>
  phoneCell: InputMaybe<Scalars['String']['input']>
  phoneDirect: InputMaybe<Scalars['String']['input']>
  phoneExt: InputMaybe<Scalars['String']['input']>
  photo: InputMaybe<Uploads_Obj_Rel_Insert_Input>
  photoUploadId: InputMaybe<Scalars['Int']['input']>
  roles: InputMaybe<UserRoles_Arr_Rel_Insert_Input>
  supervisor: InputMaybe<Users_Obj_Rel_Insert_Input>
  supervisorId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  username: InputMaybe<Scalars['String']['input']>
  workerType: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields'
  adpId: Maybe<Scalars['String']['output']>
  birthday: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  dn: Maybe<Scalars['String']['output']>
  email: Maybe<Scalars['String']['output']>
  entra_id: Maybe<Scalars['String']['output']>
  firstName: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  jobTitle: Maybe<Scalars['String']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
  lastName: Maybe<Scalars['String']['output']>
  model_type: Maybe<Scalars['bpchar']['output']>
  /** A computed field, executes function "v2.users_original_photo_url" */
  originalPhotoUrl: Maybe<Scalars['String']['output']>
  phoneCell: Maybe<Scalars['String']['output']>
  phoneDirect: Maybe<Scalars['String']['output']>
  phoneExt: Maybe<Scalars['String']['output']>
  photoUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.users_profile_photo_url" */
  profilePhotoUrl: Maybe<Scalars['String']['output']>
  supervisorId: Maybe<Scalars['Int']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  username: Maybe<Scalars['String']['output']>
  workerType: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "v2.users" */
export type Users_Max_Order_By = {
  adpId: InputMaybe<Order_By>
  birthday: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  dn: InputMaybe<Order_By>
  email: InputMaybe<Order_By>
  entra_id: InputMaybe<Order_By>
  firstName: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobTitle: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  lastName: InputMaybe<Order_By>
  model_type: InputMaybe<Order_By>
  phoneCell: InputMaybe<Order_By>
  phoneDirect: InputMaybe<Order_By>
  phoneExt: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  username: InputMaybe<Order_By>
  workerType: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields'
  adpId: Maybe<Scalars['String']['output']>
  birthday: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['timestamptz']['output']>
  departmentId: Maybe<Scalars['Int']['output']>
  dn: Maybe<Scalars['String']['output']>
  email: Maybe<Scalars['String']['output']>
  entra_id: Maybe<Scalars['String']['output']>
  firstName: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  jobTitle: Maybe<Scalars['String']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
  lastName: Maybe<Scalars['String']['output']>
  model_type: Maybe<Scalars['bpchar']['output']>
  /** A computed field, executes function "v2.users_original_photo_url" */
  originalPhotoUrl: Maybe<Scalars['String']['output']>
  phoneCell: Maybe<Scalars['String']['output']>
  phoneDirect: Maybe<Scalars['String']['output']>
  phoneExt: Maybe<Scalars['String']['output']>
  photoUploadId: Maybe<Scalars['Int']['output']>
  /** A computed field, executes function "v2.users_profile_photo_url" */
  profilePhotoUrl: Maybe<Scalars['String']['output']>
  supervisorId: Maybe<Scalars['Int']['output']>
  updatedAt: Maybe<Scalars['timestamptz']['output']>
  username: Maybe<Scalars['String']['output']>
  workerType: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "v2.users" */
export type Users_Min_Order_By = {
  adpId: InputMaybe<Order_By>
  birthday: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  departmentId: InputMaybe<Order_By>
  dn: InputMaybe<Order_By>
  email: InputMaybe<Order_By>
  entra_id: InputMaybe<Order_By>
  firstName: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobTitle: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  lastName: InputMaybe<Order_By>
  model_type: InputMaybe<Order_By>
  phoneCell: InputMaybe<Order_By>
  phoneDirect: InputMaybe<Order_By>
  phoneExt: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  username: InputMaybe<Order_By>
  workerType: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Users>
}

/** input type for inserting object relation for remote table "v2.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input
  /** upsert condition */
  on_conflict: InputMaybe<Users_On_Conflict>
}

/** on_conflict condition type for table "v2.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint
  update_columns: Array<Users_Update_Column>
  where: InputMaybe<Users_Bool_Exp>
}

/** Ordering options when selecting data from "v2.users". */
export type Users_Order_By = {
  adp: InputMaybe<Adp_Order_By>
  adpId: InputMaybe<Order_By>
  birthday: InputMaybe<Order_By>
  createdAt: InputMaybe<Order_By>
  department: InputMaybe<Departments_Order_By>
  departmentId: InputMaybe<Order_By>
  directReports_aggregate: InputMaybe<Users_Aggregate_Order_By>
  dn: InputMaybe<Order_By>
  email: InputMaybe<Order_By>
  entra_id: InputMaybe<Order_By>
  favoriteDiscussions_aggregate: InputMaybe<FavoriteDiscussions_Aggregate_Order_By>
  favoriteResources_aggregate: InputMaybe<FavoriteResources_Aggregate_Order_By>
  firstName: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  isActive: InputMaybe<Order_By>
  jobTitle: InputMaybe<Order_By>
  jobsite: InputMaybe<Jobsites_Order_By>
  jobsiteId: InputMaybe<Order_By>
  lastName: InputMaybe<Order_By>
  model_type: InputMaybe<Order_By>
  originalPhotoUrl: InputMaybe<Order_By>
  phoneCell: InputMaybe<Order_By>
  phoneDirect: InputMaybe<Order_By>
  phoneExt: InputMaybe<Order_By>
  photo: InputMaybe<Uploads_Order_By>
  photoUploadId: InputMaybe<Order_By>
  profilePhotoUrl: InputMaybe<Order_By>
  roles_aggregate: InputMaybe<UserRoles_Aggregate_Order_By>
  supervisor: InputMaybe<Users_Order_By>
  supervisorId: InputMaybe<Order_By>
  updatedAt: InputMaybe<Order_By>
  username: InputMaybe<Order_By>
  workerType: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.users" */
export enum Users_Select_Column {
  /** column name */
  AdpId = 'adpId',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Dn = 'dn',
  /** column name */
  Email = 'email',
  /** column name */
  EntraId = 'entra_id',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  JobsiteId = 'jobsiteId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  PhoneCell = 'phoneCell',
  /** column name */
  PhoneDirect = 'phoneDirect',
  /** column name */
  PhoneExt = 'phoneExt',
  /** column name */
  PhotoUploadId = 'photoUploadId',
  /** column name */
  SupervisorId = 'supervisorId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WorkerType = 'workerType'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "v2.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "v2.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'isActive'
}

/** input type for updating data in table "v2.users" */
export type Users_Set_Input = {
  adpId: InputMaybe<Scalars['String']['input']>
  birthday: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  dn: InputMaybe<Scalars['String']['input']>
  email: InputMaybe<Scalars['String']['input']>
  entra_id: InputMaybe<Scalars['String']['input']>
  firstName: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isActive: InputMaybe<Scalars['Boolean']['input']>
  jobTitle: InputMaybe<Scalars['String']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  lastName: InputMaybe<Scalars['String']['input']>
  model_type: InputMaybe<Scalars['bpchar']['input']>
  phoneCell: InputMaybe<Scalars['String']['input']>
  phoneDirect: InputMaybe<Scalars['String']['input']>
  phoneExt: InputMaybe<Scalars['String']['input']>
  photoUploadId: InputMaybe<Scalars['Int']['input']>
  supervisorId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  username: InputMaybe<Scalars['String']['input']>
  workerType: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.users" */
export type Users_Stddev_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.users" */
export type Users_Stddev_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.users" */
export type Users_Stddev_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  adpId: InputMaybe<Scalars['String']['input']>
  birthday: InputMaybe<Scalars['String']['input']>
  createdAt: InputMaybe<Scalars['timestamptz']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  dn: InputMaybe<Scalars['String']['input']>
  email: InputMaybe<Scalars['String']['input']>
  entra_id: InputMaybe<Scalars['String']['input']>
  firstName: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  isActive: InputMaybe<Scalars['Boolean']['input']>
  jobTitle: InputMaybe<Scalars['String']['input']>
  jobsiteId: InputMaybe<Scalars['Int']['input']>
  lastName: InputMaybe<Scalars['String']['input']>
  model_type: InputMaybe<Scalars['bpchar']['input']>
  phoneCell: InputMaybe<Scalars['String']['input']>
  phoneDirect: InputMaybe<Scalars['String']['input']>
  phoneExt: InputMaybe<Scalars['String']['input']>
  photoUploadId: InputMaybe<Scalars['Int']['input']>
  supervisorId: InputMaybe<Scalars['Int']['input']>
  updatedAt: InputMaybe<Scalars['timestamptz']['input']>
  username: InputMaybe<Scalars['String']['input']>
  workerType: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields'
  departmentId: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  jobsiteId: Maybe<Scalars['Int']['output']>
  photoUploadId: Maybe<Scalars['Int']['output']>
  supervisorId: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.users" */
export type Users_Sum_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** update columns of table "v2.users" */
export enum Users_Update_Column {
  /** column name */
  AdpId = 'adpId',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Dn = 'dn',
  /** column name */
  Email = 'email',
  /** column name */
  EntraId = 'entra_id',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  JobsiteId = 'jobsiteId',
  /** column name */
  LastName = 'lastName',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  PhoneCell = 'phoneCell',
  /** column name */
  PhoneDirect = 'phoneDirect',
  /** column name */
  PhoneExt = 'phoneExt',
  /** column name */
  PhotoUploadId = 'photoUploadId',
  /** column name */
  SupervisorId = 'supervisorId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username',
  /** column name */
  WorkerType = 'workerType'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<Users_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<Users_Set_Input>
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.users" */
export type Users_Var_Pop_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.users" */
export type Users_Var_Samp_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields'
  departmentId: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  jobsiteId: Maybe<Scalars['Float']['output']>
  photoUploadId: Maybe<Scalars['Float']['output']>
  supervisorId: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.users" */
export type Users_Variance_Order_By = {
  departmentId: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  jobsiteId: InputMaybe<Order_By>
  photoUploadId: InputMaybe<Order_By>
  supervisorId: InputMaybe<Order_By>
}

/** columns and relationships of "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification = {
  __typename?: 'v2_adp_associate_certification'
  associate_oid: Scalars['String']['output']
  category_code: Maybe<Scalars['String']['output']>
  certification_code: Scalars['String']['output']
  expiration_date: Maybe<Scalars['date']['output']>
  first_issue_date: Maybe<Scalars['date']['output']>
  id: Scalars['String']['output']
  raw: Scalars['jsonb']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.adp_associate_certification" */
export type V2_Adp_Associate_CertificationRawArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Aggregate = {
  __typename?: 'v2_adp_associate_certification_aggregate'
  aggregate: Maybe<V2_Adp_Associate_Certification_Aggregate_Fields>
  nodes: Array<V2_Adp_Associate_Certification>
}

/** aggregate fields of "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Aggregate_Fields = {
  __typename?: 'v2_adp_associate_certification_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_Associate_Certification_Max_Fields>
  min: Maybe<V2_Adp_Associate_Certification_Min_Fields>
}

/** aggregate fields of "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_Associate_Certification_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type V2_Adp_Associate_Certification_Append_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp_associate_certification". All fields are combined with a logical 'AND'. */
export type V2_Adp_Associate_Certification_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_Associate_Certification_Bool_Exp>>
  _not: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_Associate_Certification_Bool_Exp>>
  associate_oid: InputMaybe<String_Comparison_Exp>
  category_code: InputMaybe<String_Comparison_Exp>
  certification_code: InputMaybe<String_Comparison_Exp>
  expiration_date: InputMaybe<Date_Comparison_Exp>
  first_issue_date: InputMaybe<Date_Comparison_Exp>
  id: InputMaybe<String_Comparison_Exp>
  raw: InputMaybe<Jsonb_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_associate_certification" */
export enum V2_Adp_Associate_Certification_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdpAssociateCertificationPkey = 'adp_associate_certification_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type V2_Adp_Associate_Certification_Delete_At_Path_Input = {
  raw: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type V2_Adp_Associate_Certification_Delete_Elem_Input = {
  raw: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type V2_Adp_Associate_Certification_Delete_Key_Input = {
  raw: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Insert_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  category_code: InputMaybe<Scalars['String']['input']>
  certification_code: InputMaybe<Scalars['String']['input']>
  expiration_date: InputMaybe<Scalars['date']['input']>
  first_issue_date: InputMaybe<Scalars['date']['input']>
  id: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Adp_Associate_Certification_Max_Fields = {
  __typename?: 'v2_adp_associate_certification_max_fields'
  associate_oid: Maybe<Scalars['String']['output']>
  category_code: Maybe<Scalars['String']['output']>
  certification_code: Maybe<Scalars['String']['output']>
  expiration_date: Maybe<Scalars['date']['output']>
  first_issue_date: Maybe<Scalars['date']['output']>
  id: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Adp_Associate_Certification_Min_Fields = {
  __typename?: 'v2_adp_associate_certification_min_fields'
  associate_oid: Maybe<Scalars['String']['output']>
  category_code: Maybe<Scalars['String']['output']>
  certification_code: Maybe<Scalars['String']['output']>
  expiration_date: Maybe<Scalars['date']['output']>
  first_issue_date: Maybe<Scalars['date']['output']>
  id: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Mutation_Response = {
  __typename?: 'v2_adp_associate_certification_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_Associate_Certification>
}

/** on_conflict condition type for table "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_On_Conflict = {
  constraint: V2_Adp_Associate_Certification_Constraint
  update_columns: Array<V2_Adp_Associate_Certification_Update_Column>
  where: InputMaybe<V2_Adp_Associate_Certification_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_associate_certification". */
export type V2_Adp_Associate_Certification_Order_By = {
  associate_oid: InputMaybe<Order_By>
  category_code: InputMaybe<Order_By>
  certification_code: InputMaybe<Order_By>
  expiration_date: InputMaybe<Order_By>
  first_issue_date: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  raw: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_associate_certification */
export type V2_Adp_Associate_Certification_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type V2_Adp_Associate_Certification_Prepend_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.adp_associate_certification" */
export enum V2_Adp_Associate_Certification_Select_Column {
  /** column name */
  AssociateOid = 'associate_oid',
  /** column name */
  CategoryCode = 'category_code',
  /** column name */
  CertificationCode = 'certification_code',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FirstIssueDate = 'first_issue_date',
  /** column name */
  Id = 'id',
  /** column name */
  Raw = 'raw',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.adp_associate_certification" */
export type V2_Adp_Associate_Certification_Set_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  category_code: InputMaybe<Scalars['String']['input']>
  certification_code: InputMaybe<Scalars['String']['input']>
  expiration_date: InputMaybe<Scalars['date']['input']>
  first_issue_date: InputMaybe<Scalars['date']['input']>
  id: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "v2_adp_associate_certification" */
export type V2_Adp_Associate_Certification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_Associate_Certification_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_Associate_Certification_Stream_Cursor_Value_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  category_code: InputMaybe<Scalars['String']['input']>
  certification_code: InputMaybe<Scalars['String']['input']>
  expiration_date: InputMaybe<Scalars['date']['input']>
  first_issue_date: InputMaybe<Scalars['date']['input']>
  id: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "v2.adp_associate_certification" */
export enum V2_Adp_Associate_Certification_Update_Column {
  /** column name */
  AssociateOid = 'associate_oid',
  /** column name */
  CategoryCode = 'category_code',
  /** column name */
  CertificationCode = 'certification_code',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FirstIssueDate = 'first_issue_date',
  /** column name */
  Id = 'id',
  /** column name */
  Raw = 'raw',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Adp_Associate_Certification_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<V2_Adp_Associate_Certification_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<V2_Adp_Associate_Certification_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<V2_Adp_Associate_Certification_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<V2_Adp_Associate_Certification_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<V2_Adp_Associate_Certification_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_Associate_Certification_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_Associate_Certification_Bool_Exp
}

/** columns and relationships of "v2.adp_associates" */
export type V2_Adp_Associates = {
  __typename?: 'v2_adp_associates'
  associate_oid: Scalars['String']['output']
  emails: Array<Scalars['String']['output']>
  first_name: Scalars['String']['output']
  last_name: Scalars['String']['output']
  position_ids: Maybe<Array<Scalars['String']['output']>>
  raw: Scalars['jsonb']['output']
  status: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
  worker_id: Scalars['String']['output']
}

/** columns and relationships of "v2.adp_associates" */
export type V2_Adp_AssociatesRawArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "v2.adp_associates" */
export type V2_Adp_Associates_Aggregate = {
  __typename?: 'v2_adp_associates_aggregate'
  aggregate: Maybe<V2_Adp_Associates_Aggregate_Fields>
  nodes: Array<V2_Adp_Associates>
}

/** aggregate fields of "v2.adp_associates" */
export type V2_Adp_Associates_Aggregate_Fields = {
  __typename?: 'v2_adp_associates_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_Associates_Max_Fields>
  min: Maybe<V2_Adp_Associates_Min_Fields>
}

/** aggregate fields of "v2.adp_associates" */
export type V2_Adp_Associates_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_Associates_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type V2_Adp_Associates_Append_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp_associates". All fields are combined with a logical 'AND'. */
export type V2_Adp_Associates_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_Associates_Bool_Exp>>
  _not: InputMaybe<V2_Adp_Associates_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_Associates_Bool_Exp>>
  associate_oid: InputMaybe<String_Comparison_Exp>
  emails: InputMaybe<String_Array_Comparison_Exp>
  first_name: InputMaybe<String_Comparison_Exp>
  last_name: InputMaybe<String_Comparison_Exp>
  position_ids: InputMaybe<String_Array_Comparison_Exp>
  raw: InputMaybe<Jsonb_Comparison_Exp>
  status: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
  worker_id: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_associates" */
export enum V2_Adp_Associates_Constraint {
  /** unique or primary key constraint on columns "associate_oid" */
  AdpAssociatesPkey = 'adp_associates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type V2_Adp_Associates_Delete_At_Path_Input = {
  raw: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type V2_Adp_Associates_Delete_Elem_Input = {
  raw: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type V2_Adp_Associates_Delete_Key_Input = {
  raw: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "v2.adp_associates" */
export type V2_Adp_Associates_Insert_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  emails: InputMaybe<Array<Scalars['String']['input']>>
  first_name: InputMaybe<Scalars['String']['input']>
  last_name: InputMaybe<Scalars['String']['input']>
  position_ids: InputMaybe<Array<Scalars['String']['input']>>
  raw: InputMaybe<Scalars['jsonb']['input']>
  status: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  worker_id: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type V2_Adp_Associates_Max_Fields = {
  __typename?: 'v2_adp_associates_max_fields'
  associate_oid: Maybe<Scalars['String']['output']>
  emails: Maybe<Array<Scalars['String']['output']>>
  first_name: Maybe<Scalars['String']['output']>
  last_name: Maybe<Scalars['String']['output']>
  position_ids: Maybe<Array<Scalars['String']['output']>>
  status: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
  worker_id: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type V2_Adp_Associates_Min_Fields = {
  __typename?: 'v2_adp_associates_min_fields'
  associate_oid: Maybe<Scalars['String']['output']>
  emails: Maybe<Array<Scalars['String']['output']>>
  first_name: Maybe<Scalars['String']['output']>
  last_name: Maybe<Scalars['String']['output']>
  position_ids: Maybe<Array<Scalars['String']['output']>>
  status: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
  worker_id: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "v2.adp_associates" */
export type V2_Adp_Associates_Mutation_Response = {
  __typename?: 'v2_adp_associates_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_Associates>
}

/** on_conflict condition type for table "v2.adp_associates" */
export type V2_Adp_Associates_On_Conflict = {
  constraint: V2_Adp_Associates_Constraint
  update_columns: Array<V2_Adp_Associates_Update_Column>
  where: InputMaybe<V2_Adp_Associates_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_associates". */
export type V2_Adp_Associates_Order_By = {
  associate_oid: InputMaybe<Order_By>
  emails: InputMaybe<Order_By>
  first_name: InputMaybe<Order_By>
  last_name: InputMaybe<Order_By>
  position_ids: InputMaybe<Order_By>
  raw: InputMaybe<Order_By>
  status: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
  worker_id: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_associates */
export type V2_Adp_Associates_Pk_Columns_Input = {
  associate_oid: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type V2_Adp_Associates_Prepend_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.adp_associates" */
export enum V2_Adp_Associates_Select_Column {
  /** column name */
  AssociateOid = 'associate_oid',
  /** column name */
  Emails = 'emails',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PositionIds = 'position_ids',
  /** column name */
  Raw = 'raw',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkerId = 'worker_id'
}

/** input type for updating data in table "v2.adp_associates" */
export type V2_Adp_Associates_Set_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  emails: InputMaybe<Array<Scalars['String']['input']>>
  first_name: InputMaybe<Scalars['String']['input']>
  last_name: InputMaybe<Scalars['String']['input']>
  position_ids: InputMaybe<Array<Scalars['String']['input']>>
  raw: InputMaybe<Scalars['jsonb']['input']>
  status: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  worker_id: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "v2_adp_associates" */
export type V2_Adp_Associates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_Associates_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_Associates_Stream_Cursor_Value_Input = {
  associate_oid: InputMaybe<Scalars['String']['input']>
  emails: InputMaybe<Array<Scalars['String']['input']>>
  first_name: InputMaybe<Scalars['String']['input']>
  last_name: InputMaybe<Scalars['String']['input']>
  position_ids: InputMaybe<Array<Scalars['String']['input']>>
  raw: InputMaybe<Scalars['jsonb']['input']>
  status: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
  worker_id: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "v2.adp_associates" */
export enum V2_Adp_Associates_Update_Column {
  /** column name */
  AssociateOid = 'associate_oid',
  /** column name */
  Emails = 'emails',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PositionIds = 'position_ids',
  /** column name */
  Raw = 'raw',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkerId = 'worker_id'
}

export type V2_Adp_Associates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<V2_Adp_Associates_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<V2_Adp_Associates_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<V2_Adp_Associates_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<V2_Adp_Associates_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<V2_Adp_Associates_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_Associates_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_Associates_Bool_Exp
}

/** columns and relationships of "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories = {
  __typename?: 'v2_adp_certification_categories'
  code: Scalars['String']['output']
  name: Scalars['String']['output']
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Aggregate = {
  __typename?: 'v2_adp_certification_categories_aggregate'
  aggregate: Maybe<V2_Adp_Certification_Categories_Aggregate_Fields>
  nodes: Array<V2_Adp_Certification_Categories>
}

/** aggregate fields of "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Aggregate_Fields = {
  __typename?: 'v2_adp_certification_categories_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_Certification_Categories_Max_Fields>
  min: Maybe<V2_Adp_Certification_Categories_Min_Fields>
}

/** aggregate fields of "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_Certification_Categories_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp_certification_categories". All fields are combined with a logical 'AND'. */
export type V2_Adp_Certification_Categories_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_Certification_Categories_Bool_Exp>>
  _not: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_Certification_Categories_Bool_Exp>>
  code: InputMaybe<String_Comparison_Exp>
  name: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_certification_categories" */
export enum V2_Adp_Certification_Categories_Constraint {
  /** unique or primary key constraint on columns "code" */
  AdpCertificationCategoriesPkey = 'adp_certification_categories_pkey'
}

/** input type for inserting data into table "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Insert_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Adp_Certification_Categories_Max_Fields = {
  __typename?: 'v2_adp_certification_categories_max_fields'
  code: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Adp_Certification_Categories_Min_Fields = {
  __typename?: 'v2_adp_certification_categories_min_fields'
  code: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Mutation_Response = {
  __typename?: 'v2_adp_certification_categories_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_Certification_Categories>
}

/** on_conflict condition type for table "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_On_Conflict = {
  constraint: V2_Adp_Certification_Categories_Constraint
  update_columns: Array<V2_Adp_Certification_Categories_Update_Column>
  where: InputMaybe<V2_Adp_Certification_Categories_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_certification_categories". */
export type V2_Adp_Certification_Categories_Order_By = {
  code: InputMaybe<Order_By>
  name: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_certification_categories */
export type V2_Adp_Certification_Categories_Pk_Columns_Input = {
  code: Scalars['String']['input']
}

/** select columns of table "v2.adp_certification_categories" */
export enum V2_Adp_Certification_Categories_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.adp_certification_categories" */
export type V2_Adp_Certification_Categories_Set_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "v2_adp_certification_categories" */
export type V2_Adp_Certification_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_Certification_Categories_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_Certification_Categories_Stream_Cursor_Value_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "v2.adp_certification_categories" */
export enum V2_Adp_Certification_Categories_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Adp_Certification_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_Certification_Categories_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_Certification_Categories_Bool_Exp
}

/** columns and relationships of "v2.adp_certifications" */
export type V2_Adp_Certifications = {
  __typename?: 'v2_adp_certifications'
  code: Scalars['String']['output']
  description: Scalars['String']['output']
  docebo_import_course_id: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "v2.adp_certifications" */
export type V2_Adp_Certifications_Aggregate = {
  __typename?: 'v2_adp_certifications_aggregate'
  aggregate: Maybe<V2_Adp_Certifications_Aggregate_Fields>
  nodes: Array<V2_Adp_Certifications>
}

/** aggregate fields of "v2.adp_certifications" */
export type V2_Adp_Certifications_Aggregate_Fields = {
  __typename?: 'v2_adp_certifications_aggregate_fields'
  avg: Maybe<V2_Adp_Certifications_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_Certifications_Max_Fields>
  min: Maybe<V2_Adp_Certifications_Min_Fields>
  stddev: Maybe<V2_Adp_Certifications_Stddev_Fields>
  stddev_pop: Maybe<V2_Adp_Certifications_Stddev_Pop_Fields>
  stddev_samp: Maybe<V2_Adp_Certifications_Stddev_Samp_Fields>
  sum: Maybe<V2_Adp_Certifications_Sum_Fields>
  var_pop: Maybe<V2_Adp_Certifications_Var_Pop_Fields>
  var_samp: Maybe<V2_Adp_Certifications_Var_Samp_Fields>
  variance: Maybe<V2_Adp_Certifications_Variance_Fields>
}

/** aggregate fields of "v2.adp_certifications" */
export type V2_Adp_Certifications_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_Certifications_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type V2_Adp_Certifications_Avg_Fields = {
  __typename?: 'v2_adp_certifications_avg_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.adp_certifications". All fields are combined with a logical 'AND'. */
export type V2_Adp_Certifications_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_Certifications_Bool_Exp>>
  _not: InputMaybe<V2_Adp_Certifications_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_Certifications_Bool_Exp>>
  code: InputMaybe<String_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  docebo_import_course_id: InputMaybe<Int_Comparison_Exp>
  name: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_certifications" */
export enum V2_Adp_Certifications_Constraint {
  /** unique or primary key constraint on columns "code" */
  AdpCertificationsPkey = 'adp_certifications_pkey'
}

/** input type for incrementing numeric columns in table "v2.adp_certifications" */
export type V2_Adp_Certifications_Inc_Input = {
  docebo_import_course_id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.adp_certifications" */
export type V2_Adp_Certifications_Insert_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  docebo_import_course_id: InputMaybe<Scalars['Int']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Adp_Certifications_Max_Fields = {
  __typename?: 'v2_adp_certifications_max_fields'
  code: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  docebo_import_course_id: Maybe<Scalars['Int']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Adp_Certifications_Min_Fields = {
  __typename?: 'v2_adp_certifications_min_fields'
  code: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  docebo_import_course_id: Maybe<Scalars['Int']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp_certifications" */
export type V2_Adp_Certifications_Mutation_Response = {
  __typename?: 'v2_adp_certifications_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_Certifications>
}

/** on_conflict condition type for table "v2.adp_certifications" */
export type V2_Adp_Certifications_On_Conflict = {
  constraint: V2_Adp_Certifications_Constraint
  update_columns: Array<V2_Adp_Certifications_Update_Column>
  where: InputMaybe<V2_Adp_Certifications_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_certifications". */
export type V2_Adp_Certifications_Order_By = {
  code: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  docebo_import_course_id: InputMaybe<Order_By>
  name: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_certifications */
export type V2_Adp_Certifications_Pk_Columns_Input = {
  code: Scalars['String']['input']
}

/** select columns of table "v2.adp_certifications" */
export enum V2_Adp_Certifications_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description',
  /** column name */
  DoceboImportCourseId = 'docebo_import_course_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.adp_certifications" */
export type V2_Adp_Certifications_Set_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  docebo_import_course_id: InputMaybe<Scalars['Int']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type V2_Adp_Certifications_Stddev_Fields = {
  __typename?: 'v2_adp_certifications_stddev_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type V2_Adp_Certifications_Stddev_Pop_Fields = {
  __typename?: 'v2_adp_certifications_stddev_pop_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type V2_Adp_Certifications_Stddev_Samp_Fields = {
  __typename?: 'v2_adp_certifications_stddev_samp_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "v2_adp_certifications" */
export type V2_Adp_Certifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_Certifications_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_Certifications_Stream_Cursor_Value_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  docebo_import_course_id: InputMaybe<Scalars['Int']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type V2_Adp_Certifications_Sum_Fields = {
  __typename?: 'v2_adp_certifications_sum_fields'
  docebo_import_course_id: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.adp_certifications" */
export enum V2_Adp_Certifications_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description',
  /** column name */
  DoceboImportCourseId = 'docebo_import_course_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Adp_Certifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<V2_Adp_Certifications_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_Certifications_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_Certifications_Bool_Exp
}

/** aggregate var_pop on columns */
export type V2_Adp_Certifications_Var_Pop_Fields = {
  __typename?: 'v2_adp_certifications_var_pop_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type V2_Adp_Certifications_Var_Samp_Fields = {
  __typename?: 'v2_adp_certifications_var_samp_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type V2_Adp_Certifications_Variance_Fields = {
  __typename?: 'v2_adp_certifications_variance_fields'
  docebo_import_course_id: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.adp_license_categories" */
export type V2_Adp_License_Categories = {
  __typename?: 'v2_adp_license_categories'
  code: Scalars['String']['output']
  name: Scalars['String']['output']
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Aggregate = {
  __typename?: 'v2_adp_license_categories_aggregate'
  aggregate: Maybe<V2_Adp_License_Categories_Aggregate_Fields>
  nodes: Array<V2_Adp_License_Categories>
}

/** aggregate fields of "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Aggregate_Fields = {
  __typename?: 'v2_adp_license_categories_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_License_Categories_Max_Fields>
  min: Maybe<V2_Adp_License_Categories_Min_Fields>
}

/** aggregate fields of "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_License_Categories_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp_license_categories". All fields are combined with a logical 'AND'. */
export type V2_Adp_License_Categories_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_License_Categories_Bool_Exp>>
  _not: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_License_Categories_Bool_Exp>>
  code: InputMaybe<String_Comparison_Exp>
  name: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_license_categories" */
export enum V2_Adp_License_Categories_Constraint {
  /** unique or primary key constraint on columns "code" */
  AdpLicenseCategoriesPkey = 'adp_license_categories_pkey'
}

/** input type for inserting data into table "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Insert_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Adp_License_Categories_Max_Fields = {
  __typename?: 'v2_adp_license_categories_max_fields'
  code: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Adp_License_Categories_Min_Fields = {
  __typename?: 'v2_adp_license_categories_min_fields'
  code: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Mutation_Response = {
  __typename?: 'v2_adp_license_categories_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_License_Categories>
}

/** on_conflict condition type for table "v2.adp_license_categories" */
export type V2_Adp_License_Categories_On_Conflict = {
  constraint: V2_Adp_License_Categories_Constraint
  update_columns: Array<V2_Adp_License_Categories_Update_Column>
  where: InputMaybe<V2_Adp_License_Categories_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_license_categories". */
export type V2_Adp_License_Categories_Order_By = {
  code: InputMaybe<Order_By>
  name: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_license_categories */
export type V2_Adp_License_Categories_Pk_Columns_Input = {
  code: Scalars['String']['input']
}

/** select columns of table "v2.adp_license_categories" */
export enum V2_Adp_License_Categories_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.adp_license_categories" */
export type V2_Adp_License_Categories_Set_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "v2_adp_license_categories" */
export type V2_Adp_License_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_License_Categories_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_License_Categories_Stream_Cursor_Value_Input = {
  code: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "v2.adp_license_categories" */
export enum V2_Adp_License_Categories_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Adp_License_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_License_Categories_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_License_Categories_Bool_Exp
}

/** columns and relationships of "v2.adp_licenses" */
export type V2_Adp_Licenses = {
  __typename?: 'v2_adp_licenses'
  code: Scalars['String']['output']
  description: Scalars['String']['output']
  name: Scalars['String']['output']
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregated selection of "v2.adp_licenses" */
export type V2_Adp_Licenses_Aggregate = {
  __typename?: 'v2_adp_licenses_aggregate'
  aggregate: Maybe<V2_Adp_Licenses_Aggregate_Fields>
  nodes: Array<V2_Adp_Licenses>
}

/** aggregate fields of "v2.adp_licenses" */
export type V2_Adp_Licenses_Aggregate_Fields = {
  __typename?: 'v2_adp_licenses_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Adp_Licenses_Max_Fields>
  min: Maybe<V2_Adp_Licenses_Min_Fields>
}

/** aggregate fields of "v2.adp_licenses" */
export type V2_Adp_Licenses_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Adp_Licenses_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.adp_licenses". All fields are combined with a logical 'AND'. */
export type V2_Adp_Licenses_Bool_Exp = {
  _and: InputMaybe<Array<V2_Adp_Licenses_Bool_Exp>>
  _not: InputMaybe<V2_Adp_Licenses_Bool_Exp>
  _or: InputMaybe<Array<V2_Adp_Licenses_Bool_Exp>>
  code: InputMaybe<String_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  name: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.adp_licenses" */
export enum V2_Adp_Licenses_Constraint {
  /** unique or primary key constraint on columns "code" */
  AdpLicensesPkey = 'adp_licenses_pkey'
}

/** input type for inserting data into table "v2.adp_licenses" */
export type V2_Adp_Licenses_Insert_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Adp_Licenses_Max_Fields = {
  __typename?: 'v2_adp_licenses_max_fields'
  code: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Adp_Licenses_Min_Fields = {
  __typename?: 'v2_adp_licenses_min_fields'
  code: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.adp_licenses" */
export type V2_Adp_Licenses_Mutation_Response = {
  __typename?: 'v2_adp_licenses_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Adp_Licenses>
}

/** on_conflict condition type for table "v2.adp_licenses" */
export type V2_Adp_Licenses_On_Conflict = {
  constraint: V2_Adp_Licenses_Constraint
  update_columns: Array<V2_Adp_Licenses_Update_Column>
  where: InputMaybe<V2_Adp_Licenses_Bool_Exp>
}

/** Ordering options when selecting data from "v2.adp_licenses". */
export type V2_Adp_Licenses_Order_By = {
  code: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  name: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.adp_licenses */
export type V2_Adp_Licenses_Pk_Columns_Input = {
  code: Scalars['String']['input']
}

/** select columns of table "v2.adp_licenses" */
export enum V2_Adp_Licenses_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.adp_licenses" */
export type V2_Adp_Licenses_Set_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "v2_adp_licenses" */
export type V2_Adp_Licenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Adp_Licenses_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Adp_Licenses_Stream_Cursor_Value_Input = {
  code: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  name: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "v2.adp_licenses" */
export enum V2_Adp_Licenses_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Adp_Licenses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Adp_Licenses_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Adp_Licenses_Bool_Exp
}

/** columns and relationships of "v2.docebo_courses" */
export type V2_Docebo_Courses = {
  __typename?: 'v2_docebo_courses'
  adp_certification_category_code: Maybe<Scalars['String']['output']>
  adp_certification_code: Maybe<Scalars['String']['output']>
  adp_certification_days: Maybe<Scalars['Int']['output']>
  code: Maybe<Scalars['String']['output']>
  img: Scalars['String']['output']
  is_deleted: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  raw: Scalars['jsonb']['output']
  uid: Scalars['String']['output']
  updated_at: Scalars['timestamptz']['output']
}

/** columns and relationships of "v2.docebo_courses" */
export type V2_Docebo_CoursesRawArgs = {
  path: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "v2.docebo_courses" */
export type V2_Docebo_Courses_Aggregate = {
  __typename?: 'v2_docebo_courses_aggregate'
  aggregate: Maybe<V2_Docebo_Courses_Aggregate_Fields>
  nodes: Array<V2_Docebo_Courses>
}

/** aggregate fields of "v2.docebo_courses" */
export type V2_Docebo_Courses_Aggregate_Fields = {
  __typename?: 'v2_docebo_courses_aggregate_fields'
  avg: Maybe<V2_Docebo_Courses_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<V2_Docebo_Courses_Max_Fields>
  min: Maybe<V2_Docebo_Courses_Min_Fields>
  stddev: Maybe<V2_Docebo_Courses_Stddev_Fields>
  stddev_pop: Maybe<V2_Docebo_Courses_Stddev_Pop_Fields>
  stddev_samp: Maybe<V2_Docebo_Courses_Stddev_Samp_Fields>
  sum: Maybe<V2_Docebo_Courses_Sum_Fields>
  var_pop: Maybe<V2_Docebo_Courses_Var_Pop_Fields>
  var_samp: Maybe<V2_Docebo_Courses_Var_Samp_Fields>
  variance: Maybe<V2_Docebo_Courses_Variance_Fields>
}

/** aggregate fields of "v2.docebo_courses" */
export type V2_Docebo_Courses_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Docebo_Courses_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type V2_Docebo_Courses_Append_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type V2_Docebo_Courses_Avg_Fields = {
  __typename?: 'v2_docebo_courses_avg_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.docebo_courses". All fields are combined with a logical 'AND'. */
export type V2_Docebo_Courses_Bool_Exp = {
  _and: InputMaybe<Array<V2_Docebo_Courses_Bool_Exp>>
  _not: InputMaybe<V2_Docebo_Courses_Bool_Exp>
  _or: InputMaybe<Array<V2_Docebo_Courses_Bool_Exp>>
  adp_certification_category_code: InputMaybe<String_Comparison_Exp>
  adp_certification_code: InputMaybe<String_Comparison_Exp>
  adp_certification_days: InputMaybe<Int_Comparison_Exp>
  code: InputMaybe<String_Comparison_Exp>
  img: InputMaybe<String_Comparison_Exp>
  is_deleted: InputMaybe<Boolean_Comparison_Exp>
  name: InputMaybe<String_Comparison_Exp>
  raw: InputMaybe<Jsonb_Comparison_Exp>
  uid: InputMaybe<String_Comparison_Exp>
  updated_at: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.docebo_courses" */
export enum V2_Docebo_Courses_Constraint {
  /** unique or primary key constraint on columns "uid" */
  DoceboCoursesPkey = 'docebo_courses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type V2_Docebo_Courses_Delete_At_Path_Input = {
  raw: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type V2_Docebo_Courses_Delete_Elem_Input = {
  raw: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type V2_Docebo_Courses_Delete_Key_Input = {
  raw: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "v2.docebo_courses" */
export type V2_Docebo_Courses_Inc_Input = {
  adp_certification_days: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.docebo_courses" */
export type V2_Docebo_Courses_Insert_Input = {
  adp_certification_category_code: InputMaybe<Scalars['String']['input']>
  adp_certification_code: InputMaybe<Scalars['String']['input']>
  adp_certification_days: InputMaybe<Scalars['Int']['input']>
  code: InputMaybe<Scalars['String']['input']>
  img: InputMaybe<Scalars['String']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  name: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  uid: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type V2_Docebo_Courses_Max_Fields = {
  __typename?: 'v2_docebo_courses_max_fields'
  adp_certification_category_code: Maybe<Scalars['String']['output']>
  adp_certification_code: Maybe<Scalars['String']['output']>
  adp_certification_days: Maybe<Scalars['Int']['output']>
  code: Maybe<Scalars['String']['output']>
  img: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  uid: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type V2_Docebo_Courses_Min_Fields = {
  __typename?: 'v2_docebo_courses_min_fields'
  adp_certification_category_code: Maybe<Scalars['String']['output']>
  adp_certification_code: Maybe<Scalars['String']['output']>
  adp_certification_days: Maybe<Scalars['Int']['output']>
  code: Maybe<Scalars['String']['output']>
  img: Maybe<Scalars['String']['output']>
  name: Maybe<Scalars['String']['output']>
  uid: Maybe<Scalars['String']['output']>
  updated_at: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "v2.docebo_courses" */
export type V2_Docebo_Courses_Mutation_Response = {
  __typename?: 'v2_docebo_courses_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Docebo_Courses>
}

/** on_conflict condition type for table "v2.docebo_courses" */
export type V2_Docebo_Courses_On_Conflict = {
  constraint: V2_Docebo_Courses_Constraint
  update_columns: Array<V2_Docebo_Courses_Update_Column>
  where: InputMaybe<V2_Docebo_Courses_Bool_Exp>
}

/** Ordering options when selecting data from "v2.docebo_courses". */
export type V2_Docebo_Courses_Order_By = {
  adp_certification_category_code: InputMaybe<Order_By>
  adp_certification_code: InputMaybe<Order_By>
  adp_certification_days: InputMaybe<Order_By>
  code: InputMaybe<Order_By>
  img: InputMaybe<Order_By>
  is_deleted: InputMaybe<Order_By>
  name: InputMaybe<Order_By>
  raw: InputMaybe<Order_By>
  uid: InputMaybe<Order_By>
  updated_at: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.docebo_courses */
export type V2_Docebo_Courses_Pk_Columns_Input = {
  uid: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type V2_Docebo_Courses_Prepend_Input = {
  raw: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "v2.docebo_courses" */
export enum V2_Docebo_Courses_Select_Column {
  /** column name */
  AdpCertificationCategoryCode = 'adp_certification_category_code',
  /** column name */
  AdpCertificationCode = 'adp_certification_code',
  /** column name */
  AdpCertificationDays = 'adp_certification_days',
  /** column name */
  Code = 'code',
  /** column name */
  Img = 'img',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Name = 'name',
  /** column name */
  Raw = 'raw',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "v2.docebo_courses" */
export type V2_Docebo_Courses_Set_Input = {
  adp_certification_category_code: InputMaybe<Scalars['String']['input']>
  adp_certification_code: InputMaybe<Scalars['String']['input']>
  adp_certification_days: InputMaybe<Scalars['Int']['input']>
  code: InputMaybe<Scalars['String']['input']>
  img: InputMaybe<Scalars['String']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  name: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  uid: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type V2_Docebo_Courses_Stddev_Fields = {
  __typename?: 'v2_docebo_courses_stddev_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type V2_Docebo_Courses_Stddev_Pop_Fields = {
  __typename?: 'v2_docebo_courses_stddev_pop_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type V2_Docebo_Courses_Stddev_Samp_Fields = {
  __typename?: 'v2_docebo_courses_stddev_samp_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "v2_docebo_courses" */
export type V2_Docebo_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Docebo_Courses_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Docebo_Courses_Stream_Cursor_Value_Input = {
  adp_certification_category_code: InputMaybe<Scalars['String']['input']>
  adp_certification_code: InputMaybe<Scalars['String']['input']>
  adp_certification_days: InputMaybe<Scalars['Int']['input']>
  code: InputMaybe<Scalars['String']['input']>
  img: InputMaybe<Scalars['String']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  name: InputMaybe<Scalars['String']['input']>
  raw: InputMaybe<Scalars['jsonb']['input']>
  uid: InputMaybe<Scalars['String']['input']>
  updated_at: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type V2_Docebo_Courses_Sum_Fields = {
  __typename?: 'v2_docebo_courses_sum_fields'
  adp_certification_days: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.docebo_courses" */
export enum V2_Docebo_Courses_Update_Column {
  /** column name */
  AdpCertificationCategoryCode = 'adp_certification_category_code',
  /** column name */
  AdpCertificationCode = 'adp_certification_code',
  /** column name */
  AdpCertificationDays = 'adp_certification_days',
  /** column name */
  Code = 'code',
  /** column name */
  Img = 'img',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Name = 'name',
  /** column name */
  Raw = 'raw',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type V2_Docebo_Courses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append: InputMaybe<V2_Docebo_Courses_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path: InputMaybe<V2_Docebo_Courses_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem: InputMaybe<V2_Docebo_Courses_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key: InputMaybe<V2_Docebo_Courses_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<V2_Docebo_Courses_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend: InputMaybe<V2_Docebo_Courses_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Docebo_Courses_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Docebo_Courses_Bool_Exp
}

/** aggregate var_pop on columns */
export type V2_Docebo_Courses_Var_Pop_Fields = {
  __typename?: 'v2_docebo_courses_var_pop_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type V2_Docebo_Courses_Var_Samp_Fields = {
  __typename?: 'v2_docebo_courses_var_samp_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type V2_Docebo_Courses_Variance_Fields = {
  __typename?: 'v2_docebo_courses_variance_fields'
  adp_certification_days: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.months" */
export type V2_Months = {
  __typename?: 'v2_months'
  id: Maybe<Scalars['String']['output']>
  month: Maybe<Scalars['date']['output']>
}

/** aggregated selection of "v2.months" */
export type V2_Months_Aggregate = {
  __typename?: 'v2_months_aggregate'
  aggregate: Maybe<V2_Months_Aggregate_Fields>
  nodes: Array<V2_Months>
}

/** aggregate fields of "v2.months" */
export type V2_Months_Aggregate_Fields = {
  __typename?: 'v2_months_aggregate_fields'
  count: Scalars['Int']['output']
  max: Maybe<V2_Months_Max_Fields>
  min: Maybe<V2_Months_Min_Fields>
}

/** aggregate fields of "v2.months" */
export type V2_Months_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Months_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "v2.months". All fields are combined with a logical 'AND'. */
export type V2_Months_Bool_Exp = {
  _and: InputMaybe<Array<V2_Months_Bool_Exp>>
  _not: InputMaybe<V2_Months_Bool_Exp>
  _or: InputMaybe<Array<V2_Months_Bool_Exp>>
  id: InputMaybe<String_Comparison_Exp>
  month: InputMaybe<Date_Comparison_Exp>
}

/** aggregate max on columns */
export type V2_Months_Max_Fields = {
  __typename?: 'v2_months_max_fields'
  id: Maybe<Scalars['String']['output']>
  month: Maybe<Scalars['date']['output']>
}

/** aggregate min on columns */
export type V2_Months_Min_Fields = {
  __typename?: 'v2_months_min_fields'
  id: Maybe<Scalars['String']['output']>
  month: Maybe<Scalars['date']['output']>
}

/** Ordering options when selecting data from "v2.months". */
export type V2_Months_Order_By = {
  id: InputMaybe<Order_By>
  month: InputMaybe<Order_By>
}

/** select columns of table "v2.months" */
export enum V2_Months_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month'
}

/** Streaming cursor of the table "v2_months" */
export type V2_Months_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Months_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Months_Stream_Cursor_Value_Input = {
  id: InputMaybe<Scalars['String']['input']>
  month: InputMaybe<Scalars['date']['input']>
}

/** columns and relationships of "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup = {
  __typename?: 'v2_nomination_thumbsup'
  nomination_id: Scalars['Int']['output']
  user_id: Scalars['Int']['output']
}

/** aggregated selection of "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Aggregate = {
  __typename?: 'v2_nomination_thumbsup_aggregate'
  aggregate: Maybe<V2_Nomination_Thumbsup_Aggregate_Fields>
  nodes: Array<V2_Nomination_Thumbsup>
}

export type V2_Nomination_Thumbsup_Aggregate_Bool_Exp = {
  count: InputMaybe<V2_Nomination_Thumbsup_Aggregate_Bool_Exp_Count>
}

export type V2_Nomination_Thumbsup_Aggregate_Bool_Exp_Count = {
  arguments: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
  filter: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Aggregate_Fields = {
  __typename?: 'v2_nomination_thumbsup_aggregate_fields'
  avg: Maybe<V2_Nomination_Thumbsup_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<V2_Nomination_Thumbsup_Max_Fields>
  min: Maybe<V2_Nomination_Thumbsup_Min_Fields>
  stddev: Maybe<V2_Nomination_Thumbsup_Stddev_Fields>
  stddev_pop: Maybe<V2_Nomination_Thumbsup_Stddev_Pop_Fields>
  stddev_samp: Maybe<V2_Nomination_Thumbsup_Stddev_Samp_Fields>
  sum: Maybe<V2_Nomination_Thumbsup_Sum_Fields>
  var_pop: Maybe<V2_Nomination_Thumbsup_Var_Pop_Fields>
  var_samp: Maybe<V2_Nomination_Thumbsup_Var_Samp_Fields>
  variance: Maybe<V2_Nomination_Thumbsup_Variance_Fields>
}

/** aggregate fields of "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Aggregate_Order_By = {
  avg: InputMaybe<V2_Nomination_Thumbsup_Avg_Order_By>
  count: InputMaybe<Order_By>
  max: InputMaybe<V2_Nomination_Thumbsup_Max_Order_By>
  min: InputMaybe<V2_Nomination_Thumbsup_Min_Order_By>
  stddev: InputMaybe<V2_Nomination_Thumbsup_Stddev_Order_By>
  stddev_pop: InputMaybe<V2_Nomination_Thumbsup_Stddev_Pop_Order_By>
  stddev_samp: InputMaybe<V2_Nomination_Thumbsup_Stddev_Samp_Order_By>
  sum: InputMaybe<V2_Nomination_Thumbsup_Sum_Order_By>
  var_pop: InputMaybe<V2_Nomination_Thumbsup_Var_Pop_Order_By>
  var_samp: InputMaybe<V2_Nomination_Thumbsup_Var_Samp_Order_By>
  variance: InputMaybe<V2_Nomination_Thumbsup_Variance_Order_By>
}

/** input type for inserting array relation for remote table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Arr_Rel_Insert_Input = {
  data: Array<V2_Nomination_Thumbsup_Insert_Input>
  /** upsert condition */
  on_conflict: InputMaybe<V2_Nomination_Thumbsup_On_Conflict>
}

/** aggregate avg on columns */
export type V2_Nomination_Thumbsup_Avg_Fields = {
  __typename?: 'v2_nomination_thumbsup_avg_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Avg_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "v2.nomination_thumbsup". All fields are combined with a logical 'AND'. */
export type V2_Nomination_Thumbsup_Bool_Exp = {
  _and: InputMaybe<Array<V2_Nomination_Thumbsup_Bool_Exp>>
  _not: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
  _or: InputMaybe<Array<V2_Nomination_Thumbsup_Bool_Exp>>
  nomination_id: InputMaybe<Int_Comparison_Exp>
  user_id: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.nomination_thumbsup" */
export enum V2_Nomination_Thumbsup_Constraint {
  /** unique or primary key constraint on columns "user_id", "nomination_id" */
  NominationThumbsupPkey = 'nomination_thumbsup_pkey'
}

/** input type for incrementing numeric columns in table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Inc_Input = {
  nomination_id: InputMaybe<Scalars['Int']['input']>
  user_id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Insert_Input = {
  nomination_id: InputMaybe<Scalars['Int']['input']>
  user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type V2_Nomination_Thumbsup_Max_Fields = {
  __typename?: 'v2_nomination_thumbsup_max_fields'
  nomination_id: Maybe<Scalars['Int']['output']>
  user_id: Maybe<Scalars['Int']['output']>
}

/** order by max() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Max_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type V2_Nomination_Thumbsup_Min_Fields = {
  __typename?: 'v2_nomination_thumbsup_min_fields'
  nomination_id: Maybe<Scalars['Int']['output']>
  user_id: Maybe<Scalars['Int']['output']>
}

/** order by min() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Min_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** response of any mutation on the table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Mutation_Response = {
  __typename?: 'v2_nomination_thumbsup_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Nomination_Thumbsup>
}

/** on_conflict condition type for table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_On_Conflict = {
  constraint: V2_Nomination_Thumbsup_Constraint
  update_columns: Array<V2_Nomination_Thumbsup_Update_Column>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

/** Ordering options when selecting data from "v2.nomination_thumbsup". */
export type V2_Nomination_Thumbsup_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.nomination_thumbsup */
export type V2_Nomination_Thumbsup_Pk_Columns_Input = {
  nomination_id: Scalars['Int']['input']
  user_id: Scalars['Int']['input']
}

/** select columns of table "v2.nomination_thumbsup" */
export enum V2_Nomination_Thumbsup_Select_Column {
  /** column name */
  NominationId = 'nomination_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Set_Input = {
  nomination_id: InputMaybe<Scalars['Int']['input']>
  user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type V2_Nomination_Thumbsup_Stddev_Fields = {
  __typename?: 'v2_nomination_thumbsup_stddev_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Stddev_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type V2_Nomination_Thumbsup_Stddev_Pop_Fields = {
  __typename?: 'v2_nomination_thumbsup_stddev_pop_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Stddev_Pop_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type V2_Nomination_Thumbsup_Stddev_Samp_Fields = {
  __typename?: 'v2_nomination_thumbsup_stddev_samp_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Stddev_Samp_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** Streaming cursor of the table "v2_nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Nomination_Thumbsup_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Nomination_Thumbsup_Stream_Cursor_Value_Input = {
  nomination_id: InputMaybe<Scalars['Int']['input']>
  user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type V2_Nomination_Thumbsup_Sum_Fields = {
  __typename?: 'v2_nomination_thumbsup_sum_fields'
  nomination_id: Maybe<Scalars['Int']['output']>
  user_id: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Sum_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** update columns of table "v2.nomination_thumbsup" */
export enum V2_Nomination_Thumbsup_Update_Column {
  /** column name */
  NominationId = 'nomination_id',
  /** column name */
  UserId = 'user_id'
}

export type V2_Nomination_Thumbsup_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<V2_Nomination_Thumbsup_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Nomination_Thumbsup_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Nomination_Thumbsup_Bool_Exp
}

/** aggregate var_pop on columns */
export type V2_Nomination_Thumbsup_Var_Pop_Fields = {
  __typename?: 'v2_nomination_thumbsup_var_pop_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Var_Pop_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type V2_Nomination_Thumbsup_Var_Samp_Fields = {
  __typename?: 'v2_nomination_thumbsup_var_samp_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Var_Samp_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type V2_Nomination_Thumbsup_Variance_Fields = {
  __typename?: 'v2_nomination_thumbsup_variance_fields'
  nomination_id: Maybe<Scalars['Float']['output']>
  user_id: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "v2.nomination_thumbsup" */
export type V2_Nomination_Thumbsup_Variance_Order_By = {
  nomination_id: InputMaybe<Order_By>
  user_id: InputMaybe<Order_By>
}

/** columns and relationships of "v2.nominations" */
export type V2_Nominations = {
  __typename?: 'v2_nominations'
  category: Scalars['String']['output']
  /** An array relationship */
  comments: Array<Comments>
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate
  created_at: Scalars['timestamptz']['output']
  description: Scalars['String']['output']
  from_user_id: Scalars['Int']['output']
  id: Scalars['Int']['output']
  is_deleted: Scalars['Boolean']['output']
  project: Scalars['String']['output']
  /** An array relationship */
  thumbsup: Array<V2_Nomination_Thumbsup>
  /** An aggregate relationship */
  thumbsup_aggregate: V2_Nomination_Thumbsup_Aggregate
  to_name: Maybe<Scalars['String']['output']>
  to_user_id: Maybe<Scalars['Int']['output']>
}

/** columns and relationships of "v2.nominations" */
export type V2_NominationsCommentsArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** columns and relationships of "v2.nominations" */
export type V2_NominationsComments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Comments_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<Comments_Order_By>>
  where: InputMaybe<Comments_Bool_Exp>
}

/** columns and relationships of "v2.nominations" */
export type V2_NominationsThumbsupArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

/** columns and relationships of "v2.nominations" */
export type V2_NominationsThumbsup_AggregateArgs = {
  distinct_on: InputMaybe<Array<V2_Nomination_Thumbsup_Select_Column>>
  limit: InputMaybe<Scalars['Int']['input']>
  offset: InputMaybe<Scalars['Int']['input']>
  order_by: InputMaybe<Array<V2_Nomination_Thumbsup_Order_By>>
  where: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
}

/** aggregated selection of "v2.nominations" */
export type V2_Nominations_Aggregate = {
  __typename?: 'v2_nominations_aggregate'
  aggregate: Maybe<V2_Nominations_Aggregate_Fields>
  nodes: Array<V2_Nominations>
}

/** aggregate fields of "v2.nominations" */
export type V2_Nominations_Aggregate_Fields = {
  __typename?: 'v2_nominations_aggregate_fields'
  avg: Maybe<V2_Nominations_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<V2_Nominations_Max_Fields>
  min: Maybe<V2_Nominations_Min_Fields>
  stddev: Maybe<V2_Nominations_Stddev_Fields>
  stddev_pop: Maybe<V2_Nominations_Stddev_Pop_Fields>
  stddev_samp: Maybe<V2_Nominations_Stddev_Samp_Fields>
  sum: Maybe<V2_Nominations_Sum_Fields>
  var_pop: Maybe<V2_Nominations_Var_Pop_Fields>
  var_samp: Maybe<V2_Nominations_Var_Samp_Fields>
  variance: Maybe<V2_Nominations_Variance_Fields>
}

/** aggregate fields of "v2.nominations" */
export type V2_Nominations_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Nominations_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type V2_Nominations_Avg_Fields = {
  __typename?: 'v2_nominations_avg_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.nominations". All fields are combined with a logical 'AND'. */
export type V2_Nominations_Bool_Exp = {
  _and: InputMaybe<Array<V2_Nominations_Bool_Exp>>
  _not: InputMaybe<V2_Nominations_Bool_Exp>
  _or: InputMaybe<Array<V2_Nominations_Bool_Exp>>
  category: InputMaybe<String_Comparison_Exp>
  comments: InputMaybe<Comments_Bool_Exp>
  comments_aggregate: InputMaybe<Comments_Aggregate_Bool_Exp>
  created_at: InputMaybe<Timestamptz_Comparison_Exp>
  description: InputMaybe<String_Comparison_Exp>
  from_user_id: InputMaybe<Int_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  is_deleted: InputMaybe<Boolean_Comparison_Exp>
  project: InputMaybe<String_Comparison_Exp>
  thumbsup: InputMaybe<V2_Nomination_Thumbsup_Bool_Exp>
  thumbsup_aggregate: InputMaybe<V2_Nomination_Thumbsup_Aggregate_Bool_Exp>
  to_name: InputMaybe<String_Comparison_Exp>
  to_user_id: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.nominations" */
export enum V2_Nominations_Constraint {
  /** unique or primary key constraint on columns "id" */
  NominationsPkey = 'nominations_pkey'
}

/** input type for incrementing numeric columns in table "v2.nominations" */
export type V2_Nominations_Inc_Input = {
  from_user_id: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  to_user_id: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.nominations" */
export type V2_Nominations_Insert_Input = {
  category: InputMaybe<Scalars['String']['input']>
  comments: InputMaybe<Comments_Arr_Rel_Insert_Input>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  from_user_id: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  project: InputMaybe<Scalars['String']['input']>
  thumbsup: InputMaybe<V2_Nomination_Thumbsup_Arr_Rel_Insert_Input>
  to_name: InputMaybe<Scalars['String']['input']>
  to_user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type V2_Nominations_Max_Fields = {
  __typename?: 'v2_nominations_max_fields'
  category: Maybe<Scalars['String']['output']>
  created_at: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  from_user_id: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  project: Maybe<Scalars['String']['output']>
  to_name: Maybe<Scalars['String']['output']>
  to_user_id: Maybe<Scalars['Int']['output']>
}

/** aggregate min on columns */
export type V2_Nominations_Min_Fields = {
  __typename?: 'v2_nominations_min_fields'
  category: Maybe<Scalars['String']['output']>
  created_at: Maybe<Scalars['timestamptz']['output']>
  description: Maybe<Scalars['String']['output']>
  from_user_id: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  project: Maybe<Scalars['String']['output']>
  to_name: Maybe<Scalars['String']['output']>
  to_user_id: Maybe<Scalars['Int']['output']>
}

/** response of any mutation on the table "v2.nominations" */
export type V2_Nominations_Mutation_Response = {
  __typename?: 'v2_nominations_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Nominations>
}

/** on_conflict condition type for table "v2.nominations" */
export type V2_Nominations_On_Conflict = {
  constraint: V2_Nominations_Constraint
  update_columns: Array<V2_Nominations_Update_Column>
  where: InputMaybe<V2_Nominations_Bool_Exp>
}

/** Ordering options when selecting data from "v2.nominations". */
export type V2_Nominations_Order_By = {
  category: InputMaybe<Order_By>
  comments_aggregate: InputMaybe<Comments_Aggregate_Order_By>
  created_at: InputMaybe<Order_By>
  description: InputMaybe<Order_By>
  from_user_id: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  is_deleted: InputMaybe<Order_By>
  project: InputMaybe<Order_By>
  thumbsup_aggregate: InputMaybe<V2_Nomination_Thumbsup_Aggregate_Order_By>
  to_name: InputMaybe<Order_By>
  to_user_id: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.nominations */
export type V2_Nominations_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.nominations" */
export enum V2_Nominations_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Project = 'project',
  /** column name */
  ToName = 'to_name',
  /** column name */
  ToUserId = 'to_user_id'
}

/** input type for updating data in table "v2.nominations" */
export type V2_Nominations_Set_Input = {
  category: InputMaybe<Scalars['String']['input']>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  from_user_id: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  project: InputMaybe<Scalars['String']['input']>
  to_name: InputMaybe<Scalars['String']['input']>
  to_user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type V2_Nominations_Stddev_Fields = {
  __typename?: 'v2_nominations_stddev_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type V2_Nominations_Stddev_Pop_Fields = {
  __typename?: 'v2_nominations_stddev_pop_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type V2_Nominations_Stddev_Samp_Fields = {
  __typename?: 'v2_nominations_stddev_samp_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "v2_nominations" */
export type V2_Nominations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Nominations_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Nominations_Stream_Cursor_Value_Input = {
  category: InputMaybe<Scalars['String']['input']>
  created_at: InputMaybe<Scalars['timestamptz']['input']>
  description: InputMaybe<Scalars['String']['input']>
  from_user_id: InputMaybe<Scalars['Int']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  is_deleted: InputMaybe<Scalars['Boolean']['input']>
  project: InputMaybe<Scalars['String']['input']>
  to_name: InputMaybe<Scalars['String']['input']>
  to_user_id: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type V2_Nominations_Sum_Fields = {
  __typename?: 'v2_nominations_sum_fields'
  from_user_id: Maybe<Scalars['Int']['output']>
  id: Maybe<Scalars['Int']['output']>
  to_user_id: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.nominations" */
export enum V2_Nominations_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Project = 'project',
  /** column name */
  ToName = 'to_name',
  /** column name */
  ToUserId = 'to_user_id'
}

export type V2_Nominations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<V2_Nominations_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Nominations_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Nominations_Bool_Exp
}

/** aggregate var_pop on columns */
export type V2_Nominations_Var_Pop_Fields = {
  __typename?: 'v2_nominations_var_pop_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type V2_Nominations_Var_Samp_Fields = {
  __typename?: 'v2_nominations_var_samp_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type V2_Nominations_Variance_Fields = {
  __typename?: 'v2_nominations_variance_fields'
  from_user_id: Maybe<Scalars['Float']['output']>
  id: Maybe<Scalars['Float']['output']>
  to_user_id: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "v2.redemption_codes" */
export type V2_Redemption_Codes = {
  __typename?: 'v2_redemption_codes'
  code: Scalars['String']['output']
  id: Scalars['Int']['output']
  used_by: Maybe<Scalars['Int']['output']>
}

/** aggregated selection of "v2.redemption_codes" */
export type V2_Redemption_Codes_Aggregate = {
  __typename?: 'v2_redemption_codes_aggregate'
  aggregate: Maybe<V2_Redemption_Codes_Aggregate_Fields>
  nodes: Array<V2_Redemption_Codes>
}

/** aggregate fields of "v2.redemption_codes" */
export type V2_Redemption_Codes_Aggregate_Fields = {
  __typename?: 'v2_redemption_codes_aggregate_fields'
  avg: Maybe<V2_Redemption_Codes_Avg_Fields>
  count: Scalars['Int']['output']
  max: Maybe<V2_Redemption_Codes_Max_Fields>
  min: Maybe<V2_Redemption_Codes_Min_Fields>
  stddev: Maybe<V2_Redemption_Codes_Stddev_Fields>
  stddev_pop: Maybe<V2_Redemption_Codes_Stddev_Pop_Fields>
  stddev_samp: Maybe<V2_Redemption_Codes_Stddev_Samp_Fields>
  sum: Maybe<V2_Redemption_Codes_Sum_Fields>
  var_pop: Maybe<V2_Redemption_Codes_Var_Pop_Fields>
  var_samp: Maybe<V2_Redemption_Codes_Var_Samp_Fields>
  variance: Maybe<V2_Redemption_Codes_Variance_Fields>
}

/** aggregate fields of "v2.redemption_codes" */
export type V2_Redemption_Codes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<V2_Redemption_Codes_Select_Column>>
  distinct: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type V2_Redemption_Codes_Avg_Fields = {
  __typename?: 'v2_redemption_codes_avg_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "v2.redemption_codes". All fields are combined with a logical 'AND'. */
export type V2_Redemption_Codes_Bool_Exp = {
  _and: InputMaybe<Array<V2_Redemption_Codes_Bool_Exp>>
  _not: InputMaybe<V2_Redemption_Codes_Bool_Exp>
  _or: InputMaybe<Array<V2_Redemption_Codes_Bool_Exp>>
  code: InputMaybe<String_Comparison_Exp>
  id: InputMaybe<Int_Comparison_Exp>
  used_by: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "v2.redemption_codes" */
export enum V2_Redemption_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  RedemptionCodesPkey = 'redemption_codes_pkey'
}

/** input type for incrementing numeric columns in table "v2.redemption_codes" */
export type V2_Redemption_Codes_Inc_Input = {
  id: InputMaybe<Scalars['Int']['input']>
  used_by: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "v2.redemption_codes" */
export type V2_Redemption_Codes_Insert_Input = {
  code: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  used_by: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type V2_Redemption_Codes_Max_Fields = {
  __typename?: 'v2_redemption_codes_max_fields'
  code: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  used_by: Maybe<Scalars['Int']['output']>
}

/** aggregate min on columns */
export type V2_Redemption_Codes_Min_Fields = {
  __typename?: 'v2_redemption_codes_min_fields'
  code: Maybe<Scalars['String']['output']>
  id: Maybe<Scalars['Int']['output']>
  used_by: Maybe<Scalars['Int']['output']>
}

/** response of any mutation on the table "v2.redemption_codes" */
export type V2_Redemption_Codes_Mutation_Response = {
  __typename?: 'v2_redemption_codes_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<V2_Redemption_Codes>
}

/** on_conflict condition type for table "v2.redemption_codes" */
export type V2_Redemption_Codes_On_Conflict = {
  constraint: V2_Redemption_Codes_Constraint
  update_columns: Array<V2_Redemption_Codes_Update_Column>
  where: InputMaybe<V2_Redemption_Codes_Bool_Exp>
}

/** Ordering options when selecting data from "v2.redemption_codes". */
export type V2_Redemption_Codes_Order_By = {
  code: InputMaybe<Order_By>
  id: InputMaybe<Order_By>
  used_by: InputMaybe<Order_By>
}

/** primary key columns input for table: v2.redemption_codes */
export type V2_Redemption_Codes_Pk_Columns_Input = {
  id: Scalars['Int']['input']
}

/** select columns of table "v2.redemption_codes" */
export enum V2_Redemption_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  UsedBy = 'used_by'
}

/** input type for updating data in table "v2.redemption_codes" */
export type V2_Redemption_Codes_Set_Input = {
  code: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  used_by: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type V2_Redemption_Codes_Stddev_Fields = {
  __typename?: 'v2_redemption_codes_stddev_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type V2_Redemption_Codes_Stddev_Pop_Fields = {
  __typename?: 'v2_redemption_codes_stddev_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type V2_Redemption_Codes_Stddev_Samp_Fields = {
  __typename?: 'v2_redemption_codes_stddev_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "v2_redemption_codes" */
export type V2_Redemption_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V2_Redemption_Codes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type V2_Redemption_Codes_Stream_Cursor_Value_Input = {
  code: InputMaybe<Scalars['String']['input']>
  id: InputMaybe<Scalars['Int']['input']>
  used_by: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type V2_Redemption_Codes_Sum_Fields = {
  __typename?: 'v2_redemption_codes_sum_fields'
  id: Maybe<Scalars['Int']['output']>
  used_by: Maybe<Scalars['Int']['output']>
}

/** update columns of table "v2.redemption_codes" */
export enum V2_Redemption_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  UsedBy = 'used_by'
}

export type V2_Redemption_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc: InputMaybe<V2_Redemption_Codes_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set: InputMaybe<V2_Redemption_Codes_Set_Input>
  /** filter the rows which have to be updated */
  where: V2_Redemption_Codes_Bool_Exp
}

/** aggregate var_pop on columns */
export type V2_Redemption_Codes_Var_Pop_Fields = {
  __typename?: 'v2_redemption_codes_var_pop_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type V2_Redemption_Codes_Var_Samp_Fields = {
  __typename?: 'v2_redemption_codes_var_samp_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type V2_Redemption_Codes_Variance_Fields = {
  __typename?: 'v2_redemption_codes_variance_fields'
  id: Maybe<Scalars['Float']['output']>
  used_by: Maybe<Scalars['Float']['output']>
}

export type AddCommentMutationVariables = Exact<{
  nominationId?: InputMaybe<Scalars['Int']['input']>
  bulletinId?: InputMaybe<Scalars['Int']['input']>
  discussionId?: InputMaybe<Scalars['Int']['input']>
  comment: Scalars['String']['input']
}>

export type AddCommentMutation = {
  __typename?: 'mutation_root'
  insertComment: { __typename?: 'comments'; id: number }
}

export type AddUploadMutationVariables = Exact<{
  key: Scalars['String']['input']
  size: Scalars['Int']['input']
  type: Scalars['String']['input']
  url: Scalars['String']['input']
}>

export type AddUploadMutation = {
  __typename?: 'mutation_root'
  insertUpload: { __typename?: 'uploads'; id: number; url: string; publicUrl: string }
}

export type DeleteContentResourceMutationVariables = Exact<{
  contentId: Scalars['Int']['input']
  resourceId: Scalars['Int']['input']
}>

export type DeleteContentResourceMutation = {
  __typename?: 'mutation_root'
  deleteContentsResources: { __typename?: 'contentsResources_mutation_response'; affected_rows: number }
}

export type AddResourceMutationVariables = Exact<{
  title: Scalars['String']['input']
  fileUploadId: Scalars['Int']['input']
  description: Scalars['String']['input']
}>

export type AddResourceMutation = {
  __typename?: 'mutation_root'
  insertResource: { __typename?: 'resources'; id: number }
}

export type AddContentsResourceMutationVariables = Exact<{
  departmentContentId: Scalars['Int']['input']
  resourceId: Scalars['Int']['input']
}>

export type AddContentsResourceMutation = {
  __typename?: 'mutation_root'
  insertContentsResource: { __typename?: 'contentsResources'; id: number }
}

export type UpdateProfilePicMutationVariables = Exact<{
  userId: Scalars['Int']['input']
  uploadId: Scalars['Int']['input']
}>

export type UpdateProfilePicMutation = {
  __typename?: 'mutation_root'
  updateUserById: { __typename?: 'users'; id: number; profilePhotoUrl: string }
}

export type AddBulletinsResourceMutationVariables = Exact<{
  bulletinId: Scalars['Int']['input']
  resourceId: Scalars['Int']['input']
}>

export type AddBulletinsResourceMutation = {
  __typename?: 'mutation_root'
  insertBulletinsResource: { __typename?: 'bulletinsResources'; id: number }
}

export type DeleteBulletinsResourceMutationVariables = Exact<{
  bulletinId: Scalars['Int']['input']
  resourceId: Scalars['Int']['input']
}>

export type DeleteBulletinsResourceMutation = {
  __typename?: 'mutation_root'
  deleteBulletinsResources: { __typename?: 'bulletinsResources_mutation_response'; affected_rows: number }
}

export type AdminAddContentMutationVariables = Exact<{
  body: InputMaybe<Scalars['String']['input']>
  departmentId: InputMaybe<Scalars['Int']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  active: InputMaybe<Scalars['Boolean']['input']>
}>

export type AdminAddContentMutation = {
  __typename?: 'mutation_root'
  insertContent: { __typename?: 'contents'; id: number }
}

export type AdminUpdateContentMutationVariables = Exact<{
  body: InputMaybe<Scalars['String']['input']>
  parentId: InputMaybe<Scalars['Int']['input']>
  title: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
}>

export type AdminUpdateContentMutation = {
  __typename?: 'mutation_root'
  updateContentById: { __typename?: 'contents'; id: number; parentId: number }
}

export type DisablePageMutationVariables = Exact<{
  contentId: Scalars['Int']['input']
}>

export type DisablePageMutation = {
  __typename?: 'mutation_root'
  updateContentById: { __typename?: 'contents'; id: number }
}

export type UpdateDepartmentMutationVariables = Exact<{
  departmentId: Scalars['Int']['input']
  logoUploadId: InputMaybe<Scalars['Int']['input']>
  mastheadUploadId: InputMaybe<Scalars['Int']['input']>
  missionStatement: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type UpdateDepartmentMutation = {
  __typename?: 'mutation_root'
  updateDepartmentById: { __typename?: 'departments'; id: number }
}

export type AddBulletinMutationVariables = Exact<{
  global: Scalars['Boolean']['input']
  leadImageUploadId: Scalars['Int']['input']
  post: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type AddBulletinMutation = {
  __typename?: 'mutation_root'
  insertBulletin: { __typename?: 'bulletins'; id: number }
}

export type AddBulletinDepartmentsMutationVariables = Exact<{
  objects: Array<BulletinDepartments_Insert_Input> | BulletinDepartments_Insert_Input
}>

export type AddBulletinDepartmentsMutation = {
  __typename?: 'mutation_root'
  insertBulletinDepartments: { __typename?: 'bulletinDepartments_mutation_response'; affected_rows: number }
}

export type DeleteBulletinMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteBulletinMutation = {
  __typename?: 'mutation_root'
  deleteBulletins: { __typename?: 'bulletins_mutation_response'; affected_rows: number }
}

export type UpdateBulletinMutationVariables = Exact<{
  id: Scalars['Int']['input']
  global: Scalars['Boolean']['input']
  leadImageUploadId: Scalars['Int']['input']
  post: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type UpdateBulletinMutation = {
  __typename?: 'mutation_root'
  updateBulletinById: { __typename?: 'bulletins'; id: number }
}

export type RefetchBulletinMutationVariables = Exact<{
  id: Scalars['Int']['input']
  global: Scalars['Boolean']['input']
}>

export type RefetchBulletinMutation = {
  __typename?: 'mutation_root'
  updateBulletinById: { __typename?: 'bulletins'; id: number }
}

export type RemoveBulletinDepartmentsMutationVariables = Exact<{
  departmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
  bulletinId: Scalars['Int']['input']
}>

export type RemoveBulletinDepartmentsMutation = {
  __typename?: 'mutation_root'
  deleteBulletinDepartments: { __typename?: 'bulletinDepartments_mutation_response'; affected_rows: number }
}

export type UpdateResourceFileMutationVariables = Exact<{
  id: Scalars['Int']['input']
  fileUploadId: Scalars['Int']['input']
}>

export type UpdateResourceFileMutation = {
  __typename?: 'mutation_root'
  updateResourceById: { __typename?: 'resources'; id: number }
}

export type UpdateResourceDataMutationVariables = Exact<{
  id: Scalars['Int']['input']
  title: Scalars['String']['input']
  description: Scalars['String']['input']
}>

export type UpdateResourceDataMutation = {
  __typename?: 'mutation_root'
  updateResourceById: { __typename?: 'resources'; id: number; title: string; description: string }
}

export type DeleteResourceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type DeleteResourceMutation = {
  __typename?: 'mutation_root'
  updateResources: { __typename?: 'resources_mutation_response'; affected_rows: number }
}

export type RemoveUserRoleMutationVariables = Exact<{
  role: Roles_Enum
  userId: Scalars['Int']['input']
}>

export type RemoveUserRoleMutation = {
  __typename?: 'mutation_root'
  deleteUserRoles: { __typename?: 'userRoles_mutation_response'; affected_rows: number }
}

export type AddUserRoleMutationVariables = Exact<{
  input: UserRoles_Insert_Input
}>

export type AddUserRoleMutation = {
  __typename?: 'mutation_root'
  insertUserRole: { __typename?: 'userRoles'; role: Roles_Enum }
}

export type UpdatePageMastheadMutationVariables = Exact<{
  slug: Scalars['String']['input']
  mastheadUploadId: Scalars['Int']['input']
}>

export type UpdatePageMastheadMutation = {
  __typename?: 'mutation_root'
  updatePageBySlug: { __typename?: 'pages'; mastheadUploadId: number }
}

export type CreateDepartmentMutationVariables = Exact<{
  mastheadUploadId: Scalars['Int']['input']
  title: Scalars['String']['input']
  ownerId: Scalars['Int']['input']
}>

export type CreateDepartmentMutation = {
  __typename?: 'mutation_root'
  insertDepartment: { __typename?: 'departments'; id: number }
}

export type CreateFaqMutationVariables = Exact<{
  answer: Scalars['String']['input']
  departmentId: Scalars['Int']['input']
  question: Scalars['String']['input']
}>

export type CreateFaqMutation = {
  __typename?: 'mutation_root'
  insertDepartmentFaq: { __typename?: 'departmentFaqs'; id: number; question: string; answer: string }
}

export type UpdateFaqMutationVariables = Exact<{
  id: Scalars['Int']['input']
  answer: Scalars['String']['input']
  question: Scalars['String']['input']
}>

export type UpdateFaqMutation = {
  __typename?: 'mutation_root'
  updateDepartmentFaqById: { __typename?: 'departmentFaqs'; id: number; question: string; answer: string }
}

export type DeleteFaqMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteFaqMutation = {
  __typename?: 'mutation_root'
  deleteDepartmentFaqById: { __typename?: 'departmentFaqs'; id: number }
}

export type AuthenticateUserMutationVariables = Exact<{
  username: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type AuthenticateUserMutation = {
  __typename?: 'mutation_root'
  authenticateUser: { __typename?: 'Session'; accessToken: string; userId: number }
}

export type CreateDiscussionMutationVariables = Exact<{
  departmentId: InputMaybe<Scalars['Int']['input']>
  post: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type CreateDiscussionMutation = {
  __typename?: 'mutation_root'
  insertDiscussion: { __typename?: 'discussions'; id: number }
}

export type DeleteDiscussionMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteDiscussionMutation = {
  __typename?: 'mutation_root'
  deleteDiscussions: { __typename?: 'discussions_mutation_response'; affected_rows: number }
}

export type UpdateDiscussionMutationVariables = Exact<{
  id: Scalars['Int']['input']
  post: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type UpdateDiscussionMutation = {
  __typename?: 'mutation_root'
  updateDiscussionById: { __typename?: 'discussions'; id: number }
}

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteCommentMutation = {
  __typename?: 'mutation_root'
  deleteCommentById: { __typename?: 'comments'; id: number }
}

export type SendResourceEmailMutationVariables = Exact<{
  resourceId: Scalars['Int']['input']
  to: Scalars['String']['input']
}>

export type SendResourceEmailMutation = {
  __typename?: 'mutation_root'
  sendResourceEmail: { __typename?: 'ResourceEmailOutput'; success: boolean; id: string }
}

export type SendNominationEmailMutationVariables = Exact<{
  name: Scalars['String']['input']
  category: Scalars['String']['input']
  to: Scalars['String']['input']
  mgr_to: InputMaybe<Scalars['String']['input']>
  html: Scalars['String']['input']
  to_name: Scalars['String']['input']
}>

export type SendNominationEmailMutation = {
  __typename?: 'mutation_root'
  sendNominationEmail: { __typename?: 'NominationEmailOutput'; success: boolean; id: string }
}

export type AddFavoriteDiscussionMutationVariables = Exact<{
  discussionId: InputMaybe<Scalars['Int']['input']>
}>

export type AddFavoriteDiscussionMutation = {
  __typename?: 'mutation_root'
  insertFavoriteDiscussion: { __typename?: 'favoriteDiscussions'; id: number }
}

export type RemoveFavoriteDiscussionMutationVariables = Exact<{
  discussionId: InputMaybe<Scalars['Int']['input']>
}>

export type RemoveFavoriteDiscussionMutation = {
  __typename?: 'mutation_root'
  deleteFavoriteDiscussions: { __typename?: 'favoriteDiscussions_mutation_response'; affected_rows: number }
}

export type AddFavoriteResourceMutationVariables = Exact<{
  resourceId: InputMaybe<Scalars['Int']['input']>
}>

export type AddFavoriteResourceMutation = {
  __typename?: 'mutation_root'
  insertFavoriteResource: { __typename?: 'favoriteResources'; id: number }
}

export type RemoveFavoriteResourceMutationVariables = Exact<{
  resourceId: InputMaybe<Scalars['Int']['input']>
}>

export type RemoveFavoriteResourceMutation = {
  __typename?: 'mutation_root'
  deleteFavoriteResources: { __typename?: 'favoriteResources_mutation_response'; affected_rows: number }
}

export type GetPresignedUploadMutationVariables = Exact<{
  isPublic: Scalars['Boolean']['input']
  fileName: Scalars['String']['input']
  type: Scalars['String']['input']
}>

export type GetPresignedUploadMutation = {
  __typename?: 'mutation_root'
  getPresignedUpload: { __typename?: 'PresignedUpload'; fields: unknown; url: string; presignedGetUrl: string }
}

export type GetNominationsQueryVariables = Exact<{ [key: string]: never }>

export type GetNominationsQuery = {
  __typename?: 'query_root'
  v2_nominations: Array<{
    __typename?: 'v2_nominations'
    category: string
    created_at: string
    description: string
    from_user_id: number
    id: number
    project: string
    to_name: string
    to_user_id: number
    thumbsup: Array<{ __typename?: 'v2_nomination_thumbsup'; user_id: number }>
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
  }>
}

export type AddNominationMutationVariables = Exact<{
  category: InputMaybe<Scalars['String']['input']>
  description: InputMaybe<Scalars['String']['input']>
  from_user_id: InputMaybe<Scalars['Int']['input']>
  project: InputMaybe<Scalars['String']['input']>
  to_name: InputMaybe<Scalars['String']['input']>
  to_user_id: InputMaybe<Scalars['Int']['input']>
}>

export type AddNominationMutation = {
  __typename?: 'mutation_root'
  insert_v2_nominations_one: { __typename?: 'v2_nominations'; id: number }
}

export type RemoveNominationMutationVariables = Exact<{
  _eq: InputMaybe<Scalars['Int']['input']>
}>

export type RemoveNominationMutation = {
  __typename?: 'mutation_root'
  update_v2_nominations: { __typename?: 'v2_nominations_mutation_response'; affected_rows: number }
}

export type AddNominationThumbsUpMutationVariables = Exact<{
  nomination_id: InputMaybe<Scalars['Int']['input']>
  user_id: InputMaybe<Scalars['Int']['input']>
}>

export type AddNominationThumbsUpMutation = {
  __typename?: 'mutation_root'
  insert_v2_nomination_thumbsup_one: { __typename?: 'v2_nomination_thumbsup'; nomination_id: number; user_id: number }
}

export type RemoveNominationThumbsUpMutationVariables = Exact<{
  nomId?: InputMaybe<Scalars['Int']['input']>
  userId?: InputMaybe<Scalars['Int']['input']>
}>

export type RemoveNominationThumbsUpMutation = {
  __typename?: 'mutation_root'
  delete_v2_nomination_thumbsup: { __typename?: 'v2_nomination_thumbsup_mutation_response'; affected_rows: number }
}

export type AddQuicklinkMutationVariables = Exact<{
  departmentId: Scalars['Int']['input']
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  url: Scalars['String']['input']
}>

export type AddQuicklinkMutation = {
  __typename?: 'mutation_root'
  insertDepartmentQuicklink: { __typename?: 'departmentQuicklinks'; id: number }
}

export type UpdateQuicklinkMutationVariables = Exact<{
  id: Scalars['Int']['input']
  description: Scalars['String']['input']
  title: Scalars['String']['input']
  url: Scalars['String']['input']
}>

export type UpdateQuicklinkMutation = {
  __typename?: 'mutation_root'
  updateDepartmentQuicklinkById: { __typename?: 'departmentQuicklinks'; id: number }
}

export type DeleteQuicklinkMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteQuicklinkMutation = {
  __typename?: 'mutation_root'
  deleteDepartmentQuicklinkById: { __typename?: 'departmentQuicklinks'; id: number }
}

export type SendCrisisNotificationMutationVariables = Exact<{
  title: Scalars['String']['input']
  text: Scalars['String']['input']
}>

export type SendCrisisNotificationMutation = {
  __typename?: 'mutation_root'
  sendCrisisNotification: {
    __typename?: 'CrisisNotificationOutput'
    success: boolean
    message: string
    campaignId: string
  }
}

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['Int']['input']
  comment: Scalars['String']['input']
}>

export type UpdateCommentMutation = {
  __typename?: 'mutation_root'
  updateCommentById: { __typename?: 'comments'; id: number }
}

export type UpdateGalleryOrderMutationVariables = Exact<{
  children?: InputMaybe<Scalars['jsonb']['input']>
}>

export type UpdateGalleryOrderMutation = {
  __typename?: 'mutation_root'
  updatePageBySlug: { __typename?: 'pages'; id: number }
}

export type UpdateGalleryPhotoOrderMutationVariables = Exact<{
  id: Scalars['Int']['input']
  children?: InputMaybe<Scalars['jsonb']['input']>
}>

export type UpdateGalleryPhotoOrderMutation = {
  __typename?: 'mutation_root'
  updateGalleryById: { __typename?: 'galleries'; id: number }
}

export type DisableGalleryMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DisableGalleryMutation = {
  __typename?: 'mutation_root'
  updateGalleryById: { __typename?: 'galleries'; id: number }
}

export type UpdateGalleryMutationVariables = Exact<{
  id: Scalars['Int']['input']
  date: Scalars['timestamptz']['input']
  title: Scalars['String']['input']
  videoUploadId: InputMaybe<Scalars['Int']['input']>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
}>

export type UpdateGalleryMutation = {
  __typename?: 'mutation_root'
  updateGalleryById: { __typename?: 'galleries'; id: number; title: string; date: string }
}

export type CreateGalleryMutationVariables = Exact<{
  date: Scalars['timestamptz']['input']
  title: Scalars['String']['input']
  photos: GalleryPhotos_Arr_Rel_Insert_Input
  videoUploadId: InputMaybe<Scalars['Int']['input']>
  videoThumbnailUploadId: InputMaybe<Scalars['Int']['input']>
}>

export type CreateGalleryMutation = {
  __typename?: 'mutation_root'
  insertGallery: { __typename?: 'galleries'; id: number }
}

export type RemoveGalleryPhotoMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type RemoveGalleryPhotoMutation = {
  __typename?: 'mutation_root'
  deleteGalleryPhotoById: { __typename?: 'galleryPhotos'; id: number }
}

export type AddGalleryPhotosMutationVariables = Exact<{
  objects: Array<GalleryPhotos_Insert_Input> | GalleryPhotos_Insert_Input
}>

export type AddGalleryPhotosMutation = {
  __typename?: 'mutation_root'
  insertGalleryPhotos: { __typename?: 'galleryPhotos_mutation_response'; affected_rows: number }
}

export type CommentDetailsFragment = {
  __typename?: 'comments'
  comment: string
  createdAt: string
  updatedAt: string
  id: number
  user: {
    __typename?: 'users'
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
  }
}

export type BulletinDetailsFragment = {
  __typename?: 'bulletins'
  id: number
  title: string
  createdAt: string
  global: boolean
  leadImageUploadId: number
  leadWebUrl: string
  leadThumbUrl: string
  post: string
  author: {
    __typename?: 'users'
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
  }
  comments: Array<{
    __typename?: 'comments'
    comment: string
    createdAt: string
    updatedAt: string
    id: number
    user: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
  }>
  bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
  bulletinResources: Array<{
    __typename?: 'bulletinsResources'
    resource: {
      __typename?: 'resources'
      id: number
      createdAt: string
      title: string
      description: string
      file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
    }
  }>
}

export type DiscussionDetailsFragment = {
  __typename?: 'discussions'
  id: number
  title: string
  createdAt: string
  post: string
  departmentId: number
  author: {
    __typename?: 'users'
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
  }
  comments: Array<{
    __typename?: 'comments'
    comment: string
    createdAt: string
    updatedAt: string
    id: number
    user: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
  }>
}

export type ResourceDetailsFragment = {
  __typename?: 'resources'
  id: number
  createdAt: string
  title: string
  description: string
  file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
}

export type UserBasicFragment = {
  __typename?: 'users'
  id: number
  firstName: string
  lastName: string
  jobTitle: string
  profilePhotoUrl: string
}

export type UserDetailsFragment = {
  __typename?: 'users'
  supervisorId: number
  email: string
  phoneCell: string
  phoneDirect: string
  phoneExt: string
  id: number
  firstName: string
  lastName: string
  jobTitle: string
  profilePhotoUrl: string
  department: { __typename?: 'departments'; title: string }
  roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
  jobsite: { __typename?: 'jobsites'; title: string }
}

export type UserFavoritesFragment = {
  __typename?: 'users'
  favoriteResources: Array<{
    __typename?: 'favoriteResources'
    resourceId: number
    id: number
    resource: {
      __typename?: 'resources'
      id: number
      createdAt: string
      title: string
      description: string
      file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
    }
  }>
  favoriteDiscussions: Array<{
    __typename?: 'favoriteDiscussions'
    discussionId: number
    id: number
    discussion: {
      __typename?: 'discussions'
      id: number
      title: string
      createdAt: string
      post: string
      departmentId: number
      author: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
      comments: Array<{
        __typename?: 'comments'
        comment: string
        createdAt: string
        updatedAt: string
        id: number
        user: {
          __typename?: 'users'
          id: number
          firstName: string
          lastName: string
          jobTitle: string
          profilePhotoUrl: string
        }
      }>
    }
  }>
}

export type BulletinsQueryVariables = Exact<{ [key: string]: never }>

export type BulletinsQuery = {
  __typename?: 'query_root'
  bulletins: Array<{
    __typename?: 'bulletins'
    id: number
    title: string
    createdAt: string
    global: boolean
    leadImageUploadId: number
    leadWebUrl: string
    leadThumbUrl: string
    post: string
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
    bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
    bulletinResources: Array<{
      __typename?: 'bulletinsResources'
      resource: {
        __typename?: 'resources'
        id: number
        createdAt: string
        title: string
        description: string
        file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
      }
    }>
  }>
}

export type SingleBulletinQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type SingleBulletinQuery = {
  __typename?: 'query_root'
  bulletins: Array<{
    __typename?: 'bulletins'
    id: number
    title: string
    createdAt: string
    global: boolean
    leadImageUploadId: number
    leadWebUrl: string
    leadThumbUrl: string
    post: string
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
    bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
    bulletinResources: Array<{
      __typename?: 'bulletinsResources'
      resource: {
        __typename?: 'resources'
        id: number
        createdAt: string
        title: string
        description: string
        file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
      }
    }>
  }>
}

export type CameraEmbedsGetActiveQueryVariables = Exact<{ [key: string]: never }>

export type CameraEmbedsGetActiveQuery = {
  __typename?: 'query_root'
  cameraEmbeds: Array<{
    __typename?: 'cameraEmbeds'
    id: number
    title: string
    source: string
    stillUrl: string
    active: boolean
    jobsiteId: number
  }>
}

export type CompanyDirectoryUsersQueryVariables = Exact<{ [key: string]: never }>

export type CompanyDirectoryUsersQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    supervisorId: number
    email: string
    phoneCell: string
    phoneDirect: string
    phoneExt: string
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
    department: { __typename?: 'departments'; title: string }
    roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
    jobsite: { __typename?: 'jobsites'; title: string }
  }>
}

export type ConfigByKeyQueryVariables = Exact<{
  key: Scalars['String']['input']
}>

export type ConfigByKeyQuery = { __typename?: 'query_root'; configByKey: { __typename?: 'config'; value: string } }

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type CurrentUserQuery = {
  __typename?: 'query_root'
  currentUser: {
    __typename?: 'CurrentUserOutput'
    userId: number
    user: {
      __typename?: 'users'
      supervisorId: number
      email: string
      phoneCell: string
      phoneDirect: string
      phoneExt: string
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
      roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
      department: { __typename?: 'departments'; title: string }
      jobsite: { __typename?: 'jobsites'; title: string }
      favoriteResources: Array<{
        __typename?: 'favoriteResources'
        resourceId: number
        id: number
        resource: {
          __typename?: 'resources'
          id: number
          createdAt: string
          title: string
          description: string
          file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
        }
      }>
      favoriteDiscussions: Array<{
        __typename?: 'favoriteDiscussions'
        discussionId: number
        id: number
        discussion: {
          __typename?: 'discussions'
          id: number
          title: string
          createdAt: string
          post: string
          departmentId: number
          author: {
            __typename?: 'users'
            id: number
            firstName: string
            lastName: string
            jobTitle: string
            profilePhotoUrl: string
          }
          comments: Array<{
            __typename?: 'comments'
            comment: string
            createdAt: string
            updatedAt: string
            id: number
            user: {
              __typename?: 'users'
              id: number
              firstName: string
              lastName: string
              jobTitle: string
              profilePhotoUrl: string
            }
          }>
        }
      }>
    }
  }
}

export type DepartmentDetailsFragment = {
  __typename?: 'departments'
  id: number
  title: string
  missionStatement: string
  quicklinks: Array<{
    __typename?: 'departmentQuicklinks'
    title: string
    url: string
    id: number
    description: string
  }>
  contents: Array<{
    __typename?: 'contents'
    id: number
    title: string
    body: string
    parentId: number
    contentResources: Array<{
      __typename?: 'contentsResources'
      resource: {
        __typename?: 'resources'
        id: number
        createdAt: string
        title: string
        description: string
        file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
      }
    }>
    contents: Array<{
      __typename?: 'contents'
      id: number
      title: string
      body: string
      parentId: number
      contentResources: Array<{
        __typename?: 'contentsResources'
        resource: {
          __typename?: 'resources'
          id: number
          createdAt: string
          title: string
          description: string
          file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
        }
      }>
    }>
  }>
  masthead: { __typename?: 'uploads'; id: number; publicUrl: string; key: string }
  logo: { __typename?: 'uploads'; id: number; publicUrl: string; key: string }
  faqs: Array<{ __typename?: 'departmentFaqs'; id: number; question: string; answer: string }>
  bulletins: Array<{
    __typename?: 'bulletinDepartments'
    bulletin: {
      __typename?: 'bulletins'
      id: number
      title: string
      createdAt: string
      global: boolean
      leadImageUploadId: number
      leadWebUrl: string
      leadThumbUrl: string
      post: string
      author: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
      comments: Array<{
        __typename?: 'comments'
        comment: string
        createdAt: string
        updatedAt: string
        id: number
        user: {
          __typename?: 'users'
          id: number
          firstName: string
          lastName: string
          jobTitle: string
          profilePhotoUrl: string
        }
      }>
      bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
      bulletinResources: Array<{
        __typename?: 'bulletinsResources'
        resource: {
          __typename?: 'resources'
          id: number
          createdAt: string
          title: string
          description: string
          file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
        }
      }>
    }
  }>
  discussions: Array<{
    __typename?: 'discussions'
    id: number
    title: string
    createdAt: string
    post: string
    departmentId: number
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
  }>
  employees: Array<{
    __typename?: 'users'
    supervisorId: number
    email: string
    phoneCell: string
    phoneDirect: string
    phoneExt: string
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
    department: { __typename?: 'departments'; title: string }
    roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
    jobsite: { __typename?: 'jobsites'; title: string }
  }>
}

export type DepartmentDetailsQueryVariables = Exact<{
  departmentId: Scalars['Int']['input']
}>

export type DepartmentDetailsQuery = {
  __typename?: 'query_root'
  department: {
    __typename?: 'departments'
    id: number
    title: string
    missionStatement: string
    quicklinks: Array<{
      __typename?: 'departmentQuicklinks'
      title: string
      url: string
      id: number
      description: string
    }>
    contents: Array<{
      __typename?: 'contents'
      id: number
      title: string
      body: string
      parentId: number
      contentResources: Array<{
        __typename?: 'contentsResources'
        resource: {
          __typename?: 'resources'
          id: number
          createdAt: string
          title: string
          description: string
          file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
        }
      }>
      contents: Array<{
        __typename?: 'contents'
        id: number
        title: string
        body: string
        parentId: number
        contentResources: Array<{
          __typename?: 'contentsResources'
          resource: {
            __typename?: 'resources'
            id: number
            createdAt: string
            title: string
            description: string
            file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
          }
        }>
      }>
    }>
    masthead: { __typename?: 'uploads'; id: number; publicUrl: string; key: string }
    logo: { __typename?: 'uploads'; id: number; publicUrl: string; key: string }
    faqs: Array<{ __typename?: 'departmentFaqs'; id: number; question: string; answer: string }>
    bulletins: Array<{
      __typename?: 'bulletinDepartments'
      bulletin: {
        __typename?: 'bulletins'
        id: number
        title: string
        createdAt: string
        global: boolean
        leadImageUploadId: number
        leadWebUrl: string
        leadThumbUrl: string
        post: string
        author: {
          __typename?: 'users'
          id: number
          firstName: string
          lastName: string
          jobTitle: string
          profilePhotoUrl: string
        }
        comments: Array<{
          __typename?: 'comments'
          comment: string
          createdAt: string
          updatedAt: string
          id: number
          user: {
            __typename?: 'users'
            id: number
            firstName: string
            lastName: string
            jobTitle: string
            profilePhotoUrl: string
          }
        }>
        bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
        bulletinResources: Array<{
          __typename?: 'bulletinsResources'
          resource: {
            __typename?: 'resources'
            id: number
            createdAt: string
            title: string
            description: string
            file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
          }
        }>
      }
    }>
    discussions: Array<{
      __typename?: 'discussions'
      id: number
      title: string
      createdAt: string
      post: string
      departmentId: number
      author: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
      comments: Array<{
        __typename?: 'comments'
        comment: string
        createdAt: string
        updatedAt: string
        id: number
        user: {
          __typename?: 'users'
          id: number
          firstName: string
          lastName: string
          jobTitle: string
          profilePhotoUrl: string
        }
      }>
    }>
    employees: Array<{
      __typename?: 'users'
      supervisorId: number
      email: string
      phoneCell: string
      phoneDirect: string
      phoneExt: string
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
      department: { __typename?: 'departments'; title: string }
      roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
      jobsite: { __typename?: 'jobsites'; title: string }
    }>
  }
}

export type DepartmentEmployeesQueryVariables = Exact<{
  departmentId: Scalars['Int']['input']
}>

export type DepartmentEmployeesQuery = {
  __typename?: 'query_root'
  departmentById: {
    __typename?: 'departments'
    employees: Array<{
      __typename?: 'users'
      supervisorId: number
      email: string
      phoneCell: string
      phoneDirect: string
      phoneExt: string
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
      department: { __typename?: 'departments'; title: string }
      roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
      jobsite: { __typename?: 'jobsites'; title: string }
    }>
  }
}

export type DiscussionsQueryVariables = Exact<{ [key: string]: never }>

export type DiscussionsQuery = {
  __typename?: 'query_root'
  discussions: Array<{
    __typename?: 'discussions'
    id: number
    title: string
    createdAt: string
    post: string
    departmentId: number
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
  }>
}

export type EventFragment = {
  __typename?: 'events'
  type: EventTypes_Enum
  title: string
  startsAt: string
  id: number
  endsAt: string
  description: string
  allDay: boolean
}

export type EventsQueryVariables = Exact<{
  startFrom: Scalars['timestamptz']['input']
}>

export type EventsQuery = {
  __typename?: 'query_root'
  events: Array<{
    __typename?: 'events'
    type: EventTypes_Enum
    title: string
    startsAt: string
    id: number
    endsAt: string
    description: string
    allDay: boolean
  }>
}

export type EventsGetByDateQueryVariables = Exact<{
  start: Scalars['timestamptz']['input']
  end: Scalars['timestamptz']['input']
}>

export type EventsGetByDateQuery = {
  __typename?: 'query_root'
  events: Array<{
    __typename?: 'events'
    type: EventTypes_Enum
    title: string
    startsAt: string
    id: number
    endsAt: string
    description: string
    allDay: boolean
  }>
}

export type GetEventTypesQueryVariables = Exact<{ [key: string]: never }>

export type GetEventTypesQuery = {
  __typename?: 'query_root'
  eventTypes: Array<{ __typename?: 'eventTypes'; comment: string; value: string }>
}

export type GetAllEventsQueryVariables = Exact<{ [key: string]: never }>

export type GetAllEventsQuery = {
  __typename?: 'query_root'
  events: Array<{
    __typename?: 'events'
    type: EventTypes_Enum
    title: string
    startsAt: string
    id: number
    endsAt: string
    description: string
    allDay: boolean
  }>
}

export type CreateEventMutationVariables = Exact<{
  allDay: Scalars['Boolean']['input']
  description: Scalars['String']['input']
  endsAt: Scalars['timestamptz']['input']
  startsAt: Scalars['timestamptz']['input']
  title: Scalars['String']['input']
  type: EventTypes_Enum
}>

export type CreateEventMutation = { __typename?: 'mutation_root'; insertEvent: { __typename?: 'events'; id: number } }

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteEventMutation = {
  __typename?: 'mutation_root'
  deleteEventById: { __typename?: 'events'; id: number }
}

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['Int']['input']
  allDay: Scalars['Boolean']['input']
  description: Scalars['String']['input']
  endsAt: Scalars['timestamptz']['input']
  startsAt: Scalars['timestamptz']['input']
  title: Scalars['String']['input']
  type: EventTypes_Enum
}>

export type UpdateEventMutation = {
  __typename?: 'mutation_root'
  updateEventById: { __typename?: 'events'; id: number }
}

export type GalleriesGetAllQueryVariables = Exact<{ [key: string]: never }>

export type GalleriesGetAllQuery = {
  __typename?: 'query_root'
  galleries: Array<{
    __typename?: 'galleries'
    id: number
    date: string
    title: string
    thumbUrl: string
    children: unknown
    videoUpload: { __typename?: 'uploads'; id: number; publicUrl: string; type: string }
    videoThumbnail: { __typename?: 'uploads'; id: number; publicUrl: string }
  }>
  galleryPage: { __typename?: 'pages'; children: unknown }
}

export type GetGalleryQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetGalleryQuery = {
  __typename?: 'query_root'
  gallery: {
    __typename?: 'galleries'
    id: number
    date: string
    title: string
    children: unknown
    photos: Array<{ __typename?: 'galleryPhotos'; id: number; image: { __typename?: 'uploads'; publicUrl: string } }>
    videoUpload: { __typename?: 'uploads'; id: number; publicUrl: string; type: string }
    videoThumbnail: { __typename?: 'uploads'; id: number; publicUrl: string }
  }
}

export type RecentQueryVariables = Exact<{ [key: string]: never }>

export type RecentQuery = {
  __typename?: 'query_root'
  bulletins: Array<{
    __typename?: 'bulletins'
    id: number
    title: string
    createdAt: string
    global: boolean
    leadImageUploadId: number
    leadWebUrl: string
    leadThumbUrl: string
    post: string
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
    bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
    bulletinResources: Array<{
      __typename?: 'bulletinsResources'
      resource: {
        __typename?: 'resources'
        id: number
        createdAt: string
        title: string
        description: string
        file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
      }
    }>
  }>
  discussions: Array<{
    __typename?: 'discussions'
    id: number
    title: string
    createdAt: string
    post: string
    departmentId: number
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
  }>
  resources: Array<{
    __typename?: 'resources'
    id: number
    createdAt: string
    title: string
    description: string
    file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
  }>
}

export type RecentBulletinsQueryVariables = Exact<{ [key: string]: never }>

export type RecentBulletinsQuery = {
  __typename?: 'query_root'
  bulletins: Array<{
    __typename?: 'bulletins'
    id: number
    title: string
    createdAt: string
    global: boolean
    leadImageUploadId: number
    leadWebUrl: string
    leadThumbUrl: string
    post: string
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
    bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
    bulletinResources: Array<{
      __typename?: 'bulletinsResources'
      resource: {
        __typename?: 'resources'
        id: number
        createdAt: string
        title: string
        description: string
        file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
      }
    }>
  }>
}

export type RecentDiscussionsQueryVariables = Exact<{ [key: string]: never }>

export type RecentDiscussionsQuery = {
  __typename?: 'query_root'
  discussions: Array<{
    __typename?: 'discussions'
    id: number
    title: string
    createdAt: string
    post: string
    departmentId: number
    author: {
      __typename?: 'users'
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
    }
    comments: Array<{
      __typename?: 'comments'
      comment: string
      createdAt: string
      updatedAt: string
      id: number
      user: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
    }>
  }>
}

export type RecentResourcesQueryVariables = Exact<{ [key: string]: never }>

export type RecentResourcesQuery = {
  __typename?: 'query_root'
  resources: Array<{
    __typename?: 'resources'
    id: number
    createdAt: string
    title: string
    description: string
    file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
  }>
}

export type IosRedemptionCodeQueryVariables = Exact<{ [key: string]: never }>

export type IosRedemptionCodeQuery = {
  __typename?: 'query_root'
  iosRedemptionCode: { __typename?: 'RedemptionCodeOutput'; code: string; url: string }
}

export type JobsiteFragment = {
  __typename?: 'jobsites'
  id: number
  mainAddress: string
  mainAddress2: string
  mainAddressCity: string
  mainAddressState: string
  mainAddressZip: string
  officeAddress: string
  officeAddress2: string
  officeAddressCity: string
  officeAddressState: string
  officeAddressZip: string
  phone: string
  siteNumber: string
  title: string
  alt_names: string
}

export type JobsitesQueryVariables = Exact<{ [key: string]: never }>

export type JobsitesQuery = {
  __typename?: 'query_root'
  jobsites: Array<{
    __typename?: 'jobsites'
    id: number
    mainAddress: string
    mainAddress2: string
    mainAddressCity: string
    mainAddressState: string
    mainAddressZip: string
    officeAddress: string
    officeAddress2: string
    officeAddressCity: string
    officeAddressState: string
    officeAddressZip: string
    phone: string
    siteNumber: string
    title: string
    alt_names: string
  }>
}

export type CreateJobsiteMutationVariables = Exact<{
  mainAddress: Scalars['String']['input']
  mainAddress2: InputMaybe<Scalars['String']['input']>
  mainAddressCity: Scalars['String']['input']
  mainAddressState: Scalars['String']['input']
  mainAddressZip: Scalars['String']['input']
  officeAddress: InputMaybe<Scalars['String']['input']>
  officeAddress2: InputMaybe<Scalars['String']['input']>
  officeAddressCity: InputMaybe<Scalars['String']['input']>
  officeAddressState: InputMaybe<Scalars['String']['input']>
  officeAddressZip: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  siteNumber: Scalars['String']['input']
  title: Scalars['String']['input']
  alt_names: Scalars['String']['input']
}>

export type CreateJobsiteMutation = {
  __typename?: 'mutation_root'
  insertJobsite: { __typename?: 'jobsites'; id: number }
}

export type UpdateJobsiteMutationVariables = Exact<{
  id: Scalars['Int']['input']
  mainAddress: Scalars['String']['input']
  mainAddress2: InputMaybe<Scalars['String']['input']>
  mainAddressCity: Scalars['String']['input']
  mainAddressState: Scalars['String']['input']
  mainAddressZip: Scalars['String']['input']
  officeAddress: InputMaybe<Scalars['String']['input']>
  officeAddress2: InputMaybe<Scalars['String']['input']>
  officeAddressCity: InputMaybe<Scalars['String']['input']>
  officeAddressState: InputMaybe<Scalars['String']['input']>
  officeAddressZip: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  siteNumber: Scalars['String']['input']
  title: Scalars['String']['input']
  alt_names: Scalars['String']['input']
}>

export type UpdateJobsiteMutation = {
  __typename?: 'mutation_root'
  updateJobsiteById: { __typename?: 'jobsites'; id: number }
}

export type DeleteJobsiteMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteJobsiteMutation = {
  __typename?: 'mutation_root'
  deleteJobsiteById: { __typename?: 'jobsites'; id: number }
}

export type LatestOrgChartQueryVariables = Exact<{ [key: string]: never }>

export type LatestOrgChartQuery = {
  __typename?: 'query_root'
  resources: Array<{
    __typename?: 'resources'
    id: number
    createdAt: string
    title: string
    description: string
    file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
  }>
}

export type OrgChartUserFragment = {
  __typename?: 'users'
  id: number
  firstName: string
  lastName: string
  supervisorId: number
  profilePhotoUrl: string
  jobTitle: string
  adpId: string
  email: string
  phoneCell: string
  phoneDirect: string
  phoneExt: string
  department: { __typename?: 'departments'; title: string }
  jobsite: { __typename?: 'jobsites'; title: string }
}

export type OrgChartUsersQueryVariables = Exact<{ [key: string]: never }>

export type OrgChartUsersQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    id: number
    firstName: string
    lastName: string
    supervisorId: number
    profilePhotoUrl: string
    jobTitle: string
    adpId: string
    email: string
    phoneCell: string
    phoneDirect: string
    phoneExt: string
    department: { __typename?: 'departments'; title: string }
    jobsite: { __typename?: 'jobsites'; title: string }
  }>
}

export type PagesSignInMastheadQueryVariables = Exact<{ [key: string]: never }>

export type PagesSignInMastheadQuery = {
  __typename?: 'query_root'
  signinPage: { __typename?: 'pages'; masthead: { __typename?: 'uploads'; publicUrl: string; key: string } }
}

export type SearchQueryVariables = Exact<{
  keywords: Scalars['String']['input']
}>

export type SearchQuery = {
  __typename?: 'query_root'
  search: Array<{
    __typename?: 'search'
    modelType: string
    modelId: number
    user: {
      __typename?: 'users'
      supervisorId: number
      email: string
      phoneCell: string
      phoneDirect: string
      phoneExt: string
      id: number
      firstName: string
      lastName: string
      jobTitle: string
      profilePhotoUrl: string
      department: { __typename?: 'departments'; title: string }
      roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
      jobsite: { __typename?: 'jobsites'; title: string }
    }
    resource: {
      __typename?: 'resources'
      id: number
      createdAt: string
      title: string
      description: string
      departmentContentsResources: {
        __typename?: 'contentsResources'
        departmentContent: {
          __typename?: 'contents'
          departmentId: number
          parentId: number
          id: number
          title: string
        }
      }
      file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
    }
    bulletin: {
      __typename?: 'bulletins'
      id: number
      title: string
      createdAt: string
      global: boolean
      leadImageUploadId: number
      leadWebUrl: string
      leadThumbUrl: string
      post: string
      author: {
        __typename?: 'users'
        id: number
        firstName: string
        lastName: string
        jobTitle: string
        profilePhotoUrl: string
      }
      comments: Array<{
        __typename?: 'comments'
        comment: string
        createdAt: string
        updatedAt: string
        id: number
        user: {
          __typename?: 'users'
          id: number
          firstName: string
          lastName: string
          jobTitle: string
          profilePhotoUrl: string
        }
      }>
      bulletinDepartments: Array<{ __typename?: 'bulletinDepartments'; departmentId: number }>
      bulletinResources: Array<{
        __typename?: 'bulletinsResources'
        resource: {
          __typename?: 'resources'
          id: number
          createdAt: string
          title: string
          description: string
          file: { __typename?: 'uploads'; key: string; url: string; size: number; type: string }
        }
      }>
    }
  }>
}

export type ResourceSearchQueryVariables = Exact<{
  _ilike: InputMaybe<Scalars['String']['input']>
}>

export type ResourceSearchQuery = {
  __typename?: 'query_root'
  resources: Array<{
    __typename?: 'resources'
    title: string
    id: number
    createdAt: string
    description: string
    file: { __typename?: 'uploads'; key: string; url: string; type: string; size: number }
  }>
}

export type SiteMetaQueryVariables = Exact<{ [key: string]: never }>

export type SiteMetaQuery = {
  __typename?: 'query_root'
  departments: Array<{
    __typename?: 'departments'
    id: number
    title: string
    ownerId: number
    contents: Array<{ __typename?: 'contents'; id: number; title: string }>
    masthead: { __typename?: 'uploads'; publicUrl: string; key: string }
    logo: { __typename?: 'uploads'; key: string }
  }>
  pages: Array<{
    __typename?: 'pages'
    slug: string
    title: string
    body: string
    masthead: { __typename?: 'uploads'; publicUrl: string; key: string }
  }>
}

export type TempGetAllPtoQueryVariables = Exact<{ [key: string]: never }>

export type TempGetAllPtoQuery = {
  __typename?: 'query_root'
  pto: Array<{
    __typename?: 'pto'
    startsAt: string
    allDay: boolean
    user: { __typename?: 'users'; firstName: string; lastName: string }
  }>
}

export type TempPtoQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type TempPtoQuery = {
  __typename?: 'query_root'
  userById: { __typename?: 'users'; adp: { __typename?: 'adp'; ptoBalances: unknown; ptoRequests: unknown } }
}

export type UsersGetAllQueryVariables = Exact<{ [key: string]: never }>

export type UsersGetAllQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    supervisorId: number
    email: string
    phoneCell: string
    phoneDirect: string
    phoneExt: string
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
    department: { __typename?: 'departments'; title: string }
    roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
    jobsite: { __typename?: 'jobsites'; title: string }
  }>
}

export type UsersGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type UsersGetByIdQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    supervisorId: number
    email: string
    phoneCell: string
    phoneDirect: string
    phoneExt: string
    id: number
    firstName: string
    lastName: string
    jobTitle: string
    profilePhotoUrl: string
    department: { __typename?: 'departments'; title: string }
    roles: Array<{ __typename?: 'userRoles'; role: Roles_Enum }>
    jobsite: { __typename?: 'jobsites'; title: string }
  }>
}

export const ResourceDetailsFragmentDoc = gql`
  fragment resourceDetails on resources {
    id
    createdAt
    title
    description
    file {
      key
      url
      size
      type
      url
    }
  }
`
export const UserBasicFragmentDoc = gql`
  fragment userBasic on users {
    id
    firstName
    lastName
    jobTitle
    profilePhotoUrl
  }
`
export const CommentDetailsFragmentDoc = gql`
  fragment commentDetails on comments {
    comment
    createdAt
    updatedAt
    id
    user {
      ...userBasic
    }
  }
  ${UserBasicFragmentDoc}
`
export const DiscussionDetailsFragmentDoc = gql`
  fragment discussionDetails on discussions {
    author {
      ...userBasic
    }
    comments(order_by: { createdAt: asc }) {
      ...commentDetails
    }
    id
    title
    createdAt
    post
    departmentId
  }
  ${UserBasicFragmentDoc}
  ${CommentDetailsFragmentDoc}
`
export const UserFavoritesFragmentDoc = gql`
  fragment userFavorites on users {
    favoriteResources(where: { resource: {} }) {
      resourceId
      id
      resource {
        ...resourceDetails
      }
    }
    favoriteDiscussions(where: { discussion: {} }) {
      discussionId
      id
      discussion {
        ...discussionDetails
      }
    }
  }
  ${ResourceDetailsFragmentDoc}
  ${DiscussionDetailsFragmentDoc}
`
export const BulletinDetailsFragmentDoc = gql`
  fragment bulletinDetails on bulletins {
    id
    title
    createdAt
    global
    author {
      ...userBasic
    }
    leadImageUploadId
    leadWebUrl
    leadThumbUrl
    post
    comments(order_by: { createdAt: asc }) {
      ...commentDetails
    }
    bulletinDepartments {
      departmentId
    }
    bulletinResources(order_by: { resource: { createdAt: desc } }) {
      resource {
        ...resourceDetails
      }
    }
  }
  ${UserBasicFragmentDoc}
  ${CommentDetailsFragmentDoc}
  ${ResourceDetailsFragmentDoc}
`
export const UserDetailsFragmentDoc = gql`
  fragment userDetails on users {
    ...userBasic
    department {
      title
    }
    supervisorId
    roles {
      role
    }
    email
    phoneCell
    phoneDirect
    phoneExt
    jobsite {
      title
    }
  }
  ${UserBasicFragmentDoc}
`
export const DepartmentDetailsFragmentDoc = gql`
  fragment departmentDetails on departments {
    id
    title
    missionStatement
    quicklinks {
      title
      url
      id
      description
    }
    contents(where: { active: { _eq: true }, parentId: { _is_null: true } }) {
      id
      title
      body
      parentId
      contentResources(
        where: { resource: { deleted: { _is_null: true } } }
        order_by: { resource: { createdAt: desc } }
      ) {
        resource {
          ...resourceDetails
        }
      }
      contents(where: { active: { _eq: true } }) {
        id
        title
        body
        parentId
        contentResources(
          where: { resource: { deleted: { _is_null: true } } }
          order_by: { resource: { createdAt: desc } }
        ) {
          resource {
            ...resourceDetails
          }
        }
      }
    }
    masthead {
      id
      publicUrl
      key
    }
    logo {
      id
      publicUrl
      key
    }
    faqs(order_by: { id: asc }) {
      id
      question
      answer
    }
    bulletins(order_by: { bulletin: { createdAt: desc } }) {
      bulletin {
        ...bulletinDetails
      }
    }
    discussions(order_by: { createdAt: desc }) {
      ...discussionDetails
    }
    employees(order_by: { lastName: asc }) {
      ...userDetails
    }
  }
  ${ResourceDetailsFragmentDoc}
  ${BulletinDetailsFragmentDoc}
  ${DiscussionDetailsFragmentDoc}
  ${UserDetailsFragmentDoc}
`
export const EventFragmentDoc = gql`
  fragment event on events {
    type
    title
    startsAt
    id
    endsAt
    description
    allDay
  }
`
export const JobsiteFragmentDoc = gql`
  fragment jobsite on jobsites {
    id
    mainAddress
    mainAddress2
    mainAddressCity
    mainAddressState
    mainAddressZip
    officeAddress
    officeAddress2
    officeAddressCity
    officeAddressState
    officeAddressZip
    phone
    siteNumber
    title
    alt_names
  }
`
export const OrgChartUserFragmentDoc = gql`
  fragment orgChartUser on users {
    id
    firstName
    lastName
    supervisorId
    profilePhotoUrl
    jobTitle
    adpId
    department {
      title
    }
    jobsite {
      title
    }
    email
    phoneCell
    phoneDirect
    phoneExt
  }
`
export const AddCommentDocument = gql`
  mutation addComment(
    $nominationId: Int = null
    $bulletinId: Int = null
    $discussionId: Int = null
    $comment: String!
  ) {
    insertComment(
      object: { nominationId: $nominationId, bulletinId: $bulletinId, comment: $comment, discussionId: $discussionId }
    ) {
      id
    }
  }
`
export type AddCommentMutationFn = ApolloReactCommon.MutationFunction<AddCommentMutation, AddCommentMutationVariables>

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      nominationId: // value for 'nominationId'
 *      bulletinId: // value for 'bulletinId'
 *      discussionId: // value for 'discussionId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options)
}
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>
export type AddCommentMutationResult = ApolloReactCommon.MutationResult<AddCommentMutation>
export type AddCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddCommentMutation,
  AddCommentMutationVariables
>
export const AddUploadDocument = gql`
  mutation addUpload($key: String!, $size: Int!, $type: String!, $url: String!) {
    insertUpload(object: { key: $key, size: $size, type: $type, url: $url }) {
      id
      url
      publicUrl
    }
  }
`
export type AddUploadMutationFn = ApolloReactCommon.MutationFunction<AddUploadMutation, AddUploadMutationVariables>

/**
 * __useAddUploadMutation__
 *
 * To run a mutation, you first call `useAddUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUploadMutation, { data, loading, error }] = useAddUploadMutation({
 *   variables: {
 *      key: // value for 'key'
 *      size: // value for 'size'
 *      type: // value for 'type'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useAddUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddUploadMutation, AddUploadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddUploadMutation, AddUploadMutationVariables>(AddUploadDocument, options)
}
export type AddUploadMutationHookResult = ReturnType<typeof useAddUploadMutation>
export type AddUploadMutationResult = ApolloReactCommon.MutationResult<AddUploadMutation>
export type AddUploadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddUploadMutation,
  AddUploadMutationVariables
>
export const DeleteContentResourceDocument = gql`
  mutation deleteContentResource($contentId: Int!, $resourceId: Int!) {
    deleteContentsResources(where: { departmentContentId: { _eq: $contentId }, resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`
export type DeleteContentResourceMutationFn = ApolloReactCommon.MutationFunction<
  DeleteContentResourceMutation,
  DeleteContentResourceMutationVariables
>

/**
 * __useDeleteContentResourceMutation__
 *
 * To run a mutation, you first call `useDeleteContentResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentResourceMutation, { data, loading, error }] = useDeleteContentResourceMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDeleteContentResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteContentResourceMutation,
    DeleteContentResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteContentResourceMutation, DeleteContentResourceMutationVariables>(
    DeleteContentResourceDocument,
    options
  )
}
export type DeleteContentResourceMutationHookResult = ReturnType<typeof useDeleteContentResourceMutation>
export type DeleteContentResourceMutationResult = ApolloReactCommon.MutationResult<DeleteContentResourceMutation>
export type DeleteContentResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteContentResourceMutation,
  DeleteContentResourceMutationVariables
>
export const AddResourceDocument = gql`
  mutation addResource($title: String!, $fileUploadId: Int!, $description: String!) {
    insertResource(object: { description: $description, fileUploadId: $fileUploadId, global: false, title: $title }) {
      id
    }
  }
`
export type AddResourceMutationFn = ApolloReactCommon.MutationFunction<
  AddResourceMutation,
  AddResourceMutationVariables
>

/**
 * __useAddResourceMutation__
 *
 * To run a mutation, you first call `useAddResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResourceMutation, { data, loading, error }] = useAddResourceMutation({
 *   variables: {
 *      title: // value for 'title'
 *      fileUploadId: // value for 'fileUploadId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddResourceMutation, AddResourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddResourceMutation, AddResourceMutationVariables>(AddResourceDocument, options)
}
export type AddResourceMutationHookResult = ReturnType<typeof useAddResourceMutation>
export type AddResourceMutationResult = ApolloReactCommon.MutationResult<AddResourceMutation>
export type AddResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddResourceMutation,
  AddResourceMutationVariables
>
export const AddContentsResourceDocument = gql`
  mutation addContentsResource($departmentContentId: Int!, $resourceId: Int!) {
    insertContentsResource(object: { resourceId: $resourceId, departmentContentId: $departmentContentId }) {
      id
    }
  }
`
export type AddContentsResourceMutationFn = ApolloReactCommon.MutationFunction<
  AddContentsResourceMutation,
  AddContentsResourceMutationVariables
>

/**
 * __useAddContentsResourceMutation__
 *
 * To run a mutation, you first call `useAddContentsResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentsResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentsResourceMutation, { data, loading, error }] = useAddContentsResourceMutation({
 *   variables: {
 *      departmentContentId: // value for 'departmentContentId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAddContentsResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddContentsResourceMutation, AddContentsResourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddContentsResourceMutation, AddContentsResourceMutationVariables>(
    AddContentsResourceDocument,
    options
  )
}
export type AddContentsResourceMutationHookResult = ReturnType<typeof useAddContentsResourceMutation>
export type AddContentsResourceMutationResult = ApolloReactCommon.MutationResult<AddContentsResourceMutation>
export type AddContentsResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddContentsResourceMutation,
  AddContentsResourceMutationVariables
>
export const UpdateProfilePicDocument = gql`
  mutation updateProfilePic($userId: Int!, $uploadId: Int!) {
    updateUserById(pk_columns: { id: $userId }, _set: { photoUploadId: $uploadId }) {
      id
      profilePhotoUrl
    }
  }
`
export type UpdateProfilePicMutationFn = ApolloReactCommon.MutationFunction<
  UpdateProfilePicMutation,
  UpdateProfilePicMutationVariables
>

/**
 * __useUpdateProfilePicMutation__
 *
 * To run a mutation, you first call `useUpdateProfilePicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfilePicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfilePicMutation, { data, loading, error }] = useUpdateProfilePicMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUpdateProfilePicMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfilePicMutation, UpdateProfilePicMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateProfilePicMutation, UpdateProfilePicMutationVariables>(
    UpdateProfilePicDocument,
    options
  )
}
export type UpdateProfilePicMutationHookResult = ReturnType<typeof useUpdateProfilePicMutation>
export type UpdateProfilePicMutationResult = ApolloReactCommon.MutationResult<UpdateProfilePicMutation>
export type UpdateProfilePicMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateProfilePicMutation,
  UpdateProfilePicMutationVariables
>
export const AddBulletinsResourceDocument = gql`
  mutation addBulletinsResource($bulletinId: Int!, $resourceId: Int!) {
    insertBulletinsResource(object: { resourceId: $resourceId, bulletinId: $bulletinId }) {
      id
    }
  }
`
export type AddBulletinsResourceMutationFn = ApolloReactCommon.MutationFunction<
  AddBulletinsResourceMutation,
  AddBulletinsResourceMutationVariables
>

/**
 * __useAddBulletinsResourceMutation__
 *
 * To run a mutation, you first call `useAddBulletinsResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBulletinsResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBulletinsResourceMutation, { data, loading, error }] = useAddBulletinsResourceMutation({
 *   variables: {
 *      bulletinId: // value for 'bulletinId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAddBulletinsResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddBulletinsResourceMutation,
    AddBulletinsResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddBulletinsResourceMutation, AddBulletinsResourceMutationVariables>(
    AddBulletinsResourceDocument,
    options
  )
}
export type AddBulletinsResourceMutationHookResult = ReturnType<typeof useAddBulletinsResourceMutation>
export type AddBulletinsResourceMutationResult = ApolloReactCommon.MutationResult<AddBulletinsResourceMutation>
export type AddBulletinsResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddBulletinsResourceMutation,
  AddBulletinsResourceMutationVariables
>
export const DeleteBulletinsResourceDocument = gql`
  mutation deleteBulletinsResource($bulletinId: Int!, $resourceId: Int!) {
    deleteBulletinsResources(where: { bulletinId: { _eq: $bulletinId }, resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`
export type DeleteBulletinsResourceMutationFn = ApolloReactCommon.MutationFunction<
  DeleteBulletinsResourceMutation,
  DeleteBulletinsResourceMutationVariables
>

/**
 * __useDeleteBulletinsResourceMutation__
 *
 * To run a mutation, you first call `useDeleteBulletinsResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulletinsResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulletinsResourceMutation, { data, loading, error }] = useDeleteBulletinsResourceMutation({
 *   variables: {
 *      bulletinId: // value for 'bulletinId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDeleteBulletinsResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteBulletinsResourceMutation,
    DeleteBulletinsResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteBulletinsResourceMutation, DeleteBulletinsResourceMutationVariables>(
    DeleteBulletinsResourceDocument,
    options
  )
}
export type DeleteBulletinsResourceMutationHookResult = ReturnType<typeof useDeleteBulletinsResourceMutation>
export type DeleteBulletinsResourceMutationResult = ApolloReactCommon.MutationResult<DeleteBulletinsResourceMutation>
export type DeleteBulletinsResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteBulletinsResourceMutation,
  DeleteBulletinsResourceMutationVariables
>
export const AdminAddContentDocument = gql`
  mutation adminAddContent($body: String, $departmentId: Int, $parentId: Int, $title: String, $active: Boolean) {
    insertContent(
      object: { active: $active, body: $body, departmentId: $departmentId, parentId: $parentId, title: $title }
    ) {
      id
    }
  }
`
export type AdminAddContentMutationFn = ApolloReactCommon.MutationFunction<
  AdminAddContentMutation,
  AdminAddContentMutationVariables
>

/**
 * __useAdminAddContentMutation__
 *
 * To run a mutation, you first call `useAdminAddContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddContentMutation, { data, loading, error }] = useAdminAddContentMutation({
 *   variables: {
 *      body: // value for 'body'
 *      departmentId: // value for 'departmentId'
 *      parentId: // value for 'parentId'
 *      title: // value for 'title'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useAdminAddContentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AdminAddContentMutation, AdminAddContentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AdminAddContentMutation, AdminAddContentMutationVariables>(
    AdminAddContentDocument,
    options
  )
}
export type AdminAddContentMutationHookResult = ReturnType<typeof useAdminAddContentMutation>
export type AdminAddContentMutationResult = ApolloReactCommon.MutationResult<AdminAddContentMutation>
export type AdminAddContentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AdminAddContentMutation,
  AdminAddContentMutationVariables
>
export const AdminUpdateContentDocument = gql`
  mutation adminUpdateContent($body: String, $parentId: Int, $title: String, $id: Int!) {
    updateContentById(pk_columns: { id: $id }, _set: { body: $body, parentId: $parentId, title: $title }) {
      id
      parentId
    }
  }
`
export type AdminUpdateContentMutationFn = ApolloReactCommon.MutationFunction<
  AdminUpdateContentMutation,
  AdminUpdateContentMutationVariables
>

/**
 * __useAdminUpdateContentMutation__
 *
 * To run a mutation, you first call `useAdminUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateContentMutation, { data, loading, error }] = useAdminUpdateContentMutation({
 *   variables: {
 *      body: // value for 'body'
 *      parentId: // value for 'parentId'
 *      title: // value for 'title'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUpdateContentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>(
    AdminUpdateContentDocument,
    options
  )
}
export type AdminUpdateContentMutationHookResult = ReturnType<typeof useAdminUpdateContentMutation>
export type AdminUpdateContentMutationResult = ApolloReactCommon.MutationResult<AdminUpdateContentMutation>
export type AdminUpdateContentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AdminUpdateContentMutation,
  AdminUpdateContentMutationVariables
>
export const DisablePageDocument = gql`
  mutation disablePage($contentId: Int!) {
    updateContentById(pk_columns: { id: $contentId }, _set: { active: false }) {
      id
    }
  }
`
export type DisablePageMutationFn = ApolloReactCommon.MutationFunction<
  DisablePageMutation,
  DisablePageMutationVariables
>

/**
 * __useDisablePageMutation__
 *
 * To run a mutation, you first call `useDisablePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePageMutation, { data, loading, error }] = useDisablePageMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useDisablePageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DisablePageMutation, DisablePageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DisablePageMutation, DisablePageMutationVariables>(DisablePageDocument, options)
}
export type DisablePageMutationHookResult = ReturnType<typeof useDisablePageMutation>
export type DisablePageMutationResult = ApolloReactCommon.MutationResult<DisablePageMutation>
export type DisablePageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DisablePageMutation,
  DisablePageMutationVariables
>
export const UpdateDepartmentDocument = gql`
  mutation updateDepartment(
    $departmentId: Int!
    $logoUploadId: Int
    $mastheadUploadId: Int
    $missionStatement: String!
    $title: String!
  ) {
    updateDepartmentById(
      pk_columns: { id: $departmentId }
      _set: {
        logoUploadId: $logoUploadId
        mastheadUploadId: $mastheadUploadId
        missionStatement: $missionStatement
        title: $title
      }
    ) {
      id
    }
  }
`
export type UpdateDepartmentMutationFn = ApolloReactCommon.MutationFunction<
  UpdateDepartmentMutation,
  UpdateDepartmentMutationVariables
>

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      logoUploadId: // value for 'logoUploadId'
 *      mastheadUploadId: // value for 'mastheadUploadId'
 *      missionStatement: // value for 'missionStatement'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(
    UpdateDepartmentDocument,
    options
  )
}
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>
export type UpdateDepartmentMutationResult = ApolloReactCommon.MutationResult<UpdateDepartmentMutation>
export type UpdateDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateDepartmentMutation,
  UpdateDepartmentMutationVariables
>
export const AddBulletinDocument = gql`
  mutation addBulletin($global: Boolean!, $leadImageUploadId: Int!, $post: String!, $title: String!) {
    insertBulletin(object: { global: $global, leadImageUploadId: $leadImageUploadId, post: $post, title: $title }) {
      id
    }
  }
`
export type AddBulletinMutationFn = ApolloReactCommon.MutationFunction<
  AddBulletinMutation,
  AddBulletinMutationVariables
>

/**
 * __useAddBulletinMutation__
 *
 * To run a mutation, you first call `useAddBulletinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBulletinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBulletinMutation, { data, loading, error }] = useAddBulletinMutation({
 *   variables: {
 *      global: // value for 'global'
 *      leadImageUploadId: // value for 'leadImageUploadId'
 *      post: // value for 'post'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAddBulletinMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddBulletinMutation, AddBulletinMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddBulletinMutation, AddBulletinMutationVariables>(AddBulletinDocument, options)
}
export type AddBulletinMutationHookResult = ReturnType<typeof useAddBulletinMutation>
export type AddBulletinMutationResult = ApolloReactCommon.MutationResult<AddBulletinMutation>
export type AddBulletinMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddBulletinMutation,
  AddBulletinMutationVariables
>
export const AddBulletinDepartmentsDocument = gql`
  mutation addBulletinDepartments($objects: [bulletinDepartments_insert_input!]!) {
    insertBulletinDepartments(objects: $objects) {
      affected_rows
    }
  }
`
export type AddBulletinDepartmentsMutationFn = ApolloReactCommon.MutationFunction<
  AddBulletinDepartmentsMutation,
  AddBulletinDepartmentsMutationVariables
>

/**
 * __useAddBulletinDepartmentsMutation__
 *
 * To run a mutation, you first call `useAddBulletinDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBulletinDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBulletinDepartmentsMutation, { data, loading, error }] = useAddBulletinDepartmentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddBulletinDepartmentsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddBulletinDepartmentsMutation,
    AddBulletinDepartmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddBulletinDepartmentsMutation, AddBulletinDepartmentsMutationVariables>(
    AddBulletinDepartmentsDocument,
    options
  )
}
export type AddBulletinDepartmentsMutationHookResult = ReturnType<typeof useAddBulletinDepartmentsMutation>
export type AddBulletinDepartmentsMutationResult = ApolloReactCommon.MutationResult<AddBulletinDepartmentsMutation>
export type AddBulletinDepartmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddBulletinDepartmentsMutation,
  AddBulletinDepartmentsMutationVariables
>
export const DeleteBulletinDocument = gql`
  mutation deleteBulletin($id: Int!) {
    deleteBulletins(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`
export type DeleteBulletinMutationFn = ApolloReactCommon.MutationFunction<
  DeleteBulletinMutation,
  DeleteBulletinMutationVariables
>

/**
 * __useDeleteBulletinMutation__
 *
 * To run a mutation, you first call `useDeleteBulletinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulletinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulletinMutation, { data, loading, error }] = useDeleteBulletinMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBulletinMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBulletinMutation, DeleteBulletinMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteBulletinMutation, DeleteBulletinMutationVariables>(
    DeleteBulletinDocument,
    options
  )
}
export type DeleteBulletinMutationHookResult = ReturnType<typeof useDeleteBulletinMutation>
export type DeleteBulletinMutationResult = ApolloReactCommon.MutationResult<DeleteBulletinMutation>
export type DeleteBulletinMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteBulletinMutation,
  DeleteBulletinMutationVariables
>
export const UpdateBulletinDocument = gql`
  mutation updateBulletin($id: Int!, $global: Boolean!, $leadImageUploadId: Int!, $post: String!, $title: String!) {
    updateBulletinById(
      pk_columns: { id: $id }
      _set: { global: $global, leadImageUploadId: $leadImageUploadId, post: $post, title: $title }
    ) {
      id
    }
  }
`
export type UpdateBulletinMutationFn = ApolloReactCommon.MutationFunction<
  UpdateBulletinMutation,
  UpdateBulletinMutationVariables
>

/**
 * __useUpdateBulletinMutation__
 *
 * To run a mutation, you first call `useUpdateBulletinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulletinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulletinMutation, { data, loading, error }] = useUpdateBulletinMutation({
 *   variables: {
 *      id: // value for 'id'
 *      global: // value for 'global'
 *      leadImageUploadId: // value for 'leadImageUploadId'
 *      post: // value for 'post'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateBulletinMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBulletinMutation, UpdateBulletinMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateBulletinMutation, UpdateBulletinMutationVariables>(
    UpdateBulletinDocument,
    options
  )
}
export type UpdateBulletinMutationHookResult = ReturnType<typeof useUpdateBulletinMutation>
export type UpdateBulletinMutationResult = ApolloReactCommon.MutationResult<UpdateBulletinMutation>
export type UpdateBulletinMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateBulletinMutation,
  UpdateBulletinMutationVariables
>
export const RefetchBulletinDocument = gql`
  mutation refetchBulletin($id: Int!, $global: Boolean!) {
    updateBulletinById(pk_columns: { id: $id }, _set: { global: $global }) {
      id
    }
  }
`
export type RefetchBulletinMutationFn = ApolloReactCommon.MutationFunction<
  RefetchBulletinMutation,
  RefetchBulletinMutationVariables
>

/**
 * __useRefetchBulletinMutation__
 *
 * To run a mutation, you first call `useRefetchBulletinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchBulletinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchBulletinMutation, { data, loading, error }] = useRefetchBulletinMutation({
 *   variables: {
 *      id: // value for 'id'
 *      global: // value for 'global'
 *   },
 * });
 */
export function useRefetchBulletinMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RefetchBulletinMutation, RefetchBulletinMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RefetchBulletinMutation, RefetchBulletinMutationVariables>(
    RefetchBulletinDocument,
    options
  )
}
export type RefetchBulletinMutationHookResult = ReturnType<typeof useRefetchBulletinMutation>
export type RefetchBulletinMutationResult = ApolloReactCommon.MutationResult<RefetchBulletinMutation>
export type RefetchBulletinMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RefetchBulletinMutation,
  RefetchBulletinMutationVariables
>
export const RemoveBulletinDepartmentsDocument = gql`
  mutation removeBulletinDepartments($departmentIds: [Int!]!, $bulletinId: Int!) {
    deleteBulletinDepartments(
      where: { departmentId: { _in: $departmentIds }, bulletin: { id: { _eq: $bulletinId } } }
    ) {
      affected_rows
    }
  }
`
export type RemoveBulletinDepartmentsMutationFn = ApolloReactCommon.MutationFunction<
  RemoveBulletinDepartmentsMutation,
  RemoveBulletinDepartmentsMutationVariables
>

/**
 * __useRemoveBulletinDepartmentsMutation__
 *
 * To run a mutation, you first call `useRemoveBulletinDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBulletinDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBulletinDepartmentsMutation, { data, loading, error }] = useRemoveBulletinDepartmentsMutation({
 *   variables: {
 *      departmentIds: // value for 'departmentIds'
 *      bulletinId: // value for 'bulletinId'
 *   },
 * });
 */
export function useRemoveBulletinDepartmentsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveBulletinDepartmentsMutation,
    RemoveBulletinDepartmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveBulletinDepartmentsMutation, RemoveBulletinDepartmentsMutationVariables>(
    RemoveBulletinDepartmentsDocument,
    options
  )
}
export type RemoveBulletinDepartmentsMutationHookResult = ReturnType<typeof useRemoveBulletinDepartmentsMutation>
export type RemoveBulletinDepartmentsMutationResult =
  ApolloReactCommon.MutationResult<RemoveBulletinDepartmentsMutation>
export type RemoveBulletinDepartmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveBulletinDepartmentsMutation,
  RemoveBulletinDepartmentsMutationVariables
>
export const UpdateResourceFileDocument = gql`
  mutation updateResourceFile($id: Int!, $fileUploadId: Int!) {
    updateResourceById(pk_columns: { id: $id }, _set: { fileUploadId: $fileUploadId }) {
      id
    }
  }
`
export type UpdateResourceFileMutationFn = ApolloReactCommon.MutationFunction<
  UpdateResourceFileMutation,
  UpdateResourceFileMutationVariables
>

/**
 * __useUpdateResourceFileMutation__
 *
 * To run a mutation, you first call `useUpdateResourceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceFileMutation, { data, loading, error }] = useUpdateResourceFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileUploadId: // value for 'fileUploadId'
 *   },
 * });
 */
export function useUpdateResourceFileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceFileMutation, UpdateResourceFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateResourceFileMutation, UpdateResourceFileMutationVariables>(
    UpdateResourceFileDocument,
    options
  )
}
export type UpdateResourceFileMutationHookResult = ReturnType<typeof useUpdateResourceFileMutation>
export type UpdateResourceFileMutationResult = ApolloReactCommon.MutationResult<UpdateResourceFileMutation>
export type UpdateResourceFileMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateResourceFileMutation,
  UpdateResourceFileMutationVariables
>
export const UpdateResourceDataDocument = gql`
  mutation updateResourceData($id: Int!, $title: String!, $description: String!) {
    updateResourceById(pk_columns: { id: $id }, _set: { description: $description, title: $title }) {
      id
      title
      description
    }
  }
`
export type UpdateResourceDataMutationFn = ApolloReactCommon.MutationFunction<
  UpdateResourceDataMutation,
  UpdateResourceDataMutationVariables
>

/**
 * __useUpdateResourceDataMutation__
 *
 * To run a mutation, you first call `useUpdateResourceDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceDataMutation, { data, loading, error }] = useUpdateResourceDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateResourceDataMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceDataMutation, UpdateResourceDataMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateResourceDataMutation, UpdateResourceDataMutationVariables>(
    UpdateResourceDataDocument,
    options
  )
}
export type UpdateResourceDataMutationHookResult = ReturnType<typeof useUpdateResourceDataMutation>
export type UpdateResourceDataMutationResult = ApolloReactCommon.MutationResult<UpdateResourceDataMutation>
export type UpdateResourceDataMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateResourceDataMutation,
  UpdateResourceDataMutationVariables
>
export const DeleteResourceDocument = gql`
  mutation deleteResource($id: Int = -1) {
    updateResources(where: { id: { _eq: $id } }, _set: { deleted: true }) {
      affected_rows
    }
  }
`
export type DeleteResourceMutationFn = ApolloReactCommon.MutationFunction<
  DeleteResourceMutation,
  DeleteResourceMutationVariables
>

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(
    DeleteResourceDocument,
    options
  )
}
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>
export type DeleteResourceMutationResult = ApolloReactCommon.MutationResult<DeleteResourceMutation>
export type DeleteResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteResourceMutation,
  DeleteResourceMutationVariables
>
export const RemoveUserRoleDocument = gql`
  mutation removeUserRole($role: roles_enum!, $userId: Int!) {
    deleteUserRoles(where: { role: { _eq: $role }, userId: { _eq: $userId } }) {
      affected_rows
    }
  }
`
export type RemoveUserRoleMutationFn = ApolloReactCommon.MutationFunction<
  RemoveUserRoleMutation,
  RemoveUserRoleMutationVariables
>

/**
 * __useRemoveUserRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserRoleMutation, { data, loading, error }] = useRemoveUserRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserRoleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>(
    RemoveUserRoleDocument,
    options
  )
}
export type RemoveUserRoleMutationHookResult = ReturnType<typeof useRemoveUserRoleMutation>
export type RemoveUserRoleMutationResult = ApolloReactCommon.MutationResult<RemoveUserRoleMutation>
export type RemoveUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveUserRoleMutation,
  RemoveUserRoleMutationVariables
>
export const AddUserRoleDocument = gql`
  mutation addUserRole($input: userRoles_insert_input!) {
    insertUserRole(object: $input) {
      role
    }
  }
`
export type AddUserRoleMutationFn = ApolloReactCommon.MutationFunction<
  AddUserRoleMutation,
  AddUserRoleMutationVariables
>

/**
 * __useAddUserRoleMutation__
 *
 * To run a mutation, you first call `useAddUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserRoleMutation, { data, loading, error }] = useAddUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserRoleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserRoleMutation, AddUserRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddUserRoleMutation, AddUserRoleMutationVariables>(AddUserRoleDocument, options)
}
export type AddUserRoleMutationHookResult = ReturnType<typeof useAddUserRoleMutation>
export type AddUserRoleMutationResult = ApolloReactCommon.MutationResult<AddUserRoleMutation>
export type AddUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddUserRoleMutation,
  AddUserRoleMutationVariables
>
export const UpdatePageMastheadDocument = gql`
  mutation updatePageMasthead($slug: String!, $mastheadUploadId: Int!) {
    updatePageBySlug(pk_columns: { slug: $slug }, _set: { mastheadUploadId: $mastheadUploadId }) {
      mastheadUploadId
    }
  }
`
export type UpdatePageMastheadMutationFn = ApolloReactCommon.MutationFunction<
  UpdatePageMastheadMutation,
  UpdatePageMastheadMutationVariables
>

/**
 * __useUpdatePageMastheadMutation__
 *
 * To run a mutation, you first call `useUpdatePageMastheadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMastheadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMastheadMutation, { data, loading, error }] = useUpdatePageMastheadMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      mastheadUploadId: // value for 'mastheadUploadId'
 *   },
 * });
 */
export function useUpdatePageMastheadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageMastheadMutation, UpdatePageMastheadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdatePageMastheadMutation, UpdatePageMastheadMutationVariables>(
    UpdatePageMastheadDocument,
    options
  )
}
export type UpdatePageMastheadMutationHookResult = ReturnType<typeof useUpdatePageMastheadMutation>
export type UpdatePageMastheadMutationResult = ApolloReactCommon.MutationResult<UpdatePageMastheadMutation>
export type UpdatePageMastheadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdatePageMastheadMutation,
  UpdatePageMastheadMutationVariables
>
export const CreateDepartmentDocument = gql`
  mutation createDepartment($mastheadUploadId: Int!, $title: String!, $ownerId: Int!) {
    insertDepartment(
      object: { mastheadUploadId: $mastheadUploadId, missionStatement: "", title: $title, ownerId: $ownerId }
    ) {
      id
    }
  }
`
export type CreateDepartmentMutationFn = ApolloReactCommon.MutationFunction<
  CreateDepartmentMutation,
  CreateDepartmentMutationVariables
>

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      mastheadUploadId: // value for 'mastheadUploadId'
 *      title: // value for 'title'
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useCreateDepartmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(
    CreateDepartmentDocument,
    options
  )
}
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>
export type CreateDepartmentMutationResult = ApolloReactCommon.MutationResult<CreateDepartmentMutation>
export type CreateDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateDepartmentMutation,
  CreateDepartmentMutationVariables
>
export const CreateFaqDocument = gql`
  mutation createFaq($answer: String!, $departmentId: Int!, $question: String!) {
    insertDepartmentFaq(object: { answer: $answer, departmentId: $departmentId, question: $question }) {
      id
      question
      answer
    }
  }
`
export type CreateFaqMutationFn = ApolloReactCommon.MutationFunction<CreateFaqMutation, CreateFaqMutationVariables>

/**
 * __useCreateFaqMutation__
 *
 * To run a mutation, you first call `useCreateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaqMutation, { data, loading, error }] = useCreateFaqMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      departmentId: // value for 'departmentId'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useCreateFaqMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFaqMutation, CreateFaqMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateFaqMutation, CreateFaqMutationVariables>(CreateFaqDocument, options)
}
export type CreateFaqMutationHookResult = ReturnType<typeof useCreateFaqMutation>
export type CreateFaqMutationResult = ApolloReactCommon.MutationResult<CreateFaqMutation>
export type CreateFaqMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateFaqMutation,
  CreateFaqMutationVariables
>
export const UpdateFaqDocument = gql`
  mutation updateFaq($id: Int!, $answer: String!, $question: String!) {
    updateDepartmentFaqById(pk_columns: { id: $id }, _set: { answer: $answer, question: $question }) {
      id
      question
      answer
    }
  }
`
export type UpdateFaqMutationFn = ApolloReactCommon.MutationFunction<UpdateFaqMutation, UpdateFaqMutationVariables>

/**
 * __useUpdateFaqMutation__
 *
 * To run a mutation, you first call `useUpdateFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqMutation, { data, loading, error }] = useUpdateFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *      answer: // value for 'answer'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useUpdateFaqMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFaqMutation, UpdateFaqMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateFaqMutation, UpdateFaqMutationVariables>(UpdateFaqDocument, options)
}
export type UpdateFaqMutationHookResult = ReturnType<typeof useUpdateFaqMutation>
export type UpdateFaqMutationResult = ApolloReactCommon.MutationResult<UpdateFaqMutation>
export type UpdateFaqMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateFaqMutation,
  UpdateFaqMutationVariables
>
export const DeleteFaqDocument = gql`
  mutation deleteFaq($id: Int!) {
    deleteDepartmentFaqById(id: $id) {
      id
    }
  }
`
export type DeleteFaqMutationFn = ApolloReactCommon.MutationFunction<DeleteFaqMutation, DeleteFaqMutationVariables>

/**
 * __useDeleteFaqMutation__
 *
 * To run a mutation, you first call `useDeleteFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqMutation, { data, loading, error }] = useDeleteFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaqMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFaqMutation, DeleteFaqMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteFaqMutation, DeleteFaqMutationVariables>(DeleteFaqDocument, options)
}
export type DeleteFaqMutationHookResult = ReturnType<typeof useDeleteFaqMutation>
export type DeleteFaqMutationResult = ApolloReactCommon.MutationResult<DeleteFaqMutation>
export type DeleteFaqMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteFaqMutation,
  DeleteFaqMutationVariables
>
export const AuthenticateUserDocument = gql`
  mutation authenticateUser($username: String!, $password: String!) {
    authenticateUser(credentials: { username: $username, password: $password }) {
      accessToken
      userId
    }
  }
`
export type AuthenticateUserMutationFn = ApolloReactCommon.MutationFunction<
  AuthenticateUserMutation,
  AuthenticateUserMutationVariables
>

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(
    AuthenticateUserDocument,
    options
  )
}
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>
export type AuthenticateUserMutationResult = ApolloReactCommon.MutationResult<AuthenticateUserMutation>
export type AuthenticateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AuthenticateUserMutation,
  AuthenticateUserMutationVariables
>
export const CreateDiscussionDocument = gql`
  mutation createDiscussion($departmentId: Int, $post: String!, $title: String!) {
    insertDiscussion(object: { departmentId: $departmentId, post: $post, title: $title }) {
      id
    }
  }
`
export type CreateDiscussionMutationFn = ApolloReactCommon.MutationFunction<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>

/**
 * __useCreateDiscussionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionMutation, { data, loading, error }] = useCreateDiscussionMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      post: // value for 'post'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateDiscussionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDiscussionMutation, CreateDiscussionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateDiscussionMutation, CreateDiscussionMutationVariables>(
    CreateDiscussionDocument,
    options
  )
}
export type CreateDiscussionMutationHookResult = ReturnType<typeof useCreateDiscussionMutation>
export type CreateDiscussionMutationResult = ApolloReactCommon.MutationResult<CreateDiscussionMutation>
export type CreateDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>
export const DeleteDiscussionDocument = gql`
  mutation deleteDiscussion($id: Int!) {
    deleteDiscussions(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`
export type DeleteDiscussionMutationFn = ApolloReactCommon.MutationFunction<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>

/**
 * __useDeleteDiscussionMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionMutation, { data, loading, error }] = useDeleteDiscussionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscussionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDiscussionMutation, DeleteDiscussionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteDiscussionMutation, DeleteDiscussionMutationVariables>(
    DeleteDiscussionDocument,
    options
  )
}
export type DeleteDiscussionMutationHookResult = ReturnType<typeof useDeleteDiscussionMutation>
export type DeleteDiscussionMutationResult = ApolloReactCommon.MutationResult<DeleteDiscussionMutation>
export type DeleteDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>
export const UpdateDiscussionDocument = gql`
  mutation updateDiscussion($id: Int!, $post: String!, $title: String!) {
    updateDiscussionById(pk_columns: { id: $id }, _set: { post: $post, title: $title }) {
      id
    }
  }
`
export type UpdateDiscussionMutationFn = ApolloReactCommon.MutationFunction<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>

/**
 * __useUpdateDiscussionMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionMutation, { data, loading, error }] = useUpdateDiscussionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      post: // value for 'post'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateDiscussionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscussionMutation, UpdateDiscussionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateDiscussionMutation, UpdateDiscussionMutationVariables>(
    UpdateDiscussionDocument,
    options
  )
}
export type UpdateDiscussionMutationHookResult = ReturnType<typeof useUpdateDiscussionMutation>
export type UpdateDiscussionMutationResult = ApolloReactCommon.MutationResult<UpdateDiscussionMutation>
export type UpdateDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>
export const DeleteCommentDocument = gql`
  mutation deleteComment($id: Int!) {
    deleteCommentById(id: $id) {
      id
    }
  }
`
export type DeleteCommentMutationFn = ApolloReactCommon.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(
    DeleteCommentDocument,
    options
  )
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>
export type DeleteCommentMutationResult = ApolloReactCommon.MutationResult<DeleteCommentMutation>
export type DeleteCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>
export const SendResourceEmailDocument = gql`
  mutation sendResourceEmail($resourceId: Int!, $to: String!) {
    sendResourceEmail(config: { resourceId: $resourceId, to: $to }) {
      success
      id
    }
  }
`
export type SendResourceEmailMutationFn = ApolloReactCommon.MutationFunction<
  SendResourceEmailMutation,
  SendResourceEmailMutationVariables
>

/**
 * __useSendResourceEmailMutation__
 *
 * To run a mutation, you first call `useSendResourceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResourceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResourceEmailMutation, { data, loading, error }] = useSendResourceEmailMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSendResourceEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendResourceEmailMutation, SendResourceEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<SendResourceEmailMutation, SendResourceEmailMutationVariables>(
    SendResourceEmailDocument,
    options
  )
}
export type SendResourceEmailMutationHookResult = ReturnType<typeof useSendResourceEmailMutation>
export type SendResourceEmailMutationResult = ApolloReactCommon.MutationResult<SendResourceEmailMutation>
export type SendResourceEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendResourceEmailMutation,
  SendResourceEmailMutationVariables
>
export const SendNominationEmailDocument = gql`
  mutation sendNominationEmail(
    $name: String!
    $category: String!
    $to: String!
    $mgr_to: String
    $html: String!
    $to_name: String!
  ) {
    sendNominationEmail(
      config: { name: $name, category: $category, to: $to, mgr_to: $mgr_to, html: $html, to_name: $to_name }
    ) {
      success
      id
    }
  }
`
export type SendNominationEmailMutationFn = ApolloReactCommon.MutationFunction<
  SendNominationEmailMutation,
  SendNominationEmailMutationVariables
>

/**
 * __useSendNominationEmailMutation__
 *
 * To run a mutation, you first call `useSendNominationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNominationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNominationEmailMutation, { data, loading, error }] = useSendNominationEmailMutation({
 *   variables: {
 *      name: // value for 'name'
 *      category: // value for 'category'
 *      to: // value for 'to'
 *      mgr_to: // value for 'mgr_to'
 *      html: // value for 'html'
 *      to_name: // value for 'to_name'
 *   },
 * });
 */
export function useSendNominationEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendNominationEmailMutation, SendNominationEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<SendNominationEmailMutation, SendNominationEmailMutationVariables>(
    SendNominationEmailDocument,
    options
  )
}
export type SendNominationEmailMutationHookResult = ReturnType<typeof useSendNominationEmailMutation>
export type SendNominationEmailMutationResult = ApolloReactCommon.MutationResult<SendNominationEmailMutation>
export type SendNominationEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendNominationEmailMutation,
  SendNominationEmailMutationVariables
>
export const AddFavoriteDiscussionDocument = gql`
  mutation addFavoriteDiscussion($discussionId: Int) {
    insertFavoriteDiscussion(object: { discussionId: $discussionId }) {
      id
    }
  }
`
export type AddFavoriteDiscussionMutationFn = ApolloReactCommon.MutationFunction<
  AddFavoriteDiscussionMutation,
  AddFavoriteDiscussionMutationVariables
>

/**
 * __useAddFavoriteDiscussionMutation__
 *
 * To run a mutation, you first call `useAddFavoriteDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteDiscussionMutation, { data, loading, error }] = useAddFavoriteDiscussionMutation({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *   },
 * });
 */
export function useAddFavoriteDiscussionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddFavoriteDiscussionMutation,
    AddFavoriteDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddFavoriteDiscussionMutation, AddFavoriteDiscussionMutationVariables>(
    AddFavoriteDiscussionDocument,
    options
  )
}
export type AddFavoriteDiscussionMutationHookResult = ReturnType<typeof useAddFavoriteDiscussionMutation>
export type AddFavoriteDiscussionMutationResult = ApolloReactCommon.MutationResult<AddFavoriteDiscussionMutation>
export type AddFavoriteDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddFavoriteDiscussionMutation,
  AddFavoriteDiscussionMutationVariables
>
export const RemoveFavoriteDiscussionDocument = gql`
  mutation removeFavoriteDiscussion($discussionId: Int) {
    deleteFavoriteDiscussions(where: { discussionId: { _eq: $discussionId } }) {
      affected_rows
    }
  }
`
export type RemoveFavoriteDiscussionMutationFn = ApolloReactCommon.MutationFunction<
  RemoveFavoriteDiscussionMutation,
  RemoveFavoriteDiscussionMutationVariables
>

/**
 * __useRemoveFavoriteDiscussionMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteDiscussionMutation, { data, loading, error }] = useRemoveFavoriteDiscussionMutation({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *   },
 * });
 */
export function useRemoveFavoriteDiscussionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveFavoriteDiscussionMutation,
    RemoveFavoriteDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveFavoriteDiscussionMutation, RemoveFavoriteDiscussionMutationVariables>(
    RemoveFavoriteDiscussionDocument,
    options
  )
}
export type RemoveFavoriteDiscussionMutationHookResult = ReturnType<typeof useRemoveFavoriteDiscussionMutation>
export type RemoveFavoriteDiscussionMutationResult = ApolloReactCommon.MutationResult<RemoveFavoriteDiscussionMutation>
export type RemoveFavoriteDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveFavoriteDiscussionMutation,
  RemoveFavoriteDiscussionMutationVariables
>
export const AddFavoriteResourceDocument = gql`
  mutation addFavoriteResource($resourceId: Int) {
    insertFavoriteResource(object: { resourceId: $resourceId }) {
      id
    }
  }
`
export type AddFavoriteResourceMutationFn = ApolloReactCommon.MutationFunction<
  AddFavoriteResourceMutation,
  AddFavoriteResourceMutationVariables
>

/**
 * __useAddFavoriteResourceMutation__
 *
 * To run a mutation, you first call `useAddFavoriteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteResourceMutation, { data, loading, error }] = useAddFavoriteResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAddFavoriteResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddFavoriteResourceMutation, AddFavoriteResourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddFavoriteResourceMutation, AddFavoriteResourceMutationVariables>(
    AddFavoriteResourceDocument,
    options
  )
}
export type AddFavoriteResourceMutationHookResult = ReturnType<typeof useAddFavoriteResourceMutation>
export type AddFavoriteResourceMutationResult = ApolloReactCommon.MutationResult<AddFavoriteResourceMutation>
export type AddFavoriteResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddFavoriteResourceMutation,
  AddFavoriteResourceMutationVariables
>
export const RemoveFavoriteResourceDocument = gql`
  mutation removeFavoriteResource($resourceId: Int) {
    deleteFavoriteResources(where: { resourceId: { _eq: $resourceId } }) {
      affected_rows
    }
  }
`
export type RemoveFavoriteResourceMutationFn = ApolloReactCommon.MutationFunction<
  RemoveFavoriteResourceMutation,
  RemoveFavoriteResourceMutationVariables
>

/**
 * __useRemoveFavoriteResourceMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteResourceMutation, { data, loading, error }] = useRemoveFavoriteResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useRemoveFavoriteResourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveFavoriteResourceMutation,
    RemoveFavoriteResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveFavoriteResourceMutation, RemoveFavoriteResourceMutationVariables>(
    RemoveFavoriteResourceDocument,
    options
  )
}
export type RemoveFavoriteResourceMutationHookResult = ReturnType<typeof useRemoveFavoriteResourceMutation>
export type RemoveFavoriteResourceMutationResult = ApolloReactCommon.MutationResult<RemoveFavoriteResourceMutation>
export type RemoveFavoriteResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveFavoriteResourceMutation,
  RemoveFavoriteResourceMutationVariables
>
export const GetPresignedUploadDocument = gql`
  mutation getPresignedUpload($isPublic: Boolean!, $fileName: String!, $type: String!) {
    getPresignedUpload(config: { fileName: $fileName, isPublic: $isPublic, type: $type }) {
      fields
      url
      presignedGetUrl
    }
  }
`
export type GetPresignedUploadMutationFn = ApolloReactCommon.MutationFunction<
  GetPresignedUploadMutation,
  GetPresignedUploadMutationVariables
>

/**
 * __useGetPresignedUploadMutation__
 *
 * To run a mutation, you first call `useGetPresignedUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPresignedUploadMutation, { data, loading, error }] = useGetPresignedUploadMutation({
 *   variables: {
 *      isPublic: // value for 'isPublic'
 *      fileName: // value for 'fileName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPresignedUploadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<GetPresignedUploadMutation, GetPresignedUploadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<GetPresignedUploadMutation, GetPresignedUploadMutationVariables>(
    GetPresignedUploadDocument,
    options
  )
}
export type GetPresignedUploadMutationHookResult = ReturnType<typeof useGetPresignedUploadMutation>
export type GetPresignedUploadMutationResult = ApolloReactCommon.MutationResult<GetPresignedUploadMutation>
export type GetPresignedUploadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  GetPresignedUploadMutation,
  GetPresignedUploadMutationVariables
>
export const GetNominationsDocument = gql`
  query getNominations {
    v2_nominations(where: { is_deleted: { _eq: false } }, order_by: { created_at: desc }) {
      category
      created_at
      description
      from_user_id
      id
      project
      thumbsup {
        user_id
      }
      to_name
      to_user_id
      comments(order_by: { createdAt: asc }) {
        ...commentDetails
      }
    }
  }
  ${CommentDetailsFragmentDoc}
`

/**
 * __useGetNominationsQuery__
 *
 * To run a query within a React component, call `useGetNominationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNominationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNominationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNominationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetNominationsQuery, GetNominationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetNominationsQuery, GetNominationsQueryVariables>(GetNominationsDocument, options)
}
export function useGetNominationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNominationsQuery, GetNominationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetNominationsQuery, GetNominationsQueryVariables>(
    GetNominationsDocument,
    options
  )
}
// @ts-ignore
export function useGetNominationsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNominationsQuery, GetNominationsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetNominationsQuery, GetNominationsQueryVariables>
export function useGetNominationsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetNominationsQuery, GetNominationsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetNominationsQuery | undefined, GetNominationsQueryVariables>
export function useGetNominationsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetNominationsQuery, GetNominationsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<GetNominationsQuery, GetNominationsQueryVariables>(
    GetNominationsDocument,
    options
  )
}
export type GetNominationsQueryHookResult = ReturnType<typeof useGetNominationsQuery>
export type GetNominationsLazyQueryHookResult = ReturnType<typeof useGetNominationsLazyQuery>
export type GetNominationsSuspenseQueryHookResult = ReturnType<typeof useGetNominationsSuspenseQuery>
export type GetNominationsQueryResult = ApolloReactCommon.QueryResult<GetNominationsQuery, GetNominationsQueryVariables>
export const AddNominationDocument = gql`
  mutation addNomination(
    $category: String
    $description: String
    $from_user_id: Int
    $project: String
    $to_name: String
    $to_user_id: Int
  ) {
    insert_v2_nominations_one(
      object: {
        category: $category
        description: $description
        from_user_id: $from_user_id
        project: $project
        to_name: $to_name
        to_user_id: $to_user_id
      }
    ) {
      id
    }
  }
`
export type AddNominationMutationFn = ApolloReactCommon.MutationFunction<
  AddNominationMutation,
  AddNominationMutationVariables
>

/**
 * __useAddNominationMutation__
 *
 * To run a mutation, you first call `useAddNominationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNominationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNominationMutation, { data, loading, error }] = useAddNominationMutation({
 *   variables: {
 *      category: // value for 'category'
 *      description: // value for 'description'
 *      from_user_id: // value for 'from_user_id'
 *      project: // value for 'project'
 *      to_name: // value for 'to_name'
 *      to_user_id: // value for 'to_user_id'
 *   },
 * });
 */
export function useAddNominationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddNominationMutation, AddNominationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddNominationMutation, AddNominationMutationVariables>(
    AddNominationDocument,
    options
  )
}
export type AddNominationMutationHookResult = ReturnType<typeof useAddNominationMutation>
export type AddNominationMutationResult = ApolloReactCommon.MutationResult<AddNominationMutation>
export type AddNominationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddNominationMutation,
  AddNominationMutationVariables
>
export const RemoveNominationDocument = gql`
  mutation removeNomination($_eq: Int) {
    update_v2_nominations(where: { id: { _eq: $_eq } }, _set: { is_deleted: true }) {
      affected_rows
    }
  }
`
export type RemoveNominationMutationFn = ApolloReactCommon.MutationFunction<
  RemoveNominationMutation,
  RemoveNominationMutationVariables
>

/**
 * __useRemoveNominationMutation__
 *
 * To run a mutation, you first call `useRemoveNominationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNominationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNominationMutation, { data, loading, error }] = useRemoveNominationMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useRemoveNominationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveNominationMutation, RemoveNominationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveNominationMutation, RemoveNominationMutationVariables>(
    RemoveNominationDocument,
    options
  )
}
export type RemoveNominationMutationHookResult = ReturnType<typeof useRemoveNominationMutation>
export type RemoveNominationMutationResult = ApolloReactCommon.MutationResult<RemoveNominationMutation>
export type RemoveNominationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveNominationMutation,
  RemoveNominationMutationVariables
>
export const AddNominationThumbsUpDocument = gql`
  mutation addNominationThumbsUp($nomination_id: Int, $user_id: Int) {
    insert_v2_nomination_thumbsup_one(object: { nomination_id: $nomination_id, user_id: $user_id }) {
      nomination_id
      user_id
    }
  }
`
export type AddNominationThumbsUpMutationFn = ApolloReactCommon.MutationFunction<
  AddNominationThumbsUpMutation,
  AddNominationThumbsUpMutationVariables
>

/**
 * __useAddNominationThumbsUpMutation__
 *
 * To run a mutation, you first call `useAddNominationThumbsUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNominationThumbsUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNominationThumbsUpMutation, { data, loading, error }] = useAddNominationThumbsUpMutation({
 *   variables: {
 *      nomination_id: // value for 'nomination_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAddNominationThumbsUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddNominationThumbsUpMutation,
    AddNominationThumbsUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddNominationThumbsUpMutation, AddNominationThumbsUpMutationVariables>(
    AddNominationThumbsUpDocument,
    options
  )
}
export type AddNominationThumbsUpMutationHookResult = ReturnType<typeof useAddNominationThumbsUpMutation>
export type AddNominationThumbsUpMutationResult = ApolloReactCommon.MutationResult<AddNominationThumbsUpMutation>
export type AddNominationThumbsUpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddNominationThumbsUpMutation,
  AddNominationThumbsUpMutationVariables
>
export const RemoveNominationThumbsUpDocument = gql`
  mutation removeNominationThumbsUp($nomId: Int = 10, $userId: Int = 10) {
    delete_v2_nomination_thumbsup(where: { nomination_id: { _eq: $nomId }, user_id: { _eq: $userId } }) {
      affected_rows
    }
  }
`
export type RemoveNominationThumbsUpMutationFn = ApolloReactCommon.MutationFunction<
  RemoveNominationThumbsUpMutation,
  RemoveNominationThumbsUpMutationVariables
>

/**
 * __useRemoveNominationThumbsUpMutation__
 *
 * To run a mutation, you first call `useRemoveNominationThumbsUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNominationThumbsUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNominationThumbsUpMutation, { data, loading, error }] = useRemoveNominationThumbsUpMutation({
 *   variables: {
 *      nomId: // value for 'nomId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveNominationThumbsUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveNominationThumbsUpMutation,
    RemoveNominationThumbsUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveNominationThumbsUpMutation, RemoveNominationThumbsUpMutationVariables>(
    RemoveNominationThumbsUpDocument,
    options
  )
}
export type RemoveNominationThumbsUpMutationHookResult = ReturnType<typeof useRemoveNominationThumbsUpMutation>
export type RemoveNominationThumbsUpMutationResult = ApolloReactCommon.MutationResult<RemoveNominationThumbsUpMutation>
export type RemoveNominationThumbsUpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveNominationThumbsUpMutation,
  RemoveNominationThumbsUpMutationVariables
>
export const AddQuicklinkDocument = gql`
  mutation addQuicklink($departmentId: Int!, $description: String = "", $title: String!, $url: String!) {
    insertDepartmentQuicklink(
      object: { departmentId: $departmentId, description: $description, title: $title, url: $url }
    ) {
      id
    }
  }
`
export type AddQuicklinkMutationFn = ApolloReactCommon.MutationFunction<
  AddQuicklinkMutation,
  AddQuicklinkMutationVariables
>

/**
 * __useAddQuicklinkMutation__
 *
 * To run a mutation, you first call `useAddQuicklinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuicklinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuicklinkMutation, { data, loading, error }] = useAddQuicklinkMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      description: // value for 'description'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useAddQuicklinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddQuicklinkMutation, AddQuicklinkMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddQuicklinkMutation, AddQuicklinkMutationVariables>(
    AddQuicklinkDocument,
    options
  )
}
export type AddQuicklinkMutationHookResult = ReturnType<typeof useAddQuicklinkMutation>
export type AddQuicklinkMutationResult = ApolloReactCommon.MutationResult<AddQuicklinkMutation>
export type AddQuicklinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddQuicklinkMutation,
  AddQuicklinkMutationVariables
>
export const UpdateQuicklinkDocument = gql`
  mutation updateQuicklink($id: Int!, $description: String!, $title: String!, $url: String!) {
    updateDepartmentQuicklinkById(
      pk_columns: { id: $id }
      _set: { description: $description, title: $title, url: $url }
    ) {
      id
    }
  }
`
export type UpdateQuicklinkMutationFn = ApolloReactCommon.MutationFunction<
  UpdateQuicklinkMutation,
  UpdateQuicklinkMutationVariables
>

/**
 * __useUpdateQuicklinkMutation__
 *
 * To run a mutation, you first call `useUpdateQuicklinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuicklinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuicklinkMutation, { data, loading, error }] = useUpdateQuicklinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateQuicklinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuicklinkMutation, UpdateQuicklinkMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateQuicklinkMutation, UpdateQuicklinkMutationVariables>(
    UpdateQuicklinkDocument,
    options
  )
}
export type UpdateQuicklinkMutationHookResult = ReturnType<typeof useUpdateQuicklinkMutation>
export type UpdateQuicklinkMutationResult = ApolloReactCommon.MutationResult<UpdateQuicklinkMutation>
export type UpdateQuicklinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateQuicklinkMutation,
  UpdateQuicklinkMutationVariables
>
export const DeleteQuicklinkDocument = gql`
  mutation deleteQuicklink($id: Int!) {
    deleteDepartmentQuicklinkById(id: $id) {
      id
    }
  }
`
export type DeleteQuicklinkMutationFn = ApolloReactCommon.MutationFunction<
  DeleteQuicklinkMutation,
  DeleteQuicklinkMutationVariables
>

/**
 * __useDeleteQuicklinkMutation__
 *
 * To run a mutation, you first call `useDeleteQuicklinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuicklinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuicklinkMutation, { data, loading, error }] = useDeleteQuicklinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuicklinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuicklinkMutation, DeleteQuicklinkMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteQuicklinkMutation, DeleteQuicklinkMutationVariables>(
    DeleteQuicklinkDocument,
    options
  )
}
export type DeleteQuicklinkMutationHookResult = ReturnType<typeof useDeleteQuicklinkMutation>
export type DeleteQuicklinkMutationResult = ApolloReactCommon.MutationResult<DeleteQuicklinkMutation>
export type DeleteQuicklinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteQuicklinkMutation,
  DeleteQuicklinkMutationVariables
>
export const SendCrisisNotificationDocument = gql`
  mutation sendCrisisNotification($title: String!, $text: String!) {
    sendCrisisNotification(title: $title, text: $text) {
      success
      message
      campaignId
    }
  }
`
export type SendCrisisNotificationMutationFn = ApolloReactCommon.MutationFunction<
  SendCrisisNotificationMutation,
  SendCrisisNotificationMutationVariables
>

/**
 * __useSendCrisisNotificationMutation__
 *
 * To run a mutation, you first call `useSendCrisisNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCrisisNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCrisisNotificationMutation, { data, loading, error }] = useSendCrisisNotificationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendCrisisNotificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendCrisisNotificationMutation,
    SendCrisisNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<SendCrisisNotificationMutation, SendCrisisNotificationMutationVariables>(
    SendCrisisNotificationDocument,
    options
  )
}
export type SendCrisisNotificationMutationHookResult = ReturnType<typeof useSendCrisisNotificationMutation>
export type SendCrisisNotificationMutationResult = ApolloReactCommon.MutationResult<SendCrisisNotificationMutation>
export type SendCrisisNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendCrisisNotificationMutation,
  SendCrisisNotificationMutationVariables
>
export const UpdateCommentDocument = gql`
  mutation updateComment($id: Int!, $comment: String!) {
    updateCommentById(pk_columns: { id: $id }, _set: { comment: $comment }) {
      id
    }
  }
`
export type UpdateCommentMutationFn = ApolloReactCommon.MutationFunction<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(
    UpdateCommentDocument,
    options
  )
}
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>
export type UpdateCommentMutationResult = ApolloReactCommon.MutationResult<UpdateCommentMutation>
export type UpdateCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>
export const UpdateGalleryOrderDocument = gql`
  mutation updateGalleryOrder($children: jsonb = []) {
    updatePageBySlug(pk_columns: { slug: "gallery" }, _set: { children: $children }) {
      id
    }
  }
`
export type UpdateGalleryOrderMutationFn = ApolloReactCommon.MutationFunction<
  UpdateGalleryOrderMutation,
  UpdateGalleryOrderMutationVariables
>

/**
 * __useUpdateGalleryOrderMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryOrderMutation, { data, loading, error }] = useUpdateGalleryOrderMutation({
 *   variables: {
 *      children: // value for 'children'
 *   },
 * });
 */
export function useUpdateGalleryOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGalleryOrderMutation, UpdateGalleryOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateGalleryOrderMutation, UpdateGalleryOrderMutationVariables>(
    UpdateGalleryOrderDocument,
    options
  )
}
export type UpdateGalleryOrderMutationHookResult = ReturnType<typeof useUpdateGalleryOrderMutation>
export type UpdateGalleryOrderMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryOrderMutation>
export type UpdateGalleryOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateGalleryOrderMutation,
  UpdateGalleryOrderMutationVariables
>
export const UpdateGalleryPhotoOrderDocument = gql`
  mutation updateGalleryPhotoOrder($id: Int!, $children: jsonb = []) {
    updateGalleryById(pk_columns: { id: $id }, _set: { children: $children }) {
      id
    }
  }
`
export type UpdateGalleryPhotoOrderMutationFn = ApolloReactCommon.MutationFunction<
  UpdateGalleryPhotoOrderMutation,
  UpdateGalleryPhotoOrderMutationVariables
>

/**
 * __useUpdateGalleryPhotoOrderMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryPhotoOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryPhotoOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryPhotoOrderMutation, { data, loading, error }] = useUpdateGalleryPhotoOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      children: // value for 'children'
 *   },
 * });
 */
export function useUpdateGalleryPhotoOrderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGalleryPhotoOrderMutation,
    UpdateGalleryPhotoOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateGalleryPhotoOrderMutation, UpdateGalleryPhotoOrderMutationVariables>(
    UpdateGalleryPhotoOrderDocument,
    options
  )
}
export type UpdateGalleryPhotoOrderMutationHookResult = ReturnType<typeof useUpdateGalleryPhotoOrderMutation>
export type UpdateGalleryPhotoOrderMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryPhotoOrderMutation>
export type UpdateGalleryPhotoOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateGalleryPhotoOrderMutation,
  UpdateGalleryPhotoOrderMutationVariables
>
export const DisableGalleryDocument = gql`
  mutation disableGallery($id: Int!) {
    updateGalleryById(pk_columns: { id: $id }, _set: { active: false }) {
      id
    }
  }
`
export type DisableGalleryMutationFn = ApolloReactCommon.MutationFunction<
  DisableGalleryMutation,
  DisableGalleryMutationVariables
>

/**
 * __useDisableGalleryMutation__
 *
 * To run a mutation, you first call `useDisableGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableGalleryMutation, { data, loading, error }] = useDisableGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableGalleryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DisableGalleryMutation, DisableGalleryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DisableGalleryMutation, DisableGalleryMutationVariables>(
    DisableGalleryDocument,
    options
  )
}
export type DisableGalleryMutationHookResult = ReturnType<typeof useDisableGalleryMutation>
export type DisableGalleryMutationResult = ApolloReactCommon.MutationResult<DisableGalleryMutation>
export type DisableGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DisableGalleryMutation,
  DisableGalleryMutationVariables
>
export const UpdateGalleryDocument = gql`
  mutation updateGallery(
    $id: Int!
    $date: timestamptz!
    $title: String!
    $videoUploadId: Int
    $videoThumbnailUploadId: Int
  ) {
    updateGalleryById(
      pk_columns: { id: $id }
      _set: {
        title: $title
        date: $date
        videoUploadId: $videoUploadId
        videoThumbnailUploadId: $videoThumbnailUploadId
      }
    ) {
      id
      title
      date
    }
  }
`
export type UpdateGalleryMutationFn = ApolloReactCommon.MutationFunction<
  UpdateGalleryMutation,
  UpdateGalleryMutationVariables
>

/**
 * __useUpdateGalleryMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryMutation, { data, loading, error }] = useUpdateGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      title: // value for 'title'
 *      videoUploadId: // value for 'videoUploadId'
 *      videoThumbnailUploadId: // value for 'videoThumbnailUploadId'
 *   },
 * });
 */
export function useUpdateGalleryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateGalleryMutation, UpdateGalleryMutationVariables>(
    UpdateGalleryDocument,
    options
  )
}
export type UpdateGalleryMutationHookResult = ReturnType<typeof useUpdateGalleryMutation>
export type UpdateGalleryMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryMutation>
export type UpdateGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateGalleryMutation,
  UpdateGalleryMutationVariables
>
export const CreateGalleryDocument = gql`
  mutation createGallery(
    $date: timestamptz!
    $title: String!
    $photos: galleryPhotos_arr_rel_insert_input!
    $videoUploadId: Int
    $videoThumbnailUploadId: Int
  ) {
    insertGallery(
      object: {
        active: true
        date: $date
        title: $title
        photos: $photos
        videoUploadId: $videoUploadId
        videoThumbnailUploadId: $videoThumbnailUploadId
      }
    ) {
      id
    }
  }
`
export type CreateGalleryMutationFn = ApolloReactCommon.MutationFunction<
  CreateGalleryMutation,
  CreateGalleryMutationVariables
>

/**
 * __useCreateGalleryMutation__
 *
 * To run a mutation, you first call `useCreateGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGalleryMutation, { data, loading, error }] = useCreateGalleryMutation({
 *   variables: {
 *      date: // value for 'date'
 *      title: // value for 'title'
 *      photos: // value for 'photos'
 *      videoUploadId: // value for 'videoUploadId'
 *      videoThumbnailUploadId: // value for 'videoThumbnailUploadId'
 *   },
 * });
 */
export function useCreateGalleryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGalleryMutation, CreateGalleryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateGalleryMutation, CreateGalleryMutationVariables>(
    CreateGalleryDocument,
    options
  )
}
export type CreateGalleryMutationHookResult = ReturnType<typeof useCreateGalleryMutation>
export type CreateGalleryMutationResult = ApolloReactCommon.MutationResult<CreateGalleryMutation>
export type CreateGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateGalleryMutation,
  CreateGalleryMutationVariables
>
export const RemoveGalleryPhotoDocument = gql`
  mutation removeGalleryPhoto($id: Int!) {
    deleteGalleryPhotoById(id: $id) {
      id
    }
  }
`
export type RemoveGalleryPhotoMutationFn = ApolloReactCommon.MutationFunction<
  RemoveGalleryPhotoMutation,
  RemoveGalleryPhotoMutationVariables
>

/**
 * __useRemoveGalleryPhotoMutation__
 *
 * To run a mutation, you first call `useRemoveGalleryPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGalleryPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGalleryPhotoMutation, { data, loading, error }] = useRemoveGalleryPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGalleryPhotoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGalleryPhotoMutation, RemoveGalleryPhotoMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveGalleryPhotoMutation, RemoveGalleryPhotoMutationVariables>(
    RemoveGalleryPhotoDocument,
    options
  )
}
export type RemoveGalleryPhotoMutationHookResult = ReturnType<typeof useRemoveGalleryPhotoMutation>
export type RemoveGalleryPhotoMutationResult = ApolloReactCommon.MutationResult<RemoveGalleryPhotoMutation>
export type RemoveGalleryPhotoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RemoveGalleryPhotoMutation,
  RemoveGalleryPhotoMutationVariables
>
export const AddGalleryPhotosDocument = gql`
  mutation addGalleryPhotos($objects: [galleryPhotos_insert_input!]!) {
    insertGalleryPhotos(objects: $objects) {
      affected_rows
    }
  }
`
export type AddGalleryPhotosMutationFn = ApolloReactCommon.MutationFunction<
  AddGalleryPhotosMutation,
  AddGalleryPhotosMutationVariables
>

/**
 * __useAddGalleryPhotosMutation__
 *
 * To run a mutation, you first call `useAddGalleryPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGalleryPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGalleryPhotosMutation, { data, loading, error }] = useAddGalleryPhotosMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddGalleryPhotosMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddGalleryPhotosMutation, AddGalleryPhotosMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddGalleryPhotosMutation, AddGalleryPhotosMutationVariables>(
    AddGalleryPhotosDocument,
    options
  )
}
export type AddGalleryPhotosMutationHookResult = ReturnType<typeof useAddGalleryPhotosMutation>
export type AddGalleryPhotosMutationResult = ApolloReactCommon.MutationResult<AddGalleryPhotosMutation>
export type AddGalleryPhotosMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AddGalleryPhotosMutation,
  AddGalleryPhotosMutationVariables
>
export const BulletinsDocument = gql`
  query bulletins {
    bulletins(order_by: { createdAt: desc }, where: { global: { _eq: true } }, limit: 10) {
      ...bulletinDetails
    }
  }
  ${BulletinDetailsFragmentDoc}
`

/**
 * __useBulletinsQuery__
 *
 * To run a query within a React component, call `useBulletinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulletinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulletinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulletinsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<BulletinsQuery, BulletinsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<BulletinsQuery, BulletinsQueryVariables>(BulletinsDocument, options)
}
export function useBulletinsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulletinsQuery, BulletinsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<BulletinsQuery, BulletinsQueryVariables>(BulletinsDocument, options)
}
// @ts-ignore
export function useBulletinsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BulletinsQuery, BulletinsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<BulletinsQuery, BulletinsQueryVariables>
export function useBulletinsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BulletinsQuery, BulletinsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<BulletinsQuery | undefined, BulletinsQueryVariables>
export function useBulletinsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<BulletinsQuery, BulletinsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<BulletinsQuery, BulletinsQueryVariables>(BulletinsDocument, options)
}
export type BulletinsQueryHookResult = ReturnType<typeof useBulletinsQuery>
export type BulletinsLazyQueryHookResult = ReturnType<typeof useBulletinsLazyQuery>
export type BulletinsSuspenseQueryHookResult = ReturnType<typeof useBulletinsSuspenseQuery>
export type BulletinsQueryResult = ApolloReactCommon.QueryResult<BulletinsQuery, BulletinsQueryVariables>
export const SingleBulletinDocument = gql`
  query singleBulletin($id: Int!) {
    bulletins(where: { id: { _eq: $id } }) {
      ...bulletinDetails
    }
  }
  ${BulletinDetailsFragmentDoc}
`

/**
 * __useSingleBulletinQuery__
 *
 * To run a query within a React component, call `useSingleBulletinQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleBulletinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleBulletinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleBulletinQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SingleBulletinQuery, SingleBulletinQueryVariables> &
    ({ variables: SingleBulletinQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SingleBulletinQuery, SingleBulletinQueryVariables>(SingleBulletinDocument, options)
}
export function useSingleBulletinLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleBulletinQuery, SingleBulletinQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SingleBulletinQuery, SingleBulletinQueryVariables>(
    SingleBulletinDocument,
    options
  )
}
// @ts-ignore
export function useSingleBulletinSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleBulletinQuery, SingleBulletinQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SingleBulletinQuery, SingleBulletinQueryVariables>
export function useSingleBulletinSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SingleBulletinQuery, SingleBulletinQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SingleBulletinQuery | undefined, SingleBulletinQueryVariables>
export function useSingleBulletinSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SingleBulletinQuery, SingleBulletinQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<SingleBulletinQuery, SingleBulletinQueryVariables>(
    SingleBulletinDocument,
    options
  )
}
export type SingleBulletinQueryHookResult = ReturnType<typeof useSingleBulletinQuery>
export type SingleBulletinLazyQueryHookResult = ReturnType<typeof useSingleBulletinLazyQuery>
export type SingleBulletinSuspenseQueryHookResult = ReturnType<typeof useSingleBulletinSuspenseQuery>
export type SingleBulletinQueryResult = ApolloReactCommon.QueryResult<SingleBulletinQuery, SingleBulletinQueryVariables>
export const CameraEmbedsGetActiveDocument = gql`
  query cameraEmbedsGetActive {
    cameraEmbeds(where: { active: { _eq: true } }, order_by: { createdAt: asc }) {
      id
      title
      source
      stillUrl
      active
      jobsiteId
    }
  }
`

/**
 * __useCameraEmbedsGetActiveQuery__
 *
 * To run a query within a React component, call `useCameraEmbedsGetActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraEmbedsGetActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCameraEmbedsGetActiveQuery({
 *   variables: {
 *   },
 * });
 */
export function useCameraEmbedsGetActiveQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>(
    CameraEmbedsGetActiveDocument,
    options
  )
}
export function useCameraEmbedsGetActiveLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>(
    CameraEmbedsGetActiveDocument,
    options
  )
}
// @ts-ignore
export function useCameraEmbedsGetActiveSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CameraEmbedsGetActiveQuery,
    CameraEmbedsGetActiveQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>
export function useCameraEmbedsGetActiveSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CameraEmbedsGetActiveQuery | undefined, CameraEmbedsGetActiveQueryVariables>
export function useCameraEmbedsGetActiveSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<CameraEmbedsGetActiveQuery, CameraEmbedsGetActiveQueryVariables>(
    CameraEmbedsGetActiveDocument,
    options
  )
}
export type CameraEmbedsGetActiveQueryHookResult = ReturnType<typeof useCameraEmbedsGetActiveQuery>
export type CameraEmbedsGetActiveLazyQueryHookResult = ReturnType<typeof useCameraEmbedsGetActiveLazyQuery>
export type CameraEmbedsGetActiveSuspenseQueryHookResult = ReturnType<typeof useCameraEmbedsGetActiveSuspenseQuery>
export type CameraEmbedsGetActiveQueryResult = ApolloReactCommon.QueryResult<
  CameraEmbedsGetActiveQuery,
  CameraEmbedsGetActiveQueryVariables
>
export const CompanyDirectoryUsersDocument = gql`
  query companyDirectoryUsers {
    users(
      where: { _not: { username: { _in: ["roi", "mattw", "mcheckwood", "estevans"] } } }
      order_by: { lastName: asc }
    ) {
      ...userDetails
    }
  }
  ${UserDetailsFragmentDoc}
`

/**
 * __useCompanyDirectoryUsersQuery__
 *
 * To run a query within a React component, call `useCompanyDirectoryUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDirectoryUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDirectoryUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyDirectoryUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>(
    CompanyDirectoryUsersDocument,
    options
  )
}
export function useCompanyDirectoryUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>(
    CompanyDirectoryUsersDocument,
    options
  )
}
// @ts-ignore
export function useCompanyDirectoryUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CompanyDirectoryUsersQuery,
    CompanyDirectoryUsersQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>
export function useCompanyDirectoryUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CompanyDirectoryUsersQuery | undefined, CompanyDirectoryUsersQueryVariables>
export function useCompanyDirectoryUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<CompanyDirectoryUsersQuery, CompanyDirectoryUsersQueryVariables>(
    CompanyDirectoryUsersDocument,
    options
  )
}
export type CompanyDirectoryUsersQueryHookResult = ReturnType<typeof useCompanyDirectoryUsersQuery>
export type CompanyDirectoryUsersLazyQueryHookResult = ReturnType<typeof useCompanyDirectoryUsersLazyQuery>
export type CompanyDirectoryUsersSuspenseQueryHookResult = ReturnType<typeof useCompanyDirectoryUsersSuspenseQuery>
export type CompanyDirectoryUsersQueryResult = ApolloReactCommon.QueryResult<
  CompanyDirectoryUsersQuery,
  CompanyDirectoryUsersQueryVariables
>
export const ConfigByKeyDocument = gql`
  query configByKey($key: String!) {
    configByKey(key: $key) {
      value
    }
  }
`

/**
 * __useConfigByKeyQuery__
 *
 * To run a query within a React component, call `useConfigByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useConfigByKeyQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<ConfigByKeyQuery, ConfigByKeyQueryVariables> &
    ({ variables: ConfigByKeyQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ConfigByKeyQuery, ConfigByKeyQueryVariables>(ConfigByKeyDocument, options)
}
export function useConfigByKeyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigByKeyQuery, ConfigByKeyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ConfigByKeyQuery, ConfigByKeyQueryVariables>(ConfigByKeyDocument, options)
}
// @ts-ignore
export function useConfigByKeySuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigByKeyQuery, ConfigByKeyQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ConfigByKeyQuery, ConfigByKeyQueryVariables>
export function useConfigByKeySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ConfigByKeyQuery, ConfigByKeyQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ConfigByKeyQuery | undefined, ConfigByKeyQueryVariables>
export function useConfigByKeySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ConfigByKeyQuery, ConfigByKeyQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<ConfigByKeyQuery, ConfigByKeyQueryVariables>(ConfigByKeyDocument, options)
}
export type ConfigByKeyQueryHookResult = ReturnType<typeof useConfigByKeyQuery>
export type ConfigByKeyLazyQueryHookResult = ReturnType<typeof useConfigByKeyLazyQuery>
export type ConfigByKeySuspenseQueryHookResult = ReturnType<typeof useConfigByKeySuspenseQuery>
export type ConfigByKeyQueryResult = ApolloReactCommon.QueryResult<ConfigByKeyQuery, ConfigByKeyQueryVariables>
export const CurrentUserDocument = gql`
  query currentUser {
    currentUser {
      userId
      user {
        ...userDetails
        ...userFavorites
        roles {
          role
        }
      }
    }
  }
  ${UserDetailsFragmentDoc}
  ${UserFavoritesFragmentDoc}
`

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options)
}
export function useCurrentUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options)
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options)
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>
export type CurrentUserQueryResult = ApolloReactCommon.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>
export const DepartmentDetailsDocument = gql`
  query departmentDetails($departmentId: Int!) {
    department: departmentById(id: $departmentId) {
      ...departmentDetails
    }
  }
  ${DepartmentDetailsFragmentDoc}
`

/**
 * __useDepartmentDetailsQuery__
 *
 * To run a query within a React component, call `useDepartmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentDetailsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useDepartmentDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentDetailsQuery, DepartmentDetailsQueryVariables> &
    ({ variables: DepartmentDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>(
    DepartmentDetailsDocument,
    options
  )
}
export function useDepartmentDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>(
    DepartmentDetailsDocument,
    options
  )
}
// @ts-ignore
export function useDepartmentDetailsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>
export function useDepartmentDetailsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DepartmentDetailsQuery | undefined, DepartmentDetailsQueryVariables>
export function useDepartmentDetailsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>(
    DepartmentDetailsDocument,
    options
  )
}
export type DepartmentDetailsQueryHookResult = ReturnType<typeof useDepartmentDetailsQuery>
export type DepartmentDetailsLazyQueryHookResult = ReturnType<typeof useDepartmentDetailsLazyQuery>
export type DepartmentDetailsSuspenseQueryHookResult = ReturnType<typeof useDepartmentDetailsSuspenseQuery>
export type DepartmentDetailsQueryResult = ApolloReactCommon.QueryResult<
  DepartmentDetailsQuery,
  DepartmentDetailsQueryVariables
>
export const DepartmentEmployeesDocument = gql`
  query departmentEmployees($departmentId: Int!) {
    departmentById(id: $departmentId) {
      employees {
        ...userDetails
      }
    }
  }
  ${UserDetailsFragmentDoc}
`

/**
 * __useDepartmentEmployeesQuery__
 *
 * To run a query within a React component, call `useDepartmentEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentEmployeesQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useDepartmentEmployeesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables> &
    ({ variables: DepartmentEmployeesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>(
    DepartmentEmployeesDocument,
    options
  )
}
export function useDepartmentEmployeesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>(
    DepartmentEmployeesDocument,
    options
  )
}
// @ts-ignore
export function useDepartmentEmployeesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
export function useDepartmentEmployeesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DepartmentEmployeesQuery | undefined, DepartmentEmployeesQueryVariables>
export function useDepartmentEmployeesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>(
    DepartmentEmployeesDocument,
    options
  )
}
export type DepartmentEmployeesQueryHookResult = ReturnType<typeof useDepartmentEmployeesQuery>
export type DepartmentEmployeesLazyQueryHookResult = ReturnType<typeof useDepartmentEmployeesLazyQuery>
export type DepartmentEmployeesSuspenseQueryHookResult = ReturnType<typeof useDepartmentEmployeesSuspenseQuery>
export type DepartmentEmployeesQueryResult = ApolloReactCommon.QueryResult<
  DepartmentEmployeesQuery,
  DepartmentEmployeesQueryVariables
>
export const DiscussionsDocument = gql`
  query discussions {
    discussions(order_by: { createdAt: desc }, where: { departmentId: { _is_null: true } }) {
      ...discussionDetails
    }
  }
  ${DiscussionDetailsFragmentDoc}
`

/**
 * __useDiscussionsQuery__
 *
 * To run a query within a React component, call `useDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscussionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<DiscussionsQuery, DiscussionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<DiscussionsQuery, DiscussionsQueryVariables>(DiscussionsDocument, options)
}
export function useDiscussionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DiscussionsQuery, DiscussionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<DiscussionsQuery, DiscussionsQueryVariables>(DiscussionsDocument, options)
}
// @ts-ignore
export function useDiscussionsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DiscussionsQuery, DiscussionsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DiscussionsQuery, DiscussionsQueryVariables>
export function useDiscussionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DiscussionsQuery, DiscussionsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<DiscussionsQuery | undefined, DiscussionsQueryVariables>
export function useDiscussionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<DiscussionsQuery, DiscussionsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<DiscussionsQuery, DiscussionsQueryVariables>(DiscussionsDocument, options)
}
export type DiscussionsQueryHookResult = ReturnType<typeof useDiscussionsQuery>
export type DiscussionsLazyQueryHookResult = ReturnType<typeof useDiscussionsLazyQuery>
export type DiscussionsSuspenseQueryHookResult = ReturnType<typeof useDiscussionsSuspenseQuery>
export type DiscussionsQueryResult = ApolloReactCommon.QueryResult<DiscussionsQuery, DiscussionsQueryVariables>
export const EventsDocument = gql`
  query events($startFrom: timestamptz!) {
    events(where: { startsAt: { _gte: $startFrom } }, order_by: { startsAt: asc }) {
      ...event
    }
  }
  ${EventFragmentDoc}
`

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      startFrom: // value for 'startFrom'
 *   },
 * });
 */
export function useEventsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<EventsQuery, EventsQueryVariables> &
    ({ variables: EventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options)
}
export function useEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options)
}
// @ts-ignore
export function useEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsQuery, EventsQueryVariables>
export function useEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsQuery | undefined, EventsQueryVariables>
export function useEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options)
}
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>
export type EventsQueryResult = ApolloReactCommon.QueryResult<EventsQuery, EventsQueryVariables>
export const EventsGetByDateDocument = gql`
  query eventsGetByDate($start: timestamptz!, $end: timestamptz!) {
    events(where: { _and: { startsAt: { _lte: $start }, endsAt: { _gte: $end } } }, order_by: { startsAt: asc }) {
      ...event
    }
  }
  ${EventFragmentDoc}
`

/**
 * __useEventsGetByDateQuery__
 *
 * To run a query within a React component, call `useEventsGetByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsGetByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsGetByDateQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useEventsGetByDateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<EventsGetByDateQuery, EventsGetByDateQueryVariables> &
    ({ variables: EventsGetByDateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<EventsGetByDateQuery, EventsGetByDateQueryVariables>(
    EventsGetByDateDocument,
    options
  )
}
export function useEventsGetByDateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventsGetByDateQuery, EventsGetByDateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<EventsGetByDateQuery, EventsGetByDateQueryVariables>(
    EventsGetByDateDocument,
    options
  )
}
// @ts-ignore
export function useEventsGetByDateSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EventsGetByDateQuery, EventsGetByDateQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsGetByDateQuery, EventsGetByDateQueryVariables>
export function useEventsGetByDateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsGetByDateQuery, EventsGetByDateQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<EventsGetByDateQuery | undefined, EventsGetByDateQueryVariables>
export function useEventsGetByDateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<EventsGetByDateQuery, EventsGetByDateQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<EventsGetByDateQuery, EventsGetByDateQueryVariables>(
    EventsGetByDateDocument,
    options
  )
}
export type EventsGetByDateQueryHookResult = ReturnType<typeof useEventsGetByDateQuery>
export type EventsGetByDateLazyQueryHookResult = ReturnType<typeof useEventsGetByDateLazyQuery>
export type EventsGetByDateSuspenseQueryHookResult = ReturnType<typeof useEventsGetByDateSuspenseQuery>
export type EventsGetByDateQueryResult = ApolloReactCommon.QueryResult<
  EventsGetByDateQuery,
  EventsGetByDateQueryVariables
>
export const GetEventTypesDocument = gql`
  query getEventTypes {
    eventTypes {
      comment
      value
    }
  }
`

/**
 * __useGetEventTypesQuery__
 *
 * To run a query within a React component, call `useGetEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventTypesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, options)
}
export function useGetEventTypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, options)
}
// @ts-ignore
export function useGetEventTypesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetEventTypesQuery, GetEventTypesQueryVariables>
export function useGetEventTypesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetEventTypesQuery | undefined, GetEventTypesQueryVariables>
export function useGetEventTypesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(
    GetEventTypesDocument,
    options
  )
}
export type GetEventTypesQueryHookResult = ReturnType<typeof useGetEventTypesQuery>
export type GetEventTypesLazyQueryHookResult = ReturnType<typeof useGetEventTypesLazyQuery>
export type GetEventTypesSuspenseQueryHookResult = ReturnType<typeof useGetEventTypesSuspenseQuery>
export type GetEventTypesQueryResult = ApolloReactCommon.QueryResult<GetEventTypesQuery, GetEventTypesQueryVariables>
export const GetAllEventsDocument = gql`
  query getAllEvents {
    events {
      ...event
    }
  }
  ${EventFragmentDoc}
`

/**
 * __useGetAllEventsQuery__
 *
 * To run a query within a React component, call `useGetAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEventsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options)
}
export function useGetAllEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options)
}
// @ts-ignore
export function useGetAllEventsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetAllEventsQuery, GetAllEventsQueryVariables>
export function useGetAllEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetAllEventsQuery | undefined, GetAllEventsQueryVariables>
export function useGetAllEventsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options)
}
export type GetAllEventsQueryHookResult = ReturnType<typeof useGetAllEventsQuery>
export type GetAllEventsLazyQueryHookResult = ReturnType<typeof useGetAllEventsLazyQuery>
export type GetAllEventsSuspenseQueryHookResult = ReturnType<typeof useGetAllEventsSuspenseQuery>
export type GetAllEventsQueryResult = ApolloReactCommon.QueryResult<GetAllEventsQuery, GetAllEventsQueryVariables>
export const CreateEventDocument = gql`
  mutation createEvent(
    $allDay: Boolean!
    $description: String!
    $endsAt: timestamptz!
    $startsAt: timestamptz!
    $title: String!
    $type: eventTypes_enum!
  ) {
    insertEvent(
      object: {
        allDay: $allDay
        description: $description
        endsAt: $endsAt
        startsAt: $startsAt
        title: $title
        type: $type
      }
    ) {
      id
    }
  }
`
export type CreateEventMutationFn = ApolloReactCommon.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      allDay: // value for 'allDay'
 *      description: // value for 'description'
 *      endsAt: // value for 'endsAt'
 *      startsAt: // value for 'startsAt'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options)
}
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>
export type CreateEventMutationResult = ApolloReactCommon.MutationResult<CreateEventMutation>
export type CreateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>
export const DeleteEventDocument = gql`
  mutation deleteEvent($id: Int!) {
    deleteEventById(id: $id) {
      id
    }
  }
`
export type DeleteEventMutationFn = ApolloReactCommon.MutationFunction<
  DeleteEventMutation,
  DeleteEventMutationVariables
>

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options)
}
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>
export type DeleteEventMutationResult = ApolloReactCommon.MutationResult<DeleteEventMutation>
export type DeleteEventMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteEventMutation,
  DeleteEventMutationVariables
>
export const UpdateEventDocument = gql`
  mutation updateEvent(
    $id: Int!
    $allDay: Boolean!
    $description: String!
    $endsAt: timestamptz!
    $startsAt: timestamptz!
    $title: String!
    $type: eventTypes_enum!
  ) {
    updateEventById(
      pk_columns: { id: $id }
      _set: {
        allDay: $allDay
        description: $description
        endsAt: $endsAt
        startsAt: $startsAt
        title: $title
        type: $type
      }
    ) {
      id
    }
  }
`
export type UpdateEventMutationFn = ApolloReactCommon.MutationFunction<
  UpdateEventMutation,
  UpdateEventMutationVariables
>

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      allDay: // value for 'allDay'
 *      description: // value for 'description'
 *      endsAt: // value for 'endsAt'
 *      startsAt: // value for 'startsAt'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options)
}
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>
export type UpdateEventMutationResult = ApolloReactCommon.MutationResult<UpdateEventMutation>
export type UpdateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateEventMutation,
  UpdateEventMutationVariables
>
export const GalleriesGetAllDocument = gql`
  query galleriesGetAll {
    galleries(where: { active: { _eq: true } }) {
      id
      date
      title
      thumbUrl
      date
      children
      videoUpload {
        id
        publicUrl
        type
      }
      videoThumbnail {
        id
        publicUrl
      }
    }
    galleryPage: pagesBySlug(slug: "gallery") {
      children
    }
  }
`

/**
 * __useGalleriesGetAllQuery__
 *
 * To run a query within a React component, call `useGalleriesGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleriesGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleriesGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGalleriesGetAllQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>(
    GalleriesGetAllDocument,
    options
  )
}
export function useGalleriesGetAllLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>(
    GalleriesGetAllDocument,
    options
  )
}
// @ts-ignore
export function useGalleriesGetAllSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
export function useGalleriesGetAllSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GalleriesGetAllQuery | undefined, GalleriesGetAllQueryVariables>
export function useGalleriesGetAllSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<GalleriesGetAllQuery, GalleriesGetAllQueryVariables>(
    GalleriesGetAllDocument,
    options
  )
}
export type GalleriesGetAllQueryHookResult = ReturnType<typeof useGalleriesGetAllQuery>
export type GalleriesGetAllLazyQueryHookResult = ReturnType<typeof useGalleriesGetAllLazyQuery>
export type GalleriesGetAllSuspenseQueryHookResult = ReturnType<typeof useGalleriesGetAllSuspenseQuery>
export type GalleriesGetAllQueryResult = ApolloReactCommon.QueryResult<
  GalleriesGetAllQuery,
  GalleriesGetAllQueryVariables
>
export const GetGalleryDocument = gql`
  query getGallery($id: Int!) {
    gallery: galleryById(id: $id) {
      id
      date
      title
      children
      photos {
        id
        image {
          publicUrl
        }
      }
      videoUpload {
        id
        publicUrl
        type
      }
      videoThumbnail {
        id
        publicUrl
      }
    }
  }
`

/**
 * __useGetGalleryQuery__
 *
 * To run a query within a React component, call `useGetGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGalleryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetGalleryQuery, GetGalleryQueryVariables> &
    ({ variables: GetGalleryQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetGalleryQuery, GetGalleryQueryVariables>(GetGalleryDocument, options)
}
export function useGetGalleryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGalleryQuery, GetGalleryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetGalleryQuery, GetGalleryQueryVariables>(GetGalleryDocument, options)
}
// @ts-ignore
export function useGetGallerySuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetGalleryQuery, GetGalleryQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetGalleryQuery, GetGalleryQueryVariables>
export function useGetGallerySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetGalleryQuery, GetGalleryQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<GetGalleryQuery | undefined, GetGalleryQueryVariables>
export function useGetGallerySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<GetGalleryQuery, GetGalleryQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<GetGalleryQuery, GetGalleryQueryVariables>(GetGalleryDocument, options)
}
export type GetGalleryQueryHookResult = ReturnType<typeof useGetGalleryQuery>
export type GetGalleryLazyQueryHookResult = ReturnType<typeof useGetGalleryLazyQuery>
export type GetGallerySuspenseQueryHookResult = ReturnType<typeof useGetGallerySuspenseQuery>
export type GetGalleryQueryResult = ApolloReactCommon.QueryResult<GetGalleryQuery, GetGalleryQueryVariables>
export const RecentDocument = gql`
  query recent {
    bulletins(where: { global: { _eq: true } }, order_by: { createdAt: desc }, limit: 3) {
      ...bulletinDetails
    }
    discussions(order_by: { createdAt: desc }, limit: 3) {
      ...discussionDetails
    }
    resources(order_by: { createdAt: desc }, limit: 3) {
      ...resourceDetails
    }
  }
  ${BulletinDetailsFragmentDoc}
  ${DiscussionDetailsFragmentDoc}
  ${ResourceDetailsFragmentDoc}
`

/**
 * __useRecentQuery__
 *
 * To run a query within a React component, call `useRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentQuery, RecentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RecentQuery, RecentQueryVariables>(RecentDocument, options)
}
export function useRecentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentQuery, RecentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RecentQuery, RecentQueryVariables>(RecentDocument, options)
}
// @ts-ignore
export function useRecentSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RecentQuery, RecentQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentQuery, RecentQueryVariables>
export function useRecentSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentQuery, RecentQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentQuery | undefined, RecentQueryVariables>
export function useRecentSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentQuery, RecentQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<RecentQuery, RecentQueryVariables>(RecentDocument, options)
}
export type RecentQueryHookResult = ReturnType<typeof useRecentQuery>
export type RecentLazyQueryHookResult = ReturnType<typeof useRecentLazyQuery>
export type RecentSuspenseQueryHookResult = ReturnType<typeof useRecentSuspenseQuery>
export type RecentQueryResult = ApolloReactCommon.QueryResult<RecentQuery, RecentQueryVariables>
export const RecentBulletinsDocument = gql`
  query recentBulletins {
    bulletins(where: { global: { _eq: true } }, order_by: { createdAt: desc }, limit: 3) {
      ...bulletinDetails
    }
  }
  ${BulletinDetailsFragmentDoc}
`

/**
 * __useRecentBulletinsQuery__
 *
 * To run a query within a React component, call `useRecentBulletinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentBulletinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentBulletinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentBulletinsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<RecentBulletinsQuery, RecentBulletinsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RecentBulletinsQuery, RecentBulletinsQueryVariables>(
    RecentBulletinsDocument,
    options
  )
}
export function useRecentBulletinsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentBulletinsQuery, RecentBulletinsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RecentBulletinsQuery, RecentBulletinsQueryVariables>(
    RecentBulletinsDocument,
    options
  )
}
// @ts-ignore
export function useRecentBulletinsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RecentBulletinsQuery, RecentBulletinsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentBulletinsQuery, RecentBulletinsQueryVariables>
export function useRecentBulletinsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentBulletinsQuery, RecentBulletinsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentBulletinsQuery | undefined, RecentBulletinsQueryVariables>
export function useRecentBulletinsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentBulletinsQuery, RecentBulletinsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<RecentBulletinsQuery, RecentBulletinsQueryVariables>(
    RecentBulletinsDocument,
    options
  )
}
export type RecentBulletinsQueryHookResult = ReturnType<typeof useRecentBulletinsQuery>
export type RecentBulletinsLazyQueryHookResult = ReturnType<typeof useRecentBulletinsLazyQuery>
export type RecentBulletinsSuspenseQueryHookResult = ReturnType<typeof useRecentBulletinsSuspenseQuery>
export type RecentBulletinsQueryResult = ApolloReactCommon.QueryResult<
  RecentBulletinsQuery,
  RecentBulletinsQueryVariables
>
export const RecentDiscussionsDocument = gql`
  query recentDiscussions {
    discussions(order_by: { createdAt: desc }, limit: 3) {
      ...discussionDetails
    }
  }
  ${DiscussionDetailsFragmentDoc}
`

/**
 * __useRecentDiscussionsQuery__
 *
 * To run a query within a React component, call `useRecentDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentDiscussionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentDiscussionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>(
    RecentDiscussionsDocument,
    options
  )
}
export function useRecentDiscussionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>(
    RecentDiscussionsDocument,
    options
  )
}
// @ts-ignore
export function useRecentDiscussionsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
export function useRecentDiscussionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentDiscussionsQuery | undefined, RecentDiscussionsQueryVariables>
export function useRecentDiscussionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<RecentDiscussionsQuery, RecentDiscussionsQueryVariables>(
    RecentDiscussionsDocument,
    options
  )
}
export type RecentDiscussionsQueryHookResult = ReturnType<typeof useRecentDiscussionsQuery>
export type RecentDiscussionsLazyQueryHookResult = ReturnType<typeof useRecentDiscussionsLazyQuery>
export type RecentDiscussionsSuspenseQueryHookResult = ReturnType<typeof useRecentDiscussionsSuspenseQuery>
export type RecentDiscussionsQueryResult = ApolloReactCommon.QueryResult<
  RecentDiscussionsQuery,
  RecentDiscussionsQueryVariables
>
export const RecentResourcesDocument = gql`
  query recentResources {
    resources(order_by: { createdAt: desc }, limit: 3) {
      ...resourceDetails
    }
  }
  ${ResourceDetailsFragmentDoc}
`

/**
 * __useRecentResourcesQuery__
 *
 * To run a query within a React component, call `useRecentResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentResourcesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<RecentResourcesQuery, RecentResourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RecentResourcesQuery, RecentResourcesQueryVariables>(
    RecentResourcesDocument,
    options
  )
}
export function useRecentResourcesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentResourcesQuery, RecentResourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RecentResourcesQuery, RecentResourcesQueryVariables>(
    RecentResourcesDocument,
    options
  )
}
// @ts-ignore
export function useRecentResourcesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RecentResourcesQuery, RecentResourcesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentResourcesQuery, RecentResourcesQueryVariables>
export function useRecentResourcesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentResourcesQuery, RecentResourcesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<RecentResourcesQuery | undefined, RecentResourcesQueryVariables>
export function useRecentResourcesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<RecentResourcesQuery, RecentResourcesQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<RecentResourcesQuery, RecentResourcesQueryVariables>(
    RecentResourcesDocument,
    options
  )
}
export type RecentResourcesQueryHookResult = ReturnType<typeof useRecentResourcesQuery>
export type RecentResourcesLazyQueryHookResult = ReturnType<typeof useRecentResourcesLazyQuery>
export type RecentResourcesSuspenseQueryHookResult = ReturnType<typeof useRecentResourcesSuspenseQuery>
export type RecentResourcesQueryResult = ApolloReactCommon.QueryResult<
  RecentResourcesQuery,
  RecentResourcesQueryVariables
>
export const IosRedemptionCodeDocument = gql`
  query iosRedemptionCode {
    iosRedemptionCode {
      code
      url
    }
  }
`

/**
 * __useIosRedemptionCodeQuery__
 *
 * To run a query within a React component, call `useIosRedemptionCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIosRedemptionCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIosRedemptionCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useIosRedemptionCodeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>(
    IosRedemptionCodeDocument,
    options
  )
}
export function useIosRedemptionCodeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>(
    IosRedemptionCodeDocument,
    options
  )
}
// @ts-ignore
export function useIosRedemptionCodeSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
export function useIosRedemptionCodeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<IosRedemptionCodeQuery | undefined, IosRedemptionCodeQueryVariables>
export function useIosRedemptionCodeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<IosRedemptionCodeQuery, IosRedemptionCodeQueryVariables>(
    IosRedemptionCodeDocument,
    options
  )
}
export type IosRedemptionCodeQueryHookResult = ReturnType<typeof useIosRedemptionCodeQuery>
export type IosRedemptionCodeLazyQueryHookResult = ReturnType<typeof useIosRedemptionCodeLazyQuery>
export type IosRedemptionCodeSuspenseQueryHookResult = ReturnType<typeof useIosRedemptionCodeSuspenseQuery>
export type IosRedemptionCodeQueryResult = ApolloReactCommon.QueryResult<
  IosRedemptionCodeQuery,
  IosRedemptionCodeQueryVariables
>
export const JobsitesDocument = gql`
  query jobsites {
    jobsites(order_by: { title: asc }) {
      ...jobsite
    }
  }
  ${JobsiteFragmentDoc}
`

/**
 * __useJobsitesQuery__
 *
 * To run a query within a React component, call `useJobsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsitesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<JobsitesQuery, JobsitesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<JobsitesQuery, JobsitesQueryVariables>(JobsitesDocument, options)
}
export function useJobsitesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobsitesQuery, JobsitesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<JobsitesQuery, JobsitesQueryVariables>(JobsitesDocument, options)
}
// @ts-ignore
export function useJobsitesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<JobsitesQuery, JobsitesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<JobsitesQuery, JobsitesQueryVariables>
export function useJobsitesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<JobsitesQuery, JobsitesQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<JobsitesQuery | undefined, JobsitesQueryVariables>
export function useJobsitesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<JobsitesQuery, JobsitesQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<JobsitesQuery, JobsitesQueryVariables>(JobsitesDocument, options)
}
export type JobsitesQueryHookResult = ReturnType<typeof useJobsitesQuery>
export type JobsitesLazyQueryHookResult = ReturnType<typeof useJobsitesLazyQuery>
export type JobsitesSuspenseQueryHookResult = ReturnType<typeof useJobsitesSuspenseQuery>
export type JobsitesQueryResult = ApolloReactCommon.QueryResult<JobsitesQuery, JobsitesQueryVariables>
export const CreateJobsiteDocument = gql`
  mutation createJobsite(
    $mainAddress: String!
    $mainAddress2: String
    $mainAddressCity: String!
    $mainAddressState: String!
    $mainAddressZip: String!
    $officeAddress: String
    $officeAddress2: String
    $officeAddressCity: String
    $officeAddressState: String
    $officeAddressZip: String
    $phone: String!
    $siteNumber: String!
    $title: String!
    $alt_names: String!
  ) {
    insertJobsite(
      object: {
        mainAddress: $mainAddress
        mainAddress2: $mainAddress2
        mainAddressCity: $mainAddressCity
        mainAddressState: $mainAddressState
        mainAddressZip: $mainAddressZip
        officeAddress: $officeAddress
        officeAddress2: $officeAddress2
        officeAddressCity: $officeAddressCity
        officeAddressState: $officeAddressState
        officeAddressZip: $officeAddressZip
        phone: $phone
        siteNumber: $siteNumber
        title: $title
        alt_names: $alt_names
      }
    ) {
      id
    }
  }
`
export type CreateJobsiteMutationFn = ApolloReactCommon.MutationFunction<
  CreateJobsiteMutation,
  CreateJobsiteMutationVariables
>

/**
 * __useCreateJobsiteMutation__
 *
 * To run a mutation, you first call `useCreateJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobsiteMutation, { data, loading, error }] = useCreateJobsiteMutation({
 *   variables: {
 *      mainAddress: // value for 'mainAddress'
 *      mainAddress2: // value for 'mainAddress2'
 *      mainAddressCity: // value for 'mainAddressCity'
 *      mainAddressState: // value for 'mainAddressState'
 *      mainAddressZip: // value for 'mainAddressZip'
 *      officeAddress: // value for 'officeAddress'
 *      officeAddress2: // value for 'officeAddress2'
 *      officeAddressCity: // value for 'officeAddressCity'
 *      officeAddressState: // value for 'officeAddressState'
 *      officeAddressZip: // value for 'officeAddressZip'
 *      phone: // value for 'phone'
 *      siteNumber: // value for 'siteNumber'
 *      title: // value for 'title'
 *      alt_names: // value for 'alt_names'
 *   },
 * });
 */
export function useCreateJobsiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateJobsiteMutation, CreateJobsiteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateJobsiteMutation, CreateJobsiteMutationVariables>(
    CreateJobsiteDocument,
    options
  )
}
export type CreateJobsiteMutationHookResult = ReturnType<typeof useCreateJobsiteMutation>
export type CreateJobsiteMutationResult = ApolloReactCommon.MutationResult<CreateJobsiteMutation>
export type CreateJobsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateJobsiteMutation,
  CreateJobsiteMutationVariables
>
export const UpdateJobsiteDocument = gql`
  mutation updateJobsite(
    $id: Int!
    $mainAddress: String!
    $mainAddress2: String
    $mainAddressCity: String!
    $mainAddressState: String!
    $mainAddressZip: String!
    $officeAddress: String
    $officeAddress2: String
    $officeAddressCity: String
    $officeAddressState: String
    $officeAddressZip: String
    $phone: String!
    $siteNumber: String!
    $title: String!
    $alt_names: String!
  ) {
    updateJobsiteById(
      pk_columns: { id: $id }
      _set: {
        mainAddress: $mainAddress
        mainAddress2: $mainAddress2
        mainAddressCity: $mainAddressCity
        mainAddressState: $mainAddressState
        mainAddressZip: $mainAddressZip
        officeAddress: $officeAddress
        officeAddress2: $officeAddress2
        officeAddressCity: $officeAddressCity
        officeAddressState: $officeAddressState
        officeAddressZip: $officeAddressZip
        phone: $phone
        siteNumber: $siteNumber
        title: $title
        alt_names: $alt_names
      }
    ) {
      id
    }
  }
`
export type UpdateJobsiteMutationFn = ApolloReactCommon.MutationFunction<
  UpdateJobsiteMutation,
  UpdateJobsiteMutationVariables
>

/**
 * __useUpdateJobsiteMutation__
 *
 * To run a mutation, you first call `useUpdateJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsiteMutation, { data, loading, error }] = useUpdateJobsiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mainAddress: // value for 'mainAddress'
 *      mainAddress2: // value for 'mainAddress2'
 *      mainAddressCity: // value for 'mainAddressCity'
 *      mainAddressState: // value for 'mainAddressState'
 *      mainAddressZip: // value for 'mainAddressZip'
 *      officeAddress: // value for 'officeAddress'
 *      officeAddress2: // value for 'officeAddress2'
 *      officeAddressCity: // value for 'officeAddressCity'
 *      officeAddressState: // value for 'officeAddressState'
 *      officeAddressZip: // value for 'officeAddressZip'
 *      phone: // value for 'phone'
 *      siteNumber: // value for 'siteNumber'
 *      title: // value for 'title'
 *      alt_names: // value for 'alt_names'
 *   },
 * });
 */
export function useUpdateJobsiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateJobsiteMutation, UpdateJobsiteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateJobsiteMutation, UpdateJobsiteMutationVariables>(
    UpdateJobsiteDocument,
    options
  )
}
export type UpdateJobsiteMutationHookResult = ReturnType<typeof useUpdateJobsiteMutation>
export type UpdateJobsiteMutationResult = ApolloReactCommon.MutationResult<UpdateJobsiteMutation>
export type UpdateJobsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateJobsiteMutation,
  UpdateJobsiteMutationVariables
>
export const DeleteJobsiteDocument = gql`
  mutation deleteJobsite($id: Int!) {
    deleteJobsiteById(id: $id) {
      id
    }
  }
`
export type DeleteJobsiteMutationFn = ApolloReactCommon.MutationFunction<
  DeleteJobsiteMutation,
  DeleteJobsiteMutationVariables
>

/**
 * __useDeleteJobsiteMutation__
 *
 * To run a mutation, you first call `useDeleteJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobsiteMutation, { data, loading, error }] = useDeleteJobsiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobsiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteJobsiteMutation, DeleteJobsiteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteJobsiteMutation, DeleteJobsiteMutationVariables>(
    DeleteJobsiteDocument,
    options
  )
}
export type DeleteJobsiteMutationHookResult = ReturnType<typeof useDeleteJobsiteMutation>
export type DeleteJobsiteMutationResult = ApolloReactCommon.MutationResult<DeleteJobsiteMutation>
export type DeleteJobsiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteJobsiteMutation,
  DeleteJobsiteMutationVariables
>
export const LatestOrgChartDocument = gql`
  query latestOrgChart {
    resources(where: { title: { _ilike: "%org% %chart%" } }, order_by: { createdAt: desc_nulls_last }, limit: 1) {
      ...resourceDetails
    }
  }
  ${ResourceDetailsFragmentDoc}
`

/**
 * __useLatestOrgChartQuery__
 *
 * To run a query within a React component, call `useLatestOrgChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestOrgChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestOrgChartQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestOrgChartQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<LatestOrgChartQuery, LatestOrgChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<LatestOrgChartQuery, LatestOrgChartQueryVariables>(LatestOrgChartDocument, options)
}
export function useLatestOrgChartLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestOrgChartQuery, LatestOrgChartQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<LatestOrgChartQuery, LatestOrgChartQueryVariables>(
    LatestOrgChartDocument,
    options
  )
}
// @ts-ignore
export function useLatestOrgChartSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LatestOrgChartQuery, LatestOrgChartQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<LatestOrgChartQuery, LatestOrgChartQueryVariables>
export function useLatestOrgChartSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<LatestOrgChartQuery, LatestOrgChartQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<LatestOrgChartQuery | undefined, LatestOrgChartQueryVariables>
export function useLatestOrgChartSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<LatestOrgChartQuery, LatestOrgChartQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<LatestOrgChartQuery, LatestOrgChartQueryVariables>(
    LatestOrgChartDocument,
    options
  )
}
export type LatestOrgChartQueryHookResult = ReturnType<typeof useLatestOrgChartQuery>
export type LatestOrgChartLazyQueryHookResult = ReturnType<typeof useLatestOrgChartLazyQuery>
export type LatestOrgChartSuspenseQueryHookResult = ReturnType<typeof useLatestOrgChartSuspenseQuery>
export type LatestOrgChartQueryResult = ApolloReactCommon.QueryResult<LatestOrgChartQuery, LatestOrgChartQueryVariables>
export const OrgChartUsersDocument = gql`
  query orgChartUsers {
    users(
      where: { workerType: { _eq: "F" }, _not: { username: { _in: ["roi", "mattw"] } } }
      order_by: { lastName: asc }
    ) {
      ...orgChartUser
    }
  }
  ${OrgChartUserFragmentDoc}
`

/**
 * __useOrgChartUsersQuery__
 *
 * To run a query within a React component, call `useOrgChartUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgChartUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgChartUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgChartUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<OrgChartUsersQuery, OrgChartUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<OrgChartUsersQuery, OrgChartUsersQueryVariables>(OrgChartUsersDocument, options)
}
export function useOrgChartUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgChartUsersQuery, OrgChartUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<OrgChartUsersQuery, OrgChartUsersQueryVariables>(OrgChartUsersDocument, options)
}
// @ts-ignore
export function useOrgChartUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgChartUsersQuery, OrgChartUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<OrgChartUsersQuery, OrgChartUsersQueryVariables>
export function useOrgChartUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<OrgChartUsersQuery, OrgChartUsersQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<OrgChartUsersQuery | undefined, OrgChartUsersQueryVariables>
export function useOrgChartUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<OrgChartUsersQuery, OrgChartUsersQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<OrgChartUsersQuery, OrgChartUsersQueryVariables>(
    OrgChartUsersDocument,
    options
  )
}
export type OrgChartUsersQueryHookResult = ReturnType<typeof useOrgChartUsersQuery>
export type OrgChartUsersLazyQueryHookResult = ReturnType<typeof useOrgChartUsersLazyQuery>
export type OrgChartUsersSuspenseQueryHookResult = ReturnType<typeof useOrgChartUsersSuspenseQuery>
export type OrgChartUsersQueryResult = ApolloReactCommon.QueryResult<OrgChartUsersQuery, OrgChartUsersQueryVariables>
export const PagesSignInMastheadDocument = gql`
  query pagesSignInMasthead {
    signinPage: pagesBySlug(slug: "sign-in") {
      masthead {
        publicUrl
        key
      }
    }
  }
`

/**
 * __usePagesSignInMastheadQuery__
 *
 * To run a query within a React component, call `usePagesSignInMastheadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesSignInMastheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesSignInMastheadQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesSignInMastheadQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>(
    PagesSignInMastheadDocument,
    options
  )
}
export function usePagesSignInMastheadLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>(
    PagesSignInMastheadDocument,
    options
  )
}
// @ts-ignore
export function usePagesSignInMastheadSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
export function usePagesSignInMastheadSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<PagesSignInMastheadQuery | undefined, PagesSignInMastheadQueryVariables>
export function usePagesSignInMastheadSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<PagesSignInMastheadQuery, PagesSignInMastheadQueryVariables>(
    PagesSignInMastheadDocument,
    options
  )
}
export type PagesSignInMastheadQueryHookResult = ReturnType<typeof usePagesSignInMastheadQuery>
export type PagesSignInMastheadLazyQueryHookResult = ReturnType<typeof usePagesSignInMastheadLazyQuery>
export type PagesSignInMastheadSuspenseQueryHookResult = ReturnType<typeof usePagesSignInMastheadSuspenseQuery>
export type PagesSignInMastheadQueryResult = ApolloReactCommon.QueryResult<
  PagesSignInMastheadQuery,
  PagesSignInMastheadQueryVariables
>
export const SearchDocument = gql`
  query search($keywords: String!) {
    search(where: { keywords: { _ilike: $keywords } }) {
      user {
        ...userDetails
      }
      modelType
      modelId
      resource {
        ...resourceDetails
        departmentContentsResources {
          departmentContent {
            departmentId
            parentId
            id
            title
          }
        }
      }
      bulletin {
        ...bulletinDetails
      }
    }
  }
  ${UserDetailsFragmentDoc}
  ${ResourceDetailsFragmentDoc}
  ${BulletinDetailsFragmentDoc}
`

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SearchQuery, SearchQueryVariables> &
    ({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options)
}
export function useSearchLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options)
}
// @ts-ignore
export function useSearchSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SearchQuery, SearchQueryVariables>
export function useSearchSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SearchQuery | undefined, SearchQueryVariables>
export function useSearchSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options)
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>
export type SearchQueryResult = ApolloReactCommon.QueryResult<SearchQuery, SearchQueryVariables>
export const ResourceSearchDocument = gql`
  query resourceSearch($_ilike: String) {
    resources(
      where: { deleted: { _is_null: true }, title: { _ilike: $_ilike } }
      limit: 10
      order_by: { createdAt: desc_nulls_last }
    ) {
      title
      id
      createdAt
      description
      file {
        key
        url
        type
        size
      }
    }
  }
`

/**
 * __useResourceSearchQuery__
 *
 * To run a query within a React component, call `useResourceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceSearchQuery({
 *   variables: {
 *      _ilike: // value for '_ilike'
 *   },
 * });
 */
export function useResourceSearchQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ResourceSearchQuery, ResourceSearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ResourceSearchQuery, ResourceSearchQueryVariables>(ResourceSearchDocument, options)
}
export function useResourceSearchLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourceSearchQuery, ResourceSearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ResourceSearchQuery, ResourceSearchQueryVariables>(
    ResourceSearchDocument,
    options
  )
}
// @ts-ignore
export function useResourceSearchSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResourceSearchQuery, ResourceSearchQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ResourceSearchQuery, ResourceSearchQueryVariables>
export function useResourceSearchSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ResourceSearchQuery, ResourceSearchQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<ResourceSearchQuery | undefined, ResourceSearchQueryVariables>
export function useResourceSearchSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<ResourceSearchQuery, ResourceSearchQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<ResourceSearchQuery, ResourceSearchQueryVariables>(
    ResourceSearchDocument,
    options
  )
}
export type ResourceSearchQueryHookResult = ReturnType<typeof useResourceSearchQuery>
export type ResourceSearchLazyQueryHookResult = ReturnType<typeof useResourceSearchLazyQuery>
export type ResourceSearchSuspenseQueryHookResult = ReturnType<typeof useResourceSearchSuspenseQuery>
export type ResourceSearchQueryResult = ApolloReactCommon.QueryResult<ResourceSearchQuery, ResourceSearchQueryVariables>
export const SiteMetaDocument = gql`
  query siteMeta {
    departments {
      id
      title
      ownerId
      contents(where: { parentId: { _is_null: true }, active: { _eq: true } }) {
        id
        title
      }
      masthead {
        publicUrl
        key
      }
      logo {
        key
      }
    }
    pages {
      masthead {
        publicUrl
        key
      }
      slug
      title
      body
    }
  }
`

/**
 * __useSiteMetaQuery__
 *
 * To run a query within a React component, call `useSiteMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteMetaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SiteMetaQuery, SiteMetaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SiteMetaQuery, SiteMetaQueryVariables>(SiteMetaDocument, options)
}
export function useSiteMetaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteMetaQuery, SiteMetaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SiteMetaQuery, SiteMetaQueryVariables>(SiteMetaDocument, options)
}
// @ts-ignore
export function useSiteMetaSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SiteMetaQuery, SiteMetaQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SiteMetaQuery, SiteMetaQueryVariables>
export function useSiteMetaSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SiteMetaQuery, SiteMetaQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<SiteMetaQuery | undefined, SiteMetaQueryVariables>
export function useSiteMetaSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<SiteMetaQuery, SiteMetaQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<SiteMetaQuery, SiteMetaQueryVariables>(SiteMetaDocument, options)
}
export type SiteMetaQueryHookResult = ReturnType<typeof useSiteMetaQuery>
export type SiteMetaLazyQueryHookResult = ReturnType<typeof useSiteMetaLazyQuery>
export type SiteMetaSuspenseQueryHookResult = ReturnType<typeof useSiteMetaSuspenseQuery>
export type SiteMetaQueryResult = ApolloReactCommon.QueryResult<SiteMetaQuery, SiteMetaQueryVariables>
export const TempGetAllPtoDocument = gql`
  query tempGetAllPto {
    pto {
      startsAt
      allDay
      user {
        firstName
        lastName
      }
    }
  }
`

/**
 * __useTempGetAllPtoQuery__
 *
 * To run a query within a React component, call `useTempGetAllPtoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempGetAllPtoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempGetAllPtoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTempGetAllPtoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>(TempGetAllPtoDocument, options)
}
export function useTempGetAllPtoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>(TempGetAllPtoDocument, options)
}
// @ts-ignore
export function useTempGetAllPtoSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
export function useTempGetAllPtoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<TempGetAllPtoQuery | undefined, TempGetAllPtoQueryVariables>
export function useTempGetAllPtoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>(
    TempGetAllPtoDocument,
    options
  )
}
export type TempGetAllPtoQueryHookResult = ReturnType<typeof useTempGetAllPtoQuery>
export type TempGetAllPtoLazyQueryHookResult = ReturnType<typeof useTempGetAllPtoLazyQuery>
export type TempGetAllPtoSuspenseQueryHookResult = ReturnType<typeof useTempGetAllPtoSuspenseQuery>
export type TempGetAllPtoQueryResult = ApolloReactCommon.QueryResult<TempGetAllPtoQuery, TempGetAllPtoQueryVariables>
export const TempPtoDocument = gql`
  query tempPto($id: Int!) {
    userById(id: $id) {
      adp {
        ptoBalances
        ptoRequests
      }
    }
  }
`

/**
 * __useTempPtoQuery__
 *
 * To run a query within a React component, call `useTempPtoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTempPtoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempPtoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTempPtoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<TempPtoQuery, TempPtoQueryVariables> &
    ({ variables: TempPtoQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TempPtoQuery, TempPtoQueryVariables>(TempPtoDocument, options)
}
export function useTempPtoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TempPtoQuery, TempPtoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TempPtoQuery, TempPtoQueryVariables>(TempPtoDocument, options)
}
// @ts-ignore
export function useTempPtoSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TempPtoQuery, TempPtoQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<TempPtoQuery, TempPtoQueryVariables>
export function useTempPtoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<TempPtoQuery, TempPtoQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<TempPtoQuery | undefined, TempPtoQueryVariables>
export function useTempPtoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<TempPtoQuery, TempPtoQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<TempPtoQuery, TempPtoQueryVariables>(TempPtoDocument, options)
}
export type TempPtoQueryHookResult = ReturnType<typeof useTempPtoQuery>
export type TempPtoLazyQueryHookResult = ReturnType<typeof useTempPtoLazyQuery>
export type TempPtoSuspenseQueryHookResult = ReturnType<typeof useTempPtoSuspenseQuery>
export type TempPtoQueryResult = ApolloReactCommon.QueryResult<TempPtoQuery, TempPtoQueryVariables>
export const UsersGetAllDocument = gql`
  query usersGetAll {
    users(where: { _not: { username: { _in: ["roi", "mattw"] } } }, order_by: { lastName: asc }) {
      ...userDetails
    }
  }
  ${UserDetailsFragmentDoc}
`

/**
 * __useUsersGetAllQuery__
 *
 * To run a query within a React component, call `useUsersGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersGetAllQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options)
}
export function useUsersGetAllLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options)
}
// @ts-ignore
export function useUsersGetAllSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersGetAllQuery, UsersGetAllQueryVariables>
export function useUsersGetAllSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersGetAllQuery | undefined, UsersGetAllQueryVariables>
export function useUsersGetAllSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options)
}
export type UsersGetAllQueryHookResult = ReturnType<typeof useUsersGetAllQuery>
export type UsersGetAllLazyQueryHookResult = ReturnType<typeof useUsersGetAllLazyQuery>
export type UsersGetAllSuspenseQueryHookResult = ReturnType<typeof useUsersGetAllSuspenseQuery>
export type UsersGetAllQueryResult = ApolloReactCommon.QueryResult<UsersGetAllQuery, UsersGetAllQueryVariables>
export const UsersGetByIdDocument = gql`
  query usersGetById($id: Int!) {
    users(where: { id: { _eq: $id } }) {
      ...userDetails
    }
  }
  ${UserDetailsFragmentDoc}
`

/**
 * __useUsersGetByIdQuery__
 *
 * To run a query within a React component, call `useUsersGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersGetByIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables> &
    ({ variables: UsersGetByIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options)
}
export function useUsersGetByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options)
}
// @ts-ignore
export function useUsersGetByIdSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersGetByIdQuery, UsersGetByIdQueryVariables>
export function useUsersGetByIdSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>
): ApolloReactHooks.UseSuspenseQueryResult<UsersGetByIdQuery | undefined, UsersGetByIdQueryVariables>
export function useUsersGetByIdSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSuspenseQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options)
}
export type UsersGetByIdQueryHookResult = ReturnType<typeof useUsersGetByIdQuery>
export type UsersGetByIdLazyQueryHookResult = ReturnType<typeof useUsersGetByIdLazyQuery>
export type UsersGetByIdSuspenseQueryHookResult = ReturnType<typeof useUsersGetByIdSuspenseQuery>
export type UsersGetByIdQueryResult = ApolloReactCommon.QueryResult<UsersGetByIdQuery, UsersGetByIdQueryVariables>
